(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["ReactSubstance"] = factory(require("react"));
	else
		root["ReactSubstance"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_262__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(61)['default'];
	
	exports.__esModule = true;
	
	var _SubstanceEditor2 = __webpack_require__(104);
	
	var _SubstanceEditor3 = _interopRequireDefault(_SubstanceEditor2);
	
	exports.SubstanceEditor = _SubstanceEditor3['default'];

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Mostly taken from lodash.
	 *
	 * @class Helpers
	 * @static
	 * @module Basics
	 */
	var Helpers = {};
	
	// Lang helpers
	
	/**
	 * See https://lodash.com/docs#isEqual
	 * @method isEqual
	 */
	Helpers.isEqual = __webpack_require__(218);
	/**
	 * See https://lodash.com/docs#isObject
	 * @method isObject
	 */
	Helpers.isObject = __webpack_require__(8);
	/**
	 * See https://lodash.com/docs#isArray
	 * @method isArray
	 */
	Helpers.isArray = __webpack_require__(5);
	/**
	 * See https://lodash.com/docs#isString
	 * @method isString
	 */
	Helpers.isString = __webpack_require__(55);
	/**
	 * See https://lodash.com/docs#isNumber
	 * @method isNumber
	 */
	Helpers.isNumber = __webpack_require__(219);
	/**
	 * See https://lodash.com/docs#isBoolean
	 * @method isBoolean
	 */
	Helpers.isBoolean = __webpack_require__(216);
	/**
	 * See https://lodash.com/docs#isFunction
	 * @method isFunction
	 */
	Helpers.isFunction = __webpack_require__(93);
	/**
	 * See https://lodash.com/docs#cloneDeep
	 * @method cloneDeep
	 */
	Helpers.cloneDeep = __webpack_require__(215);
	
	/**
	 * See https://lodash.com/docs#clone
	 * @method clone
	 */
	Helpers.clone = __webpack_require__(214);
	
	/**
	 * See https://lodash.com/docs#isEmpty
	 * @method isEmpty
	 */
	Helpers.isEmpty = __webpack_require__(217);
	
	// Function helpers
	
	/**
	 * See https://lodash.com/docs#bind
	 * @method bind
	 */
	Helpers.bind = __webpack_require__(169);
	/**
	 * See https://lodash.com/docs#delay
	 * @method delay
	 */
	Helpers.delay = __webpack_require__(171);
	/**
	 * See https://lodash.com/docs#debounce
	 * @method debounce
	 */
	Helpers.debounce = __webpack_require__(170);
	
	// Object helpers
	
	/**
	 * See https://lodash.com/docs#extend
	 * @method extend
	 */
	Helpers.extend = __webpack_require__(222);
	/**
	 * See https://lodash.com/docs#omit
	 * @method omit
	 */
	Helpers.omit = __webpack_require__(223);
	
	// Array helpers
	
	/**
	 * See https://lodash.com/docs#last
	 * @method last
	 */
	Helpers.last = __webpack_require__(158);
	/**
	 * See https://lodash.com/docs#first
	 * @method first
	 */
	Helpers.first = __webpack_require__(156);
	/**
	 * See https://lodash.com/docs#compact
	 * @method compact
	 */
	Helpers.compact = __webpack_require__(154);
	/**
	 * See https://lodash.com/docs#uniq
	 * @method uniq
	 */
	Helpers.uniq = __webpack_require__(160);
	/**
	 * See https://lodash.com/docs#intersection
	 * @method intersection
	 */
	Helpers.intersection = __webpack_require__(157);
	/**
	 * See https://lodash.com/docs#union
	 * @method union
	 */
	Helpers.union = __webpack_require__(159);
	/**
	 * See https://lodash.com/docs#without
	 * @method without
	 */
	Helpers.without = __webpack_require__(161);
	
	// Collection helpers
	
	/**
	 * See https://lodash.com/docs#each
	 * @method each
	 */
	Helpers.each = __webpack_require__(164);
	/**
	 * See https://lodash.com/docs#filter
	 * @method filter
	 */
	Helpers.filter = __webpack_require__(162);
	/**
	 * See https://lodash.com/docs#includes
	 * @method includes
	 */
	Helpers.includes = __webpack_require__(165);
	/**
	 * See https://lodash.com/docs#find
	 * @method find
	 */
	Helpers.find = __webpack_require__(163);
	/**
	 * See https://lodash.com/docs#map
	 * @method map
	 */
	Helpers.map = __webpack_require__(77);
	/**
	 * See https://lodash.com/docs#pluck
	 * @method pluck
	 */
	Helpers.pluck = __webpack_require__(167);
	/**
	 * See https://lodash.com/docs#indexBy
	 * @method indexBy
	 */
	Helpers.indexBy = __webpack_require__(166);
	/**
	 * See https://lodash.com/docs#sortBy
	 * @method sortBy
	 */
	Helpers.sortBy = __webpack_require__(168);
	
	// String helpers
	
	/**
	 * See https://lodash.com/docs#capitalize
	 * @method capitalize
	 */
	Helpers.capitalize = __webpack_require__(225);
	
	/**
	 * Check if two arrays are equal.
	 *
	 * @method isArrayEqual
	 * @param {Array} a
	 * @param {Array} b
	 * @deprecated use `Helpers.isEqual` instead.
	 */
	Helpers.isArrayEqual = function(a, b) {
	  if (a === b) return true;
	  if (a === null || b === null) return false;
	  if (a.length != b.length) return false;
	  for (var i = 0; i < a.length; ++i) {
	    if (a[i] !== b[i]) return false;
	  }
	  return true;
	};
	
	/**
	 * Removes all occurrence of value in array using Array.splice
	 * I.e., this changes the array instead of creating a new one
	 * as _.without() does.
	 *
	 * @method deleteFromArray
	 * @param {Array} array
	 * @param value
	 */
	Helpers.deleteFromArray = function(array, value) {
	  for (var i = 0; i < array.length; i++) {
	    if (array[i] === value) {
	      array.splice(i, 1);
	      i--;
	    }
	  }
	};
	
	/**
	 * Clones a given object.
	 * Uses obj.clone() if available, otherwise delegates to _.cloneDeep().
	 *
	 * @method clone
	 * @param {Object} obj
	 * @return The cloned object.
	 */
	Helpers.deepclone = function(obj) {
	  if (obj === null || obj === undefined) {
	    return obj;
	  }
	  if (Helpers.isFunction(obj.clone)) {
	    return obj.clone();
	  }
	  return Helpers.deepclone(obj);
	};
	
	/**
	 * Alias for {{#crossLink "Helpers/cloneDeep:method"}}{{/crossLink}}.
	 * @method deepClone
	 */
	Helpers.deepclone = Helpers.cloneDeep;
	
	/**
	 * Web helper to compute the relative offset of an element to an ancestor element.
	 *
	 * @method getRelativeOffset
	 * @param {jQuery.Selector} $element
	 * @param {jQuery.Selector} $ancestor
	 * @return An object with properties
	 *   - top: Number
	 *   - left: Number
	 */
	Helpers.getRelativeOffset = function ( $element, $ancestor ) {
	  var pos = $element.offset();
	  var ancestorPos = $ancestor.offset();
	  pos.left -= ancestorPos.left;
	  pos.top -= ancestorPos.top;
	  return pos;
	};
	
	Helpers.uuid = __webpack_require__(35);
	
	module.exports = Helpers;


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	
	/**
	 * Helpers for OO programming.
	 *
	 * Inspired by VisualEditor's OO module.
	 *
	 * @class OO
	 * @static
	 * @module Basics
	 */
	var OO = {};
	
	var extend = function( parent, proto ) {
	  var Constructor = function ExtendedClass() {
	    this.__className__ = proto.displayName || proto.name;
	    parent.apply(this, arguments);
	    if (this.init) {
	      this.init.apply(this, arguments);
	    }
	  };
	  if (proto.displayName) {
	    Constructor.displayName = proto.displayName;
	  } else if (proto.name) {
	    Constructor.displayName = proto.name;
	  }
	  OO.inherit(Constructor, parent);
	  for(var key in proto) {
	    if (proto.hasOwnProperty(key)) {
	      if (key === "name") {
	        continue;
	      }
	      Constructor.prototype[key] = proto[key];
	    }
	  }
	  Constructor.static.name = proto.name;
	  return Constructor;
	};
	
	/**
	 * Initialize a class.
	 *
	 * @param {Constructor} clazz
	 * @method initClass
	 */
	OO.initClass = function(clazz) {
	  if (clazz.Prototype && !(clazz.prototype instanceof clazz.Prototype)) {
	    clazz.prototype = new clazz.Prototype();
	    clazz.prototype.constructor = clazz;
	  }
	  clazz.static = clazz.static || {};
	  clazz.extend = clazz.extend || _.bind(extend, null, clazz);
	};
	
	/**
	 * Inherit from a parent class.
	 *
	 * @param clazz {Constructor} class constructor
	 * @param parentClazz {Constructor} parent constructor
	 *
	 * @method inherit
	 */
	OO.inherit =  function(clazz, parentClazz) {
	  if (clazz.prototype instanceof parentClazz) {
	    throw new Error('Target already inherits from origin');
	  }
	  var targetConstructor = clazz.prototype.constructor;
	  // Customization: supporting a prototype constructor function
	  // defined as a static member 'Prototype' of the target function.
	  var TargetPrototypeCtor = clazz.Prototype;
	  // Provide a shortcut to the parent constructor
	  clazz.super = parentClazz;
	  if (TargetPrototypeCtor) {
	    TargetPrototypeCtor.prototype = parentClazz.prototype;
	    clazz.prototype = new TargetPrototypeCtor();
	    clazz.prototype.constructor = clazz;
	  } else {
	    clazz.prototype = Object.create(parentClazz.prototype, {
	      // Restore constructor property of clazz
	      constructor: {
	        value: targetConstructor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  }
	  // provide a shortcut to the parent prototype
	  clazz.prototype.super = parentClazz.prototype;
	  // Extend static properties - always initialize both sides
	  OO.initClass( parentClazz );
	  clazz.static = Object.create(parentClazz.static);
	  clazz.extend = _.bind(extend, null, clazz);
	};
	
	/**
	 * @param clazz {Constructor} class constructor
	 * @param mixinClazz {Constructor} parent constructor
	 * @method mixin
	 */
	OO.mixin = function(clazz, mixinClazz) {
	  var key;
	  var prototype = mixinClazz.prototype;
	  if (mixinClazz.Prototype) {
	    prototype = new mixinClazz.Prototype();
	  }
	  // Copy prototype properties
	  for ( key in prototype ) {
	    if ( key !== 'constructor' && prototype.hasOwnProperty( key ) ) {
	      clazz.prototype[key] = prototype[key];
	    }
	  }
	  // make sure the clazz is initialized
	  OO.initClass(clazz);
	  // Copy static properties
	  if ( mixinClazz.static ) {
	    for ( key in mixinClazz.static ) {
	      if ( mixinClazz.static.hasOwnProperty( key ) ) {
	        clazz.static[key] = mixinClazz.static[key];
	      }
	    }
	  } else {
	    OO.initClass(mixinClazz);
	  }
	};
	
	module.exports = OO;


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	
	/**
	 * Substance.Basics
	 * ----------------
	 * A collection of helpers pulled together from different sources, such as lodash.
	 *
	 * @module Basics
	 * @main Basics
	 */
	var Basics = {};
	
	_.extend(Basics, __webpack_require__(1));
	_.extend(Basics, __webpack_require__(2));
	Basics.OO = __webpack_require__(2);
	Basics.PathAdapter = __webpack_require__(21);
	Basics.EventEmitter = __webpack_require__(27);
	Basics.Error = __webpack_require__(119);
	Basics.Registry = __webpack_require__(34);
	Basics.Factory = __webpack_require__(120);
	_.extend(Basics, __webpack_require__(121));
	
	module.exports = Basics;


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var OO = __webpack_require__(2);
	var _ = __webpack_require__(1);
	
	var __id__ = 0;
	var _isDocumentElement;
	var _isInDocument;
	var VirtualTextNode;
	
	
	/**
	 * A light-weight component implementation inspired by React and Ember.
	 * In contrast to the large frameworks it does much less things automagically
	 * in favour of a simple and synchronous life-cyle.
	 *
	 * Features:
	 * - light-weight but simplified rerendering
	 * - minimalistic life-cycle with hooks
	 * - up-tree communication (send action)
	 * - dependency injection
	 *
	 * ## Concepts
	 *
	 * ### `props`
	 *
	 * Props are provided by a parent component. There is a set of built-in properties,
	 * such as `data` attributes or `classNames`.
	 * An initial set of properties is provided via constructor. After that, the parent
	 * component can call `setProps` to update these properties which triggers rerendering if the properties
	 * change.
	 *
	 * ### `state`
	 *
	 * The component state is a set of flags and values which are used to control how the component
	 * gets rendered give the current props.
	 * Using `setState` the component can change its internal state, which leads to a rerendering if the state
	 * changes.
	 *
	 * ### The `key` property
	 *
	 * A child component with a `key` id will be reused on rerender. All others will be wiped and rerender from scratch.
	 * If you want to preserve a grand-child (or lower), then make sure that all anchestors have a key id.
	 * After rendering the child will be accessible via `this.refs[key]`.
	 *
	 * ### Actions
	 *
	 * A component can send actions via `send` which are bubbled up through all parent components
	 * until one handles it.
	 * To register an action handler, a component must register like this
	 * ```
	 *   this.actions({
	 *     "open-modal": this.openModal,
	 *     "close-modal": this.closeModal
	 *   });
	 * ```
	 * which is typically done in the constructor.
	 */
	function Component(parent, params) {
	  if (!parent && parent !== "root") {
	    throw new Error("Contract: every component needs to have a parent.");
	  }
	
	  this.__id__ = __id__++;
	  params = params || {};
	
	  this.refs = {};
	
	  this.parent = parent;
	  this.children = [];
	
	  // get context from parent (dependency injection)
	  this.context = this._getContext();
	
	  this._key = params._key;
	  this._htmlProps = {
	    classNames: params.classNames || "",
	    attributes: params.attributes || {},
	    style: params.style || {},
	  };
	  this._setProps(params.props);
	
	  if (this.initialize) {
	    console.warn("Component.initialize() has been deprecated. Use Component.didInitialize() instead.");
	    this.initialize();
	  }
	  this.didInitialize();
	
	  this._setState(this.getInitialState());
	
	  this.actionHandlers = {};
	
	  this._data = {
	    attributes: {},
	    style: {},
	    handlers: {},
	    props: {},
	    children: []
	  };
	}
	
	Component.Prototype = function ComponentPrototype() {
	
	  this.getChildContext = function() {
	    return this.childContext || {};
	  };
	
	  this.didInitialize = function() {};
	
	  this.getInitialState = function() {
	    return {};
	  };
	
	  this.getParent = function() {
	    return this.parent;
	  };
	
	  /**
	   * Renders the component.
	   *
	   * Note: actually it does not create a DOM presentation directly
	   * but a virtual representation which is compiled into a DOM element.
	   */
	  this.render = function() {
	    return Component.$$('div');
	  };
	
	  this.shouldRerender = function(newProps, newState) {
	    /* jshint unused: false */
	    return !_.isEqual(newProps, this.props) || !_.isEqual(newState, this.state);
	  };
	
	  this.rerender = function() {
	    this._render(this.render());
	  };
	
	  /**
	   * Renders and appends this component to a given element.
	   *
	   * If the element is in the DOM already, triggers `component.didMount()`
	   * on this component and all of its children.
	   */
	  this.mount = function($el) {
	    this._render(this.render());
	    $el.append(this.$el);
	    // trigger didMount automatically if the given element is already in the DOM
	    if (_isInDocument($el[0])) {
	      this.triggerDidMount();
	    }
	    return this;
	  };
	
	  /**
	   * Triggers didMount handlers recursively.
	   *
	   * Gets called when using `component.mount(el)` on an element being
	   * in the DOM already. Typically this is done for a root component.
	   *
	   * If this is not possible because you want to do things differently, make sure
	   * you call 'component.triggerDidMount()' on root components.
	   *
	   * @example
	   * ```
	   * var frag = document.createDocumentFragment();
	   * var component = new MyComponent();
	   * component.mount(frag);
	   * ...
	   * $('body').append(frag);
	   * component.triggerDidMount();
	   * ```
	   */
	  this.triggerDidMount = function() {
	    this.didMount();
	    _.each(this.children, function(child) {
	      child.triggerDidMount();
	    });
	  };
	
	  /**
	   * Called when the element is inserted into the DOM.
	   *
	   * Node: make sure that you call `component.mount(el)` using an element
	   * which is already in the DOM.
	   *
	   * @example
	   * ```
	   * var component = new MyComponent();
	   * component.mount($('body')[0])
	   * ```
	   */
	  this.didMount = function() {};
	
	  /**
	   * Removes this component from its parent.
	   */
	  this.unmount = function() {
	    this.triggerWillUnmount();
	    this.$el.remove();
	    // TODO: do we need to remove this from parents children
	    // right now it feels like that it doesn't make a great difference
	    // because most often this method is called by the parent during rerendering
	    // and on other cases it would be gone after the next parent rerender.
	    return this;
	  };
	
	  this.isMounted = function() {
	    if (this.$el) {
	      return _isInDocument(this.$el[0]);
	    }
	    return false;
	  };
	
	  this.triggerWillUnmount = function() {
	    _.each(this.children, function(child) {
	      child.triggerWillUnmount();
	    });
	    this.willUnmount();
	  };
	
	  this.willUnmount = function() {
	    // console.log('Will unmount', this);
	  };
	
	  this.send = function(action) {
	    var comp = this;
	    while(comp) {
	      if (comp.actionHandlers[action]) {
	        return comp.actionHandlers[action].apply(comp, Array.prototype.slice.call(arguments, 1));
	      }
	      comp = comp.getParent();
	    }
	    throw new Error('No component handled action: ' + action);
	  };
	
	  this.actions = function(actions) {
	    _.each(actions, function(method, action) {
	      var handler = method.bind(this);
	      this.actionHandlers[action] = handler;
	    }, this);
	  };
	
	  this.setState = function(newState) {
	    var needRerender = this.shouldRerender(this.getProps(), newState);
	    this.willUpdateState(newState);
	    this._setState(newState);
	    this.didUpdateState();
	    if (needRerender) {
	      this.rerender();
	    }
	  };
	
	  this.extendState = function(newState) {
	    newState = _.extend({}, this.state, newState);
	    this.setState(newState);
	  };
	
	  this.getState = function() {
	    return this.state;
	  };
	
	  this.willUpdateState = function(newState) {
	    /* jshint unused: false */
	  };
	
	  this.didUpdateState = function() {};
	
	  this.setProps = function(newProps) {
	    var needRerender = this.shouldRerender(newProps, this.getState());
	    this.willReceiveProps(newProps);
	    this._setProps(newProps);
	    this.didReceiveProps();
	    if (needRerender) {
	      this.rerender();
	    }
	  };
	
	  this.getProps = function() {
	    return this.props;
	  };
	
	  this.willReceiveProps = function(newProps) {
	    /* jshint unused: false */
	  };
	
	  this.didReceiveProps = function() {};
	
	  /* API for incremental updates */
	
	  this.addClass = function(className) {
	    this._data.addClass(className);
	    if (this.$el) {
	      this.$el.addClass(className);
	    }
	    return this;
	  };
	
	  this.removeClass = function(className) {
	    this._data.removeClass(className);
	    if (this.$el) {
	      this.$el.removeClass(className);
	    }
	    return this;
	  };
	
	  this.toggleClass = function(className) {
	    this._data.toggleClass(className);
	    if (this.$el) {
	      this.$el.toggleClass(className);
	    }
	    return this;
	  };
	
	  this.attr = function() {
	    this._data.attr.apply(this._data, arguments);
	    if (this.$el) {
	      this.$el.attr.apply(this.$el, arguments);
	    }
	    return this;
	  };
	
	  this.removeAttr = function() {
	    this._data.removeAttr.apply(this._data, arguments);
	    if (this.$el) {
	      this.$el.removeAttr.apply(this.$el, arguments);
	    }
	    return this;
	  };
	
	  this.css = function(style) {
	    if (style) {
	      this._data.css(style);
	      this.$el.css(style);
	    }
	    return this;
	  };
	
	  this.append = function(child) {
	    var isMounted = this.isMounted();
	    var comp = this._compileComponent(child, {
	      refs: this.refs
	    });
	    this._data.append(child);
	    if (isMounted) comp.triggerDidMount();
	    this.$el.append(comp.$el);
	    this.children.push(comp);
	    return this;
	  };
	
	  this.insertAt = function(pos, child) {
	    var isMounted = this.isMounted();
	    var comp = this._compileComponent(child, {
	      refs: this.refs
	    });
	    this._data.insertAt(pos, child);
	    if (isMounted) comp.triggerDidMount();
	    comp.$el.insertBefore(this.children[pos].$el);
	    this.children.splice(pos, 0, comp);
	    return this;
	  };
	
	  this.removeAt = function(pos) {
	    this._data.removeAt(pos);
	    this.children[pos].unmount();
	    return this;
	  };
	
	  this.empty = function() {
	    this._data.children = [];
	    this.$el.empty();
	    for (var i = 0; i < this.children.length; i++) {
	      this.children[i].unmount();
	    }
	    return this;
	  };
	
	  /* Internal API */
	
	  var _indexByKey = function(children) {
	    var index = {};
	    for (var i = 0; i < children.length; i++) {
	      var child = children[i];
	      var key = child._key;
	      if (key) {
	        index[key] = child;
	      }
	    }
	    return index;
	  };
	
	  this._createElement = function(data, scope) {
	    var $el = $('<' + data.tagName + '>');
	    $el.addClass(this._htmlProps.classNames);
	    $el.addClass(data.classNames);
	    $el.attr(this._htmlProps.attributes);
	    $el.attr(data.attributes);
	    $el.css(this._htmlProps.style);
	    if(data.style) {
	      $el.css(data.style);
	    }
	    _.each(data.handlers, function(handler, event) {
	      // console.log('Binding to', event, 'in', scope.owner);
	      $el.on(event, handler.bind(scope.owner));
	    }, this);
	    return $el;
	  };
	
	  this._updateElement = function(data, oldData, scope) {
	    var $el = this.$el;
	    var oldClassNames = oldData.classNames;
	    var newClassNames = data.classNames;
	    if (oldClassNames !== newClassNames) {
	      $el.removeClass(oldClassNames);
	      $el.addClass(newClassNames);
	    }
	    var oldAttributes = oldData.attributes;
	    var newAttributes = data.attributes;
	    // TODO: this could be done more incrementally by using difference
	    if (!_.isEqual(oldAttributes, newAttributes)) {
	      var oldAttrNames = Object.keys(oldAttributes);
	      $el.removeAttr(oldAttrNames.join(" "));
	      $el.attr(newAttributes);
	    }
	    // css styles must be overwritten explicitly (there is no '$.removeCss')
	    if (!_.isEqual(oldData.style, data.style)) {
	      if (data.style) {
	        $el.css(data.style);
	      }
	    }
	    if (!_.isEqual(oldData.handlers, data.handlers)) {
	      _.each(oldData.handlers, function(handler, event) {
	        $el.off(event);
	      });
	      _.each(data.handlers, function(handler, event) {
	        $el.on(event, handler.bind(scope.owner));
	      }, this);
	    }
	    return $el;
	  };
	
	  this._render = function(data, scope) {
	    if (data.type !== 'element') {
	      if (data instanceof $) {
	        throw new Error("Your render() method accidently return a jQuery instance instead of a VirtualComponent created $$.");
	      }
	      throw new Error("Component.render() must return one html element: e.g., $$('div')");
	    }
	    if (!scope) {
	      scope = {
	        owner: this,
	        refs: {}
	      };
	    }
	    var oldData = this._data;
	    // the first time we need to create the component element
	    if (!this.$el) {
	      this.$el = this._createElement(data, scope);
	    } else {
	      // update the element
	      this._updateElement(data, oldData, scope);
	    }
	    // TODO: we can enable this simplification when the general implementation
	    // is stable
	    if (this._simple_) {
	      this._renderSimple(data, scope);
	      return;
	    }
	
	    var el = this.$el[0];
	    var isMounted = _isInDocument(el);
	
	    var oldContent = oldData.children;
	    var newContent = data.children;
	
	    if (_.isEqual(oldContent, newContent)) {
	      // console.log('-----');
	      this._data = data;
	      return;
	    }
	
	    var oldComps = _indexByKey(oldData.children, "old");
	    var newComps = _indexByKey(data.children);
	
	    var pos = 0;
	    var oldPos = 0;
	    var newPos = 0;
	
	    var oldChildren = this.children;
	    var children = [];
	
	    function _replace(oldComp, newComp) {
	      oldComp.triggerWillUnmount();
	      oldComp.$el.replaceWith(newComp.$el[0]);
	    }
	
	    function _update(comp, data) {
	      if (comp instanceof Component.Container) {
	        comp._render(data);
	      } else {
	        // TODO: we probably need to propagate updates for attr, style, handlers, too
	        comp.setProps(data.props);
	      }
	    }
	
	    // step through old and new content data (~virtual DOM)
	    // and apply changes to the component element
	    while(oldPos < oldContent.length || newPos < newContent.length) {
	      var node = el.childNodes[pos];
	      var _old = oldContent[oldPos];
	      var _new = newContent[newPos];
	      var comp = null;
	      var oldComp = oldChildren[oldPos];
	
	      // append remaining new components if there is no old one left
	      if (!_old) {
	        for (var i = newPos; i < newContent.length; i++) {
	          comp = this._compileComponent(newContent[i], scope);
	          if (isMounted) comp.triggerDidMount();
	          this.$el.append(comp.$el);
	          children.push(comp);
	        }
	        break;
	      }
	      // unmount remaining old components if there is no old one left
	      if (!_new) {
	        for (var j = oldPos; j < oldContent.length; j++) {
	          oldChildren[j].unmount();
	        }
	        break;
	      }
	
	      // otherwise do a differential update
	      if (node !== oldComp.$el[0]) {
	        throw new Error('Assertion failed: DOM structure is not as expected.');
	      }
	
	      // Note: if the key property is set the component is treated preservatively
	      var newKey = _new._key;
	      var oldKey = _old._key;
	      if (oldKey && newKey) {
	        // the component is in the right place already
	        if (oldKey === newKey) {
	          comp = oldComp;
	          _update(comp, _new);
	          pos++; oldPos++; newPos++;
	        }
	        // a new component has been inserted
	        else if (!oldComps[newKey] && newComps[oldKey]) {
	          comp = this._compileComponent(_new, scope);
	          comp.$el.insertBefore(node);
	          if (isMounted) comp.triggerDidMount();
	          pos++; newPos++;
	        }
	        // old component has been replaced
	        else if (!oldComps[newKey] && !newComps[oldKey]) {
	          comp = this._compileComponent(_new, scope);
	          _replace(oldComp, comp);
	          if (isMounted) comp.triggerDidMount();
	          pos++; newPos++; oldPos++;
	        }
	        // a component has been removed
	        else if (oldComps[newKey] && !newComps[oldKey]) {
	          oldComp.unmount();
	          oldPos++;
	          // continueing as we did not insert a component
	          continue;
	        }
	        // component has been moved to a different position
	        else if (oldComps[newKey] && newComps[oldKey]) {
	          throw new Error('Swapping positions of persisted components not supported!');
	        }
	        else {
	          throw new Error('Assertion failed: should not reach this statement.');
	        }
	      } else if (newKey) {
	        if (oldComps[newKey]) {
	          oldComp.unmount();
	          oldPos++;
	          // continueing as we did not insert a component
	          continue;
	        }
	        else {
	          comp = this._compileComponent(_new, scope);
	          _replace(oldComp, comp);
	          if (isMounted) comp.triggerDidMount();
	          pos++; oldPos++; newPos++;
	        }
	      } else if (oldKey) {
	        comp = this._compileComponent(_new, scope);
	        if (newComps[oldKey]) {
	          comp.$el.insertBefore(node);
	        } else {
	          _replace(oldComp, comp);
	          oldPos++;
	        }
	        if (isMounted) comp.triggerDidMount();
	        pos++; newPos++;
	      } else {
	        // do not replace text components if they are equal
	        if (_new.type === "text" && _old.type === "text" && _new.props.text === _old.props.text) {
	          // skip
	          comp = oldComp;
	        } else {
	          comp = this._compileComponent(_new, scope);
	          _replace(oldComp, comp);
	          if (isMounted) comp.triggerDidMount();
	        }
	        pos++; oldPos++; newPos++;
	      }
	      if (comp._key) {
	        scope.refs[comp._key] = comp;
	      }
	      children.push(comp);
	    }
	
	    if (Object.keys(scope.refs).length > 0) {
	      delete this._simple_;
	    } else {
	      this._simple_ = true;
	    }
	
	    this.children = children;
	    this.refs = _.clone(scope.refs);
	    this._data = data;
	  };
	
	  this._renderSimple = function(data, scope) {
	    for (var i = 0; i < this.children.length; i++) {
	      this.children[i].unmount();
	    }
	    var isMounted = _isInDocument(this.$el[0]);
	    var children = [];
	    for (var j = 0; j < data.children.length; j++) {
	      var comp = this._compileComponent(data.children[j], scope);
	      if (isMounted) comp.triggerDidMount();
	      this.$el.append(comp.$el);
	      children.push(comp);
	    }
	    if (Object.keys(scope.refs).length > 0) {
	      delete this._simple_;
	    } else {
	      this._simple_ = true;
	    }
	    this.refs = scope.refs;
	    this.children = children;
	    this._data = data;
	  };
	
	  this._compileComponent = function(data, scope) {
	    var component;
	    switch(data.type) {
	      case 'text':
	        component = new Component.Text(this, data.props.text);
	        component._render();
	        break;
	      case 'element':
	        component = new Component.HtmlElement(this, data.tagName, data);
	        component._render(data, scope);
	        break;
	      case 'component':
	        component = new data.ComponentClass(this, data);
	        // TODO: we have a problem here: basically this is the place
	        // where we descend into a child component implementation.
	        // The component's render implementation would expect e.g. that handlers are
	        // bound to it, and also refs created within that component.
	        // However, it is also possible to provide children via append,
	        // in the parent component's render method. Those handlers should be bound
	        // to the parent. The same for refs.
	        // To solve this, $$ would need to be contextified, which is quite ugly.
	        component._render(component.render());
	        break;
	      default:
	        throw new Error('Illegal state.');
	    }
	    if (data._key) {
	      scope.refs[data._key] = component;
	    }
	    return component;
	  };
	
	  this._getContext = function() {
	    var parent = this.getParent();
	    var parentContext = parent.context || {};
	    if (parent.getChildContext) {
	      return _.extend(parentContext, parent.getChildContext());
	    } else {
	      return parentContext;
	    }
	  };
	
	  this._setProps = function(props) {
	    this.props = props || {};
	
	    // freezing state to 'enforce' immutability
	    Object.freeze(this.props);
	  };
	
	  this._setState = function(state) {
	    this.state = state || {};
	    // freezing state to 'enforce' immutability
	    Object.freeze(this.state);
	  };
	
	};
	
	OO.initClass(Component);
	
	/* Built-in components */
	
	Component.Root = function(params) {
	  Component.call(this, "root", params);
	};
	OO.inherit(Component.Root, Component);
	
	Component.Container = function(parent, params) {
	  Component.call(this, parent, params);
	};
	Component.Container.Prototype = function() {
	};
	OO.inherit(Component.Container, Component);
	
	Component.HtmlElement = function(parent, tagName, params) {
	  this.tagName = tagName;
	  Component.Container.call(this, parent, params);
	};
	
	OO.inherit(Component.HtmlElement, Component.Container);
	
	Component.Text = function(parent, text) {
	  Component.call(this, parent);
	  this.text = text;
	};
	
	Component.Text.Prototype = function() {
	  this._render = function() {
	    if (!this.$el) {
	      var el = document.createTextNode(this.text);
	      this.$el = $(el);
	    } else {
	      this.$el[0].textContent = this.text;
	    }
	  };
	};
	
	OO.inherit(Component.Text, Component);
	
	/* Virtual Components */
	
	function VirtualNode() {
	  this.attributes = {};
	  this.style = {};
	  this.handlers = {};
	  this.props = {};
	  this.children = [];
	}
	
	VirtualNode.Prototype = function() {
	  this.key = function(key) {
	    this._key = key;
	    return this;
	  };
	  this.append = function(/* ...children */) {
	    var children;
	    var _children = this._getChildren();
	    if (arguments.length === 1) {
	      var child = arguments[0];
	      if (!child) {
	        return this;
	      }
	      if (_.isArray(child)) {
	        children = child;
	        Component.$$.prepareChildren(children);
	        Array.prototype.push.apply(_children, children);
	      } else if (_.isString(child)) {
	        _children.push(new VirtualTextNode(child));
	      } else {
	        _children.push(child);
	      }
	    } else {
	      children = Array.prototype.slice.call(arguments,0);
	      Component.$$.prepareChildren(children);
	      Array.prototype.push.apply(_children, children);
	    }
	    return this;
	  };
	  this._getChildren = function() {
	    return this.children;
	  };
	  this.insertAt = function(pos, child) {
	    this.children.splice(pos, 0, child);
	    return this;
	  };
	  this.removeAt = function(pos) {
	    this.children.splice(pos, 1);
	    return this;
	  };
	  this.addClass = function(className) {
	    if (!this.classNames) {
	      this.classNames = "";
	    }
	    this.classNames += " " + className;
	    return this;
	  };
	  this.removeClass = function(className) {
	    var classes = this.classNames.split(/\s+/);
	    classes = _.without(classes, className);
	    this.classNames = classes.join(' ');
	    return this;
	  };
	  this.toggleClass = function(className) {
	    var classes = this.classNames.split(/\s+/);
	    if (classes.indexOf(className) >= 0) {
	      classes = _.without(classes, className);
	    } else {
	      classes.push(className);
	    }
	    this.classNames = classes.join(' ');
	    return this;
	  };
	  this.addProps = function(props) {
	    _.extend(this.props, props);
	    return this;
	  };
	  this.attr = function(attr) {
	    if (arguments.length === 2) {
	      this.attributes[arguments[0]] = arguments[1];
	    } else {
	      // TODO we could treat HTML attributes as special props
	      // then we do need to fish attributes from custom props
	      _.extend(this.attributes, attr);
	    }
	    return this;
	  };
	  this.removeAttr = function(attr) {
	    if (_.isString(attr)) {
	      delete this.attributes[attr];
	    } else {
	      this.attributes = _.omit(this.attributes, attr);
	    }
	    return this;
	  };
	  this.on = function(event, handler) {
	    if (arguments.length !== 2 || !_.isString(event) || !_.isFunction(handler)) {
	      throw new Error('Illegal arguments for $$.on(event, handler).');
	    }
	    this.handlers[event] = handler;
	    return this;
	  };
	  this.css = function(style) {
	    if (!this.style) {
	      this.style = {};
	    }
	    _.extend(this.style, style);
	    return this;
	  };
	};
	
	OO.initClass(VirtualNode);
	
	function VirtualElement(tagName) {
	  VirtualNode.call(this);
	  this.type = 'element';
	  this.tagName = tagName;
	}
	OO.inherit(VirtualElement, VirtualNode);
	
	function VirtualComponent(ComponentClass) {
	  VirtualNode.call(this);
	  this.type = 'component';
	  this.ComponentClass = ComponentClass;
	}
	VirtualComponent.Prototype = function() {
	  // Note: for VirtualComponents we put children into props
	  // so that the render method of ComponentClass can place it.
	  this._getChildren = function() {
	    if (!this.props.children) {
	      this.props.children = [];
	    }
	    return this.props.children;
	  };
	};
	OO.inherit(VirtualComponent, VirtualNode);
	
	VirtualTextNode = function VirtualTextNode(text) {
	  VirtualNode.call(this);
	  this.type = 'text';
	  this.props = { text: text };
	};
	
	Component.$$ = function() {
	  var content = null;
	  if (_.isString(arguments[0])) {
	    if (arguments.length !== 1) {
	      throw new Error('Illegal usage of Component.$$.');
	    }
	    content = new VirtualElement(arguments[0]);
	  } else if (_.isFunction(arguments[0]) && arguments[0].prototype instanceof Component) {
	    if (arguments.length < 1 || arguments.length > 2) {
	      throw new Error('Illegal usage of Component.$$.');
	    }
	    content = new VirtualComponent(arguments[0]);
	    // EXPERIMENTAL: to reduce boilerplate, we want to allow to specifiy props as 2nd argument of $$
	    if (arguments.length === 2) {
	      content.addProps(arguments[1]);
	    }
	  } else {
	    throw new Error('Illegal usage of Component.$$.');
	  }
	  return content;
	};
	
	Component.$$.prepareChildren = function(children) {
	  for (var i = 0; i < children.length; i++) {
	    if(_.isString(children[i])) {
	      children[i] = new VirtualTextNode(children[i]);
	    }
	  }
	};
	
	_isDocumentElement = function(el) {
	  // Node.DOCUMENT_NODE = 9
	  return (el.nodeType === 9);
	};
	
	_isInDocument = function(el) {
	  while(el) {
	    if (_isDocumentElement(el)) {
	      return true;
	    }
	    el = el.parentNode;
	  }
	  return false;
	};
	
	Component.mount = function(data, $el) {
	  var component;
	  var scope = {
	    context: null,
	    refs: {}
	  };
	  switch(data.type) {
	    case 'text':
	      component = new Component.Text("root", data.props.text);
	      component._render();
	      break;
	    case 'element':
	      component = new Component.HtmlElement("root", data.tagName, data);
	      component._render(data, scope);
	      break;
	    case 'component':
	      component = new data.ComponentClass("root", data);
	      component._render(component.render());
	      break;
	    default:
	      throw new Error('Illegal state.');
	  }
	  // TODO: some code replication of Component.prototype.mount()
	  // however, we do not want to rerender right-away
	  $el.append(component.$el);
	  if (_isInDocument($el[0])) {
	    component.triggerDidMount();
	  }
	  return component;
	};
	
	Component.VirtualTextNode = VirtualTextNode;
	
	module.exports = Component;


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(7),
	    isNative = __webpack_require__(11),
	    isObjectLike = __webpack_require__(12);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the `toStringTag` of values.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * for more details.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = isNative(nativeIsArray = Array.isArray) && nativeIsArray;
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return (isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag) || false;
	};
	
	module.exports = isArray;


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var Data = __webpack_require__(13);
	
	var Node = Data.Node.extend({
	  displayName: "DocumentNode",
	  name: "node",
	
	  attach: function(document) {
	    this.document = document;
	    this.didAttach(document);
	  },
	
	  detach: function() {
	    var doc = this.document;
	    _.each(this.constructor.schema, function(type, propertyName) {
	      doc.getEventProxy('path').remove([this.id, propertyName], this);
	    });
	    this.document = null;
	    this.didDetach(doc);
	  },
	
	  didAttach: function() {},
	
	  didDetach: function() {},
	
	  isAttached: function() {
	    return this.document !== null;
	  },
	
	  getDocument: function() {
	    return this.document;
	  },
	
	  hasParent: function() {
	    return !!this.parent;
	  },
	
	  getParent: function() {
	    return this.document.get(this.parent);
	  },
	
	  getRoot: function() {
	    var node = this;
	    while (node.hasParent()) {
	      node = node.getParent();
	    }
	    return node;
	  },
	
	  getComponents: function() {
	    var componentNames = this.constructor.static.components || [];
	    if (componentNames.length === 0) {
	      console.warn('Contract: a node must define its editable properties.', this.constructor.static.name);
	    }
	    return componentNames;
	  },
	
	  isExternal: function() {
	    return this.constructor.static.external;
	  },
	
	  // Note: children are provided for inline nodes only.
	  toHtml: function(converter, children) {
	    return this.constructor.static.toHtml(this, converter, children);
	  },
	
	  connect: function(ctx, handlers) {
	    _.each(handlers, function(func, name) {
	      var match = /([a-zA-Z_0-9]+):changed/.exec(name);
	      if (match) {
	        var propertyName = match[1];
	        if (this.constructor.static.schema[propertyName]) {
	          this.getDocument().getEventProxy('path').add([this.id, propertyName], this, this._onPropertyChange.bind(this, propertyName));
	        }
	      }
	    });
	    Data.Node.prototype.connect.apply(this, arguments);
	  },
	
	  disconnect: function() {
	    // TODO: right now do not unregister from the event proxy
	    // when there is no property listener left
	    // We would need to implement disconnect
	    Data.Node.prototype.disconnect.apply(this, arguments);
	  },
	
	  _onPropertyChange: function(propertyName) {
	    var args = [propertyName + ':changed']
	      .concat(Array.prototype.slice.call(arguments, 1));
	    this.emit.apply(this, args);
	  },
	
	});
	
	Node.initNodeClass = Data.Node.initNodeClass;
	
	// default HTML serialization
	Node.static.toHtml = function(node, converter) {
	  var $el = $('<div itemscope>')
	    .attr('data-id', node.id)
	    .attr('data-type', node.type);
	  _.each(node.properties, function(value, name) {
	    var $prop = $('<div>').attr('itemprop', name);
	    if (node.getPropertyType === 'string') {
	      $prop[0].appendChild(converter.annotatedText([node.id, name]));
	    } else {
	      $prop.text(value);
	    }
	    $el.append($prop);
	  });
	  return $el;
	};
	
	Node.static.external = false;
	
	module.exports = Node;


/***/ },
/* 7 */
/***/ function(module, exports) {

	/**
	 * Used as the maximum length of an array-like value.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * for more details.
	 */
	var MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on ES `ToLength`. See the
	 * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
	 * for more details.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 8 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the language type of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * **Note:** See the [ES5 spec](https://es5.github.io/#x8) for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return type == 'function' || (value && type == 'object') || false;
	}
	
	module.exports = isObject;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var Substance = __webpack_require__(3);
	
	function Tool(context) {
	  Substance.EventEmitter.call(this);
	
	  this.context = context;
	
	  this.state = {
	    // we disable tools by default
	    disabled: true,
	    // if the tool is turned on / toggled on
	    active: false
	  };
	}
	
	Tool.Prototype = function() {
	
	  this.needsEnabledSurface = true;
	
	  this.getName = function() {
	    return this.constructor.static.name;
	  };
	
	  this.getSurface = function() {
	    return this.surface;
	  };
	
	  this.getDocument = function() {
	    var surface = this.getSurface();
	    if (surface) {
	      return surface.getDocument();
	    }
	  };
	
	  this.getContainer = function() {
	    var surface = this.getSurface();
	    if (surface) {
	      return surface.getContainer();
	    }
	  };
	
	  this.setToolState = function(newState) {
	    var oldState = this.state;
	    this.state = newState;
	    this.emit('toolstate:changed', newState, this, oldState);
	  };
	
	  this.getToolState = function() {
	    return this.state;
	  };
	
	  this.isEnabled = function() {
	    return !this.state.disabled;
	  };
	
	  this.isDisabled = function() {
	    return this.state.disabled;
	  };
	
	  this.setEnabled = function() {
	    this.setToolState({
	      disabled: false,
	      active: false
	    });
	  };
	
	  this.setDisabled = function() {
	    this.setToolState({
	      disabled: true,
	      active: false
	    });
	  };
	
	  this.disableTool = function() {
	    console.error('DEPRECATED: use tool.setDisabled()');
	    this.setDisabled();
	  };
	
	  this.setSelected = function() {
	    this.setToolState({
	      disabled: false,
	      active: true
	    });
	  };
	
	  /* jshint unused:false */
	  this.update = function(surface, sel) {
	    this.surface = surface;
	    if (this.needsEnabledSurface && !surface.isEnabled()) {
	      return this.setDisabled();
	    }
	  };
	
	  //legacy TODO fixme
	  this.updateToolState = function(sel, surface) {
	    return this.update(surface, sel);
	  };
	};
	
	Substance.inherit(Tool, Substance.EventEmitter);
	
	module.exports = Tool;


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	
	// A collection of methods to update annotations
	// --------
	//
	// As we treat annotations as overlay of plain text we need to keep them up-to-date during editing.
	
	var insertedText = function(doc, coordinate, length) {
	  if (!length) return;
	  var index = doc.getIndex('annotations');
	  var annotations = index.get(coordinate.path);
	  _.each(annotations, function(anno) {
	    var pos = coordinate.offset;
	    var start = anno.startOffset;
	    var end = anno.endOffset;
	    var newStart = start;
	    var newEnd = end;
	    if ( (pos < start) ||
	         (pos === start) ) {
	      newStart += length;
	    }
	    // Node: external nodes do not expand automatically
	    if ( (pos < end) ||
	         (pos === end && !anno.isExternal()) ) {
	      newEnd += length;
	    }
	    if (newStart !== start) {
	      doc.set([anno.id, 'startOffset'], newStart);
	    }
	    if (newEnd !== end) {
	      doc.set([anno.id, 'endOffset'], newEnd);
	    }
	  });
	  // same for container annotation anchors
	  index = doc.getIndex('container-annotation-anchors');
	  var anchors = index.get(coordinate.path);
	  _.each(anchors, function(anchor) {
	    var pos = coordinate.offset;
	    var start = anchor.offset;
	    var changed = false;
	    if ( (pos < start) ||
	         (pos === start && !coordinate.after) ) {
	      start += length;
	      changed = true;
	    }
	    if (changed) {
	      var property = (anchor.isStart?'startOffset':'endOffset');
	      doc.set([anchor.id, property], start);
	    }
	  });
	};
	
	var deletedText = function(doc, path, startOffset, endOffset) {
	  if (startOffset === endOffset) return;
	  var index = doc.getIndex('annotations');
	  var annotations = index.get(path);
	  var length = endOffset - startOffset;
	  _.each(annotations, function(anno) {
	    var pos1 = startOffset;
	    var pos2 = endOffset;
	    var start = anno.startOffset;
	    var end = anno.endOffset;
	    var newStart = start;
	    var newEnd = end;
	    if (pos2 <= start) {
	      newStart -= length;
	      newEnd -= length;
	      doc.set([anno.id, 'startOffset'], newStart);
	      doc.set([anno.id, 'endOffset'], newEnd);
	    } else {
	      if (pos1 <= start) {
	        newStart = start - Math.min(pos2-pos1, start-pos1);
	      }
	      if (pos1 <= end) {
	        newEnd = end - Math.min(pos2-pos1, end-pos1);
	      }
	      // delete the annotation if it has collapsed by this delete
	      if (start !== end && newStart === newEnd) {
	        doc.delete(anno.id);
	      } else {
	        if (start !== newStart) {
	          doc.set([anno.id, 'startOffset'], newStart);
	        }
	        if (end !== newEnd) {
	          doc.set([anno.id, 'endOffset'], newEnd);
	        }
	      }
	    }
	  });
	  // same for container annotation anchors
	  index = doc.getIndex('container-annotation-anchors');
	  var anchors = index.get(path);
	  var containerAnnoIds = [];
	  _.each(anchors, function(anchor) {
	    containerAnnoIds.push(anchor.id);
	    var pos1 = startOffset;
	    var pos2 = endOffset;
	    var start = anchor.offset;
	    var changed = false;
	    if (pos2 <= start) {
	      start -= length;
	      changed = true;
	    } else {
	      if (pos1 <= start) {
	        var newStart = start - Math.min(pos2-pos1, start-pos1);
	        if (start !== newStart) {
	          start = newStart;
	          changed = true;
	        }
	      }
	    }
	    if (changed) {
	      var property = (anchor.isStart?'startOffset':'endOffset');
	      doc.set([anchor.id, property], start);
	    }
	  });
	  // check all anchors after that if they have collapsed and remove the annotation in that case
	  _.each(_.uniq(containerAnnoIds), function(id) {
	    var anno = doc.get(id);
	    var annoSel = anno.getSelection();
	    if(annoSel.isCollapsed()) {
	      console.log("...deleting container annotation because it has collapsed" + id);
	      doc.delete(id);
	    }
	  });
	};
	
	// used when breaking a node to transfer annotations to the new property
	var transferAnnotations = function(doc, path, offset, newPath, newOffset) {
	  var index = doc.getIndex('annotations');
	  var annotations = index.get(path, offset);
	  _.each(annotations, function(a) {
	    var isInside = (offset > a.startOffset && offset < a.endOffset);
	    var start = a.startOffset;
	    var end = a.endOffset;
	    var newStart, newEnd;
	    // 1. if the cursor is inside an annotation it gets either split or truncated
	    if (isInside) {
	      // create a new annotation if the annotation is splittable
	      if (a.canSplit()) {
	        var newAnno = _.clone(a.properties);
	        newAnno.id = _.uuid(a.type + "_");
	        newAnno.startOffset = newOffset;
	        newAnno.endOffset = newOffset + a.endOffset - offset;
	        newAnno.path = newPath;
	        doc.create(newAnno);
	      }
	      // in either cases truncate the first part
	      newStart = a.startOffset;
	      newEnd = offset;
	      // if after truncate the anno is empty, delete it
	      if (newEnd === newStart) {
	        doc.delete(a.id);
	      }
	      // ... otherwise update the range
	      else {
	        if (newStart !== start) {
	          doc.set([a.id, "startOffset"], newStart);
	        }
	        if (newEnd !== end) {
	          doc.set([a.id, "endOffset"], newEnd);
	        }
	      }
	    }
	    // 2. if the cursor is before an annotation then simply transfer the annotation to the new node
	    else if (a.startOffset >= offset) {
	      // Note: we are preserving the annotation so that anything which is connected to the annotation
	      // remains valid.
	      newStart = newOffset + a.startOffset - offset;
	      newEnd = newOffset + a.endOffset - offset;
	      doc.set([a.id, "path"], newPath);
	      doc.set([a.id, "startOffset"], newStart);
	      doc.set([a.id, "endOffset"], newEnd);
	    }
	  });
	  // same for container annotation anchors
	  index = doc.getIndex('container-annotation-anchors');
	  var anchors = index.get(path);
	  var containerAnnoIds = [];
	  _.each(anchors, function(anchor) {
	    containerAnnoIds.push(anchor.id);
	    var start = anchor.offset;
	    if (offset <= start) {
	      var pathProperty = (anchor.isStart?'startPath':'endPath');
	      var offsetProperty = (anchor.isStart?'startOffset':'endOffset');
	      doc.set([anchor.id, pathProperty], newPath);
	      doc.set([anchor.id, offsetProperty], newOffset + anchor.offset - offset);
	    }
	  });
	  // check all anchors after that if they have collapsed and remove the annotation in that case
	  _.each(_.uniq(containerAnnoIds), function(id) {
	    var anno = doc.get(id);
	    var annoSel = anno.getSelection();
	    if(annoSel.isCollapsed()) {
	      console.log("...deleting container annotation because it has collapsed" + id);
	      doc.delete(id);
	    }
	  });
	};
	
	module.exports = {
	  insertedText: insertedText,
	  deletedText: deletedText,
	  transferAnnotations: transferAnnotations
	};


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var escapeRegExp = __webpack_require__(226),
	    isObjectLike = __webpack_require__(12);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/**
	 * Used to resolve the `toStringTag` of values.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * for more details.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reNative = RegExp('^' +
	  escapeRegExp(objToString)
	  .replace(/toString|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (objToString.call(value) == funcTag) {
	    return reNative.test(fnToString.call(value));
	  }
	  return (isObjectLike(value) && reHostCtor.test(value)) || false;
	}
	
	module.exports = isNative;


/***/ },
/* 12 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return (value && typeof value == 'object') || false;
	}
	
	module.exports = isObjectLike;


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Substance.Data
	 * --------------
	 * Provides a data model with a simple CRUD style manuipulation API,
	 * support for OT based incremental manipulations, etc.
	 *
	 * @module Data
	 * @main Data
	 */
	
	var Data = __webpack_require__(65);
	
	Data.Incremental = __webpack_require__(122);
	Data.Node = __webpack_require__(36);
	Data.Schema = __webpack_require__(125);
	Data.Index = __webpack_require__(124);
	
	module.exports = Data;


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(185),
	    baseMatchesProperty = __webpack_require__(186),
	    baseProperty = __webpack_require__(87),
	    bindCallback = __webpack_require__(15),
	    identity = __webpack_require__(58),
	    isBindable = __webpack_require__(206);
	
	/**
	 * The base implementation of `_.callback` which supports specifying the
	 * number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function baseCallback(func, thisArg, argCount) {
	  var type = typeof func;
	  if (type == 'function') {
	    return (typeof thisArg != 'undefined' && isBindable(func))
	      ? bindCallback(func, thisArg, argCount)
	      : func;
	  }
	  if (func == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return baseMatches(func);
	  }
	  return typeof thisArg == 'undefined'
	    ? baseProperty(func + '')
	    : baseMatchesProperty(func + '', thisArg);
	}
	
	module.exports = baseCallback;


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(58);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (typeof thisArg == 'undefined') {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(7),
	    isNative = __webpack_require__(11),
	    isObject = __webpack_require__(8),
	    shimKeys = __webpack_require__(212);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = isNative(nativeKeys = Object.keys) && nativeKeys;
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  if (object) {
	    var Ctor = object.constructor,
	        length = object.length;
	  }
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	     (typeof object != 'function' && (length && isLength(length)))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	module.exports = keys;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Substance = __webpack_require__(3);
	var Node = __webpack_require__(6);
	
	// Annotation
	// --------
	//
	// An annotation can be used to overlay text and give it a special meaning.
	// Annotations only work on text properties. If you want to annotate multiple
	// nodes you have to use a ContainerAnnotation.
	//
	// Properties:
	//   - path: Identifies a text property in the document (e.g. ["text_1", "content"])
	//   - startOffset: the character where the annoation starts
	//   - endOffset: the character where the annoation starts
	
	// TODO: in current terminology this is a PropertyAnnotation
	var Annotation = Node.extend({
	  displayName: "Annotation",
	  name: "annotation",
	
	  properties: {
	    path: ['array', 'string'],
	    startOffset: 'number',
	    endOffset: 'number'
	  },
	
	  canSplit: function() {
	    return true;
	  },
	
	  getSelection: function() {
	    return this.getDocument().createSelection({
	      type: 'property',
	      path: this.path,
	      startOffset: this.startOffset,
	      endOffset: this.endOffset
	    });
	  },
	
	  updateRange: function(tx, sel) {
	    if (!sel.isPropertySelection()) {
	      throw new Error('Cannot change to ContainerAnnotation.');
	    }
	    if (!Substance.isEqual(this.startPath, sel.start.path)) {
	      tx.set([this.id, 'path'], sel.start.path);
	    }
	    if (this.startOffset !== sel.start.offset) {
	      tx.set([this.id, 'startOffset'], sel.start.offset);
	    }
	    if (this.endOffset !== sel.end.offset) {
	      tx.set([this.id, 'endOffset'], sel.end.offset);
	    }
	  },
	
	  getText: function() {
	    var doc = this.getDocument();
	    if (!doc) {
	      console.warn('Trying to use an Annotation which is not attached to the document.');
	      return "";
	    }
	    var text = doc.get(this.path);
	    return text.substring(this.startOffset, this.endOffset);
	  },
	
	  // volatile property necessary to render highlighted annotations differently
	  setActive: function(val) {
	    if (this.active !== val) {
	      this.active = val;
	      this.emit('active', val);
	    }
	  },
	
	});
	
	Annotation.static.isInline = true;
	
	// default implementation for inline elements
	// Attention: there is a difference between the implementation
	// of toHtml for annotations and general nodes.
	// Annotations are modeled as overlays, so they do not 'own' their content.
	// Thus, during conversion HtmlExporter serves the content as a prepared
	// array of children element which just need to be wrapped (or can be manipulated).
	Annotation.static.toHtml = function(anno, converter, children) {
	  var id = anno.id;
	  var tagName = anno.constructor.static.tagName || 'span';
	  var $el = $('<' + tagName + '>')
	    .attr('id', id)
	    .append(children);
	  return $el;
	};
	
	Object.defineProperties(Annotation.prototype, {
	  startPath: {
	    get: function() {
	      return this.path;
	    }
	  },
	  endPath: {
	    get: function() {
	      return this.path;
	    }
	  }
	});
	
	module.exports = Annotation;


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Document = __webpack_require__(129);
	
	Document.Schema = __webpack_require__(131);
	
	Document.Node = __webpack_require__(6);
	Document.Annotation = __webpack_require__(17);
	Document.Container = __webpack_require__(68);
	Document.ContainerAnnotation = __webpack_require__(22);
	Document.TextNode = __webpack_require__(23);
	
	Document.Coordinate = __webpack_require__(39);
	Document.Range = __webpack_require__(41);
	Document.Selection = __webpack_require__(19);
	Document.nullSelection = Document.Selection.nullSelection;
	Document.PropertySelection = __webpack_require__(40);
	Document.ContainerSelection = __webpack_require__(69);
	Document.TableSelection = __webpack_require__(74);
	
	Document.Annotator = __webpack_require__(37);
	Document.AnnotationUpdates = __webpack_require__(10);
	
	Document.HtmlImporter = __webpack_require__(71);
	Document.HtmlExporter = __webpack_require__(70);
	Document.ClipboardImporter = __webpack_require__(38);
	Document.ClipboardExporter = __webpack_require__(67);
	
	// Standard node implementations
	Document.Include = __webpack_require__(137);
	Document.Paragraph = __webpack_require__(139);
	Document.Codeblock = __webpack_require__(134);
	Document.Blockquote = __webpack_require__(133);
	Document.Heading = __webpack_require__(136);
	Document.Emphasis = __webpack_require__(135);
	Document.Strong = __webpack_require__(140);
	Document.Link = __webpack_require__(138);
	Document.Table = __webpack_require__(141);
	Document.TableSection = __webpack_require__(145);
	Document.TableRow = __webpack_require__(144);
	Document.TableCell = __webpack_require__(142);
	Document.List = __webpack_require__(72);
	Document.ListItem = __webpack_require__(73);
	
	Document.Transformations = __webpack_require__(149);
	
	module.exports = Document;


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Substance = __webpack_require__(3);
	
	function Selection() {
	}
	
	Selection.Prototype = function() {
	
	  this.getRanges = function() {
	    return [];
	  };
	
	  this.isNull = function() {
	    return false;
	  };
	
	  this.isMultiSeletion = function() {
	    return false;
	  };
	
	  this.isPropertySelection = function() {
	    return false;
	  };
	
	  this.isContainerSelection = function() {
	    return false;
	  };
	
	  this.isTableSelection = function() {
	    return false;
	  };
	
	  this.isCollapsed = function() {
	    return true;
	  };
	
	  this.isReverse = function() {
	    return false;
	  };
	
	  this.equals = function(other) {
	    if (this === other) {
	      return true ;
	    } else if (!other) {
	      return false;
	    } else if (this.isNull() !== other.isNull()) {
	      return false;
	    } else {
	      return true;
	    }
	  };
	
	  this.toString = function() {
	    return "null";
	  };
	
	};
	
	Substance.initClass(Selection);
	
	var NullSelection = function() {};
	NullSelection.Prototype = function() {
	  this.isNull = function() {
	    return true;
	  };
	};
	Substance.inherit(NullSelection, Selection);
	Selection.nullSelection = Object.freeze(new NullSelection());
	
	module.exports = Selection;


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(86),
	    isLength = __webpack_require__(7),
	    toObject = __webpack_require__(54);
	
	/**
	 * The base implementation of `_.forEach` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	function baseEach(collection, iteratee) {
	  var length = collection ? collection.length : 0;
	  if (!isLength(length)) {
	    return baseForOwn(collection, iteratee);
	  }
	  var index = -1,
	      iterable = toObject(collection);
	
	  while (++index < length) {
	    if (iteratee(iterable[index], index, iterable) === false) {
	      break;
	    }
	  }
	  return collection;
	}
	
	module.exports = baseEach;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var oo = __webpack_require__(2);
	
	/**
	 * An adapter to access an object via path.
	 *
	 * @class PathAdapter
	 * @module Basics
	 * @constructor
	 */
	function PathAdapter(obj) {
	  if (obj) {
	    this.root = obj;
	  }
	}
	
	PathAdapter.Prototype = function() {
	
	  // use this to create extra scope for children ids
	  // Example: {
	  //   "foo": {
	  //      "bar": true
	  //      "children": {
	  //          "bla": {
	  //            "blupp": true
	  //          }
	  //      }
	  //   }
	  // }
	  this.childrenScope = false;
	
	  this.getRoot = function() {
	    return this.root || this;
	  };
	
	  this._resolve = function(path, create) {
	    var lastIdx = path.length-1;
	    var context = this.getRoot();
	    for (var i = 0; i < lastIdx; i++) {
	      var key = path[i];
	      if (context[key] === undefined) {
	        if (create) {
	          context[key] = {};
	          if (this.childrenScope) {
	            context[key].children = {};
	          }
	        } else {
	          return undefined;
	        }
	      }
	      context = context[key];
	      if (this.childrenScope) {
	        context = context.children;
	      }
	    }
	    return context;
	  };
	
	  this.get = function(path) {
	    if (_.isString(path)) {
	      return this[path];
	    } else if (!path || path.length === 0) {
	      return this.getRoot();
	    } else {
	      var key = path[path.length-1];
	      var context = this._resolve(path);
	      if (context) {
	        return context[key];
	      } else {
	        return undefined;
	      }
	    }
	  };
	
	  this.set = function(path, value) {
	    if (_.isString(path)) {
	      this[path] = value;
	    } else {
	      var key = path[path.length-1];
	      this._resolve(path, true)[key] = value;
	    }
	  };
	
	  this.delete = function(path, strict) {
	    if (_.isString(path)) {
	      delete this[path];
	    } else {
	      var key = path[path.length-1];
	      var obj = this._resolve(path);
	      if (strict && !obj || !obj[key]) {
	        throw new Error('Invalid path.');
	      }
	      delete obj[key];
	    }
	  };
	
	  this.clear = function() {
	    var root = this.getRoot();
	    for (var key in root) {
	      if (root.hasOwnProperty(key)) {
	        delete root[key];
	      }
	    }
	  };
	
	  this._traverse = function(root, path, fn, ctx) {
	    for (var id in root) {
	      if (!root.hasOwnProperty(id)) continue;
	      if (id !== '__values__') {
	        var childPath = path.concat([id]);
	        fn.call(ctx, childPath, root[id]);
	        this._traverse(root[id], childPath, fn, ctx);
	      }
	    }
	  };
	
	  this.traverse = function(fn, ctx) {
	    this._traverse(this.getRoot(), [], fn, ctx);
	  };
	
	};
	
	oo.initClass( PathAdapter );
	
	PathAdapter.Arrays = function() {
	  PathAdapter.apply(this, arguments);
	};
	
	PathAdapter.Arrays.Prototype = function() {
	
	  this.get = function(path) {
	    if (_.isString(path)) {
	      return this[path];
	    } else if (!path || path.length === 0) {
	      return this.getRoot();
	    } else {
	      var key = path[path.length-1];
	      var context = this._resolve(path);
	      if (context && context[key]) {
	        return context[key].__values__;
	      } else {
	        return undefined;
	      }
	    }
	  };
	
	  this.add = function(path, value) {
	    var key = path[path.length-1];
	    var context = this._resolve(path, true);
	    if (!context[key]) {
	      context[key] = {__values__: []};
	    }
	    var values = context[key].__values__;
	    values.push(value);
	  };
	
	  this.remove = function(path, value) {
	    var values = this.get(path);
	    if (values) {
	      _.deleteFromArray(values, value);
	    } else {
	      console.warn('Warning: trying to remove a value for an unknown path.', path, value);
	    }
	  };
	
	  this.removeAll = function(path) {
	    var values = this.get(path);
	    values.splice(0, values.length);
	  };
	
	  this.set = function() {
	    throw new Error('This method is not available for PathAdapter.Arrays');
	  };
	
	  this._traverse = function(root, path, fn, ctx) {
	    for (var id in root) {
	      if (!root.hasOwnProperty(id)) continue;
	      if (id === '__values__') {
	        fn.call(ctx, path, root.__values__);
	      } else {
	        var childPath = path.concat([id]);
	        this._traverse(root[id], childPath, fn, ctx);
	      }
	    }
	  };
	
	};
	
	oo.inherit(PathAdapter.Arrays, PathAdapter);
	
	module.exports = PathAdapter;


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var OO = __webpack_require__(2);
	var EventEmitter = __webpack_require__(27);
	var Node = __webpack_require__(6);
	var Selection = __webpack_require__(19);
	var PathAdapter = __webpack_require__(21);
	
	
	// Container Annotation
	// ----------------
	//
	// Describes an annotation sticking on a container that can span over multiple
	// nodes.
	//
	// Here's an example:
	//
	// {
	//   "id": "subject_reference_1",
	//   "type": "subject_reference",
	//   "container": "content",
	//   "startPath": ["text_2", "content"],
	//   "startOffset": 100,
	//   "endPath": ["text_4", "content"],
	//   "endOffset": 40
	// }
	
	
	var ContainerAnnotation = Node.extend({
	  displayName: "ContainerAnnotation",
	  name: "container_annotation",
	
	  properties: {
	    // id of container node
	    container: 'string',
	    startPath: ['array', 'string'],
	    startOffset: 'number',
	    endPath: ['array', 'string'],
	    endOffset: 'number'
	  },
	
	  getStartAnchor: function() {
	    if (!this._startAnchor) {
	      this._startAnchor = new ContainerAnnotation.Anchor(this, 'isStart');
	    }
	    return this._startAnchor;
	  },
	
	  getEndAnchor: function() {
	    if (!this._endAnchor) {
	      this._endAnchor = new ContainerAnnotation.Anchor(this);
	    }
	    return this._endAnchor;
	  },
	
	  // Provide a selection which has the same range as this annotation.
	  getSelection: function() {
	    var doc = this.getDocument();
	    // Guard: when this is called while this node has been detached already.
	    if (!doc) {
	      console.warn('Trying to use a ContainerAnnotation which is not attached to the document.');
	      return Selection.nullSelection();
	    }
	    return doc.createSelection({
	      type: "container",
	      containerId: this.container,
	      startPath: this.startPath,
	      startOffset: this.startOffset,
	      endPath: this.endPath,
	      endOffset: this.endOffset
	    });
	  },
	
	  getText: function() {
	    var doc = this.getDocument();
	    if (!doc) {
	      console.warn('Trying to use a ContainerAnnotation which is not attached to the document.');
	      return "";
	    }
	    return doc.getTextForSelection(this.getSelection());
	  },
	
	  updateRange: function(tx, sel) {
	    if (!sel.isContainerSelection()) {
	      throw new Error('Cannot change to ContainerAnnotation.');
	    }
	    if (!_.isEqual(this.startPath, sel.start.path)) {
	      tx.set([this.id, 'startPath'], sel.start.path);
	    }
	    if (this.startOffset !== sel.start.offset) {
	      tx.set([this.id, 'startOffset'], sel.start.offset);
	    }
	    if (!_.isEqual(this.endPath, sel.end.path)) {
	      tx.set([this.id, 'endPath'], sel.end.path);
	    }
	    if (this.endOffset !== sel.end.offset) {
	      tx.set([this.id, 'endOffset'], sel.end.offset);
	    }
	  },
	
	  setActive: function(val) {
	    if (this.active !== val) {
	      this.active = val;
	      this.emit('active', val);
	      _.each(this.fragments, function(frag) {
	        frag.emit('active', val);
	      });
	    }
	  },
	
	  // FIXME: this implementation will not prune old fragments
	  getFragments: function() {
	    if (!this._fragments) {
	      this._fragments = new PathAdapter();
	    }
	    var fragments = [];
	    var doc = this.getDocument();
	    var startAnchor = this.getStartAnchor();
	    var endAnchor = this.getEndAnchor();
	    var container = doc.get(this.container);
	    var fragment;
	    // if start and end anchors are on the same property, then there is only one fragment
	    if (_.isEqual(startAnchor.path, endAnchor.path)) {
	      fragment = this._fragments.get(startAnchor.path);
	      if (!fragment) {
	        fragment = new ContainerAnnotation.Fragment(this, startAnchor.path, "property");
	        this._fragments.set(fragment.path, fragment);
	      } else if (!fragment.mode === "property") {
	        fragment.mode = "property";
	      }
	      fragments.push(fragment);
	    }
	    // otherwise create a trailing fragment for the property of the start anchor,
	    // full-spanning fragments for inner properties,
	    // and one for the property containing the end anchor.
	    else {
	      var text = doc.get(startAnchor.path);
	      var startComp = container.getComponent(startAnchor.path);
	      var endComp = container.getComponent(endAnchor.path);
	      if (!startComp || !endComp) {
	        throw new Error('Could not find components of AbstractContainerAnnotation');
	      }
	      fragment = this._fragments.get(startAnchor.path);
	      if (!fragment) {
	        fragment = new ContainerAnnotation.Fragment(this, startAnchor.path, "start");
	        this._fragments.set(fragment.path, fragment);
	      } else if (fragment.mode !== "start") {
	        fragment.mode = "start";
	      }
	      fragments.push(fragment);
	      for (var idx = startComp.idx + 1; idx < endComp.idx; idx++) {
	        var comp = container.getComponentAt(idx);
	        text = doc.get(comp.path);
	        fragment = this._fragments.get(comp.path);
	        if (!fragment) {
	          fragment = new ContainerAnnotation.Fragment(this, comp.path, "inner");
	          this._fragments.set(fragment.path, fragment);
	        } else if (fragment.mode !== "inner") {
	          fragment.mode = "inner";
	        }
	        fragments.push(fragment);
	      }
	      fragment = this._fragments.get(endAnchor.path);
	      if (!fragment) {
	        fragment = new ContainerAnnotation.Fragment(this, endAnchor.path, "end");
	        this._fragments.set(fragment.path, fragment);
	      } else if (fragment.mode !== "end") {
	        fragment.mode = "end";
	      }
	      fragments.push(fragment);
	    }
	    this.fragments = fragments;
	    return fragments;
	  },
	
	});
	
	ContainerAnnotation.Anchor = function Anchor(anno, isStart) {
	  EventEmitter.call(this);
	  this.type = "container-annotation-anchor";
	  this.anno = anno;
	  // TODO: remove this.node in favor of this.anno
	  this.node = anno;
	  this.id = anno.id;
	  this.container = anno.container;
	  this.isStart = !!isStart;
	  Object.freeze(this);
	};
	
	ContainerAnnotation.Anchor.Prototype = function() {
	  _.extend(this, EventEmitter.prototype);
	
	  this.zeroWidth = true;
	
	  this.getTypeNames = function() {
	    return [this.type];
	  };
	};
	
	OO.initClass(ContainerAnnotation.Anchor);
	
	ContainerAnnotation.Fragment = function Fragment(anno, path, mode) {
	  EventEmitter.call(this);
	
	  this.type = "container_annotation_fragment";
	  this.anno = anno;
	  // HACK: id is necessary for Annotator
	  this.id = anno.id;
	  this.path = path;
	  this.mode = mode;
	};
	
	ContainerAnnotation.Fragment.Prototype = function() {
	  _.extend(this, EventEmitter.prototype);
	
	  this.getTypeNames = function() {
	    return [this.type];
	  };
	};
	
	OO.initClass(ContainerAnnotation.Fragment);
	
	Object.defineProperties(ContainerAnnotation.Fragment.prototype, {
	  startOffset: {
	    get: function() {
	      return ( (this.mode === "start" || this.mode === "property") ? this.anno.startOffset : 0);
	    },
	    set: function() { throw new Error('Immutable!'); }
	  },
	  endOffset: {
	    get: function() {
	      var doc = this.anno.getDocument();
	      var textProp = doc.get(this.path);
	      var length = textProp.length;
	      return ( (this.mode === "end" || this.mode === "property") ? this.anno.endOffset : length);
	    },
	    set: function() { throw new Error('Immutable!'); }
	  },
	  active: {
	    get: function() {
	      return this.anno.active;
	    },
	    set: function() { throw new Error('Immutable!'); }
	  }
	});
	
	
	ContainerAnnotation.Fragment.static.level = Number.MAX_VALUE;
	
	Object.defineProperties(ContainerAnnotation.Anchor.prototype, {
	  path: {
	    get: function() {
	      return (this.isStart ? this.node.startPath : this.node.endPath);
	    },
	    set: function() { throw new Error('Immutable!'); }
	  },
	  offset: {
	    get: function() {
	      return (this.isStart ? this.node.startOffset : this.node.endOffset);
	    },
	    set: function() { throw new Error('Immutable!'); }
	  },
	});
	
	module.exports = ContainerAnnotation;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Node = __webpack_require__(6);
	
	// Text Node
	// ---------
	//
	// A base class for all text-ish nodes, such as Paragraphs, Headings,
	// Prerendered, etc.
	
	var TextNode = Node.extend({
	  displayName: "TextNode",
	  name: "text",
	
	  properties: {
	    content: 'string'
	  },
	
	  getTextPath: function() {
	    return [this.id, 'content'];
	  },
	
	  getText: function() {
	    return this.content;
	  },
	});
	
	TextNode.static.components = ['content'];
	
	module.exports = TextNode;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var deleteCharacter = __webpack_require__(75);
	var deleteNode = __webpack_require__(44);
	var merge = __webpack_require__(45);
	var Annotations = __webpack_require__(10);
	
	/* jshint latedef:false */
	
	/**
	 * Deletes a given selection.
	 *
	 * @param args object with `selection`
	 * @return object with updated `selection`
	 */
	function deleteSelection(tx, args) {
	  var selection = args.selection;
	  if (selection.isCollapsed()) {
	    args = deleteCharacter(tx, args);
	  } else if (selection.isPropertySelection()) {
	    args = _deletePropertySelection(tx, args);
	  } else {
	    // deal with container deletes
	    args = _deleteContainerSelection(tx, args);
	  }
	  return args;
	}
	
	function _deletePropertySelection(tx, args) {
	  var range = args.selection.getRange();
	  var path = range.start.path;
	  var startOffset = range.start.offset;
	  var endOffset = range.end.offset;
	  tx.update(path, { delete: { start: startOffset, end: endOffset } });
	  Annotations.deletedText(tx, path, startOffset, endOffset);
	  args.selection = tx.createSelection({
	    type: 'property',
	    path: path,
	    startOffset: startOffset
	  });
	  return args;
	}
	
	function _deleteContainerSelection(tx, args) {
	  var selection = args.selection;
	  var containerId = selection.containerId;
	  var range = selection.getRange();
	  var nodeSels = _getNodeSelection(tx, selection);
	  var nodeSel, node, type;
	
	  args.selection = null;
	  // apply deletion backwards so that we do not to recompute array positions
	  var container = tx.get(containerId);
	  var firstNodePos = container.getPosition(nodeSels[0].node.id);
	
	  for (var idx = nodeSels.length - 1; idx >= 0; idx--) {
	    nodeSel = nodeSels[idx];
	    node = nodeSel.node;
	    if (nodeSel.isFully) {
	      deleteNode(tx, _.extend({}, args, {
	        nodeId: node.id
	      }));
	    } else {
	      _deleteNodePartially(tx, _.extend({}, args, {
	        nodeSel: nodeSel
	      }));
	    }
	  }
	  // update the selection; take the first component which is not fully deleted
	  if (!nodeSels[0].isFully) {
	    args.selection = tx.createSelection({
	      type: 'property',
	      path: range.start.path,
	      startOffset: range.start.offset
	    });
	  } else {
	    // if the first node has been deleted fully we need to find the first property
	    // which remained and set the selection to the first character.
	    args.selection = null;
	    for (var i = 1; i < nodeSels.length; i++) {
	      nodeSel = nodeSels[i];
	      if (!nodeSel.isFully) {
	        args.selection = tx.createSelection({
	          type: 'property',
	          path: nodeSel.components[0].path,
	          startOffset: 0
	        });
	        break;
	      }
	    }
	    // TODO: if we could not find an insertion position,
	    // that is the case when nodes were fully selected,
	    // insert a default text node and set the cursor into it
	    if (args.selection === null) {
	      type = tx.getSchema().getDefaultTextType();
	      node = {
	        type: type,
	        id: _.uuid(type),
	        content: ""
	      };
	      tx.create(node);
	      container.show(node.id, firstNodePos);
	      args.selection = tx.createSelection({
	        type: 'property',
	        path: [node.id, 'content'],
	        startOffset: 0
	      });
	    }
	  }
	  // Do a merge
	  if (nodeSels.length>1) {
	    var firstSel = nodeSels[0];
	    var lastSel = nodeSels[nodeSels.length-1];
	    if (firstSel.isFully || lastSel.isFully) {
	      // TODO: think about if we want to merge in those cases
	    } else {
	      var secondComp = _.last(lastSel.components);
	      var tmp = merge(tx, _.extend({}, args, {
	        selection: args.selection,
	        containerId: containerId,
	        path: secondComp.path,
	        direction: 'left'
	      }));
	      args.selection = tmp.selection;
	    }
	  }
	  // If the container is empty after deletion insert a default text node is inserted
	  container = tx.get(containerId);
	  if (container.nodes.length === 0) {
	    type = tx.getSchema().getDefaultTextType();
	    node = {
	      type: type,
	      id: _.uuid(type),
	      content: ""
	    };
	    tx.create(node);
	    container.show(node.id, 0);
	    args.selection = tx.createSelection({
	      type: 'property',
	      path: [node.id, 'content'],
	      startOffset: 0
	    });
	  }
	  return args;
	}
	
	function _deleteNodePartially(tx, args) {
	  // Just go through all components and apply a property deletion
	  var nodeSel = args.nodeSel;
	  var components = nodeSel.components;
	  var length = components.length;
	  for (var i = 0; i < length; i++) {
	    var comp = components[i];
	    var startOffset = 0;
	    var endOffset = tx.get(comp.path).length;
	    if (i === 0) {
	      startOffset = nodeSel.startOffset;
	    }
	    if (i === length-1) {
	      endOffset = nodeSel.endOffset;
	    }
	    _deletePropertySelection(tx, _.extend({}, args, {
	      selection: tx.createSelection({
	        type: 'property',
	        path: comp.path,
	        startOffset: startOffset,
	        endOffset: endOffset
	      })
	    }));
	  }
	}
	
	// TODO: find a better naming and extract this into its own class
	// it generates a data structure containing
	// information about a selection range grouped by nodes
	// e.g, if a node is fully selected or only partially
	function _getNodeSelection(doc, containerSelection) {
	  var result = [];
	  var groups = {};
	  var range = containerSelection.getRange();
	  var container = doc.get(containerSelection.containerId);
	  var components = container.getComponentsForRange(range);
	  for (var i = 0; i < components.length; i++) {
	    var comp = components[i];
	    var node = doc.get(comp.rootId);
	    if (!node) {
	      throw new Error('Illegal state: expecting a component to have a proper root node id set.');
	    }
	    var nodeId = node.id;
	    var nodeGroup;
	    if (!groups[nodeId]) {
	      nodeGroup = {
	        node: node,
	        isFully: true,
	        components: []
	      };
	      groups[nodeId] = nodeGroup;
	      result.push(nodeGroup);
	    }
	    nodeGroup = groups[nodeId];
	    nodeGroup.components.push(comp);
	  }
	  // finally we analyze the first and last node-selection
	  // if these
	  var startComp = components[0];
	  var endComp = components[components.length-1];
	  var startNodeSel = result[0];
	  var endNodeSel = result[result.length-1];
	  var startLen = doc.get(startComp.path).length;
	  var endLen = doc.get(endComp.path).length;
	  if (range.start.offset > 0 ||
	    (startComp.hasPrevious() && startComp.getPrevious().rootId === startComp.rootId))
	  {
	    startNodeSel.isFully = false;
	    startNodeSel.startOffset = range.start.offset;
	    if (result.length === 1) {
	      startNodeSel.endOffset = range.end.offset;
	    } else {
	      startNodeSel.endOffset = startLen;
	    }
	  }
	  if (result.length > 1 &&
	      (range.end.offset < endLen ||
	        (endComp.hasNext() && endComp.getNext().rootId === endComp.rootId))
	     ) {
	    endNodeSel.isFully = false;
	    endNodeSel.startOffset = 0;
	    endNodeSel.endOffset = range.end.offset;
	  }
	  return result;
	}
	
	module.exports = deleteSelection;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(7),
	    isObjectLike = __webpack_require__(12);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the `toStringTag` of values.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * for more details.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  var length = isObjectLike(value) ? value.length : undefined;
	  return (isLength(length) && objToString.call(value) == argsTag) || false;
	}
	
	module.exports = isArguments;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var OO = __webpack_require__(2);
	var Component = __webpack_require__(4);
	var $$ = Component.$$;
	var Annotator = __webpack_require__(37);
	var AnnotationComponent = __webpack_require__(102);
	
	function TextPropertyComponent() {
	  Component.apply(this, arguments);
	}
	
	TextPropertyComponent.Prototype = function() {
	
	  this.render = function() {
	    var componentRegistry = this.context.componentRegistry;
	    var doc = this.getDocument();
	    var path = this.getPath();
	    var text = doc.get(path) || "";
	    var annotations = this.getAnnotations();
	
	    var el = $$(this.props.tagName || 'span')
	      .addClass("text-property")
	      .attr({
	        "data-path": this.props.path.join('.'),
	        spellCheck: false,
	      })
	      .css({
	        whiteSpace: "pre-wrap"
	      });
	
	    var annotator = new Annotator();
	    var fragmentCounters = {};
	    // for debugging
	    // var _level = 0;
	    // var _logIndent = function(level) {
	    //   var prefix = "";
	    //   for (var i = 0; i < level; i++) {
	    //     prefix = prefix.concat("  ");
	    //   }
	    //   return prefix;
	    // };
	    // var _logPrefix = "";
	    annotator.onText = function(context, text) {
	      // console.log(_logPrefix+text);
	      if (text && text.length > 0) {
	        context.append(text);
	      }
	    };
	    annotator.onEnter = function(entry) {
	      // for debugging
	      // _logPrefix = _logIndent(++_level);
	      var node = entry.node;
	      var id = node.id;
	      if (!fragmentCounters[id]) {
	        fragmentCounters[id] = 0;
	      }
	      fragmentCounters[id] = fragmentCounters[id]+1;
	      // for debugging
	      // console.log(_logPrefix+"<"+node.type+" key="+key+">");
	
	      // TODO: we need a component factory, so that we can create the appropriate component
	      var ViewClass;
	      if (componentRegistry.contains(node.type)) {
	        ViewClass = componentRegistry.get(node.type);
	      } else {
	        ViewClass = AnnotationComponent;
	      }
	      var el = $$(ViewClass, {
	        doc: doc,
	        node: node,
	      })
	      // adding keys here, enables preservative rerendering
	      // TODO: experiment, if this reduces cursor flickering, already...
	      // .key(id + "@" + fragmentCounters[id]);
	      // special support for container annotation fragments
	      if (node.type === "container_annotation_fragment") {
	        // TODO: this seems a bit messy
	        el.addClass(node.anno.getTypeNames().join(' ').replace(/_/g, "-"));
	        el.addClass("annotation-fragment");
	      } else if (node.type === "container-annotation-anchor") {
	        el.addClass(node.anno.getTypeNames().join(' ').replace(/_/g, "-"));
	        el.addClass("anchor");
	        el.addClass(node.isStart?"start-anchor":"end-anchor");
	      }
	      return el;
	    };
	    annotator.onExit = function(entry, context, parentContext) {
	      // for debugging
	      // _logPrefix = _logIndent(_level--);
	      // console.log(_logPrefix+"</"+entry.node.type+">");
	      parentContext.append(context);
	    };
	    annotator.start(el, text, annotations);
	    // NOTE: this is particularly necessary for text-properties of
	    // block level text nodes. Otherwise, the element will not y-expand
	    // as desired, and soft-breaks are not visible.
	    // TODO: sometimes we do not want to do this. Make it configurable.
	    el.append($$('br'));
	    // // HACK: need to post-process as some of the data has been
	    // // add using push and not processed via $$.
	    // Component.$$.prepareChildren(el.children);
	    return el;
	  };
	
	  this.didMount = function() {
	    var doc = this.props.doc;
	    doc.getEventProxy('path').add(this.props.path, this, this.textPropertyDidChange);
	  };
	
	  this.willUnmount = function() {
	    var doc = this.props.doc;
	    doc.getEventProxy('path').remove(this.props.path, this);
	  };
	
	  this.getAnnotations = function() {
	    return this.context.surface.getAnnotationsForProperty(this.props.path);
	  };
	
	  // Annotations that are active (not just visible)
	  this.getHighlights = function() {
	    if (this.context.getHighlightedNodes) {
	      return this.context.getHighlightedNodes();
	    } else {
	      return [];
	    }
	  };
	
	  this.textPropertyDidChange = function() {
	    this.rerender();
	  };
	
	  this.getContainer = function() {
	    return this.getSurface().getContainer();
	  };
	
	  this.getDocument = function() {
	    return this.props.doc;
	  };
	
	  this.getPath = function() {
	    return this.props.path;
	  };
	
	  this.getElement = function() {
	    return this.$el[0];
	  };
	
	  this.getSurface = function() {
	    return this.context.surface;
	  };
	};
	
	OO.inherit(TextPropertyComponent, Component);
	
	module.exports = TextPropertyComponent;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var OO = __webpack_require__(2);
	
	/**
	 * Event support.
	 *
	 * Inspired by VisualEditor's EventEmitter class.
	 *
	 * @class EventEmitter
	 * @constructor
	 * @module Basics
	 */
	function EventEmitter() {
	  this.__events__ = {};
	}
	
	EventEmitter.Prototype = function() {
	
	  function validateMethod( method, context ) {
	    // Validate method and context
	    if ( typeof method === 'string' ) {
	      // Validate method
	      if ( context === undefined || context === null ) {
	        throw new Error( 'Method name "' + method + '" has no context.' );
	      }
	      if ( !( method in context ) ) {
	        // Technically the method does not need to exist yet: it could be
	        // added before call time. But this probably signals a typo.
	        throw new Error( 'Method not found: "' + method + '"' );
	      }
	      if ( typeof context[method] !== 'function' ) {
	        // Technically the property could be replaced by a function before
	        // call time. But this probably signals a typo.
	        throw new Error( 'Property "' + method + '" is not a function' );
	      }
	    } else if ( typeof method !== 'function' ) {
	      throw new Error( 'Invalid callback. Function or method name expected.' );
	    }
	  }
	
	  /**
	   * Internal implementation for registering a listener.
	   *
	   * @param {String} event
	   * @param {Function} method
	   * @param {Object} context
	   */
	  this._on = function ( event, method, context, priority) {
	    var bindings;
	    validateMethod( method, context );
	    if ( this.__events__.hasOwnProperty( event ) ) {
	      bindings = this.__events__[event];
	    } else {
	      // Auto-initialize bindings list
	      bindings = this.__events__[event] = [];
	    }
	    // Add binding
	    bindings.push({
	      method: method,
	      context: context || null,
	      priority: priority
	    });
	    return this;
	  };
	
	  /**
	   * Remove a listener.
	   *
	   * @method off
	   * @param {String} event
	   * @param {Function} method
	   * @param {Object} context
	   * @chainable
	   */
	  this._off = function ( event, method, context ) {
	    var i, bindings;
	    if ( arguments.length === 1 ) {
	      // Remove all bindings for event
	      delete this.__events__[event];
	      return this;
	    }
	    validateMethod( method, context );
	    if ( !( event in this.__events__ ) || !this.__events__[event].length ) {
	      // No matching bindings
	      return this;
	    }
	    // Default to null context
	    if ( arguments.length < 3 ) {
	      context = null;
	    }
	    // Remove matching handlers
	    bindings = this.__events__[event];
	    i = bindings.length;
	    while ( i-- ) {
	      if ( bindings[i].method === method && bindings[i].context === context ) {
	        bindings.splice( i, 1 );
	      }
	    }
	    // Cleanup if now empty
	    if ( bindings.length === 0 ) {
	      delete this.__events__[event];
	    }
	    return this;
	  };
	
	  this._connect = function (obj, methods, options) {
	    var priority = 0;
	    if (arguments.length === 3) {
	      priority = options.priority || priority;
	    }
	    for ( var event in methods ) {
	      var method = methods[event];
	      this._on( event, method, obj, priority);
	    }
	    this.__events__[event].sort(byPriorityDescending);
	    return this;
	  };
	
	  this._disconnect = function(context) {
	    var i, event, bindings;
	    // Remove all connections to the context
	    for ( event in this.__events__ ) {
	      bindings = this.__events__[event];
	      i = bindings.length;
	      while ( i-- ) {
	        // bindings[i] may have been removed by the previous step's
	        // this.off so check it still exists
	        if ( bindings[i] && bindings[i].context === context ) {
	          this._off( event, bindings[i].method, context );
	        }
	      }
	    }
	    return this;
	  };
	
	  /**
	   * Emit an event.
	   *
	   * @method emit
	   * @param {String} event
	   * @param ...arguments
	   * @return true if a listener was notified, false otherwise.
	   */
	  this.emit = function (event) {
	    if ( event in this.__events__ ) {
	      // Clone the list of bindings so that handlers can remove or add handlers during the call.
	      var bindings = this.__events__[event].slice();
	      var args = Array.prototype.slice.call(arguments, 1);
	      for (var i = 0, len = bindings.length; i < len; i++) {
	        var binding = bindings[i];
	        binding.method.apply(binding.context, args);
	      }
	      return true;
	    }
	    return false;
	  };
	
	  // sort descending as a listener with higher priority should be
	  // called earlier
	  function byPriorityDescending(a, b) {
	    return b.priority - a.priority;
	  }
	
	  /**
	   * Connect a listener to a set of events.
	   *
	   * Optionally, a `priority` can be provided to control the order
	   * of all bindings. The default priority is 0. All listeners with the
	   * same priority remain in order of registration.
	   * A lower priority will make the listener be called later, a higher
	   * priority earlier.
	   *
	   * @method emit
	   * @param {Object} listener
	   * @param {Object} hash with event as keys, and handler functions as values.
	   * @param {Number} hash with `priority` as ordering hint (default is 0).
	   * @chainable
	   */
	  this.connect = function (obj, methods, options) {
	    /* jshint unused:false */
	    return this._connect.apply(this, arguments);
	  };
	
	  /**
	   * Disconnect a listener (all bindings).
	   *
	   * @method disconnect
	   * @param {Object} listener
	   * @chainable
	   */
	  this.disconnect = function(listener) {
	    return this._disconnect(listener);
	  };
	
	  this.on = function(event, method, context, options) {
	    var priority = 0;
	    if (arguments.length === 4) {
	      priority = options.priority || priority;
	    }
	    this._on(event, method, context, priority);
	    this.__events__[event].sort(byPriorityDescending);
	  };
	
	  this.off = function(event, method, context) {
	    /* jshint unused:false */
	    // TODO: we could add sugar to be able to be able to just use
	    // emitter.off('event', this)
	    // i.e., without need to specify the handler again
	    return this._off.apply(this, arguments);
	  };
	};
	
	OO.initClass( EventEmitter );
	
	module.exports = EventEmitter;


/***/ },
/* 28 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function arrayCopy(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = arrayCopy;


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(202);
	
	/**
	 * The base implementation of `_.indexOf` without support for binary searches.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = (fromIndex || 0) - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 30 */
/***/ function(module, exports) {

	/**
	 * Used as the maximum length of an array-like value.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * for more details.
	 */
	var MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = +value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var isIndex = __webpack_require__(30),
	    isLength = __webpack_require__(7),
	    isObject = __webpack_require__(8);
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number') {
	    var length = object.length,
	        prereq = isLength(length) && isIndex(index, length);
	  } else {
	    prereq = type == 'string' && index in object;
	  }
	  if (prereq) {
	    var other = object[index];
	    return value === value ? value === other : other !== other;
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Substance = __webpack_require__(3);
	
	function Operation() {
	}
	
	Operation.Prototype = function() {
	
	  this.isOperation = true;
	
	};
	
	Substance.initClass(Operation);
	
	module.exports = Operation;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(1);
	var OO = __webpack_require__(2);
	var Tool = __webpack_require__(9);
	
	function AnnotationTool(context) {
	  Tool.call(this, context);
	}
	
	AnnotationTool.Prototype = function() {
	  // blacklist of modes; one of 'create', 'remove', 'truncate', 'expand', 'fusion'
	  this.disabledModes = [];
	
	  this.splitContainerSelections = false;
	
	  // Provides the type of the associated annotation node.
	  // The default implementation uses the Tool's static name.
	  // Override this method to customize.
	  this.getAnnotationType = function() {
	    if (this.constructor.static.name) {
	      return this.constructor.static.name;
	    } else {
	      throw new Error('Contract: AnnotationTool.static.name should be associated to a document annotation type.');
	    }
	  };
	
	  this.afterCreate = function() {};
	
	  this.afterFusion = function() {};
	
	  this.afterRemove = function() {};
	
	  this.afterTruncate = function() {};
	
	  this.afterExpand = function() {};
	
	  // When there's no existing annotation overlapping, we create a new one.
	  this.canCreate = function(annos, sel) {
	    return (annos.length === 0 && !sel.isCollapsed());
	  };
	
	  // When more than one annotation overlaps with the current selection
	  this.canFusion = function(annos, sel) {
	    return (annos.length >= 2 && !sel.isCollapsed());
	  };
	
	  // When the cursor or selection is inside an existing annotation
	  this.canRemove = function(annos, sel) {
	    if (annos.length !== 1) return false;
	    var annoSel = annos[0].getSelection();
	    return sel.isInsideOf(annoSel);
	  };
	
	  // When there's some overlap with only a single annotation we do an expand
	  this.canExpand = function(annos, sel) {
	    if (annos.length !== 1) return false;
	    var annoSel = annos[0].getSelection();
	    return sel.overlaps(annoSel) && !sel.isInsideOf(annoSel);
	  };
	
	  this.canTruncate = function(annos, sel) {
	    if (annos.length !== 1) return false;
	    var annoSel = annos[0].getSelection();
	    return (sel.isLeftAlignedWith(annoSel) || sel.isRightAlignedWith(annoSel)) && !sel.equals(annoSel) && !sel.isCollapsed();
	  };
	
	  this.update = function(surface, sel) {
	    this.surface = surface;
	    if ( (this.needsEnabledSurface && !surface.isEnabled()) ||
	          sel.isNull() ) {
	      return this.setDisabled();
	    }
	    var doc = this.getDocument();
	    var annotationType = this.getAnnotationType();
	    var isContainerAnno = this.isContainerAnno();
	    // Extract range and matching annos of current selection
	    var annos;
	    if (isContainerAnno) {
	      annos = doc.getContainerAnnotationsForSelection(sel, this.getContainer(), {
	        type: annotationType
	      });
	    } else {
	      // Don't react on container selections if the associated annotation type
	      // is a property annotation.
	      // In future we could introduce a multi-annotation (multiple property selections)
	      // and create multiple annotations at once.
	      if (!sel.isPropertySelection() && !this.splitContainerSelections) {
	        return this.setDisabled();
	      }
	      annos = doc.getAnnotationsForSelection(sel, { type: annotationType });
	    }
	
	    var newState = {
	      surface: surface,
	      disabled: false,
	      active: false,
	      mode: null,
	      sel: sel,
	      annos: annos
	    };
	
	    if (this.canCreate(annos, sel)) {
	      newState.mode = "create";
	    } else if (this.canFusion(annos, sel)) {
	      newState.mode = "fusion";
	    } else if (this.canTruncate(annos, sel)) {
	      newState.active = true;
	      newState.mode = "truncate";
	    } else if (this.canRemove(annos, sel)) {
	      newState.active = true;
	      newState.mode = "remove";
	    } else if (this.canExpand(annos, sel)) {
	      newState.mode = "expand";
	    }
	
	    // Verifies if the detected mode has been disabled by the concrete implementation
	    if (!newState.mode || _.includes(this.disabledModes, newState.mode)) {
	      return this.setDisabled();
	    } else {
	      this.setToolState(newState);
	    }
	  };
	
	  this.performAction = function() {
	    var state = this.getToolState();
	    // TODO: is this really necessary? better just check if the toolstate does not have a proper mode
	    if (!state.sel || !state.mode || state.sel.isNull()) return;
	    switch (state.mode) {
	      case "create":
	        return this.handleCreate(state);
	      case "fusion":
	        return this.handleFusion(state);
	      case "remove":
	        return this.handleRemove(state);
	      case "truncate":
	        return this.handleTruncate(state);
	      case "expand":
	        return this.handleExpand(state);
	    }
	  };
	
	  this.handleCreate = function(state) {
	    var sel = state.sel;
	    var anno;
	
	    if (sel.isNull()) return;
	    this.surface.transaction({ selection: sel }, function(tx, args) {
	      anno = this.createAnnotationForSelection(tx, sel);
	      return args;
	    }, this);
	    this.afterCreate(anno);
	  };
	
	  this.getAnnotationData = function() {
	    return {};
	  };
	
	  this.isContainerAnno = function() {
	    var doc = this.getDocument();
	    var schema = doc.getSchema();
	    return schema.isInstanceOf(this.getAnnotationType(), "container_annotation");
	  };
	
	  this._createPropertyAnnotations = function(tx, sel) {
	    var sels;
	    var annotationType = this.getAnnotationType();
	    if (sel.isPropertySelection()) {
	      sels = [];
	    } else if (sel.isContainerSelection()) {
	      sels = sel.splitIntoPropertySelections();
	    }
	    for (var i = 0; i < sels.length; i++) {
	      var anno = {
	        id: _.uuid(annotationType),
	        type: annotationType
	      };
	      _.extend(anno, this.getAnnotationData());
	      anno.path = sels[i].getPath();
	      anno.startOffset = sels[i].getStartOffset();
	      anno.endOffset = sels[i].getEndOffset();
	      tx.create(anno);
	    }
	  };
	
	  this.createAnnotationForSelection = function(tx, sel) {
	    if (this.splitContainerSelections && sel.isContainerSelection()) {
	      return this._createPropertyAnnotations(tx, sel);
	    }
	    var annotationType = this.getAnnotationType();
	    var anno = {
	      id: _.uuid(annotationType),
	      type: annotationType,
	    };
	    _.extend(anno, this.getAnnotationData());
	    if (this.isContainerAnno()) {
	      anno.startPath = sel.start.path;
	      anno.endPath = sel.end.path;
	
	      // Assuming that this branch only gets reached when the surface has a container
	      // editor attached, we can ask this editor for the containerId
	      var containerId = this.surface.getEditor().getContainerId();
	      if (!containerId) throw "Container could not be determined";
	      anno.container = containerId;
	    } else if (sel.isPropertySelection()) {
	      anno.path = sel.getPath();
	    } else {
	      throw new Error('Illegal state: can not apply ContainerSelection');
	    }
	    anno.startOffset = sel.getStartOffset();
	    anno.endOffset = sel.getEndOffset();
	    // start the transaction with an initial selection
	    return tx.create(anno);
	  };
	
	  this.handleFusion = function(state) {
	    var sel = state.sel;
	    this.surface.transaction({ selection: sel }, function(tx, args) {
	      _.each(state.annos, function(anno) {
	        sel = sel.expand(anno.getSelection());
	      });
	      _.each(state.annos, function(anno) {
	        tx.delete(anno.id);
	      });
	      this.createAnnotationForSelection(tx, sel);
	      this.afterFusion();
	      args.selection = sel;
	      return args;
	    }, this);
	  };
	
	  this.handleRemove = function(state) {
	    var sel = state.sel;
	    this.surface.transaction({ selection: sel }, function(tx, args) {
	      var annoId = state.annos[0].id;
	      tx.delete(annoId);
	      this.afterRemove();
	      return args;
	    }, this);
	  };
	
	  this.handleTruncate = function(state) {
	    var sel = state.sel;
	    this.surface.transaction({ selection: sel }, function(tx, args) {
	      var anno = state.annos[0];
	      var annoSel = anno.getSelection();
	      var newAnnoSel = annoSel.truncate(sel);
	      anno.updateRange(tx, newAnnoSel);
	      this.afterTruncate();
	      return args;
	    }, this);
	  };
	
	  this.handleExpand = function(state) {
	    var sel = state.sel;
	    this.surface.transaction({ selection: sel }, function(tx, args) {
	      var anno = state.annos[0];
	      var annoSel = anno.getSelection();
	      var newAnnoSel = annoSel.expand(sel);
	      anno.updateRange(tx, newAnnoSel);
	      this.afterExpand();
	      return args;
	    }, this);
	  };
	};
	
	OO.inherit(AnnotationTool, Tool);
	
	module.exports = AnnotationTool;


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var oo = __webpack_require__(2);
	
	/**
	 * Simple registry implementation.
	 *
	 * @class Registry
	 * @constructor
	 * @module Basics
	 */
	function Registry() {
	  this.entries = {};
	  // used to control order
	  this.names = [];
	}
	
	Registry.Prototype = function() {
	
	  /**
	   * Check if an entry is registered for a given name.
	   *
	   * @param {String} name
	   * @method contains
	   */
	  this.contains = function(name) {
	    return !!this.entries[name];
	  };
	
	  /**
	   * Add an entry to the registry.
	   *
	   * @param {String} name
	   * @param {Object} entry
	   * @method add
	   */
	  this.add = function(name, entry) {
	    if (this.contains(name)) {
	      this.remove(name);
	    }
	    this.entries[name] = entry;
	    this.names.push(name);
	  };
	
	  /**
	   * Remove an entry from the registry.
	   *
	   * @param {String} name
	   * @method remove
	   */
	  this.remove = function(name) {
	    var pos = this.names.indexOf(name);
	    if (pos >= 0) {
	      this.names.splice(pos, 1);
	    }
	    delete this.entries[name];
	  };
	
	  this.clear = function() {
	    this.names = [];
	    this.entries = [];
	  };
	
	  /**
	   * Get the entry registered for a given name.
	   *
	   * @param {String} name
	   * @return The registered entry
	   * @method get
	   */
	  this.get = function(name) {
	    var res = this.entries[name];
	
	    if (!res) {
	      console.error("No entry with name", name);
	    }
	    return res;
	  };
	
	  /**
	   * Iterate all registered entries in the order they were registered.
	   *
	   * @param {Function} callback with signature function(entry, name)
	   * @param {Object} execution context
	   * @method each
	   */
	  this.each = function(callback, ctx) {
	    for (var i = 0; i < this.names.length; i++) {
	      var name = this.names[i];
	      var _continue = callback.call(ctx, this.entries[name], name);
	      if (_continue === false) {
	        break;
	      }
	    }
	  };
	};
	
	oo.initClass(Registry);
	
	module.exports = Registry;


/***/ },
/* 35 */
/***/ function(module, exports) {

	/*!
	Math.uuid.js (v1.4)
	http://www.broofa.com
	mailto:robert@broofa.com
	Copyright (c) 2010 Robert Kieffer
	Dual licensed under the MIT and GPL licenses.
	*/
	
	/**
	 * Generates a unique id.
	 *
	 * @method uuid
	 * @param {String} [prefix] if provided the UUID will be prefixed.
	 * @param {Number} [len] if provided a UUID with given length will be created.
	 * @return A generated uuid.
	 */
	module.exports = function uuid(prefix, len) {
	  if (prefix && prefix[prefix.length-1] !== "_") {
	    prefix = prefix.concat("_");
	  }
	  var chars = '0123456789abcdefghijklmnopqrstuvwxyz'.split(''),
	      uuid = [],
	      radix = 16,
	      idx;
	  len = len || 32;
	  if (len) {
	    // Compact form
	    for (idx = 0; idx < len; idx++) uuid[idx] = chars[0 | Math.random()*radix];
	  } else {
	    // rfc4122, version 4 form
	    var r;
	    // rfc4122 requires these characters
	    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
	    uuid[14] = '4';
	    // Fill in random data.  At i==19 set the high bits of clock sequence as
	    // per rfc4122, sec. 4.1.5
	    for (idx = 0; idx < 36; idx++) {
	      if (!uuid[idx]) {
	        r = 0 | Math.random()*16;
	        uuid[idx] = chars[(idx == 19) ? (r & 0x3) | 0x8 : r];
	      }
	    }
	  }
	  return (prefix ? prefix : "") + uuid.join('');
	};


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var OO = __webpack_require__(2);
	var _ = __webpack_require__(1);
	var uuid = __webpack_require__(35);
	var EventEmitter = __webpack_require__(27);
	
	/**
	 * Base node implemention.
	 *
	 * @class Data.Node
	 * @extends EventEmitter
	 * @constructor
	 * @param {Object} properties
	 * @module Data
	 */
	function Node( properties ) {
	  EventEmitter.call(this);
	
	  /**
	   * The internal storage for properties.
	   * @property properties {Object}
	   */
	  this.properties = _.extend({}, this.getDefaultProperties(), properties);
	  this.properties.type = this.constructor.static.name;
	  this.properties.id = this.properties.id || uuid(this.properties.type);
	}
	
	Node.Prototype = function() {
	
	  /**
	   * Serialize to JSON.
	   *
	   * @method toJSON
	   * @return Plain object.
	   */
	  this.toJSON = function() {
	    return this.properties;
	  };
	
	  /**
	   * Get default properties.
	   *
	   * Stub implementation.
	   *
	   * @method getDefaultProperties
	   * @return An object containing default properties.
	   */
	  this.getDefaultProperties = function() {};
	
	  /**
	   * Check if the node is of a given type.
	   *
	   * @method isInstanceOf
	   * @param {String} typeName
	   * @return true if the node has a parent with given type, false otherwise.
	   */
	  this.isInstanceOf = function(typeName) {
	    return Node.isInstanceOf(this.constructor, typeName);
	  };
	
	  /**
	   * Get a the list of all polymorphic types.
	   *
	   * @method getTypeNames
	   * @return An array of type names.
	   */
	  this.getTypeNames = function() {
	    var typeNames = [];
	    var staticData = this.constructor.static;
	    while (staticData && staticData.name !== "node") {
	      typeNames.push(staticData.name);
	      staticData = Object.getPrototypeOf(staticData);
	    }
	    return typeNames;
	  };
	
	  /**
	   * Get the type of a property.
	   *
	   * @method getPropertyType
	   * @param {String} propertyName
	   * @return The property's type.
	   */
	  this.getPropertyType = function(propertyName) {
	    var schema = this.constructor.static.schema;
	    return schema[propertyName];
	  };
	
	};
	
	OO.inherit(Node, EventEmitter);
	
	/**
	 * Symbolic name for this model class. Must be set to a unique string by every subclass.
	 * @static
	 * @property name {String}
	 */
	Node.static.name = "node";
	
	/**
	 * The node schema.
	 *
	 * @property schema {Object}
	 * @static
	 */
	Node.static.schema = {
	  type: 'string',
	  id: 'string'
	};
	
	/**
	 * Read-only properties.
	 *
	 * @property readOnlyProperties {Array}
	 * @static
	 */
	Node.static.readOnlyProperties = ['type', 'id'];
	
	/**
	 * Internal implementation of Node.prototype.isInstanceOf.
	 *
	 * @method isInstanceOf
	 * @static
	 * @private
	 */
	 Node.isInstanceOf = function(NodeClass, typeName) {
	  var staticData = NodeClass.static;
	  while (staticData && staticData.name !== "node") {
	    if (staticData && staticData.name === typeName) {
	      return true;
	    }
	    staticData = Object.getPrototypeOf(staticData);
	  }
	  return false;
	};
	
	Node.static.isInstanceOf = Node.isInstanceOf;
	
	var defineProperty = function(prototype, property, readonly) {
	  var getter, setter;
	  getter = function() {
	    return this.properties[property];
	  };
	  if (readonly) {
	    setter = function() {
	      throw new Error("Property " + property + " is readonly!");
	    };
	  } else {
	    setter = function(val) {
	      this.properties[property] = val;
	      return this;
	    };
	  }
	  var spec = {
	    get: getter,
	    set: setter
	  };
	  Object.defineProperty(prototype, property, spec);
	};
	
	var defineProperties = function(NodeClass) {
	  var prototype = NodeClass.prototype;
	  if (!NodeClass.static.schema) return;
	  var properties = Object.keys(NodeClass.static.schema);
	  for (var i = 0; i < properties.length; i++) {
	    var property = properties[i];
	    if (prototype.hasOwnProperty(property)) continue;
	    var readonly = ( NodeClass.static.readOnlyProperties &&
	      NodeClass.static.readOnlyProperties.indexOf(property) > 0 );
	    defineProperty(prototype, property, readonly);
	  }
	};
	
	var extend;
	
	var prepareSchema = function(NodeClass) {
	  var schema = NodeClass.static.schema;
	  var parentStatic = Object.getPrototypeOf(NodeClass.static);
	  var parentSchema = parentStatic.schema;
	  if (parentSchema) {
	    NodeClass.static.schema = _.extend(Object.create(parentSchema), schema);
	  }
	};
	
	var initNodeClass = function(NodeClass) {
	  // add a extend method so that this class can be used to create child models.
	  NodeClass.extend = _.bind(extend, null, NodeClass);
	  // define properties and so on
	  defineProperties(NodeClass);
	  prepareSchema(NodeClass);
	  NodeClass.type = NodeClass.static.name;
	};
	
	// TODO: try to reuse OO.extend here. Will need some changes to OO.extend, though.
	
	extend = function( parent, modelSpec ) {
	  var ctor = function NodeClass() {
	    parent.apply(this, arguments);
	    if (this.init) {
	      this.init.apply(this, arguments);
	    }
	  };
	  OO.inherit(ctor, parent);
	  for(var key in modelSpec) {
	    if (modelSpec.hasOwnProperty(key)) {
	      if (key === "name" || key === "properties") {
	        continue;
	      }
	      ctor.prototype[key] = modelSpec[key];
	    }
	  }
	  ctor.static.name = modelSpec.name;
	  ctor.static.schema = modelSpec.properties;
	  initNodeClass(ctor);
	  return ctor;
	};
	
	initNodeClass(Node);
	
	Node.initNodeClass = initNodeClass;
	
	module.exports = Node;


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var Substance = __webpack_require__(3);
	
	var ENTER = 1;
	var EXIT = -1;
	// Markers are put before other opening tags
	var ENTER_EXIT = -2;
	
	// Annotator
	// --------
	//
	// An algorithm that is used to fragment overlapping structure elements
	// following a priority rule set.
	// E.g., we use this for creating DOM elements for annotations. The annotations
	// can partially be overlapping. However this is not allowed in general for DOM elements
	// or other hierarchical structures.
	//
	// Example: For the Annotation use casec consider a 'comment' spanning partially
	// over an 'emphasis' annotation.
	// 'The <comment>quick brown <bold>fox</comment> jumps over</bold> the lazy dog.'
	// We want to be able to create a valid XML structure:
	// 'The <comment>quick brown <bold>fox</bold></comment><bold> jumps over</bold> the lazy dog.'
	//
	// For that one would choose
	//
	//     {
	//        'comment': 0,
	//        'bold': 1
	//     }
	//
	// as priority levels.
	// In case of structural violations as in the example, elements with a higher level
	// would be fragmented and those with lower levels would be preserved as one piece.
	//
	// TODO: If a violation for nodes of the same level occurs an Error should be thrown.
	// Currently, in such cases the first element that is opened earlier is preserved.
	
	var Annotator = function(options) {
	  Substance.extend(this, options);
	};
	
	Annotator.Prototype = function() {
	
	  // This is a sweep algorithm wich uses a set of ENTER/EXIT entries
	  // to manage a stack of active elements.
	  // Whenever a new element is entered it will be appended to its parent element.
	  // The stack is ordered by the annotation types.
	  //
	  // Examples:
	  //
	  // - simple case:
	  //
	  //       [top] -> ENTER(idea1) -> [top, idea1]
	  //
	  //   Creates a new 'idea' element and appends it to 'top'
	  //
	  // - stacked ENTER:
	  //
	  //       [top, idea1] -> ENTER(bold1) -> [top, idea1, bold1]
	  //
	  //   Creates a new 'bold' element and appends it to 'idea1'
	  //
	  // - simple EXIT:
	  //
	  //       [top, idea1] -> EXIT(idea1) -> [top]
	  //
	  //   Removes 'idea1' from stack.
	  //
	  // - reordering ENTER:
	  //
	  //       [top, bold1] -> ENTER(idea1) -> [top, idea1, bold1]
	  //
	  //   Inserts 'idea1' at 2nd position, creates a new 'bold1', and appends itself to 'top'
	  //
	  // - reordering EXIT
	  //
	  //       [top, idea1, bold1] -> EXIT(idea1)) -> [top, bold1]
	  //
	  //   Removes 'idea1' from stack and creates a new 'bold1'
	  //
	
	  // Orders sweep events according to following precedences:
	  //
	  // 1. pos
	  // 2. EXIT < ENTER
	  // 3. if both ENTER: ascending level
	  // 4. if both EXIT: descending level
	
	  var _compare = function(a, b) {
	    if (a.pos < b.pos) return -1;
	    if (a.pos > b.pos) return 1;
	
	    if (a.id === b.id) {
	      return b.mode - a.mode;
	    }
	
	    if (a.mode < b.mode) return -1;
	    if (a.mode > b.mode) return 1;
	
	    if (a.mode === ENTER) {
	      if (a.level < b.level) return -1;
	      if (a.level > b.level) return 1;
	    }
	
	    if (a.mode === EXIT) {
	      if (a.level > b.level) return -1;
	      if (a.level < b.level) return 1;
	    }
	
	    return 0;
	  };
	
	  var extractEntries = function(annotations) {
	    var entries = [];
	    Substance.each(annotations, function(a) {
	      // special treatment for zero-width annos such as ContainerAnnotation.Anchors
	      if (a.zeroWidth) {
	        entries.push({ pos: a.offset, mode: ENTER_EXIT, id: a.id, level: Number.MAX_VALUE, type: 'anchor', node: a });
	      } else {
	        // use a weak default level when not given
	        var l = a.constructor.static.level || 1000;
	        entries.push({ pos : a.startOffset, mode: ENTER, level: l, id: a.id, type: a.type, node: a });
	        entries.push({ pos : a.endOffset, mode: EXIT, level: l, id: a.id, type: a.type, node: a });
	      }
	    });
	    return entries;
	  };
	
	  this.onText = function(/*context, text*/) {};
	
	  // should return the created user context
	  this.onEnter = function(/*entry, parentContext*/) {
	    return null;
	  };
	
	  this.onExit = function(/*entry, context, parentContext*/) {};
	
	  this.enter = function(entry, parentContext) {
	    return this.onEnter(entry, parentContext);
	  };
	
	  this.exit = function(entry, context, parentContext) {
	    this.onExit(entry, context, parentContext);
	  };
	
	  this.createText = function(context, text) {
	    if (text.length > 0) {
	      this.onText(context, text);
	    }
	  };
	
	  this.start = function(rootContext, text, annotations) {
	    var self = this;
	
	    var entries = extractEntries.call(this, annotations);
	    entries.sort(_compare.bind(this));
	    var stack = [{context: rootContext, entry: null}];
	    var pos = 0;
	
	    for (var i = 0; i < entries.length; i++) {
	      var entry = entries[i];
	      // in any case we add the last text to the current element
	      this.createText(stack[stack.length-1].context, text.substring(pos, entry.pos));
	
	      pos = entry.pos;
	      var stackLevel, idx;
	      if (entry.mode === ENTER || entry.mode === ENTER_EXIT) {
	        // find the correct position and insert an entry
	        for (stackLevel = 1; stackLevel < stack.length; stackLevel++) {
	          if (entry.level < stack[stackLevel].entry.level) {
	            break;
	          }
	        }
	        // create elements which are open, and are now stacked ontop of the
	        // entered entry
	        for (idx = stack.length-1; idx >= stackLevel; idx--) {
	          this.exit(stack[idx].entry, stack[idx].context, stack[idx-1].context);
	        }
	        stack.splice(stackLevel, 0, {entry: entry});
	        // create new elements for all lower entries
	        for (idx = stackLevel; idx < stack.length; idx++) {
	          stack[idx].context = self.enter(stack[idx].entry, stack[idx-1].context);
	        }
	      }
	      if (entry.mode === EXIT || entry.mode === ENTER_EXIT) {
	        // find the according entry and remove it from the stack
	        for (stackLevel = 1; stackLevel < stack.length; stackLevel++) {
	          if (stack[stackLevel].entry.node === entry.node) {
	            break;
	          }
	        }
	        for (idx = stack.length-1; idx >= stackLevel; idx--) {
	          this.exit(stack[idx].entry, stack[idx].context, stack[idx-1].context);
	        }
	        stack.splice(stackLevel, 1);
	        // create new elements for all lower entries
	        for (idx = stackLevel; idx < stack.length; idx++) {
	          stack[idx].context = self.enter(stack[idx].entry, stack[idx-1].context);
	        }
	      }
	    }
	
	    // Finally append a trailing text node
	    this.createText(rootContext, text.substring(pos));
	  };
	
	};
	
	Substance.initClass( Annotator );
	
	module.exports = Annotator;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(1);
	var OO = __webpack_require__(2);
	var HtmlImporter = __webpack_require__(71);
	var CLIPBOARD_CONTAINER_ID = __webpack_require__(43).CLIPBOARD_CONTAINER_ID;
	
	function ClipboardImporter(config) {
	  if (!config.schema) {
	    throw new Error('Missing argument: config.schema is required.');
	  }
	  _.extend(config, {
	    trimWhitespaces: true,
	    REMOVE_INNER_WS: true,
	  });
	  ClipboardImporter.super.call(this, config);
	}
	
	ClipboardImporter.Prototype = function() {
	
	  this.convert = function($rootEl, doc) {
	    this.initialize(doc, $rootEl);
	
	    var $body = $rootEl.find('body');
	    $body = this.sanitizeBody($body);
	    // TODO: the containerId for the clipboard content should be
	    // shared via a constant (see)
	    this.convertContainer($body, CLIPBOARD_CONTAINER_ID);
	    this.finish();
	  };
	
	  this.sanitizeBody = function($body) {
	    // Look for paragraphs in <b> which is served by GDocs.
	    var $gdocs = $body.find('b > p');
	    if ($gdocs.length) {
	      $body = $($gdocs[0].parentNode);
	    }
	    return $body;
	  };
	
	  this.checkQuality = function($rootEl) {
	    var $body = $rootEl.find('body');
	    // TODO: proper GDocs detection
	    if ($body.children('b').children('p').length) {
	      return true;
	    }
	    // Are there any useful block-level elements?
	    // For example this works if you copy'n'paste a set of paragraphs from a wikipedia page
	    if ($body.children('p').length) {
	      return true;
	    }
	    // if we have paragraphs on a deeper level, it is fishy
	    if ($body.find('* p').length) {
	      return false;
	    }
	    if ($body.children('a,b,i,strong,italic').length) {
	      return true;
	    }
	    // TODO: how does the content for inline data look like?
	    return false;
	  };
	
	};
	
	OO.inherit(ClipboardImporter, HtmlImporter);
	
	module.exports = ClipboardImporter;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var OO = __webpack_require__(2);
	var _ = __webpack_require__(1);
	
	// path: the address of a property, such as ['text_1', 'content']
	// offset: the position in the property
	// after: an internal flag indicating if the address should be associated to the left or right side
	//   Note: at boundaries of annotations there are two possible positions with the same address
	//       foo <strong>bar</strong> ...
	//     With offset=7 normally we associate this position:
	//       foo <strong>bar|</strong> ...
	//     With after=true we can describe this position:
	//       foo <strong>bar</strong>| ...
	function Coordinate(path, offset, after) {
	  this.path = path;
	  this.offset = offset;
	  this.after = after;
	  if (!_.isArray(path)) {
	    throw new Error('Invalid arguments: path should be an array.');
	  }
	  if (!_.isNumber(offset) || offset < 0) {
	    throw new Error('Invalid arguments: offset must be a positive number.');
	  }
	  // make sure that path can't be changed afterwards
	  if (!Object.isFrozen(path)) {
	    Object.freeze(path);
	  }
	  Object.freeze(this);
	}
	
	Coordinate.Prototype = function() {
	
	  this.equals = function(other) {
	    return (other === this ||
	      (_.isArrayEqual(other.path, this.path) && other.offset === this.offset) );
	  };
	
	  this.withCharPos = function(offset) {
	    return new Coordinate(this.path, offset);
	  };
	
	  this.getNodeId = function() {
	    return this.path[0];
	  };
	
	  this.getPath = function() {
	    return this.path;
	  };
	
	  this.getOffset = function() {
	    return this.offset;
	  };
	
	};
	
	OO.initClass( Coordinate );
	
	module.exports = Coordinate;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var OO = __webpack_require__(2);
	var Selection = __webpack_require__(19);
	var Coordinate = __webpack_require__(39);
	var Range = __webpack_require__(41);
	
	function PropertySelection(properties) {
	  var path = properties.path;
	  var startOffset = properties.startOffset;
	  var endOffset = properties.endOffset || properties.startOffset;
	  if (!path || !_.isNumber(startOffset)) {
	    throw new Error('Invalid arguments: `path` and `startOffset` are mandatory');
	  }
	  this.range = new Range(
	    new Coordinate(path, startOffset),
	    new Coordinate(path, endOffset)
	  );
	  this.reverse = properties.reverse;
	  this._internal = {};
	  Object.freeze(this);
	}
	
	PropertySelection.Prototype = function() {
	
	  _.extend(this, Selection.prototype);
	
	  this.toJSON = function() {
	    return {
	      type: 'property',
	      path: this.path,
	      startOffset: this.startOffset,
	      endOffset: this.endOffset,
	      reverse: this.reverse
	    };
	  };
	
	  this.attach = function(doc) {
	    this._internal.doc = doc;
	    return this;
	  };
	
	  this.isNull = function() {
	    return false;
	  };
	
	  this.getRanges = function() {
	    return [this.range];
	  };
	
	  this.getRange = function() {
	    return this.range;
	  };
	
	  this.isCollapsed = function() {
	    return this.range.isCollapsed();
	  };
	
	  this.isReverse = function() {
	    return this.reverse;
	  };
	
	  this.isPropertySelection = function() {
	    return true;
	  };
	
	  this.isMultiSeletion = function() {
	    return false;
	  };
	
	  this.equals = function(other) {
	    return (
	      Selection.prototype.equals.call(this, other) &&
	      !other.isTableSelection() &&
	      this.range.equals(other.range)
	    );
	  };
	
	  this.collapse = function(direction) {
	    var coor;
	    if (direction === 'left') {
	      coor = this.range.start;
	    } else {
	      coor = this.range.end;
	    }
	    return this.createWithNewRange(coor.offset, coor.offset);
	  };
	
	  // Helper Methods
	  // ----------------------
	
	  this.getPath = function() {
	    return this.range.start.path;
	  };
	
	  this.getStartOffset = function() {
	    return this.range.start.offset;
	  };
	
	  this.getEndOffset = function() {
	    return this.range.end.offset;
	  };
	
	  this.toString = function() {
	    return [
	      "PropertySelection(", JSON.stringify(this.range.start.path), ", ",
	        this.range.start.offset, " -> ", this.range.end.offset,
	        (this.reverse?", reverse":""),
	        (this.range.start.after?", after":""),
	      ")"
	    ].join('');
	  };
	
	  this.isInsideOf = function(other, strict) {
	    if (other.isNull()) return false;
	    if (other.isContainerSelection()) {
	      // console.log('PropertySelection.isInsideOf: delegating to ContainerSelection.contains...');
	      return other.contains(this);
	    }
	    if (strict) {
	      return (_.isEqual(this.path, other.path) &&
	        this.start.offset > other.start.offset &&
	        this.end.offset < other.end.offset);
	    } else {
	      return (_.isEqual(this.path, other.path) &&
	        this.start.offset >= other.start.offset &&
	        this.end.offset <= other.end.offset);
	    }
	  };
	
	  this.contains = function(other, strict) {
	    if (other.isNull()) return false;
	    if (other.isContainerSelection()) {
	      // console.log('PropertySelection.contains: delegating to ContainerSelection.isInsideOf...');
	      return other.isInsideOf(this);
	    }
	    if (strict) {
	      return (_.isEqual(this.path, other.path) &&
	        this.start.offset < other.start.offset &&
	        this.end.offset > other.end.offset);
	    } else {
	      return (_.isEqual(this.path, other.path) &&
	        this.start.offset <= other.start.offset &&
	        this.end.offset >= other.end.offset);
	    }
	  };
	
	  this.overlaps = function(other, strict) {
	    if (other.isNull()) return false;
	    if (other.isContainerSelection()) {
	      // console.log('PropertySelection.overlaps: delegating to ContainerSelection.overlaps...');
	      return other.overlaps(this);
	    }
	    if (!_.isEqual(this.getPath(), other.getPath())) return false;
	    if (strict) {
	      return (! (this.startOffset>=other.endOffset||this.endOffset<=other.startOffset) );
	    } else {
	      return (! (this.startOffset>other.endOffset||this.endOffset<other.startOffset) );
	    }
	  };
	
	  this.isRightAlignedWith = function(other) {
	    if (other.isNull()) return false;
	    if (other.isContainerSelection()) {
	      // console.log('PropertySelection.isRightAlignedWith: delegating to ContainerSelection.isRightAlignedWith...');
	      return other.isRightAlignedWith(this);
	    }
	    return (_.isEqual(this.getPath(), other.getPath()) &&
	      this.getEndOffset() === other.getEndOffset());
	  };
	
	  this.isLeftAlignedWith = function(other) {
	    if (other.isNull()) return false;
	    if (other.isContainerSelection()) {
	      // console.log('PropertySelection.isLeftAlignedWith: delegating to ContainerSelection.isLeftAlignedWith...');
	      return other.isLeftAlignedWith(this);
	    }
	    return (_.isEqual(this.getPath(), other.getPath()) &&
	      this.getStartOffset() === other.getStartOffset());
	  };
	
	  this.expand = function(other) {
	    if (other.isNull()) return this;
	    if (other.isContainerSelection()) {
	      // console.log('PropertySelection.expand: delegating to ContainerSelection.expand...');
	      return other.expand(this);
	    }
	    if (!_.isEqual(this.path, other.path)) {
	      throw new Error('Can not expand PropertySelection to a different property.');
	    }
	    var newStartOffset = Math.min(this.startOffset, other.startOffset);
	    var newEndOffset = Math.max(this.endOffset, other.endOffset);
	    return this.createWithNewRange(newStartOffset, newEndOffset);
	  };
	
	  this.createWithNewRange = function(startOffset, endOffset) {
	    return new PropertySelection({
	      path: this.path,
	      startOffset: startOffset,
	      endOffset: endOffset
	    });
	  };
	
	  this.truncate = function(other) {
	    if (other.isNull()) return this;
	    // Checking that paths are ok
	    // doing that in a generalized manner so that other can even be a ContainerSelection
	    if (!_.isEqual(this.start.path, other.start.path) ||
	      !_.isEqual(this.end.path, other.end.path)) {
	      throw new Error('Can not expand PropertySelection to a different property.');
	    }
	    var newStartOffset;
	    var newEndOffset;
	    if (this.startOffset === other.startOffset) {
	      newStartOffset = other.endOffset;
	      newEndOffset = this.endOffset;
	    } else if (this.endOffset === other.endOffset) {
	      newStartOffset = this.startOffset;
	      newEndOffset = other.startOffset;
	    }
	    return this.createWithNewRange(newStartOffset, newEndOffset);
	  };
	
	  this._coordinates = function() {
	    return this;
	  };
	};
	
	OO.inherit(PropertySelection, Selection);
	
	Object.defineProperties(PropertySelection.prototype, {
	  start: {
	    get: function() {
	      return this.range.start;
	    },
	    set: function() { throw new Error('immutable.'); }
	  },
	  end: {
	    get: function() {
	      return this.range.end;
	    },
	    set: function() { throw new Error('immutable.'); }
	  },
	  path: {
	    get: function() {
	      return this.range.start.path;
	    },
	    set: function() { throw new Error('immutable.'); }
	  },
	  startOffset: {
	    get: function() {
	      return this.range.start.offset;
	    },
	    set: function() { throw new Error('immutable.'); }
	  },
	  endOffset: {
	    get: function() {
	      return this.range.end.offset;
	    },
	    set: function() { throw new Error('immutable.'); }
	  },
	  collapsed: {
	    get: function() {
	      return this.isCollapsed();
	    },
	    set: function() { throw new Error('immutable.'); }
	  },
	
	});
	
	module.exports = PropertySelection;


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Substance = __webpack_require__(3);
	
	var Range = function(start, end) {
	  this.start = start;
	  this.end = end;
	  Object.freeze(this);
	};
	
	Range.Prototype = function() {
	
	  this.isCollapsed = function() {
	    return this.start.equals(this.end);
	  };
	
	  this.equals = function(other) {
	    if (this === other) return true;
	    else return (this.start.equals(other.start) && this.end.equals(other.end));
	  };
	
	};
	
	Substance.initClass(Range);
	
	module.exports = Range;


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var uuid = __webpack_require__(35);
	var deleteSelection = __webpack_require__(24);
	var Annotations = __webpack_require__(10);
	
	/* jshint latedef: false */
	
	/**
	 * @params args object with fields `selection`, `containerId`
	 */
	function breakNode(tx, args) {
	  if (!args.selection) {
	    throw new Error("Argument 'selection' is mandatory.");
	  }
	  if (!args.containerId) {
	    throw new Error("Argument 'containerId' is mandatory.");
	  }
	  if (!args.selection.isCollapsed()) {
	    args = deleteSelection(tx, args);
	  }
	  var range = args.selection.getRange();
	  var node = tx.get(range.start.path[0]);
	  var behavior = args.editingBehavior;
	  if (node.isInstanceOf('text')) {
	    return breakTextNode(tx, args);
	  } else if (behavior && behavior.canBreak(node.type)) {
	    var breaker = behavior.getBreaker(node.type);
	    return breaker.call(breaker, tx, args);
	  } else {
	    console.info("Breaking is not supported for node type %s.", node.type);
	    return args;
	  }
	}
	
	function breakTextNode(tx, args) {
	  var selection = args.selection;
	  var containerId = args.containerId;
	  if (!selection.isPropertySelection()) {
	    throw new Error('Expected property selection.');
	  }
	  var range = selection.getRange();
	  var path = range.start.path;
	  var offset = range.start.offset;
	  var node = tx.get(path[0]);
	
	  // split the text property and create a new paragraph node with trailing text and annotations transferred
	  var text = node.content;
	  var container = tx.get(containerId);
	  var nodePos = container.getPosition(node.id);
	  var id = uuid(node.type);
	  var newPath = [id, 'content'];
	  var newNode;
	  // when breaking at the first position, a new node of the same
	  // type will be inserted.
	  if (offset === 0) {
	    newNode = tx.create({
	      id: id,
	      type: node.type,
	      content: ""
	    });
	    // show the new node
	    container.show(id, nodePos);
	    selection = tx.createSelection({
	      type: 'property',
	      path: path,
	      startOffset: 0
	    });
	  }
	  // otherwise a default text type node is inserted
	  else {
	    // create a new node
	    newNode = tx.create({
	      id: id,
	      type: tx.getSchema().getDefaultTextType(),
	      content: text.substring(offset)
	    });
	    if (offset < text.length) {
	      // transfer annotations which are after offset to the new node
	      Annotations.transferAnnotations(tx, path, offset, [id, 'content'], 0);
	      // truncate the original property
	      tx.update(path, {
	        delete: { start: offset, end: text.length }
	      });
	    }
	    // show the new node
	    container.show(id, nodePos+1);
	    // update the selection
	    selection = tx.createSelection({
	      type: 'property',
	      path: newPath,
	      startOffset: 0
	    });
	  }
	  args.selection = selection;
	  args.node = newNode;
	  return args;
	}
	
	module.exports = breakNode;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var Annotations = __webpack_require__(10);
	
	/* jshint latedef: false */
	
	// create a document instance containing only the selected content
	var copySelection = function(doc, args) {
	  var selection = args.selection;
	  if (selection.isNull()) {
	    args.doc = null;
	  }
	  // return a simplified version if only a piece of text is selected
	  else if (selection.isPropertySelection() || _.isEqual(selection.start.path, selection.end.path)) {
	    args.doc = _copyPropertySelection(doc, selection);
	  }
	  else if (selection.isContainerSelection()) {
	    args.doc = _copyContainerSelection(doc, selection);
	  } else {
	    console.error('Copy is not yet supported for selection type.');
	    args.doc = null;
	  }
	  return args;
	};
	
	var _copyPropertySelection = function(doc, selection) {
	  var copy = doc.newInstance();
	  copy._setForClipboard(true);
	  var path = selection.start.path;
	  var offset = selection.start.offset;
	  var endOffset = selection.end.offset;
	  var text = doc.get(path);
	  var containerNode = copy.get(copySelection.CLIPBOARD_CONTAINER_ID);
	  if (!containerNode) {
	    containerNode = copy.create({
	      type: 'container',
	      id: copySelection.CLIPBOARD_CONTAINER_ID,
	      nodes: []
	    });
	  }
	  copy.create({
	    type: doc.schema.getDefaultTextType(),
	    id: 'text',
	    content: text.substring(offset, endOffset)
	  });
	  containerNode.show('text');
	  var annotations = doc.getIndex('annotations').get(path, offset, endOffset);
	  _.each(annotations, function(anno) {
	    var data = _.deepclone(anno.toJSON());
	    data.path = ['text', 'content'];
	    data.startOffset = Math.max(offset, anno.startOffset)-offset;
	    data.endOffset = Math.min(endOffset, anno.endOffset)-offset;
	    copy.create(data);
	  });
	  return copy;
	};
	
	var _copyContainerSelection = function(doc, selection) {
	  var copy = doc.newInstance();
	  copy._setForClipboard(true);
	  var annotationIndex = doc.getIndex('annotations');
	  var container = doc.get(selection.containerId);
	  var startComp = container.getComponent(selection.start.path);
	  var endComp = container.getComponent(selection.end.path);
	  var containerNode = copy.create({
	    type: 'container',
	    id: copySelection.CLIPBOARD_CONTAINER_ID,
	    nodes: []
	  });
	  // 1. Copy nodes and annotations.
	  var i, comp;
	  var created = {};
	  for (i = startComp.getIndex(); i <= endComp.getIndex(); i++) {
	    comp = container.getComponentAt(i);
	    var nodeId = comp.parentNode.id;
	    var node = doc.get(nodeId);
	    if (!created[nodeId]) {
	      created[nodeId] = copy.create(node.toJSON());
	      containerNode.show(nodeId);
	    }
	    var annotations = annotationIndex.get(comp.path);
	    for (var j = 0; j < annotations.length; j++) {
	      copy.create(_.deepclone(annotations[j].toJSON()));
	    }
	  }
	  // 2. Truncate properties according to the selection.
	  // TODO: we need a more sophisticated concept when we introduce dynamic structures
	  // such as lists or tables
	  var startNodeComponent = startComp.parentNode;
	  var text;
	  for (i = 0; i < startNodeComponent.components.length; i++) {
	    comp = startNodeComponent.components[i];
	    if (comp === startComp) {
	      if (selection.start.offset > 0) {
	        text = doc.get(comp.path);
	        copy.update(comp.path, {
	          delete: { start: 0, end: selection.start.offset }
	        });
	        Annotations.deletedText(copy, comp.path, 0, selection.start.offset);
	      }
	      break;
	    } else {
	      copy.set(comp.path, "");
	    }
	  }
	  var endNodeComponent = endComp.parentNode;
	  for (i = 0; i < endNodeComponent.components.length; i++) {
	    comp = endNodeComponent.components[i];
	    if (comp === endComp) {
	      text = doc.get(comp.path);
	      if (selection.end.offset < text.length) {
	        copy.update(comp.path, {
	          delete: { start: selection.end.offset, end: text.length }
	        });
	        Annotations.deletedText(copy, comp.path, selection.end.offset, text.length);
	      }
	      break;
	    } else {
	      copy.set(comp.path, "");
	    }
	  }
	  return copy;
	};
	
	copySelection.CLIPBOARD_CONTAINER_ID = "clipboard_content";
	
	module.exports = copySelection;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	
	/**
	 * Delete a node and all annotations attached to it,
	 * and removes the node from all containers.
	 *
	 * @param args object with fields: `nodeId`.
	 */
	function deleteNode(tx, args) {
	  if (!args.nodeId) {
	    throw new Error('Parameter `nodeId` is mandatory.');
	  }
	  var nodeId = args.nodeId;
	  // remove all associated annotations
	  var annos = tx.getIndex('annotations').get(nodeId);
	  var i;
	  for (i = 0; i < annos.length; i++) {
	    tx.delete(annos[i].id);
	  }
	  // We need to transfer anchors of ContainerAnnotations
	  // to previous or next node
	  var anchors = tx.getIndex('container-annotation-anchors').get(nodeId);
	  for (i = 0; i < anchors.length; i++) {
	    var anchor = anchors[i];
	    var container = tx.get(anchor.container);
	    // Note: during the course of this loop we might have deleted the node already
	    // so, do not do it again
	    if (!tx.get(anchor.id)) continue;
	    var comp = container.getComponent(anchor.path);
	    if (anchor.isStart) {
	      if (comp.hasNext()) {
	        tx.set([anchor.id, 'startPath'], comp.next.path);
	        tx.set([anchor.id, 'startOffset'], 0);
	      } else {
	        tx.delete(anchor.id);
	      }
	    } else {
	      if (comp.hasPrevious()) {
	        var prevLength = tx.get(comp.previous.path).length;
	        tx.set([anchor.id, 'endPath'], comp.previous.path);
	        tx.set([anchor.id, 'endOffset'], prevLength);
	      } else {
	        tx.delete(anchor.id);
	      }
	    }
	  }
	  _.each(tx.getIndex('type').get('container'), function(container) {
	    // remove from view first
	    container.hide(nodeId);
	  });
	  // and then delete permanently
	  tx.delete(nodeId);
	  return args;
	}
	
	module.exports = deleteNode;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var Annotations = __webpack_require__(10);
	
	/* jshint latedef: false */
	
	// low-level merge implementation
	var merge = function(tx, args) {
	  var containerId = args.containerId;
	  var path = args.path;
	  var direction = args.direction;
	  if (!containerId||!path||!direction) {
	    throw new Error('Insufficient arguments! mandatory fields: `containerId`, `path`, `direction`');
	  }
	  var container = tx.get(containerId);
	  var component = container.getComponent(path);
	  var tmp;
	  if (direction === 'right' && component.next) {
	    tmp = _mergeComponents(tx, _.extend({}, args, {
	      containerId: containerId,
	      first: component,
	      second: component.next
	    }));
	    args.selection = tmp.selection;
	  } else if (direction === 'left' && component.previous) {
	    tmp = _mergeComponents(tx, _.extend({}, args, {
	      containerId: containerId,
	      first: component.previous,
	      second: component
	    }));
	    args.selection = tmp.selection;
	  } else {
	    // No behavior defined for this merge
	  }
	  return args;
	};
	
	var _mergeComponents = function(tx, args) {
	  var firstComp = args.first;
	  var secondComp = args.second;
	  var firstNode = tx.get(firstComp.parentNode.id);
	  var secondNode = tx.get(secondComp.parentNode.id);
	  var behavior = args.editingBehavior;
	  var mergeTrafo;
	  // some components consist of multiple child components
	  // in this case, a custom editing behavior must have been defined
	  if (firstNode === secondNode) {
	    if (behavior && behavior.canMergeComponents(firstNode.type)) {
	      mergeTrafo = behavior.getComponentMerger(firstNode.type);
	      return mergeTrafo.call(this, tx, _.extend({}, args, {
	        node: firstNode,
	        first: firstComp,
	        second: secondComp
	      }));
	    }
	  } else {
	    // most often a merge happens between two different nodes (e.g., 2 paragraphs)
	    mergeTrafo = _getNodeMerger(args.editingBehavior, firstNode, secondNode);
	    if (mergeTrafo) {
	      return mergeTrafo.call(this, tx, _.extend({}, args, {
	        containerId: args.containerId,
	        first: firstNode,
	        second: secondNode
	      }));
	    }
	  }
	  return args;
	};
	
	function _getNodeMerger(behavior, node, otherNode) {
	  if (behavior) {
	    if (behavior.canMerge(node.type, otherNode.type)) {
	      return behavior.getMerger(node.type, otherNode.type);
	    }
	    // Behaviors with text nodes involved
	    //
	    // 1. first textish, second custom
	    // Example:
	    //  <p>abc<p>
	    //  <ul>
	    //    <li>def</li>
	    //    <li>ghi</li>
	    //  </ul>
	    //
	    // could be transformed into
	    //
	    //  <p>abcdef<p>
	    //  <ul>
	    //    <li>ghi</li>
	    //  </ul>
	    else if (node.isInstanceOf('text') &&
	      behavior.canMerge('textish', otherNode.type)) {
	      return behavior.getMerger('textish', otherNode.type);
	    }
	    // 2. first custom, second textish
	    // Example:
	    //  <figure>
	    //     ...
	    //     <figcaption>abc</figcaption>
	    //  </figure>
	    //  <p>def</p>
	    //
	    //  could be transformed into
	    //
	    //  <figure>
	    //     ...
	    //     <figcaption>abcdef</figcaption>
	    //  </figure>
	    //
	    else if (otherNode.isInstanceOf('text') &&
	      behavior.canMerge(node.type, 'textish')) {
	      return behavior.getMerger(node.type, 'textish');
	    }
	  }
	  // Built-in behavior for textish nodes
	  if (node.isInstanceOf('text') && otherNode.isInstanceOf('text')) {
	    return _mergeTextNodes;
	  }
	  console.info("No merge behavior defined for %s <- %s", node.type, otherNode.type);
	  return null;
	}
	
	var _mergeTextNodes = function(tx, args) {
	  var containerId = args.containerId;
	  var first = args.first;
	  var second = args.second;
	  var container = tx.get(containerId);
	  var firstPath = first.getTextPath();
	  var firstText = first.getText();
	  var firstLength = firstText.length;
	  var secondPath = second.getTextPath();
	  var secondText = second.getText();
	  var selection;
	  if (firstLength === 0) {
	    // hide the second node
	    container.hide(firstPath[0]);
	    // delete the second node
	    tx.delete(firstPath[0]);
	    // set the selection to the end of the first component
	    selection = tx.createSelection({
	      type: 'property',
	      path: secondPath,
	      startOffset: 0
	    });
	  } else {
	    // append the second text
	    tx.update(firstPath, { insert: { offset: firstLength, value: secondText } });
	    // transfer annotations
	    Annotations.transferAnnotations(tx, secondPath, 0, firstPath, firstLength);
	    // hide the second node
	    container.hide(secondPath[0]);
	    // delete the second node
	    tx.delete(secondPath[0]);
	    // set the selection to the end of the first component
	    selection = tx.createSelection({
	      type: 'property',
	      path: firstPath,
	      startOffset: firstLength
	    });
	  }
	  args.selection = selection;
	  return args;
	};
	
	module.exports = merge;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(181);
	
	/**
	 * The base implementation of `_.isEqual` without support for `this` binding
	 * `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isWhere] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, isWhere, stackA, stackB) {
	  // Exit early for identical values.
	  if (value === other) {
	    // Treat `+0` vs. `-0` as not equal.
	    return value !== 0 || (1 / value == 1 / other);
	  }
	  var valType = typeof value,
	      othType = typeof other;
	
	  // Exit early for unlike primitive values.
	  if ((valType != 'function' && valType != 'object' && othType != 'function' && othType != 'object') ||
	      value == null || other == null) {
	    // Return `false` unless both values are `NaN`.
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isWhere, stackA, stackB);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(58),
	    metaMap = __webpack_require__(92);
	
	/**
	 * The base implementation of `setData` without support for hot loop detection.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ },
/* 48 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  start = start == null ? 0 : (+start || 0);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (typeof end == 'undefined' || end > length) ? length : (+end || 0);
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : (end - start) >>> 0;
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(8);
	
	/**
	 * Checks if `value` is in `cache` mimicking the return signature of
	 * `_.indexOf` by returning `0` if the value is found, else `-1`.
	 *
	 * @private
	 * @param {Object} cache The cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `0` if `value` is found, else `-1`.
	 */
	function cacheIndexOf(cache, value) {
	  var data = cache.data,
	      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	  return result ? 0 : -1;
	}
	
	module.exports = cacheIndexOf;


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var SetCache = __webpack_require__(172),
	    constant = __webpack_require__(94),
	    isNative = __webpack_require__(11);
	
	/** Native method references. */
	var Set = isNative(Set = global.Set) && Set;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = isNative(nativeCreate = Object.create) && nativeCreate;
	
	/**
	 * Creates a `Set` cache object to optimize linear searches of large arrays.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	 */
	var createCache = !(nativeCreate && Set) ? constant(null) : function(values) {
	  return new SetCache(values);
	};
	
	module.exports = createCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(176),
	    isObject = __webpack_require__(8);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtorWrapper(Ctor) {
	  return function() {
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, arguments);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtorWrapper;


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(8);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && (value === 0 ? ((1 / value) > 0) : !isObject(value));
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 53 */
/***/ function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    if (array[index] === placeholder) {
	      array[index] = PLACEHOLDER;
	      result[++resIndex] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(8);
	
	/**
	 * Converts `value` to an object if it is not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(12);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the `toStringTag` of values.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * for more details.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag) || false;
	}
	
	module.exports = isString;


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(25),
	    isArray = __webpack_require__(5),
	    isIndex = __webpack_require__(30),
	    isLength = __webpack_require__(7),
	    isObject = __webpack_require__(8),
	    support = __webpack_require__(57);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || (support.nonEnumArgs && isArguments(object))) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var isNative = __webpack_require__(11);
	
	/** Used to detect functions containing a `this` reference. */
	var reThis = /\bthis\b/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to detect DOM support. */
	var document = (document = global.window) && document.document;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * An object environment feature flags.
	 *
	 * @static
	 * @memberOf _
	 * @type Object
	 */
	var support = {};
	
	(function(x) {
	
	  /**
	   * Detect if functions can be decompiled by `Function#toString`
	   * (all but Firefox OS certified apps, older Opera mobile browsers, and
	   * the PlayStation 3; forced `false` for Windows 8 apps).
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.funcDecomp = !isNative(global.WinRTError) && reThis.test(function() { return this; });
	
	  /**
	   * Detect if `Function#name` is supported (all but IE).
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.funcNames = typeof Function.name == 'string';
	
	  /**
	   * Detect if the DOM is supported.
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  try {
	    support.dom = document.createDocumentFragment().nodeType === 11;
	  } catch(e) {
	    support.dom = false;
	  }
	
	  /**
	   * Detect if `arguments` object indexes are non-enumerable.
	   *
	   * In Firefox < 4, IE < 9, PhantomJS, and Safari < 5.1 `arguments` object
	   * indexes are non-enumerable. Chrome < 25 and Node.js < 0.11.0 treat
	   * `arguments` object indexes as non-enumerable and fail `hasOwnProperty`
	   * checks for indexes that exceed their function's formal parameters with
	   * associated values of `0`.
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  try {
	    support.nonEnumArgs = !propertyIsEnumerable.call(arguments, 1);
	  } catch(e) {
	    support.nonEnumArgs = true;
	  }
	}(0, 0));
	
	module.exports = support;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 58 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 59 */
/***/ function(module, exports) {

	'use strict';
	
	function Conflict(a, b) {
	  Error.call(this, "Conflict: " + JSON.stringify(a) +" vs " + JSON.stringify(b));
	  this.a = a;
	  this.b = b;
	}
	Conflict.prototype = Error.prototype;
	
	module.exports = Conflict;


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Substance = __webpack_require__(3);
	
	function NodeView(props) {
	  this.props = props;
	  this.doc = props.doc;
	  this.node = props.node;
	}
	
	NodeView.Prototype = function() {
	
	  this.tagName = 'div';
	
	  this.createElement = function() {
	    var element = document.createElement(this.getTagName());
	    var classNames = this.getClassNames();
	    $(element).addClass(classNames);
	    element.dataset.id = this.node.id;
	    return element;
	  };
	
	  this.getTagName = function() {
	    return this.node.constructor.static.tagName || this.tagName;
	  };
	
	  this.getClassNames = function() {
	    return [];
	  };
	
	  this.render = function() {
	    var element = this.createElement();
	    var children = this.props.children;
	    if (children) {
	      for (var i = 0; i < children.length; i++) {
	        var child = children[i];
	        if (Substance.isString(child)) {
	          element.appendChild(document.createTextNode(child));
	        } else if (child instanceof NodeView) {
	          var el = child.render();
	          element.appendChild(el);
	        } else if (child instanceof window.Node) {
	          element.appendChild(child);
	        }
	      }
	    }
	    return element;
	  };
	
	};
	
	Substance.initClass(NodeView);
	
	module.exports = NodeView;


/***/ },
/* 61 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};
	
	exports.__esModule = true;

/***/ },
/* 62 */
/***/ function(module, exports) {

	var core = module.exports = {};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 63 */
/***/ function(module, exports) {

	// http://jsperf.com/core-js-isobject
	module.exports = function(it){
	  return it !== null && (typeof it == 'object' || typeof it == 'function');
	};

/***/ },
/* 64 */
/***/ function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var Substance = __webpack_require__(3);
	var PathAdapter = Substance.PathAdapter;
	var EventEmitter = Substance.EventEmitter;
	
	/**
	 * A data storage implemention.
	 *
	 * @class Data
	 * @extends EventEmitter
	 * @constructor
	 * @param {Schema} schema
	 * @param {Object} [options]
	 * @module Data
	 */
	function Data(schema, options) {
	  EventEmitter.call(this);
	
	  this.schema = schema;
	  this.nodes = new PathAdapter();
	  this.indexes = {};
	  // Handlers that are called after a node was created or deleted
	  options = options || {};
	  // For example in Substance.Document this is used to attach and detach a document from a node.
	  this.didCreateNode = options.didCreateNode || function() {};
	  this.didDeleteNode = options.didDeleteNode || function() {};
	}
	
	Data.Prototype = function() {
	
	  /**
	   * Get a node or value via path.
	   *
	   * @method get
	   * @param {String|Array} path node id or path to property.
	   * @return a Node instance, a value or undefined if not found.
	   */
	  this.get = function(path) {
	    if (!path) {
	      throw new Error('Path or id required');
	    }
	    return this.nodes.get(path);
	  };
	
	  /**
	   * Get the internal storage for nodes.
	   *
	   * @method getNodes
	   * @return The internal node storage.
	   */
	  this.getNodes = function() {
	    return this.nodes;
	  };
	
	  /**
	   * Create a node from the given data.
	   *
	   * @method create
	   * @return {Node} The created node.
	   */
	  this.create = function(nodeData) {
	    var node = this.schema.getNodeFactory().create(nodeData.type, nodeData);
	    if (!node) {
	      throw new Error('Illegal argument: could not create node for data:', nodeData);
	    }
	    if (this.contains(node.id)) {
	      throw new Error("Node already exists: " + node.id);
	    }
	    if (!node.id || !node.type) {
	      throw new Error("Node id and type are mandatory.");
	    }
	    this.nodes[node.id] = node;
	    _.each(this.indexes, function(index) {
	      if (index.select(node)) {
	        index.create(node);
	      }
	    });
	    this.didCreateNode(node);
	    return node;
	  };
	
	  /**
	   * Delete the node with given id.
	   *
	   * @method delete
	   * @param {String} nodeId
	   * @return {Node} The deleted node.
	   */
	  this.delete = function(nodeId) {
	    var node = this.nodes[nodeId];
	    delete this.nodes[nodeId];
	    this.didDeleteNode(node);
	    _.each(this.indexes, function(index) {
	      if (index.select(node)) {
	        index.delete(node);
	      }
	    });
	    return node;
	  };
	
	  /**
	   * Set a property to a new value.
	   *
	   * @method set
	   * @param {Array} property path
	   * @param {Object} newValue
	   * @return {Node} The deleted node.
	   */
	  this.set = function(path, newValue) {
	    var node = this.get(path[0]);
	    var oldValue = this.nodes.get(path);
	    this.nodes.set(path, newValue);
	    _.each(this.indexes, function(index) {
	      if (index.select(node)) {
	        index.update(node, path, newValue, oldValue);
	      }
	    });
	    return oldValue;
	  };
	
	  // TODO: do we really want this incremental implementation here?
	  this.update = function(path, diff) {
	    var oldValue = this.nodes.get(path);
	    var newValue;
	    if (diff.isOperation) {
	      newValue = diff.apply(oldValue);
	    } else {
	      var start, end, pos, val;
	      if (_.isString(oldValue)) {
	        if (diff['delete']) {
	          // { delete: [2, 5] }
	          start = diff['delete'].start;
	          end = diff['delete'].end;
	          newValue = oldValue.split('').splice(start, end-start).join('');
	        } else if (diff['insert']) {
	          // { insert: [2, "foo"] }
	          pos = diff['insert'].offset;
	          val = diff['insert'].value;
	          newValue = [oldValue.substring(0, pos), val, oldValue.substring(pos)].join('');
	        } else {
	          throw new Error('Diff is not supported:', JSON.stringify(diff));
	        }
	      } else if (_.isArray(oldValue)) {
	        newValue = oldValue.slice(0);
	        if (diff['delete']) {
	          // { delete: 2 }
	          pos = diff['delete'].offset;
	          newValue.splice(pos, 1);
	        } else if (diff['insert']) {
	          // { insert: [2, "foo"] }
	          pos = diff['insert'].offset;
	          val = diff['insert'].value;
	          newValue.splice(pos, 0, val);
	        } else {
	          throw new Error('Diff is not supported:', JSON.stringify(diff));
	        }
	      } else {
	        throw new Error('Diff is not supported:', JSON.stringify(diff));
	      }
	    }
	    this.nodes.set(path, newValue);
	    var node = this.get(path[0]);
	    _.each(this.indexes, function(index) {
	      if (index.select(node)) {
	        index.update(node, path, oldValue, newValue);
	      }
	    });
	    return oldValue;
	  };
	
	  /**
	   * Convert to JSON.
	   *
	   * @method toJSON
	   * @return {Object} Plain content.
	   */
	  this.toJSON = function() {
	    return {
	      schema: [this.schema.id, this.schema.version],
	      nodes: _.deepclone(this.nodes)
	    };
	  };
	
	  /**
	   * Check if this storage contains a node with given id.
	   *
	   * @method contains
	   * @return {Boolean} `true` if a node with id exists, `false` otherwise.
	   */
	  this.contains = function(id) {
	    return (!!this.nodes[id]);
	  };
	
	  /**
	   * Clear nodes.
	   *
	   * @method reset
	   */
	  this.reset = function() {
	    this.nodes = new PathAdapter();
	  };
	
	  /**
	   * Add a node index.
	   *
	   * @method addIndex
	   * @param {String} name
	   * @param {NodeIndex} index
	   */
	  this.addIndex = function(name, index) {
	    if (this.indexes[name]) {
	      console.error('Index with name %s already exists.', name);
	    }
	    index.reset(this);
	    this.indexes[name] = index;
	    return index;
	  };
	
	  /**
	   * Get the node index with given name.
	   *
	   * @method getIndex
	   * @param {String} name
	   * @return The node index.
	   */
	  this.getIndex = function(name) {
	    return this.indexes[name];
	  };
	
	};
	
	Substance.inherit(Data, EventEmitter);
	
	module.exports = Data;


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var Substance = __webpack_require__(3);
	var Data = __webpack_require__(13);
	var Selection = __webpack_require__(19);
	var PropertySelection = __webpack_require__(40);
	var ContainerSelection = __webpack_require__(69);
	var TableSelection = __webpack_require__(74);
	
	function AbstractDocument(schema) {
	  Substance.EventEmitter.call(this);
	  this.schema = schema;
	
	  this.AUTO_ATTACH = true;
	  this.FOR_CLIPBOARD = false;
	
	  this.data = new Data.Incremental(schema, {
	    didCreateNode: _.bind(this._didCreateNode, this),
	    didDeleteNode: _.bind(this._didDeleteNode, this),
	  });
	}
	
	AbstractDocument.Prototype = function() {
	
	  this.isTransaction = function() {
	    return false;
	  };
	
	  this.isClipboard = function() {
	    return this.FOR_CLIPBOARD;
	  };
	
	  this.newInstance = function() {
	    throw new Error('Must be implemented in subclass.');
	  };
	
	  this.initialize = function() {
	    // add things to the document, such as containers etc.
	  };
	
	  this.addIndex = function(name, index) {
	    return this.data.addIndex(name, index);
	  };
	
	  this.getIndex = function(name) {
	    return this.data.getIndex(name);
	  };
	
	  /**
	   * Enable or disable auto-attaching of nodes.
	   * When this is enabled (default), a created node
	   * gets attached to the document instantly.
	   * Otherwise you need to take care of that yourself.
	   *
	   * Used internally e.g., by AbstractDocument.prototype.loadSeed()
	   */
	  this._setAutoAttach = function(val) {
	    this.AUTO_ATTACH = val;
	  };
	
	  this._setForClipboard = function(val) {
	    this.FOR_CLIPBOARD = val;
	  };
	
	  this._resetContainers = function() {
	    var containers = this.getIndex('type').get('container');
	    // reset containers initially
	    Substance.each(containers, function(container) {
	      container.reset();
	    });
	  };
	
	  this._create = function(nodeData) {
	    var op = this.data.create(nodeData);
	    this._updateContainers(op);
	    return op;
	  };
	
	  this._delete = function(nodeId) {
	    var op = this.data.delete(nodeId);
	    this._updateContainers(op);
	    return op;
	  };
	
	  this._update = function(path, diff) {
	    var op = this.data.update(path, diff);
	    this._updateContainers(op);
	    return op;
	  };
	
	  this._set = function(path, value) {
	    var op = this.data.set(path, value);
	    this._updateContainers(op);
	    return op;
	  };
	
	  this.documentDidLoad = function() {};
	
	  this.getSchema = function() {
	    return this.schema;
	  };
	
	  this.get = function(path) {
	    return this.data.get(path);
	  };
	
	  this.getNodes = function() {
	    return this.data.getNodes();
	  };
	
	  this.addIndex = function(name, index) {
	    return this.data.addIndex(name, index);
	  };
	
	  this.getIndex = function(name) {
	    return this.data.getIndex(name);
	  };
	
	  this.loadSeed = function(seed) {
	    // Attention: order of nodes may be 'invalid'
	    // so that we should not attach the doc a created note
	    // until all its dependencies are created
	    //
	    // Thus we disable AUTO_ATTACH when creating nodes
	
	    // 1. clear all existing nodes (as they should be there in the seed)
	    _.each(this.data.nodes, function(node) {
	      this.delete(node.id);
	    }, this);
	    // 2. create nodes with AUTO_ATTACH disabled
	    this._setAutoAttach(false);
	    _.each(seed.nodes, function(nodeData) {
	      this.create(nodeData);
	    }, this);
	    this._setAutoAttach(true);
	    // 3. attach all nodes
	    _.each(this.data.nodes, function(node) {
	      node.attach(this);
	    }, this);
	
	    this.documentDidLoad();
	  };
	
	  this.getTextForSelection = function(sel) {
	    var result = [];
	    var text;
	    if (!sel || sel.isNull()) {
	      return "";
	    } else if (sel.isPropertySelection()) {
	      text = this.get(sel.start.path);
	      result.push(text.substring(sel.start.offset, sel.end.offset));
	    } else if (sel.isContainerSelection()) {
	      var container = this.get(sel.containerId);
	      var components = container.getComponentsForRange(sel.range);
	      for (var i = 0; i < components.length; i++) {
	        var comp = components[i];
	        text = this.get(comp.path);
	        if (components.length === 1) {
	          result.push(text.substring(sel.start.offset, sel.end.offset));
	        } else if (i===0) {
	          result.push(text.substring(sel.start.offset));
	        } else if (i===components.length-1) {
	          result.push(text.substring(0, sel.end.offset));
	        } else {
	          result.push(text);
	        }
	      }
	    }
	    return result.join('');
	  };
	
	  this.toJSON = function() {
	    var nodes = {};
	    _.each(this.getNodes(), function(node) {
	      nodes[node.id] = node.toJSON();
	    });
	    return {
	      schema: [this.schema.name, this.schema.version],
	      nodes: nodes
	    };
	  };
	
	  this.create = function(nodeData) {
	    /* jshint unused:false */
	    throw new Error('Method is abstract.');
	  };
	
	  this.delete = function(nodeId) {
	    /* jshint unused:false */
	    throw new Error('Method is abstract.');
	  };
	
	  this.set = function(path, value) {
	    /* jshint unused:false */
	    throw new Error('Method is abstract.');
	  };
	
	  this.update = function(path, diff) {
	    /* jshint unused:false */
	    throw new Error('Method is abstract.');
	  };
	
	  this.setText = function(path, text, annotations) {
	    var idx;
	    var oldAnnos = this.getIndex('annotations').get(path);
	    // TODO: what to do with container annotations
	    for (idx = 0; idx < oldAnnos.length; idx++) {
	      this.delete(oldAnnos[idx].id);
	    }
	    this.set(path, text);
	    for (idx = 0; idx < annotations.length; idx++) {
	      this.create(annotations[idx]);
	    }
	  };
	
	  /**
	   * Creates a selection which is attached to this document.
	   * Every selection implementation provides its own
	   * parameter format which is basically a JSON representation.
	   *
	   * @param an object describing the selection.
	   * @example
	   *   doc.createSelection({
	   *     type: 'property',
	   *     path: [ 'text1', 'content'],
	   *     startOffset: 10,
	   *     endOffset: 20
	   *   })
	   */
	  this.createSelection = function(sel) {
	    if (!sel) {
	      return Selection.nullSelection;
	    }
	    switch(sel.type) {
	      case 'property':
	        return new PropertySelection(sel).attach(this);
	      case 'container':
	        return new ContainerSelection(sel).attach(this);
	      case 'table':
	        return new TableSelection(sel).attach(this);
	      default:
	        throw new Error('Unsupported selection type', sel.type);
	    }
	  };
	
	  // Called back by Substance.Data after a node instance has been created
	  this._didCreateNode = function(node) {
	    if (this.AUTO_ATTACH) {
	      // create the node from schema
	      node.attach(this);
	    } 
	  };
	
	  this._didDeleteNode = function(node) {
	    // create the node from schema
	    node.detach(this);
	  };
	
	  this._updateContainers = function(op) {
	    var containers = this.getIndex('type').get('container');
	    _.each(containers, function(container) {
	      container.update(op);
	    });
	  };
	};
	
	Substance.inherit(AbstractDocument, Substance.EventEmitter);
	
	module.exports = AbstractDocument;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var OO = __webpack_require__(2);
	var ClipboardImporter = __webpack_require__(38);
	var HtmlExporter = __webpack_require__(70);
	
	function ClipboardExporter() {
	  ClipboardExporter.super.call(this);
	}
	
	ClipboardExporter.Prototype = function() {
	
	
	  this.convert = function(doc, options) {
	    this.initialize(doc, options);
	    var $doc = this.createHtmlDocument();
	    // Note: the content of a clipboard document
	    // is coming as container with id 'clipboard'
	    var content = doc.get('clipboard_content');
	    $doc.find('body').append(this.convertContainer(content));
	
	    // This is not working with jquery
	    //return $doc.html();
	
	    return $doc.find('html').html();
	  };
	
	};
	
	OO.inherit(ClipboardExporter, HtmlExporter);
	
	module.exports = ClipboardExporter;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var OO = __webpack_require__(2);
	var PathAdapter = __webpack_require__(21);
	var Node = __webpack_require__(6);
	var ContainerAnnotation = __webpack_require__(22);
	
	// Container
	// --------
	//
	// A Container represents a list of node ids in first place.
	// At the same time it keeps a sequence of components which are the editable
	// properties of the nodes within this container.
	// While most editing occurs on a property level (such as editing text),
	// other things happen on a node level, e.g., breaking or mergin nodes,
	// or spanning annotations or so called ContainerAnnotations.
	// A Container provides a bridge between those two worlds: nodes and properties.
	//
	// Example:
	// A figure node might consist of a title, an image, and a caption.
	// As the image is not editable via conventional editing, we can say, the figure consists of
	// two editable properties 'title' and 'caption'.
	//
	// In our data model we can describe selections by a start coordinate and an end
	// coordinate, such as
	//      start: { path: ['paragraph_1', 'content'],   offset: 10 } },
	//      end:   { path: ['figure_10',   'caption'],   offset: 5  } }
	// I.e. such a selection starts in a component of a paragraph, and ends in the caption of a figure.
	// If you want to use that selection for deleting, you need to derive somehow what exactly
	// lies between those coordinates. For example, there could be some paragraphs, which would
	// get deleted completely and the paragraph and the figure where the selection started and ended
	// would only be updated.
	//
	function Container() {
	  Node.apply(this, arguments);
	  this.components = [];
	  this.nodeComponents = {};
	  this.byPath = new PathAdapter({});
	}
	
	Container.Prototype = function() {
	
	  this.didAttach = function() {
	    this.reset();
	  };
	
	  this.getPosition = function(nodeId) {
	    var pos = this.nodes.indexOf(nodeId);
	    return pos;
	  };
	
	  this.show = function(nodeId, pos) {
	    var doc = this.getDocument();
	    // Note: checking with ==  is what we want here
	    /* jshint eqnull: true */
	    if (pos == null) {
	      pos = this.nodes.length;
	    }
	    /* jshint eqnull: false */
	    doc.update([this.id, 'nodes'], { insert: { offset: pos, value: nodeId } });
	  };
	
	  this.hide = function(nodeId) {
	    var doc = this.getDocument();
	    var pos = this.nodes.indexOf(nodeId);
	    if (pos >= 0) {
	      doc.update([this.id, 'nodes'], { delete: { offset: pos } });
	    }
	  };
	
	  this.getComponents = function() {
	    return this.components;
	  };
	
	  this.getComponent = function(path) {
	    var comp = this.byPath.get(path);
	    return comp;
	  };
	
	  this.getComponentsForRange = function(range) {
	    var comps = [];
	    var startComp = this.byPath.get(range.start.path);
	    var endComp = this.byPath.get(range.end.path);
	    var startIdx = startComp.getIndex();
	    var endIdx = endComp.getIndex();
	    comps.push(startComp);
	    for (var idx = startIdx+1; idx <= endIdx; idx++) {
	      comps.push(this.getComponentAt(idx));
	    }
	    return comps;
	  };
	
	  this.getComponentAt = function(idx) {
	    return this.components[idx];
	  };
	
	  this.getFirstComponent = function() {
	    return this.components[0];
	  };
	
	  this.getLastComponent = function() {
	    return _.last(this.components);
	  };
	
	  this.getComponentsForNode = function(nodeId) {
	    var nodeComponent = this.nodeComponents[nodeId];
	    if (nodeComponent) {
	      return nodeComponent.components.slice(0);
	    }
	  };
	
	  this.getNodeForComponentPath = function(path) {
	    var comp = this.getComponent(path);
	    if (!comp) return null;
	    var nodeId = comp.rootId;
	    return this.getDocument().get(nodeId);
	  };
	
	  this.getAnnotationFragments = function(containerAnnotation) {
	    var fragments = [];
	    var doc = containerAnnotation.getDocument();
	    var anno = containerAnnotation;
	    var startAnchor = anno.getStartAnchor();
	    var endAnchor = anno.getEndAnchor();
	    // if start and end anchors are on the same property, then there is only one fragment
	    if (_.isEqual(startAnchor.path, endAnchor.path)) {
	      fragments.push(new ContainerAnnotation.Fragment(anno, startAnchor.path, "property"));
	    }
	    // otherwise create a trailing fragment for the property of the start anchor,
	    // full-spanning fragments for inner properties,
	    // and one for the property containing the end anchor.
	    else {
	      var text = doc.get(startAnchor.path);
	      var startComp = this.getComponent(startAnchor.path);
	      var endComp = this.getComponent(endAnchor.path);
	      if (!startComp || !endComp) {
	        throw new Error('Could not find components of AbstractContainerAnnotation');
	      }
	      fragments.push(new ContainerAnnotation.Fragment(anno, startAnchor.path, "start"));
	      for (var idx = startComp.idx + 1; idx < endComp.idx; idx++) {
	        var comp = this.getComponentAt(idx);
	        text = doc.get(comp.path);
	        fragments.push(new ContainerAnnotation.Fragment(anno, comp.path, "inner"));
	      }
	      fragments.push(new ContainerAnnotation.Fragment(anno, endAnchor.path, "end"));
	    }
	    return fragments;
	  };
	
	  this.reset = function() {
	    this.byPath = new PathAdapter();
	    var doc = this.getDocument();
	    var components = [];
	    _.each(this.nodes, function(id) {
	      var node = doc.get(id);
	      components = components.concat(_getNodeComponents(node));
	    }, this);
	    this.components = [];
	    this.nodeComponents = {};
	    this._insertComponentsAt(0, components);
	    this._updateComponentPositions(0);
	  };
	
	  // Incrementally updates the container based on a given operation.
	  // Gets called by Substance.Document for every applied operation.
	  this.update = function(op) {
	    if (op.type === "create" || op.type === "delete") {
	      return;
	    }
	    if (op.path[0] === this.id && op.path[1] === 'nodes') {
	      if (op.type === 'set') {
	        this.reset();
	      } else {
	        var diff = op.diff;
	        if (diff.isInsert()) {
	          var insertPos = this._handleInsert(diff.getValue(), diff.getOffset());
	          this._updateComponentPositions(insertPos);
	        } else if (diff.isDelete()) {
	          var deletePos = this._handleDelete(diff.getValue());
	          this._updateComponentPositions(deletePos);
	        } else {
	          throw new Error('Illegal state');
	        }
	      }
	    }
	    // HACK: this is for lists. We need to find a generalized way for hierarchical node types
	    else if (op.type === 'update' && op.path[1] === 'items') {
	      this.updateNode(op.path[0]);
	    }
	  };
	
	  // TODO: nested structures such as tables and lists should
	  // call this whenever they change
	  this.updateNode = function(nodeId) {
	    var node = this.getDocument().get(nodeId);
	    var deletePos = this._handleDelete(nodeId);
	    var components = _getNodeComponents(node);
	    this._insertComponentsAt(deletePos, components);
	    this._updateComponentPositions(deletePos);
	  };
	
	  this._insertComponentsAt = function(pos, components) {
	    var before = this.components[pos-1];
	    var after = this.components[pos];
	    var nodeComponents = this.nodeComponents;
	    var byPath = this.byPath;
	    for (var i = 0; i < components.length; i++) {
	      var comp = components[i];
	      var nodeId = comp.rootId;
	      var nodeComponent = nodeComponents[nodeId];
	      if (!nodeComponent) {
	        nodeComponent = new Container.NodeComponent(nodeId);
	        nodeComponents[nodeId] = nodeComponent;
	      }
	      comp.parentNode = nodeComponent;
	      if (i === 0 && before) {
	        before.next = comp;
	        comp.previous = before;
	      } else if (i > 0) {
	        comp.previous = components[i-1];
	        components[i-1].next = comp;
	      }
	      nodeComponent.components.push(comp);
	      byPath.set(comp.path, comp);
	    }
	    if (after) {
	      components[components.length-1].next = after;
	      after.previous = components[components.length-1];
	    }
	    this.components.splice.apply(this.components, [pos, 0].concat(components));
	  };
	
	  this._updateComponentPositions = function(startPos) {
	    for (var i = startPos; i < this.components.length; i++) {
	      this.components[i].idx = i;
	    }
	  };
	
	  // if something has been inserted, we need to get the next id
	  // and insert before its first component.
	  this._handleInsert = function(nodeId, nodePos) {
	    var doc = this.getDocument();
	    var node = doc.get(nodeId);
	    var length = this.nodes.length;
	    var componentPos;
	    // NOTE: the original length of the nodes was one less
	    // Thus, we detect an 'append' situation by comparing the insertPosition with
	    // the previous length
	    if (nodePos === length-1) {
	      componentPos = this.components.length;
	    } else {
	      var afterId = this.nodes[nodePos+1];
	      var after = this.nodeComponents[afterId].components[0];
	      componentPos = after.getIndex();
	    }
	    var components = _getNodeComponents(node);
	    this._insertComponentsAt(componentPos, components);
	    return componentPos;
	  };
	
	  this._handleDelete = function(nodeId) {
	    var nodeComponent = this.nodeComponents[nodeId];
	    var components = nodeComponent.components;
	    var start = nodeComponent.components[0].getIndex();
	    var end = _.last(components).getIndex();
	
	    // remove the components from the tree
	    for (var i = 0; i < components.length; i++) {
	      var comp = components[i];
	      this.byPath.delete(comp.path);
	    }
	    // and delete the nodeComponent
	    delete this.nodeComponents[nodeId];
	
	    this.components.splice(start, end-start+1);
	    if (this.components.length > start) {
	      this.components[start].previous = this.components[start-1];
	    }
	    if (start>0) {
	      this.components[start-1].next = this.components[start];
	    }
	    return start;
	  };
	
	  var _getNodeComponents = function(node, rootNode) {
	    rootNode = rootNode || node;
	    var components = [];
	    var componentNames = node.getComponents();
	    var childNode;
	    for (var i = 0; i < componentNames.length; i++) {
	      var name = componentNames[i];
	      var propertyType = node.getPropertyType(name);
	      // text property
	      if ( propertyType === "string" ) {
	        var path = [node.id, name];
	        components.push(new Container.Component(path, rootNode.id));
	      }
	      // child node
	      else if (propertyType === "id") {
	        var childId = node[name];
	        childNode = node.getDocument().get(childId);
	        components = components.concat(_getNodeComponents(childNode, rootNode));
	      }
	      // array of children
	      else if (_.isEqual(propertyType, ['array', 'id'])) {
	        var ids = node[name];
	        for (var j = 0; j < ids.length; j++) {
	          childNode = node.getDocument().get(ids[j]);
	          components = components.concat(_getNodeComponents(childNode, rootNode));
	        }
	      } else {
	        throw new Error('Not yet implemented.');
	      }
	    }
	    return components;
	  };
	};
	
	OO.inherit(Container, Node);
	
	Container.static.name = "container";
	
	Container.static.schema = {
	  nodes: ["array", "string"]
	};
	
	// HACK: ATM we do a lot of Node initialization, but we only do it using Node.extend(..)
	Node.initNodeClass(Container);
	
	Container.Component = function Component(path, rootId) {
	  this.path = path;
	  this.rootId = rootId;
	  // computed dynamically
	  this.idx = -1;
	  this.parentNode = null;
	  this.previous = null;
	  this.next = null;
	};
	
	Container.Component.Prototype = function() {
	
	  this.getPath = function() {
	    return this.path;
	  };
	
	  this.hasPrevious = function() {
	    return !!this.previous;
	  };
	
	  this.getPrevious = function() {
	    return this.previous;
	  };
	
	  this.hasNext = function() {
	    return !!this.next;
	  };
	
	  this.getNext = function() {
	    return this.next;
	  };
	
	  this.getIndex = function() {
	    return this.idx;
	  };
	
	  this.getParentNode = function() {
	    return this.parentNode;
	  };
	};
	
	OO.initClass(Container.Component);
	
	Container.NodeComponent = function NodeComponent(id) {
	  this.id = id;
	  this.components = [];
	};
	
	OO.initClass(Container.NodeComponent);
	
	module.exports = Container;


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var OO = __webpack_require__(2);
	var _ = __webpack_require__(1);
	var PropertySelection = __webpack_require__(40);
	var Selection = __webpack_require__(19);
	var Range = __webpack_require__(41);
	var Coordinate = __webpack_require__(39);
	
	function ContainerSelection(properties) {
	  // Note: not calling the super ctor as it freezes the instance
	  var containerId = properties.containerId;
	  var startPath = properties.startPath;
	  var endPath = properties.endPath || properties.startPath;
	  var startOffset = properties.startOffset;
	  var endOffset = properties.endOffset || properties.startOffset;
	  if (!containerId || !startPath || !_.isNumber(startOffset)) {
	    throw new Error('Invalid arguments: `containerId`, `startPath` and `startOffset` are mandatory');
	  }
	
	  // TODO: validate arguments
	  this.containerId = containerId;
	  this.range = new Range(
	    new Coordinate(startPath, startOffset),
	    new Coordinate(endPath, endOffset)
	  );
	  this.reverse = properties.reverse;
	  this._internal = {};
	  Object.freeze(this);
	}
	
	ContainerSelection.Prototype = function() {
	
	  this.toJSON = function() {
	    return {
	      type: 'container',
	      containerId: this.containerId,
	      startPath: this.startPath,
	      startOffset: this.startOffset,
	      endPath: this.endPath,
	      endOffset: this.endOffset,
	      reverse: this.reverse
	    };
	  };
	
	  this.attach = function(doc) {
	    this._internal.doc = doc;
	    return this;
	  };
	
	  this.isPropertySelection = function() {
	    return false;
	  };
	
	  this.isContainerSelection = function() {
	    return true;
	  };
	
	  this.toString = function() {
	    return "ContainerSelection("+ JSON.stringify(this.range.start.path) + ":" + this.range.start.offset + " -> " +  JSON.stringify(this.range.end.path) + ":" + this.range.end.offset + (this.reverse ? ", reverse" : "") + ")";
	  };
	
	  this.getDocument = function() {
	    var doc = this._internal.doc;
	    if (!doc) {
	      throw new Error('Selection is not attached to a document.');
	    }
	    return doc;
	  };
	
	  this.getContainer = function() {
	    return this.getDocument().get(this.containerId);
	  };
	
	  this.expand = function(other) {
	    var c1 = this._coordinates(this);
	    var c2 = this._coordinates(other);
	    var c1s = c1.start;
	    var c2s = c2.start;
	    var c1e = c1.end;
	    var c2e = c2.end;
	    var newCoors = {
	      start: { pos: c1s.pos, offset: c1s.offset },
	      end: { pos: c1e.pos, offset: c1e.offset }
	    };
	    if (c1s.pos > c2s.pos) {
	      newCoors.start.pos = c2s.pos;
	      newCoors.start.offset = c2s.offset;
	    } else if (c1s.pos === c2s.pos) {
	      newCoors.start.offset = Math.min(c1s.offset, c2s.offset);
	    }
	    if (c1e.pos < c2e.pos) {
	      newCoors.end.pos = c2e.pos;
	      newCoors.end.offset = c2e.offset;
	    } else if (c1e.pos === c2e.pos) {
	      newCoors.end.offset = Math.max(c1e.offset, c2e.offset);
	    }
	    return _createNewSelection(this, newCoors);
	  };
	
	  // There should be exactly one
	  this.truncate = function(other) {
	    var c1 = this._coordinates(this);
	    var c2 = this._coordinates(other);
	    var newCoors = {};
	    if (_isBefore(c2.start, c1.start, 'strict')) {
	      newCoors.start = c1.start;
	      newCoors.end = c2.end;
	    } else if (_isBefore(c1.end, c2.end, 'strict')) {
	      newCoors.start = c2.start;
	      newCoors.end = c1.end;
	    } else if (_isEqual(c1.start, c2.start)) {
	      if (_isEqual(c1.end, c2.end)) {
	        return Selection.nullSelection;
	      } else {
	        newCoors.start = c2.end;
	        newCoors.end = c1.end;
	      }
	    } else if (_isEqual(c1.end, c2.end)) {
	      newCoors.start = c1.start;
	      newCoors.end = c2.start;
	    }
	    return _createNewSelection(this, newCoors);
	  };
	
	  this.isInsideOf = function(other, strict) {
	    if (other.isNull()) return false;
	    var c1 = this._coordinates(this);
	    var c2 = this._coordinates(other);
	    return (_isBefore(c2.start, c1.start, strict) && _isBefore(c1.end, c2.end, strict));
	  };
	
	  this.contains = function(other) {
	    var c1 = this._coordinates(this);
	    var c2 = this._coordinates(other);
	    return (_isBefore(c1.start, c2.start) && _isBefore(c2.end, c1.end));
	  };
	
	  // includes and at least one boundary
	  this.includesWithOneBoundary = function(other) {
	    var c1 = this._coordinates(this);
	    var c2 = this._coordinates(other);
	    return (
	      (_isEqual(c1.start, c2.start) && _isBefore(c2.end, c1.end)) ||
	      (_isEqual(c1.end, c2.end) && _isBefore(c1.start, c2.start))
	    );
	  };
	
	  this.overlaps = function(other) {
	    var c1 = this._coordinates(this);
	    var c2 = this._coordinates(other);
	    // it overlaps if they are not disjunct
	    return !(_isBefore(c1.end, c2.start) || _isBefore(c2.end, c1.start));
	  };
	
	  this.isLeftAlignedWith = function(other) {
	    var c1 = this._coordinates(this);
	    var c2 = this._coordinates(other);
	    return _isEqual(c1.start, c2.start);
	  };
	
	  this.isRightAlignedWith = function(other) {
	    var c1 = this._coordinates(this);
	    var c2 = this._coordinates(other);
	    return _isEqual(c1.end, c2.end);
	  };
	
	  this.splitIntoPropertySelections = function() {
	    var sels = [];
	    var container = this.getContainer();
	    var comps = container.getComponentsForRange(this.range);
	    var doc = container.getDocument();
	    for (var i = 0; i < comps.length; i++) {
	      var comp = comps[i];
	      var startOffset, endOffset;
	      if (i===0) {
	        startOffset = this.startOffset;
	      } else {
	        startOffset = 0;
	      }
	      if (i===comps.length-1) {
	        endOffset = this.endOffset;
	      } else {
	        endOffset = doc.get(comp.path).length;
	      }
	      sels.push(doc.createSelection({
	        type: 'property',
	        path: comp.path,
	        startOffset: startOffset,
	        endOffset: endOffset
	      }));
	    }
	    return sels;
	  };
	
	  this._coordinates = function(sel) {
	    if (sel._internal.containerRange) {
	      return sel._internal.containerRange;
	    }
	    var container = this.getContainer();
	    var range = sel.getRange();
	    var startPos = container.getComponent(range.start.path).getIndex();
	    var endPos;
	    if (sel.isCollapsed()) {
	      endPos = startPos;
	    } else {
	      endPos = container.getComponent(range.end.path).getIndex();
	    }
	    var containerRange = {
	      start: {
	        pos: startPos,
	        offset: range.start.offset,
	      },
	      end: {
	        pos: endPos,
	        offset: range.end.offset
	      }
	    };
	    if (sel instanceof ContainerSelection) {
	      sel._internal.containerRange = containerRange;
	    }
	    return containerRange;
	  };
	
	  var _isBefore = function(c1, c2, strict) {
	    if (strict) {
	      if (c1.pos >= c2.pos) return false;
	      if (c1.pos == c2.pos && c1.offset >= c2.offset) return false;
	      return true;
	    } else {
	      if (c1.pos > c2.pos) return false;
	      if (c1.pos == c2.pos && c1.offset > c2.offset) return false;
	      return true;
	    }
	  };
	
	  var _isEqual = function(c1, c2) {
	    return (c1.pos === c2.pos && c1.offset === c2.offset);
	  };
	
	  var _createNewSelection = function(containerSel, newCoors) {
	    var container = containerSel.getContainer();
	    newCoors.start.path = container.getComponentAt(newCoors.start.pos).path;
	    newCoors.end.path = container.getComponentAt(newCoors.end.pos).path;
	    return new ContainerSelection({
	      containerId: containerSel.containerId,
	      startPath: newCoors.start.path,
	      startOffset: newCoors.start.offset,
	      endPath: newCoors.end.path,
	      endOffset: newCoors.end.offset
	    });
	  };
	};
	
	OO.inherit(ContainerSelection, PropertySelection);
	
	Object.defineProperties(ContainerSelection.prototype, {
	  path: {
	    get: function() {
	      throw new Error('ContainerSelection has no path property. Use startPath and endPath instead');
	    },
	    set: function() { throw new Error('immutable.'); }
	  },
	  startPath: {
	    get: function() {
	      return this.range.start.path;
	    },
	    set: function() { throw new Error('immutable.'); }
	  },
	  endPath: {
	    get: function() {
	      return this.range.end.path;
	    },
	    set: function() { throw new Error('immutable.'); }
	  }
	});
	
	module.exports = ContainerSelection;


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var Substance = __webpack_require__(3);
	var Annotator = __webpack_require__(37);
	
	var inBrowser = (typeof window !== 'undefined');
	
	function HtmlExporter(config) {
	  this.config = config || {};
	  this.state = null;
	}
	
	HtmlExporter.Prototype = function() {
	
	  /**
	   * @param doc Substance.Document instance
	   * @param object options TODO: what options are available?
	   * @return $element
	   */
	  this.convert = function(doc, options) {
	    /* jshint unused:false */
	    throw new Error('Method is abstract.');
	
	    /**
	      Example:
	
	      this.initialize(doc, options);
	      var body = doc.get('body');
	      this.convertContainer(body);
	      return this.state.$root;
	    */
	  };
	
	  this.getNodeConverter = function(node) {
	    return node.constructor;
	  };
	
	  this.convertProperty = function(doc, path, options) {
	    this.initialize(doc, options);
	    var $wrapper = $('<div>')
	      .append(this.annotatedText(path));
	    return $wrapper.html();
	  };
	
	  this.initialize = function(doc, options) {
	    options = {} || options;
	    this.state =  {
	      doc: doc,
	      options: options
	    };
	  };
	
	  this.convertNode = function(node) {
	    var NodeConverter = this.getNodeConverter(node);
	    return NodeConverter.static.toHtml(node, this);
	  };
	
	  this.convertContainer = function(containerNode) {
	    var state = this.state;
	    var nodeIds = containerNode.nodes;
	    var elements = [];
	    for (var i = 0; i < nodeIds.length; i++) {
	      var node = state.doc.get(nodeIds[i]);
	      var $el = this.convertNode(node);
	      if (!$el || !this.isElementNode($el[0])) {
	        throw new Error('Contract: Node.static.toHtml() must return a DOM element. NodeType: '+node.type);
	      }
	      $el.attr('id', node.id);
	      elements.push($el);
	    }
	    return elements;
	  };
	
	  this.annotatedText = function(path) {
	    var self = this;
	    var doc = this.state.doc;
	    var annotations = doc.getIndex('annotations').get(path);
	    var text = doc.get(path);
	
	    var annotator = new Annotator();
	    annotator.onText = function(context, text) {
	      context.children.push(text);
	    };
	    annotator.onEnter = function(entry) {
	      var anno = entry.node;
	      return {
	        annotation: anno,
	        children: []
	      };
	    };
	    annotator.onExit = function(entry, context, parentContext) {
	      var anno = context.annotation;
	      var NodeConverter = self.getNodeConverter(anno);
	      var $el = NodeConverter.static.toHtml(anno, self, context.children);
	      if (!$el || !self.isElementNode($el[0])) {
	        throw new Error('Contract: Annotation.toHtml() must return a DOM element.');
	      }
	      $el.attr('id', anno.id);
	      parentContext.children.push($el);
	    };
	    var wrapper = { children: [] };
	    annotator.start(wrapper, text, annotations);
	    return wrapper.children;
	  };
	
	  this.isElementNode = function(el) {
	    if (inBrowser) {
	      return (el.nodeType === window.Node.ELEMENT_NODE);
	    } else {
	      return el.type === "tag";
	    }
	  };
	
	  this.createHtmlDocument = function() {
	    var EMPTY_DOC = '<!DOCTYPE html><html><head></head><body></body></html>';
	    if (inBrowser) {
	      var parser = new window.DOMParser();
	      var doc = parser.parseFromString(EMPTY_DOC, "text/html");
	      return $(doc);
	    } else {
	      // creating document using cheerio
	      var $root = $.load(EMPTY_DOC).root();
	      return $root;
	    }
	  };
	
	  this.createXmlDocument = function() {
	    // We provide xmlns="http://www.w3.org/1999/xhtml" so we don't get the whole doc
	    // polluted with xmlns attributes
	    // See: http://stackoverflow.com/questions/8084175/how-do-i-prevent-jquery-from-inserting-the-xmlns-attribute-in-an-xml-object
	    var EMPTY_DOC = '<article xmlns="http://www.w3.org/1999/xhtml"></article>';
	    if (inBrowser) {
	      var parser = new window.DOMParser();
	      var doc = parser.parseFromString(EMPTY_DOC, "text/xml");
	      return $(doc);
	    } else {
	      // creating document using cheerio
	      var $root = $.load(EMPTY_DOC).root();
	      return $root;
	    }
	  };
	};
	
	Substance.initClass(HtmlExporter);
	
	module.exports = HtmlExporter;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var Substance = __webpack_require__(3);
	var _ = Substance;
	
	var inBrowser = (typeof window !== 'undefined');
	
	function HtmlImporter( config ) {
	  this.config = config || {};
	  this.nodeTypesByName = {};
	  this.nodeTypes = [];
	  this.blockTypes = [];
	  this.inlineTypes = [];
	  // register converters defined in schema
	  if (this.config.schema) {
	    this.config.schema.each(function(NodeClass) {
	      this.defineNodeImporter(NodeClass);
	    }, this);
	  }
	  this.$ = global.$;
	}
	
	HtmlImporter.Prototype = function HtmlImporterPrototype() {
	
	  this.defineNodeImporter = function(NodeClass) {
	    // ATM Node.matchElement is required
	    if (!NodeClass.static.matchElement) {
	      return;
	    }
	    this.nodeTypes.push(NodeClass);
	    this.nodeTypesByName[NodeClass.static.name] = NodeClass;
	    if (NodeClass.static.blockType) {
	      this.blockTypes.push(NodeClass);
	    } else if (NodeClass.static.isInline){
	      this.inlineTypes.push(NodeClass);
	    }
	  };
	
	  this.defaultConverter = function($el, converter) {
	    /* jshint unused:false */
	    console.warn('This element is not handled by the converters you provided. This is the default implementation which just skips conversion. Override HtmlImporter.defaultConverter(el, converter) to change this behavior.', this.$toStr($el));
	    var defaultTextType = this.state.doc.getSchema().getDefaultTextType();
	    var DefaultBlockTextClass = this.nodeTypesByName[defaultTextType];
	    if (!DefaultBlockTextClass) {
	      throw new Error('Could not class for default text type', defaultTextType);
	    }
	    var node = DefaultBlockTextClass.static.fromHtml($el, converter);
	    if (node) {
	      node.type = defaultTextType;
	    }
	    return node;
	  };
	
	  this.initialize = function(doc, $root) {
	    var state = {
	      doc: doc,
	      $root: $root,
	      inlineNodes: [],
	      trimWhitespaces: !!this.config.trimWhitespaces,
	      // stack of contexts to handle reentrant calls
	      stack: [],
	      lastChar: "",
	      skipTypes: {},
	      ignoreAnnotations: false,
	    };
	    this.state = state;
	  };
	
	  this.convert = function($root, doc) {
	    /* jshint unused:false */
	    throw new Error('This method is abstract.');
	
	    /* Example:
	
	    this.initialize(doc, $root);
	    var $body = $root.find('body');
	    this.convertContainer($body, 'body');
	    this.finish();
	
	    */
	  };
	
	  // convert a container with block level elements and show
	  // the result in the container node with given id
	  this.convertContainer = function($containerEl, containerId) {
	    var state = this.state;
	    var doc = state.doc;
	    var containerNode = doc.get(containerId);
	    state.containerNode = containerNode;
	    var childIterator = new HtmlImporter.ChildNodeIterator($containerEl[0]);
	    while(childIterator.hasNext()) {
	      var el = childIterator.next();
	      var $el = this.$(el);
	      var blockType = this._getBlockTypeForElement($el);
	      var node;
	      if (blockType) {
	        node = blockType.static.fromHtml($el, this);
	        if (!node) {
	          throw new Error("Contract: a Node's fromHtml() method must return a node", this.$toStr($el));
	        } else {
	          node.type = blockType.static.name;
	          node.id = node.id || $el.attr('id') || Substance.uuid(node.type);
	          doc.create(node);
	          containerNode.show(node.id);
	        }
	      } else {
	        if (this.isCommentNode(el)) {
	          // skip comment nodes on block level
	        } else if (this.isTextNode(el)) {
	          var text = $el.text();
	          if (/^\s*$/.exec(text)) continue;
	          // If we find text nodes on the block level we wrap
	          // it into a paragraph element (or what is configured as default block level element)
	          childIterator.back();
	          this.wrapInlineElementsIntoBlockElement(childIterator);
	        } else if (this.isElementNode(el)) {
	          var inlineType = this._getInlineTypeForElement($el);
	          // NOTE: hard to tell if unsupported nodes on this level
	          // should be treated as inline or not.
	          // ATM we only support spans as entry to the catch-all implementation
	          // that collects inline elements and wraps into a paragraph.
	          // TODO: maybe this should be the default?
	          if (inlineType || this.getTagName(el) === "span") {
	            childIterator.back();
	            this.wrapInlineElementsIntoBlockElement(childIterator);
	          } else {
	            this.createDefaultBlockElement($el);
	          }
	        }
	      }
	    }
	  };
	
	  this.finish = function() {
	    var doc = this.state.doc;
	    // create annotations afterwards so that the targeted nodes
	    // exist for sure
	    for (var i = 0; i < this.state.inlineNodes.length; i++) {
	      doc.create(this.state.inlineNodes[i]);
	    }
	  };
	
	  this.convertProperty = function(doc, path, html) {
	    var $el = this.$('<div>').html(html);
	    this.initialize(doc, $el);
	    var text = this.annotatedText($el, path);
	    doc.setText(path, text, this.state.inlineNodes);
	  };
	
	  this.convertElement = function($el, data) {
	    var doc = this.state.doc;
	    var nodeType = this._getNodeTypeForElement($el);
	    if (!nodeType) {
	      throw new Error("Could not find a node class associated to element:" + this.$toStr($el));
	    }
	    var node = nodeType.static.fromHtml($el, this);
	    node.type = nodeType.static.name;
	    node.id = node.id || this.defaultId($el, node.type);
	    _.extend(node, data);
	    return doc.create(node);
	  };
	
	  this.getDocument = function() {
	    return this.state.doc;
	  };
	
	  this.getTagName = function(el) {
	    if (!el.tagName) {
	      return "";
	    } else {
	      return el.tagName.toLowerCase();
	    }
	  };
	
	  this.isTextNode = function(el) {
	    if (inBrowser) {
	      return (el.nodeType === window.Node.TEXT_NODE);
	    } else {
	      // cheerio text node
	      return el.type === "text";
	    }
	  };
	
	  this.isElementNode = function(el) {
	    if (inBrowser) {
	      return (el.nodeType === window.Node.ELEMENT_NODE);
	    } else {
	      return el.type === "tag";
	    }
	  };
	
	  this.isCommentNode = function(el) {
	    if (inBrowser) {
	      return (el.nodeType === window.Node.COMMENT_NODE);
	    } else {
	      return el.type === "comment";
	    }
	  };
	
	  this.wrapInlineElementsIntoBlockElement = function(childIterator) {
	    var state = this.state;
	    var doc = state.doc;
	    var containerNode = state.containerNode;
	    var $wrapper = this.$('<div>');
	    while(childIterator.hasNext()) {
	      var el = childIterator.next();
	      var $el = this.$(el);
	      var blockType = this._getBlockTypeForElement($el);
	      if (blockType) {
	        childIterator.back();
	        break;
	      }
	      $wrapper.append($el.clone());
	    }
	    var node = this.defaultConverter($wrapper, this);
	    if (node) {
	      if (!node.type) {
	        throw new Error('Contract: Html.defaultConverter() must return a node with type.');
	      }
	      node.id = node.id || this.nextId(node.type);
	      doc.create(node);
	      containerNode.show(node.id);
	    }
	  };
	
	  this.createDefaultBlockElement = function($el) {
	    var state = this.state;
	    var doc = state.doc;
	    var containerNode = state.containerNode;
	    var node = this.defaultConverter($el, this);
	    if (node) {
	      if (!node.type) {
	        throw new Error('Contract: Html.defaultConverter() must return a node with type.', this.$toStr($el));
	      }
	      node.id = node.id || this.defaultId($el, node.type);
	      doc.create(node);
	      containerNode.show(node.id);
	    }
	  };
	
	  /**
	   * Parse annotated text
	   *
	   * Make sure you call this method only for elements where `this.isParagraphish(elements) === true`
	   */
	  this.annotatedText = function($el, path) {
	    var state = this.state;
	    if (path) {
	      if (state.stack.length>0) {
	        throw new Error('Contract: it is not allowed to bind a new call annotatedText to a path while the previous has not been completed.', this.$toStr($el));
	      }
	      state.stack = [{ path: path, offset: 0, text: ""}];
	    } else {
	      if (state.stack.length===0) {
	        throw new Error("Contract: HtmlImporter.annotatedText() requires 'path' for non-reentrant call.", this.$toStr($el));
	      }
	    }
	    // IMO we should reset the last char, as it is only relevant within one
	    // annotated text property. This feature is mainly used to eat up
	    // whitespace in XML/HTML at tag boundaries, produced by pretty-printed XML/HTML.
	    this.state.lastChar = '';
	
	    var iterator = new HtmlImporter.ChildNodeIterator($el[0]);
	    var text = this._annotatedText(iterator);
	    if (path) {
	      state.stack.pop();
	    }
	    return text;
	  };
	
	  this.plainText = function($el) {
	    var state = this.state;
	    var text = $el.text();
	    if (state.stack.length > 0) {
	      var context = _.last(state.stack);
	      context.offset += text.length;
	      context.text += context.text.concat(text);
	    }
	    return text;
	  };
	
	  this.customText = function(text) {
	    var state = this.state;
	    if (state.stack.length > 0) {
	      var context = _.last(state.stack);
	      context.offset += text.length;
	      context.text += context.text.concat(text);
	    }
	    return text;
	  };
	
	  this.nextId = function(prefix) {
	    // TODO: we could create more beautiful ids?
	    // however we would need to be careful as there might be another
	    // element in the HTML coming with that id
	    // For now we use shas
	    return Substance.uuid(prefix);
	  };
	
	  /**
	   * Removes any leading and trailing whitespaces from the content
	   * within the given element.
	   * Attention: this is not yet implemented fully. Atm, trimming is only done
	   * on the first and last text node (if they exist).
	   */
	  this.trimTextContent = function($el) {
	    var nodes = $el[0].childNodes;
	    var first = nodes[0];
	    var last = _.last(nodes);
	    if (first) {
	      // trim the first and last text
	      if (this._getDomNodeType(first) === "text") {
	        text = first.textContent;
	        trimmed = this.trimLeft(text);
	        first.textContent = trimmed;
	      }
	    }
	    if (last) {
	      if (this._getDomNodeType(last) === "text") {
	        text = last.textContent;
	        trimmed = this.trimRight(text);
	        last.textContent = trimmed;
	      }
	    }
	    return $el;
	  };
	
	  // TODO: maybe we want to capture warnings and errors in future
	  this.warning = function(msg) {
	    console.warn('[HtmlImporter] ' + msg);
	  };
	
	  this.error = function(msg) {
	    console.error('[HtmlImporter] ' + msg);
	  };
	
	  this.defaultId = function($el, type) {
	    var id = $el.attr('id') || this.nextId(type);
	    while (this.state.doc.get(id)) {
	      id = this.nextId(type)
	    }
	    // TODO: check for collisions
	    return id;
	  };
	
	  // Internal function for parsing annotated text
	  // --------------------------------------------
	  //
	  this._annotatedText = function(iterator) {
	    var state = this.state;
	    var context = _.last(state.stack);
	    if (!context) {
	      throw new Error('Illegal state: context is null.');
	    }
	    while(iterator.hasNext()) {
	      var el = iterator.next();
	      var $el = this.$(el);
	      var text = "";
	      // Plain text nodes...
	      if (this.isTextNode(el)) {
	        text = this._prepareText(state, $el.text());
	        if (text.length) {
	          // Note: text is not merged into the reentrant state
	          // so that we are able to return for this reentrant call
	          context.text = context.text.concat(text);
	          context.offset += text.length;
	        }
	      } else if (this.isCommentNode(el)) {
	        // skip comment nodes
	        continue;
	      } else if (this.isElementNode(el)) {
	        var inlineType = this._getInlineTypeForElement($el);
	        if (!inlineType) {
	          var blockType = this._getInlineTypeForElement($el);
	          if (blockType) {
	            throw new Error('Expected inline element. Found block element:', this.$toStr($el));
	          }
	          console.warn('Unsupported inline element. We will not create an annotation for it, but process its children to extract annotated text.', this.$toStr($el));
	          // Note: this will store the result into the current context
	          this.annotatedText($el);
	          continue;
	        }
	        // reentrant: we delegate the conversion to the inline node class
	        // it will either call us back (this.annotatedText) or give us a finished
	        // node instantly (self-managed)
	        var startOffset = context.offset;
	        var inlineNode;
	        if (inlineType.static.fromHtml) {
	          // push a new context so we can deal with reentrant calls
	          state.stack.push({ path: context.path, offset: startOffset, text: ""});
	          inlineNode = inlineType.static.fromHtml($el, this);
	          if (!inlineNode) {
	            throw new Error("Contract: a Node's fromHtml() method must return a node", this.$toStr($el));
	          }
	          // external nodes are attached to an invisible character
	          if (inlineType.static.external) {
	            this.customText("\u200B");
	          }
	          // ... and transfer the result into the current context
	          var result = state.stack.pop();
	          context.offset = result.offset;
	          context.text = context.text.concat(result.text);
	        } else {
	          inlineNode = {};
	          this.annotatedText($el);
	        }
	        // in the mean time the offset will probably have changed to reentrant calls
	        var endOffset = context.offset;
	        inlineNode.type = inlineType.static.name;
	        inlineNode.id = inlineType.id || this.nextId(inlineNode.type);
	        inlineNode.startOffset = startOffset;
	        inlineNode.endOffset = endOffset;
	        inlineNode.path = context.path.slice(0);
	        state.inlineNodes.push(inlineNode);
	      } else {
	        console.warn('Unknown element type. Taking plain text.', this.$toStr($el));
	        text = this._prepareText(state, $el.text());
	        context.text = context.text.concat(text);
	        context.offset += text.length;
	      }
	    }
	    // return the plain text collected during this reentrant call
	    return context.text;
	  };
	
	  this._getBlockTypeForElement = function($el) {
	    // HACK: tagName does not exist for prmitive nodes such as DOM TextNode.
	    if (!$el[0].tagName) return null;
	    for (var i = 0; i < this.blockTypes.length; i++) {
	      if (this.blockTypes[i].static.matchElement($el)) {
	        return this.blockTypes[i];
	      }
	    }
	  };
	
	  this._getInlineTypeForElement = function($el) {
	    for (var i = 0; i < this.inlineTypes.length; i++) {
	      if (this.inlineTypes[i].static.matchElement($el)) {
	        return this.inlineTypes[i];
	      }
	    }
	  };
	
	  this._getNodeTypeForElement = function($el) {
	    for (var i = 0; i < this.nodeTypes.length; i++) {
	      if (this.nodeTypes[i].static.matchElement($el)) {
	        return this.nodeTypes[i];
	      }
	    }
	  };
	
	  this._getDomNodeType = function(el) {
	    if (this.isTextNode(el)) {
	      return "text";
	    } else if (this.isCommentNode(el)) {
	      return "comment";
	    } else if (el.tagName) {
	      return el.tagName.toLowerCase();
	    } else {
	      throw new Error("Unknown node type");
	    }
	  };
	
	  var WS_LEFT = /^\s+/g;
	  var WS_LEFT_ALL = /^\s*/g;
	  var WS_RIGHT = /\s+$/g;
	  var WS_ALL = /\s+/g;
	  // var ALL_WS_NOTSPACE_LEFT = /^[\t\n]+/g;
	  // var ALL_WS_NOTSPACE_RIGHT = /[\t\n]+$/g;
	  var SPACE = " ";
	  var TABS_OR_NL = /[\t\n\r]+/g;
	
	  // TODO: this needs to be tested and documented
	  this._prepareText = function(state, text) {
	    if (!state.trimWhitespaces) {
	      return text;
	    }
	    var repl = SPACE;
	    // replace multiple tabs and new-lines by one space
	    text = text.replace(TABS_OR_NL, SPACE);
	    // TODO: the last char handling is only necessary for for nested calls
	    // i.e., when processing the content of an annotation, for instance
	    // we need to work out how we could control this with an inner state
	    if (state.lastChar === SPACE) {
	      text = text.replace(WS_LEFT_ALL, repl);
	    } else {
	      text = text.replace(WS_LEFT, repl);
	    }
	    text = text.replace(WS_RIGHT, repl);
	    // EXPERIMENTAL: also remove white-space within
	    if (this.config.REMOVE_INNER_WS) {
	      text = text.replace(WS_ALL, SPACE);
	    }
	    state.lastChar = text[text.length-1] || state.lastChar;
	    return text;
	  };
	
	
	  this.trimLeft = function(text) {
	    return text.replace(WS_LEFT, "");
	  };
	
	  this.trimRight = function(text) {
	    return text.replace(WS_RIGHT, "");
	  };
	
	  // for error messages
	  this.$toStr = function($el) {
	    var $clone = $el.clone();
	    $clone.empty();
	    return $('<p>').append($clone).html();
	  };
	
	};
	HtmlImporter.prototype = new HtmlImporter.Prototype();
	
	HtmlImporter.ChildNodeIterator = function(arg) {
	  this.nodes = arg.childNodes;
	  this.length = this.nodes.length;
	  this.pos = -1;
	};
	
	HtmlImporter.ChildNodeIterator.Prototype = function() {
	  this.hasNext = function() {
	    return this.pos < this.length - 1;
	  };
	  this.next = function() {
	    this.pos += 1;
	    return this.nodes[this.pos];
	  };
	  this.back = function() {
	    if (this.pos >= 0) {
	      this.pos -= 1;
	    }
	    return this;
	  };
	};
	HtmlImporter.ChildNodeIterator.prototype = new HtmlImporter.ChildNodeIterator.Prototype();
	
	module.exports = HtmlImporter;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var DocumentNode = __webpack_require__(6);
	var ListItem = __webpack_require__(73);
	
	// Note: we have chosen a semi-hierarchical model for lists
	// consisting of one list wrapper with many list items.
	// Nesting and type information is stored on the items.
	// This will make life easier for editing.
	// The wrapping list node helps us to create a scope for rendering, and
	// import/export.
	var List = DocumentNode.extend({
	  displayName: "List",
	  name: "list",
	
	  properties: {
	    ordered: "boolean",
	    items: ["array", "id"]
	  },
	
	  getItems: function() {
	    var doc = this.getDocument();
	    return _.map(this.items, function(id) {
	      return doc.get(id);
	    }, this);
	  },
	  removeItem: function(id) {
	    var doc = this.getDocument();
	    var offset = this.items.indexOf(id);
	    if (offset >= 0) {
	      doc.update([this.id, 'items'], { "delete": { offset: offset } });
	    } else {
	      throw new Error('List item is not a child of this list: ' + id);
	    }
	  },
	  insertItemAt: function(offset, id) {
	    var doc = this.getDocument();
	    doc.update([this.id, 'items'], { "insert": { offset: offset, value: id } });
	  },
	});
	
	List.static.components = ['items'];
	
	// HtmlImporter
	
	List.static.blockType = true;
	
	List.static.matchElement = function($el) {
	  return $el.is('ul,ol');
	};
	
	/**
	 *
	 * <ol>
	 *   <li>Item 1
	 *     <ul>
	 *       <li>Point A</li>
	 *       <li>Point B</li>
	 *     </ul>
	 *   </li>
	 *   <li>Item 2
	 *     <ul>
	 *       <li>Point C</li>
	 *       <li>Point D</li>
	 *     </ul>
	 *   </li>
	 * </ol>
	 *
	 * Will be modeled as:
	 *
	 * list:
	 *   - list-item[1,o,"Item 1"]
	 *   - list-item[2,u,"Point A"]
	 *   - list-item[2,u,"Point B"]
	 *   - list-item[1,o,"Item 2"]
	 *   - list-item[2,u,"Point A"]
	 *   - list-item[2,u,"Point B"]
	 */
	
	List.static.fromHtml = function($el, converter) {
	  var id = converter.defaultId($el, 'list');
	  var list = {
	    id: id,
	    items: []
	  };
	  // iterate through the children keeping track of the nesting level
	  // and associate a list type
	  var level = 0;
	  var types = [];
	
	  // TODO: this needs to be fleshed out to be 100% robust
	  function _normalizeListItem(converter, li) {
	    var segments = [[]];
	    var last = segments[0];
	    for(var child=li.firstChild; child; child = child.nextSibling) {
	      var type = converter._getDomNodeType(child);
	      if (type === "ol" || type === "ul") {
	        last = child;
	        segments.push(last);
	      } else {
	        if (/^\s*$/.exec($(child).text())) {
	          // skip fragments with only whitespace
	          continue;
	        }
	        if (!_.isArray(last)) {
	          last = [];
	          segments.push(last);
	        }
	        last.push(child);
	      }
	    }
	    return segments;
	  }
	
	  function _convertListItem(li) {
	    var ordered = (_.last(types) === "ol");
	    // in our interpretation a list item may have leading annotated text
	    // and trailing list element
	    var fragments = _normalizeListItem(converter, li);
	    for (var i = 0; i < fragments.length; i++) {
	      var fragment = fragments[i];
	      if (_.isArray(fragment)) {
	        // create a list item and use the fragment as annotated content
	        var $wrapper = $('<span>').append(fragment);
	        converter.trimTextContent($wrapper);
	        var listItem = ListItem.static.fromHtml($wrapper, converter);
	        listItem.ordered = ordered;
	        listItem.level = level;
	        converter.getDocument().create(listItem);
	        list.items.push(listItem.id);
	      } else {
	        _convertList(fragment);
	      }
	    }
	  }
	
	  function _convertList(listEl) {
	    level++;
	    types.push(converter._getDomNodeType(listEl));
	    for (var child = listEl.firstChild; child; child = child.nextSibling) {
	      var type = converter._getDomNodeType(child);
	      if (type === "li") {
	        _convertListItem(child);
	      } else if (type == "ol" || type === "ul") {
	        _convertList(child);
	      }
	    }
	    level--;
	    types.pop();
	  }
	  _convertList($el[0]);
	
	  return list;
	};
	
	List.static.toHtml = function(list, converter) {
	  return List.static.render(list, {
	    createElement: function(tagName) {
	      return $('<' + tagName + '>');
	    },
	    createAnnotatedTextNode: function(path) {
	      return converter.annotatedText(path);
	    },
	  });
	};
	
	List.static.render = function(list, impl) {
	  var tagName = list.ordered ? 'ol' : 'ul';
	  var id = list.id;
	  var children = list.getItems();
	  var el = impl.createElement(tagName);
	  el.attr('data-id', id);
	
	  var j;
	  var current = el;
	  var stack = [current];
	  var level = 1;
	
	  for (var i = 0; i < children.length; i++) {
	    var item = children[i];
	    if (item.level === level) {
	      // nothing to change
	    } else if (item.level > level) {
	      // push structure
	      var _tagName = item.ordered ? 'ol' : 'ul';
	      for (j = level; j < item.level; j++) {
	        // create a list element and wrap it into a 'li'
	        var listEl = impl.createElement(_tagName);
	        current.append(listEl);
	        // update level and stack
	        current = listEl;
	        stack.push(current);
	        level++;
	      }
	    } else /* if (item.level < level) */ {
	      // pop structure
	      for (j = level; j > item.level; j--) {
	        stack.pop();
	        level--;
	      }
	      current = stack[stack.length-1];
	    }
	    current.append(impl.createElement('li')
	      .addClass("content-node list-item")
	      .attr("data-id", item.id)
	      .append(
	        impl.createAnnotatedTextNode([item.id, "content"])
	      )
	    );
	  }
	  return el;
	};
	
	Object.defineProperties(List.prototype, {
	  itemNodes: {
	    'get': function() {
	      return this.getItems();
	    }
	  }
	});
	
	module.exports = List;


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var Node = __webpack_require__(6);
	
	var ListItem = Node.extend({
	  displayName: "ListItem",
	  name: "list-item",
	  properties: {
	    parent: "id",
	    level: "number",
	    ordered: "bool",
	    content: "string"
	  },
	});
	
	ListItem.static.components = ['content'];
	
	// HtmlImporter
	
	ListItem.static.fromHtml = function($el, converter) {
	  var level = $el.data('level') || 1;
	  var id = converter.defaultId($el, 'li');
	  var item = {
	    id: id,
	    type: 'list-item',
	    level: level,
	    ordered: false,
	    content: ''
	  };
	  item.content = converter.annotatedText($el, [id, 'content']);
	  return item;
	};
	
	ListItem.static.toHtml = function(item, converter) {
	  var id = item.id;
	  var $el = $('<li>')
	    .attr('id', item.id)
	    .data('level', item.level)
	    .append(converter.annotatedText([id, 'content']))
	  return $el;
	};
	
	module.exports = ListItem;


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Substance = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var Selection = __webpack_require__(19);
	
	function TableSelection(properties) {
	  this.tableId = properties.tableId;
	  if (properties.rectangle) {
	    this.rectangle = properties.rectangle;
	  } else {
	    this.rectangle = new TableSelection.Rectangle(properties.startRow, properties.startCol,
	      properties.endRow, properties.endCol);
	  }
	  if (!this.tableId) {
	    throw new Error('Invalid arguments. `tableId` is mandatory.');
	  }
	  this._internal = {};
	  Object.freeze(this);
	}
	
	TableSelection.Prototype = function() {
	
	  this.isPropertySelection = function() {
	    return false;
	  };
	
	  this.isTableSelection = function() {
	    return true;
	  };
	
	  this.isSingleCell = function() {
	    return this.rectangle.isSingleCell();
	  };
	
	  this.getTableId = function() {
	    return this.tableId;
	  };
	
	  this.getRectangle = function() {
	    return this.rectangle;
	  };
	
	  this.equals = function(other) {
	    return (Selection.prototype.equals.call(this, other) &&
	      !other.isTableSelection() &&
	      (this.startRow === other.startRow && this.endRow === other.endRow &&
	       this.startCol === other.startCol && this.ednCol === other.endCol ));
	  };
	
	  this.toString = function() {
	    var r = this.rectangle;
	    return "T[("+ r.start.row + "," + r.start.col + "), ("+ r.end.row + ", " + r.end.col +")]";
	  };
	
	  this.attach = function(doc) {
	    this._internal.doc = doc;
	    return this;
	  };
	
	};
	
	Substance.inherit(TableSelection, Selection);
	
	Object.defineProperties(TableSelection.prototype, {
	  startRow: {
	    get: function() {
	      return this.rectangle.start.row;
	    }
	  },
	  endRow: {
	    get: function() {
	      return this.rectangle.end.row;
	    }
	  },
	  startCol: {
	    get: function() {
	      return this.rectangle.start.col;
	    }
	  },
	  endCol: {
	    get: function() {
	      return this.rectangle.end.col;
	    }
	  },
	});
	
	TableSelection.Rectangle = function(startRow, startCol, endRow, endCol) {
	  var minRow = Math.min(startRow, endRow);
	  var maxRow = Math.max(startRow, endRow);
	  var minCol = Math.min(startCol, endCol);
	  var maxCol = Math.max(startCol, endCol);
	
	  this.start = {
	    row: minRow,
	    col: minCol
	  };
	  this.end = {
	    row: maxRow,
	    col: maxCol
	  };
	  Object.freeze(this.start);
	  Object.freeze(this.end);
	  Object.freeze(this);
	};
	
	TableSelection.Rectangle.prototype.isSingleCell = function() {
	  return (this.start.row === this.end.row && this.start.col === this.end.col);
	};
	
	module.exports = TableSelection;


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var Annotations = __webpack_require__(10);
	var merge = __webpack_require__(45);
	
	/**
	 * The behavior when you press delete or backspace.
	 * I.e., it starts with a collapsed PropertySelection and deletes the character before
	 * or after the caret.
	 * If the caret is at the begin or end it will call `mergeNodes`.
	 */
	var deleteCharacter = function(tx, args) {
	  var selection = args.selection;
	  var direction = args.direction;
	  var range = selection.getRange();
	  var startChar, endChar;
	  if (!selection.isCollapsed()) {
	    throw new Error('Selection must be collapsed for transformation "deleteCharacter"');
	  }
	  var prop = tx.get(range.start.path);
	  if ((range.start.offset === 0 && direction === 'left') ||
	      (range.start.offset === prop.length && direction === 'right')) {
	    var tmp = merge(tx, _.extend({}, args, {
	      selection: selection,
	      containerId: args.containerId,
	      path: range.start.path,
	      direction: direction
	    }));
	    selection = tmp.selection;
	  } else {
	    // simple delete one character
	    startChar = (direction === 'left') ? range.start.offset-1 : range.start.offset;
	    endChar = startChar+1;
	    tx.update(range.start.path, { delete: { start: startChar, end: endChar } });
	    Annotations.deletedText(tx, range.start.path, startChar, endChar);
	    selection = tx.createSelection({
	      type: 'property',
	      path: range.start.path,
	      startOffset: startChar
	    });
	  }
	  args.selection = selection;
	  return args;
	};
	
	module.exports = deleteCharacter;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var deleteSelection = __webpack_require__(24);
	var Annotations = __webpack_require__(10);
	
	var insertText = function(tx, args) {
	  var selection = args.selection;
	  var text = args.text;
	  if (!selection) {
	    throw new Error('Argument `selection` is mandatory for transformation `insertText`.');
	  }
	  if (!text) {
	    throw new Error('Argument `text` is mandatory for transformation `insertText`.');
	  }
	  if (!(selection.isPropertySelection() || selection.isContainerSelection())) {
	    throw new Error('Selection must be property or container selection.');
	  }
	  var tmp;
	  if (!selection.isCollapsed()) {
	    tmp = deleteSelection(tx, _.extend({}, args, {
	      selection: selection,
	      direction: 'right'
	    }));
	    selection = tmp.selection;
	  }
	  var range = selection.getRange();
	  // HACK(?): if the string property is not initialized yet we do it here
	  // for convenience.
	  if (tx.get(range.start.path) === undefined) {
	    tx.set(range.start.path, "");
	  }
	  tx.update(range.start.path, { insert: { offset: range.start.offset, value: text } } );
	  Annotations.insertedText(tx, range.start, text.length);
	
	  args.selection = tx.createSelection({
	    type: 'property',
	    path: range.start.path,
	    startOffset: range.start.offset + text.length
	  });
	
	  return args;
	};
	
	module.exports = insertText;


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(80),
	    baseCallback = __webpack_require__(14),
	    baseMap = __webpack_require__(184),
	    isArray = __webpack_require__(5);
	
	/**
	 * Creates an array of values by running each element in `collection` through
	 * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	 * arguments; (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * Many lodash methods are guarded to work as interatees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`, `drop`,
	 * `dropRight`, `fill`, `flatten`, `invert`, `max`, `min`, `parseInt`, `slice`,
	 * `sortBy`, `take`, `takeRight`, `template`, `trim`, `trimLeft`, `trimRight`,
	 * `trunc`, `random`, `range`, `sample`, `uniq`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @alias collect
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	 *  per iteration.
	 *  create a `_.property` or `_.matches` style callback respectively.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function timesThree(n) {
	 *   return n * 3;
	 * }
	 *
	 * _.map([1, 2], timesThree);
	 * // => [3, 6]
	 *
	 * _.map({ 'a': 1, 'b': 2 }, timesThree);
	 * // => [3, 6] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // using the `_.property` callback shorthand
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee, thisArg) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  iteratee = baseCallback(iteratee, thisArg, 3);
	  return func(collection, iteratee);
	}
	
	module.exports = map;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(11);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeNow = isNative(nativeNow = Date.now) && nativeNow;
	
	/**
	 * Gets the number of milliseconds that have elapsed since the Unix epoch
	 * (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @category Date
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => logs the number of milliseconds it took for the deferred function to be invoked
	 */
	var now = nativeNow || function() {
	  return new Date().getTime();
	};
	
	module.exports = now;


/***/ },
/* 79 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for callback
	 * shorthands or `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 80 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for callback
	 * shorthands or `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(28),
	    arrayEach = __webpack_require__(79),
	    baseCopy = __webpack_require__(82),
	    baseForOwn = __webpack_require__(86),
	    initCloneArray = __webpack_require__(203),
	    initCloneByTag = __webpack_require__(204),
	    initCloneObject = __webpack_require__(205),
	    isArray = __webpack_require__(5),
	    isObject = __webpack_require__(8),
	    keys = __webpack_require__(16);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	cloneableTags[dateTag] = cloneableTags[float32Tag] =
	cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[stringTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[mapTag] = cloneableTags[setTag] =
	cloneableTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the `toStringTag` of values.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * for more details.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.clone` without support for argument juggling
	 * and `this` binding `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {Function} [customizer] The function to customize cloning values.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The object `value` belongs to.
	 * @param {Array} [stackA=[]] Tracks traversed source objects.
	 * @param {Array} [stackB=[]] Associates clones with source counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object) : customizer(value);
	  }
	  if (typeof result != 'undefined') {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return arrayCopy(value, result);
	    }
	  } else {
	    var tag = objToString.call(value),
	        isFunc = tag == funcTag;
	
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return baseCopy(value, result, keys(value));
	      }
	    } else {
	      return cloneableTags[tag]
	        ? initCloneByTag(value, tag, isDeep)
	        : (object ? value : {});
	    }
	  }
	  // Check for circular references and return corresponding clone.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == value) {
	      return stackB[length];
	    }
	  }
	  // Add the source value to the stack of traversed objects and associate it with its clone.
	  stackA.push(value);
	  stackB.push(result);
	
	  // Recursively populate clone (susceptible to call stack limits).
	  (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	    result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 82 */
/***/ function(module, exports) {

	/**
	 * Copies the properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Array} props The property names to copy.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, object, props) {
	  if (!props) {
	    props = object;
	    object = {};
	  }
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(29),
	    cacheIndexOf = __webpack_require__(49),
	    createCache = __webpack_require__(50);
	
	/**
	 * The base implementation of `_.difference` which accepts a single array
	 * of values to exclude.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values) {
	  var length = array ? array.length : 0,
	      result = [];
	
	  if (!length) {
	    return result;
	  }
	  var index = -1,
	      indexOf = baseIndexOf,
	      isCommon = true,
	      cache = (isCommon && values.length >= 200) ? createCache(values) : null,
	      valuesLength = values.length;
	
	  if (cache) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	    values = cache;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index];
	
	    if (isCommon && value === value) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === value) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (indexOf(values, value) < 0) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(25),
	    isArray = __webpack_require__(5),
	    isLength = __webpack_require__(7),
	    isObjectLike = __webpack_require__(12);
	
	/**
	 * The base implementation of `_.flatten` with added support for restricting
	 * flattening and specifying the start index.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {boolean} [isDeep] Specify a deep flatten.
	 * @param {boolean} [isStrict] Restrict flattening to arrays and `arguments` objects.
	 * @param {number} [fromIndex=0] The index to start from.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, isDeep, isStrict, fromIndex) {
	  var index = (fromIndex || 0) - 1,
	      length = array.length,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	
	    if (isObjectLike(value) && isLength(value.length) && (isArray(value) || isArguments(value))) {
	      if (isDeep) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        value = baseFlatten(value, isDeep, isStrict);
	      }
	      var valIndex = -1,
	          valLength = value.length;
	
	      result.length += valLength;
	      while (++valIndex < valLength) {
	        result[++resIndex] = value[valIndex];
	      }
	    } else if (!isStrict) {
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(54);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iterator functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	function baseFor(object, iteratee, keysFunc) {
	  var index = -1,
	      iterable = toObject(object),
	      props = keysFunc(object),
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    if (iteratee(iterable[key], key, iterable) === false) {
	      break;
	    }
	  }
	  return object;
	}
	
	module.exports = baseFor;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(85),
	    keys = __webpack_require__(16);
	
	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 87 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` which does not coerce `key` to a string.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 88 */
/***/ function(module, exports) {

	/**
	 * Converts `value` to a string if it is not one. An empty string is returned
	 * for `null` or `undefined` values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  if (typeof value == 'string') {
	    return value;
	  }
	  return value == null ? '' : (value + '');
	}
	
	module.exports = baseToString;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(29),
	    cacheIndexOf = __webpack_require__(49),
	    createCache = __webpack_require__(50);
	
	/**
	 * The base implementation of `_.uniq` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The function invoked per iteration.
	 * @returns {Array} Returns the new duplicate-value-free array.
	 */
	function baseUniq(array, iteratee) {
	  var index = -1,
	      indexOf = baseIndexOf,
	      length = array.length,
	      isCommon = true,
	      isLarge = isCommon && length >= 200,
	      seen = isLarge ? createCache() : null,
	      result = [];
	
	  if (seen) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	  } else {
	    isLarge = false;
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value, index, array) : value;
	
	    if (isCommon && value === value) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (indexOf(seen, computed) < 0) {
	      if (iteratee || isLarge) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 90 */
/***/ function(module, exports) {

	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array|Object} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders) {
	  var holdersLength = holders.length,
	      argsIndex = -1,
	      argsLength = nativeMax(args.length - holdersLength, 0),
	      leftIndex = -1,
	      leftLength = partials.length,
	      result = Array(argsLength + leftLength);
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    result[holders[argsIndex]] = args[argsIndex];
	  }
	  while (argsLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ },
/* 91 */
/***/ function(module, exports) {

	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array|Object} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders) {
	  var holdersIndex = -1,
	      holdersLength = holders.length,
	      argsIndex = -1,
	      argsLength = nativeMax(args.length - holdersLength, 0),
	      rightIndex = -1,
	      rightLength = partials.length,
	      result = Array(argsLength + rightLength);
	
	  while (++argsIndex < argsLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var pad = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[pad + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    result[pad + holders[holdersIndex]] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var isNative = __webpack_require__(11);
	
	/** Native method references. */
	var WeakMap = isNative(WeakMap = global.WeakMap) && WeakMap;
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var baseIsFunction = __webpack_require__(182),
	    isNative = __webpack_require__(11);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the `toStringTag` of values.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * for more details.
	 */
	var objToString = objectProto.toString;
	
	/** Native method references. */
	var Uint8Array = isNative(Uint8Array = global.Uint8Array) && Uint8Array;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	var isFunction = !(baseIsFunction(/x/) || (Uint8Array && !baseIsFunction(Uint8Array))) ? baseIsFunction : function(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return objToString.call(value) == funcTag;
	};
	
	module.exports = isFunction;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 94 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var getter = _.constant(object);
	 *
	 * getter() === object;
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var OO = __webpack_require__(2);
	var Operation = __webpack_require__(32);
	var Conflict = __webpack_require__(59);
	
	var NOP = "NOP";
	var DEL = "delete";
	var INS = "insert";
	
	var ArrayOperation = function(data) {
	  Operation.call(this);
	
	  /* jshint eqnull: true */
	  if (!data || data.type == null) {
	    throw new Error("Illegal argument: insufficient data.");
	  }
	  /* jshint eqnull: false */
	  this.type = data.type;
	  if (this.type === NOP) return;
	
	  if (this.type !== INS && this.type !== DEL) {
	    throw new Error("Illegal type.");
	  }
	  // the position where to apply the operation
	  this.pos = data.pos;
	  // the value to insert or delete
	  this.val = data.val;
	  if (!_.isNumber(this.pos) || this.pos < 0) {
	    throw new Error("Illegal argument: expecting positive number as pos.");
	  }
	};
	
	ArrayOperation.fromJSON = function(data) {
	  return new ArrayOperation(data);
	};
	
	ArrayOperation.Prototype = function() {
	
	  this.apply = function(array) {
	    if (this.type === NOP) {
	      return array;
	    }
	    if (this.type === INS) {
	      if (array.length < this.pos) {
	        throw new Error("Provided array is too small.");
	      }
	      array.splice(this.pos, 0, this.val);
	      return array;
	    }
	    // Delete
	    else /* if (this.type === DEL) */ {
	      if (array.length < this.pos) {
	        throw new Error("Provided array is too small.");
	      }
	      if (!_.isEqual(array[this.pos], this.val)) {
	        throw Error("Unexpected value at position " + this.pos + ". Expected " + this.val + ", found " + array[this.pos]);
	      }
	      array.splice(this.pos, 1);
	      return array;
	    }
	  };
	
	  this.clone = function() {
	    var data = {
	      type: this.type,
	      pos: this.pos,
	      val: _.deepclone(this.val)
	    };
	    return new ArrayOperation(data);
	  };
	
	  this.invert = function() {
	    var data = this.toJSON();
	    if (this.type === NOP) data.type = NOP;
	    else if (this.type === INS) data.type = DEL;
	    else /* if (this.type === DEL) */ data.type = INS;
	    return new ArrayOperation(data);
	  };
	
	  this.hasConflict = function(other) {
	    return ArrayOperation.hasConflict(this, other);
	  };
	
	  this.toJSON = function() {
	    var result = {
	      type: this.type,
	    };
	    if (this.type === NOP) return result;
	    result.pos = this.pos;
	    result.val = _.deepclone(this.val);
	    return result;
	  };
	
	  this.isInsert = function() {
	    return this.type === INS;
	  };
	
	  this.isDelete = function() {
	    return this.type === DEL;
	  };
	
	  this.getOffset = function() {
	    return this.pos;
	  };
	
	  this.getValue = function() {
	    return this.val;
	  };
	
	  this.isNOP = function() {
	    return this.type === NOP;
	  };
	
	  this.toString = function() {
	    return ["(", (this.isInsert() ? '+' : '-'), ",", this.getOffset(), ",'", this.getValue(), "')"].join('');
	  };
	};
	
	OO.inherit(ArrayOperation, Operation);
	
	var hasConflict = function(a, b) {
	  if (a.type === NOP || b.type === NOP) return false;
	  if (a.type === INS && b.type === INS) {
	    return a.pos === b.pos;
	  } else {
	    return false;
	  }
	};
	
	function transform_insert_insert(a, b) {
	  if (a.pos === b.pos) {
	    b.pos += 1;
	  }
	  // a before b
	  else if (a.pos < b.pos) {
	    b.pos += 1;
	  }
	  // a after b
	  else  {
	    a.pos += 1;
	  }
	}
	
	function transform_delete_delete(a, b) {
	  // turn the second of two concurrent deletes into a NOP
	  if (a.pos === b.pos) {
	    b.type = NOP;
	    a.type = NOP;
	    return;
	  }
	  if (a.pos < b.pos) {
	    b.pos -= 1;
	  } else {
	    a.pos -= 1;
	  }
	}
	
	function transform_insert_delete(a, b) {
	  // reduce to a normalized case
	  if (a.type === DEL) {
	    var tmp = a;
	    a = b;
	    b = tmp;
	  }
	  if (a.pos <= b.pos) {
	    b.pos += 1;
	  } else {
	    a.pos -= 1;
	  }
	}
	
	var transform = function(a, b, options) {
	  options = options || {};
	  // enable conflicts when you want to notify the user of potential problems
	  // Note that even in these cases, there is a defined result.
	  if (options['no-conflict'] && hasConflict(a, b)) {
	    throw new Conflict(a, b);
	  }
	  // this is used internally only as optimization, e.g., when rebasing an operation
	  if (!options.inplace) {
	    a = a.clone();
	    b = b.clone();
	  }
	  if (a.type === NOP || b.type === NOP)  {
	    // nothing to transform
	  }
	  else if (a.type === INS && b.type === INS)  {
	    transform_insert_insert(a, b);
	  }
	  else if (a.type === DEL && b.type === DEL) {
	    transform_delete_delete(a, b);
	  }
	  else {
	    transform_insert_delete(a, b);
	  }
	  return [a, b];
	};
	
	ArrayOperation.transform = transform;
	ArrayOperation.hasConflict = hasConflict;
	
	/* Factories */
	
	ArrayOperation.Insert = function(pos, val) {
	  return new ArrayOperation({type:INS, pos: pos, val: val});
	};
	
	ArrayOperation.Delete = function(pos, val) {
	  return new ArrayOperation({ type:DEL, pos: pos, val: val });
	};
	
	ArrayOperation.NOP = NOP;
	ArrayOperation.DELETE = DEL;
	ArrayOperation.INSERT = INS;
	
	// Export
	// ========
	
	module.exports = ArrayOperation;


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var OO = __webpack_require__(2);
	var Operation = __webpack_require__(32);
	var Conflict = __webpack_require__(59);
	
	var INS = "+";
	var DEL = "-";
	
	var hasConflict;
	
	function TextOperation(data) {
	  Operation.call(this);
	  if (!data || data.type === undefined || data.pos === undefined || data.str === undefined) {
	    throw new Error("Illegal argument: insufficient data.");
	  }
	  // '+' or '-'
	  this.type = data.type;
	  // the position where to apply the operation
	  this.pos = data.pos;
	  // the string to delete or insert
	  this.str = data.str;
	  // sanity checks
	  if(!this.isInsert() && !this.isDelete()) {
	    throw new Error("Illegal type.");
	  }
	  if (!_.isString(this.str)) {
	    throw new Error("Illegal argument: expecting string.");
	  }
	  if (!_.isNumber(this.pos) || this.pos < 0) {
	    throw new Error("Illegal argument: expecting positive number as pos.");
	  }
	}
	
	TextOperation.fromJSON = function(data) {
	  return new TextOperation(data);
	};
	
	TextOperation.Prototype = function() {
	
	  this.apply = function(str) {
	    if (this.isEmpty()) return str;
	    if (this.type === INS) {
	      if (str.length < this.pos) {
	        throw new Error("Provided string is too short.");
	      }
	      if (str.splice) {
	        return str.splice(this.pos, 0, this.str);
	      } else {
	        return str.slice(0, this.pos).concat(this.str).concat(str.slice(this.pos));
	      }
	    }
	    else /* if (this.type === DEL) */ {
	      if (str.length < this.pos + this.str.length) {
	        throw new Error("Provided string is too short.");
	      }
	      if (str.splice) {
	        return str.splice(this.pos, this.str.length);
	      } else {
	        return str.slice(0, this.pos).concat(str.slice(this.pos + this.str.length));
	      }
	    }
	  };
	
	  this.clone = function() {
	    return new TextOperation(this);
	  };
	
	  this.isNOP = function() {
	    return this.type === "NOP" || this.str.length === 0;
	  };
	
	  this.isInsert = function() {
	    return this.type === INS;
	  };
	
	  this.isDelete = function() {
	    return this.type === DEL;
	  };
	
	  this.getLength = function() {
	    return this.str.length;
	  };
	
	  this.invert = function() {
	    var data = {
	      type: this.isInsert() ? '-' : '+',
	      pos: this.pos,
	      str: this.str
	    };
	    return new TextOperation(data);
	  };
	
	  this.hasConflict = function(other) {
	    return hasConflict(this, other);
	  };
	
	  this.isEmpty = function() {
	    return this.str.length === 0;
	  };
	
	  this.toJSON = function() {
	    return {
	      type: this.type,
	      pos: this.pos,
	      str: this.str
	    };
	  };
	
	  this.toString = function() {
	    return ["(", (this.isInsert() ? '+' : '-'), ",", this.pos, ",'", this.str, "')"].join('');
	  };
	};
	
	OO.inherit(TextOperation, Operation);
	
	hasConflict = function(a, b) {
	  // Insert vs Insert:
	  //
	  // Insertions are conflicting iff their insert position is the same.
	  if (a.type === INS && b.type === INS)  return (a.pos === b.pos);
	  // Delete vs Delete:
	  //
	  // Deletions are conflicting if their ranges overlap.
	  if (a.type === DEL && b.type === DEL) {
	    // to have no conflict, either `a` should be after `b` or `b` after `a`, otherwise.
	    return !(a.pos >= b.pos + b.str.length || b.pos >= a.pos + a.str.length);
	  }
	  // Delete vs Insert:
	  //
	  // A deletion and an insertion are conflicting if the insert position is within the deleted range.
	  var del, ins;
	  if (a.type === DEL) {
	    del = a; ins = b;
	  } else {
	    del = b; ins = a;
	  }
	  return (ins.pos >= del.pos && ins.pos < del.pos + del.str.length);
	};
	
	// Transforms two Insertions
	// --------
	
	function transform_insert_insert(a, b) {
	  if (a.pos === b.pos) {
	    b.pos += a.str.length;
	  }
	  else if (a.pos < b.pos) {
	    b.pos += a.str.length;
	  }
	  else {
	    a.pos += b.str.length;
	  }
	}
	
	// Transform two Deletions
	// --------
	//
	
	function transform_delete_delete(a, b, first) {
	  // reduce to a normalized case
	  if (a.pos > b.pos) {
	    return transform_delete_delete(b, a, !first);
	  }
	  if (a.pos === b.pos && a.str.length > b.str.length) {
	    return transform_delete_delete(b, a, !first);
	  }
	  // take out overlapping parts
	  if (b.pos < a.pos + a.str.length) {
	    var s = b.pos - a.pos;
	    var s1 = a.str.length - s;
	    var s2 = s + b.str.length;
	    a.str = a.str.slice(0, s) + a.str.slice(s2);
	    b.str = b.str.slice(s1);
	    b.pos -= s;
	  } else {
	    b.pos -= a.str.length;
	  }
	}
	
	// Transform Insert and Deletion
	// --------
	//
	
	function transform_insert_delete(a, b) {
	  if (a.type === DEL) {
	    return transform_insert_delete(b, a);
	  }
	  // we can assume, that a is an insertion and b is a deletion
	  // a is before b
	  if (a.pos <= b.pos) {
	    b.pos += a.str.length;
	  }
	  // a is after b
	  else if (a.pos >= b.pos + b.str.length) {
	    a.pos -= b.str.length;
	  }
	  // Note: this is a conflict case the user should be noticed about
	  // If applied still, the deletion takes precedence
	  // a.pos > b.pos && <= b.pos + b.length
	  else {
	    var s = a.pos - b.pos;
	    b.str = b.str.slice(0, s) + a.str + b.str.slice(s);
	    a.str = "";
	  }
	}
	
	var transform = function(a, b, options) {
	  options = options || {};
	  if (options["no-conflict"] && hasConflict(a, b)) {
	    throw new Conflict(a, b);
	  }
	  if (!options.inplace) {
	    a = a.clone();
	    b = b.clone();
	  }
	  if (a.type === INS && b.type === INS)  {
	    transform_insert_insert(a, b);
	  }
	  else if (a.type === DEL && b.type === DEL) {
	    transform_delete_delete(a, b, true);
	  }
	  else {
	    transform_insert_delete(a,b);
	  }
	  return [a, b];
	};
	
	TextOperation.transform = function() {
	  return transform.apply(null, arguments);
	};
	
	/* Factories */
	
	TextOperation.Insert = function(pos, str) {
	  return new TextOperation({ type: INS, pos: pos, str: str });
	};
	
	TextOperation.Delete = function(pos, str) {
	  return new TextOperation({ type: DEL, pos: pos, str: str });
	};
	
	TextOperation.INSERT = INS;
	TextOperation.DELETE = DEL;
	
	module.exports = TextOperation;


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var NodeView = __webpack_require__(60);
	
	var AnnotationView = NodeView.extend({
	  name: "annotation",
	  tagName: 'span',
	
	  getClassNames: function() {
	    var classNames = this.node.getClassNames();
	    if (this.props.classNames) {
	      classNames += " " + this.props.classNames.join(' ');
	    }
	    return classNames.replace(/_/g, '-');
	  }
	});
	
	module.exports = AnnotationView;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Substance = __webpack_require__(3);
	var Document = __webpack_require__(18);
	var Selection = Document.Selection;
	var Annotations = Document.AnnotationUpdates;
	var Transformations = Document.Transformations;
	
	function FormEditor() {}
	
	FormEditor.Prototype = function() {
	
	  this.isContainerEditor = function() {
	    return false;
	  };
	
	  // Selects the current property.
	  this.selectAll = function(doc, selection) {
	    var sel = selection;
	    if (sel.isNull()) return;
	    if (sel.isPropertySelection()) {
	      var path = sel.start.path;
	      var text = doc.get(path);
	      return doc.createSelection({
	        type: 'property',
	        path: path,
	        startOffset: 0,
	        endOffset: text.length
	      });
	    }
	  };
	
	  this.insertText = function(tx, args) {
	    if (args.selection.isPropertySelection() || args.selection.isContainerSelection()) {
	      return Transformations.insertText(tx, args);
	    }
	  };
	
	  // implements backspace and delete
	  this.delete = function(tx, args) {
	    return Transformations.deleteSelection(tx, args);
	  };
	
	  // no breaking
	  this.break = function(tx, args) {
	    return this.softBreak(tx, args);
	  };
	
	  this.softBreak = function(tx, args) {
	    args.text = "\n";
	    return this.insertText(tx, args);
	  };
	
	  // create a document instance containing only the selected content
	  this.copy = function(doc, selection) {
	    var result = Transformations.copySelection(doc, { selection: selection });
	    return result.doc;
	  };
	
	  this.paste = function(tx, args) {
	    // TODO: for now only plain text is inserted
	    // We could do some stitching however, preserving the annotations
	    // received in the document
	    if (args.text) {
	      return this.insertText(tx, args);
	    }
	  };
	
	};
	
	Substance.initClass(FormEditor);
	
	module.exports = FormEditor;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	
	var Surface = __webpack_require__(100);
	Surface.SurfaceManager = __webpack_require__(233);
	Surface.SurfaceSelection = __webpack_require__(101);
	
	Surface.FormEditor = __webpack_require__(98);
	Surface.ContainerEditor = __webpack_require__(231);
	Surface.Clipboard = __webpack_require__(230);
	
	Surface.NodeView = __webpack_require__(60);
	Surface.AnnotationView = __webpack_require__(97);
	Surface.TextProperty = __webpack_require__(235);
	
	Surface.Tool = __webpack_require__(9);
	Surface.AnnotationTool = __webpack_require__(33);
	Surface.SwitchTypeTool = __webpack_require__(234);
	Surface.ToolRegistry = __webpack_require__(236);
	Surface.Panel = __webpack_require__(232);
	
	Surface.Tools = __webpack_require__(240);
	
	module.exports = Surface;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var OO = __webpack_require__(2);
	var Substance = __webpack_require__(3);
	var SurfaceSelection = __webpack_require__(101);
	var Document = __webpack_require__(18);
	var Selection = Document.Selection;
	
	var __id__ = 0;
	
	function Surface(surfaceManager, doc, editor, options) {
	  Substance.EventEmitter.call(this);
	
	  if (!doc) {
	    throw new Error('Illegal argument: document is required. was ' + doc);
	  }
	
	  options = options || {};
	
	  this.__id__ = __id__++;
	  this.name = options.name || this.__id__;
	  this.doc = doc;
	  this.surfaceManager = surfaceManager;
	
	  this.selection = Document.nullSelection;
	
	  // this.element must be set via surface.attach(element)
	  this.element = null;
	  this.$element = null;
	  this.editor = editor;
	
	  this.surfaceSelection = null;
	
	  this.logger = options.logger || window.console;
	
	  // TODO: VE make jquery injectable
	  this.$ = $;
	  this.$window = this.$( window );
	  this.$document = this.$( window.document );
	
	  this.dragging = false;
	
	  this._onMouseUp = _.bind( this.onMouseUp, this );
	  this._onMouseDown = _.bind( this.onMouseDown, this );
	  this._onMouseMove = _.bind( this.onMouseMove, this );
	
	  this._onKeyDown = _.bind(this.onKeyDown, this);
	  this._onTextInput = _.bind(this.onTextInput, this);
	  this._onTextInputShim = _.bind( this.onTextInputShim, this );
	  this._onCompositionStart = _.bind( this.onCompositionStart, this );
	
	  this._onDomMutations = _.bind(this.onDomMutations, this);
	  this.domObserver = new window.MutationObserver(this._onDomMutations);
	  this.domObserverConfig = { subtree: true, characterData: true };
	  this.skipNextObservation = false;
	
	  // set when editing is enabled
	  this.enabled = true;
	
	  // surface usually gets frozen while showing a popup
	  this.frozen = false;
	  this.$caret = $('<span>').addClass('surface-caret');
	
	  this.isIE = Surface.detectIE();
	  this.isFF = window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
	
	  this.undoEnabled = true;
	
	  /*jshint eqnull:true */
	  if (options.undoEnabled != null) {
	    this.undoEnabled = options.undoEnabled;
	  }
	  if (options.contentEditable != null) {
	    this.enableContentEditable = options.contentEditable;
	  } else {
	    this.enableContentEditable = true;
	  }
	
	  this.surfaceManager.registerSurface(this);
	  /*jshint eqnull:false */
	}
	
	Surface.Prototype = function() {
	
	  this.getName = function() {
	    return this.name;
	  };
	
	  this.getElement = function() {
	    return this.element;
	  };
	
	  this.getContainerName = function() {
	    if (this.editor.isContainerEditor()) {
	      return this.editor.getContainerId();
	    }
	  };
	
	  this.getContainer = function() {
	    if (this.editor.isContainerEditor()) {
	      return this.doc.get(this.editor.getContainerId());
	    }
	  };
	
	  this.getEditor = function() {
	    return this.editor;
	  };
	
	  this.getDocument = function() {
	    return this.doc;
	  };
	
	  this.dispose = function() {
	    this.setSelection(null);
	    this.detach();
	    this.surfaceManager.unregisterSurface(this);
	  };
	
	  this.attach = function(element) {
	    if (!element) {
	      throw new Error('Illegal argument: Surface element is required. was ' + element);
	    }
	    var doc = this.getDocument();
	
	    // Initialization
	    this.element = element;
	    this.$element = $(element);
	
	    // We leave this now to the view implementation, because readers don't have ce on.
	    // if (this.enableContentEditable) {
	    //   this.$element.prop('contentEditable', 'true');
	    // }
	    this.surfaceSelection = new SurfaceSelection(element, doc, this.getContainer());
	
	    this.$element.addClass('surface');
	
	    // Keyboard Events
	    //
	    this.attachKeyboard();
	
	    // Mouse Events
	    //
	    this.$element.on('mousedown', this._onMouseDown);
	
	    // disable drag'n'drop
	    this.$element.on('dragstart', this.onDragStart);
	
	    // Document Change Events
	    //
	    this.domObserver.observe(element, this.domObserverConfig);
	
	    this.attached = true;
	  };
	
	  this.attachKeyboard = function() {
	    this.$element.on('keydown', this._onKeyDown);
	    // OSX specific handling of dead-keys
	    if (this.element.addEventListener) {
	      this.element.addEventListener('compositionstart', this._onCompositionStart, false);
	    }
	    if (window.TextEvent && !this.isIE) {
	      this.element.addEventListener('textInput', this._onTextInput, false);
	    } else {
	      this.$element.on('keypress', this._onTextInputShim);
	    }
	  };
	
	  this.detach = function() {
	    var doc = this.getDocument();
	
	    this.domObserver.disconnect();
	
	    // Document Change Events
	    //
	    doc.disconnect(this);
	
	    // Mouse Events
	    //
	    this.$element.off('mousedown', this._onMouseDown );
	
	    // enable drag'n'drop
	    this.$element.off('dragstart', this.onDragStart);
	
	    // Keyboard Events
	    //
	    this.detachKeyboard();
	
	    this.$element.removeClass('surface');
	
	    // Clean-up
	    //
	    this.element = null;
	    this.$element = null;
	    this.surfaceSelection = null;
	
	    this.attached = false;
	  };
	
	  this.detachKeyboard = function() {
	    this.$element.off('keydown', this._onKeyDown);
	    if (this.element.addEventListener) {
	      this.element.removeEventListener('compositionstart', this._onCompositionStart, false);
	    }
	    if (window.TextEvent && !this.isIE) {
	      this.element.removeEventListener('textInput', this._onTextInput, false);
	    } else {
	      this.$element.off('keypress', this._onTextInputShim);
	    }
	  };
	
	  this.isAttached = function() {
	    return this.attached;
	  };
	
	  this.enable = function() {
	    if (this.enableContentEditable) {
	      this.$element.prop('contentEditable', 'true');
	    }
	    this.enabled = true;
	  };
	
	  this.isEnabled = function() {
	    return this.enabled;
	  };
	
	  this.disable = function() {
	    if (this.enableContentEditable) {
	      this.$element.removeAttr('contentEditable');
	    }
	    this.enabled = false;
	  };
	
	  this.freeze = function() {
	    console.log('Freezing surface...');
	    if (this.enableContentEditable) {
	      this.$element.removeAttr('contentEditable');
	    }
	    this.$element.addClass('frozen');
	    this.domObserver.disconnect();
	    this.frozen = true;
	  };
	
	  this.unfreeze = function() {
	    if (!this.frozen) {
	      return;
	    }
	    console.log('Unfreezing surface...');
	    if (this.enableContentEditable) {
	      this.$element.prop('contentEditable', 'true');
	    }
	    this.$element.removeClass('frozen');
	    this.domObserver.observe(this.element, this.domObserverConfig);
	    this.frozen = false;
	  };
	
	  // ###########################################
	  // Keyboard Handling
	  //
	
	  /**
	   * Handle document key down events.
	   */
	  this.onKeyDown = function( e ) {
	    if (this.frozen) {
	      return;
	    }
	    if ( e.which === 229 ) {
	      // ignore fake IME events (emitted in IE and Chromium)
	      return;
	    }
	    switch ( e.keyCode ) {
	      case Surface.Keys.LEFT:
	      case Surface.Keys.RIGHT:
	        return this.handleLeftOrRightArrowKey(e);
	      case Surface.Keys.UP:
	      case Surface.Keys.DOWN:
	        return this.handleUpOrDownArrowKey(e);
	      case Surface.Keys.ENTER:
	        return this.handleEnterKey(e);
	      case Surface.Keys.SPACE:
	        return this.handleSpaceKey(e);
	      case Surface.Keys.BACKSPACE:
	      case Surface.Keys.DELETE:
	        return this.handleDeleteKey(e);
	      default:
	        break;
	    }
	
	    // Built-in key combos
	    // console.log('####', e.keyCode, e.metaKey, e.ctrlKey, e.shiftKey);
	    // Ctrl+A: select all
	    var handled = false;
	    if ( (e.ctrlKey||e.metaKey) && e.keyCode === 65 ) {
	      var newSelection = this.editor.selectAll(this.getDocument(), this.getSelection());
	      this.setSelection(newSelection);
	      this.surfaceSelection.setSelection(newSelection);
	      this.emit('selection:changed', newSelection, this);
	      handled = true;
	    }
	    // Undo/Redo: cmd+z, cmd+shift+z
	    else if (this.undoEnabled && e.keyCode === 90 && (e.metaKey||e.ctrlKey)) {
	      if (e.shiftKey) {
	        this.redo();
	      } else {
	        this.undo();
	      }
	      handled = true;
	    }
	
	    if (handled) {
	      e.preventDefault();
	      e.stopPropagation();
	    }
	  };
	
	  this.undo = function() {
	    var doc = this.getDocument();
	    if (doc.done.length>0) {
	      doc.undo();
	    }
	  };
	
	  this.redo = function() {
	    var doc = this.getDocument();
	    if (doc.undone.length>0) {
	      doc.redo();
	    }
	  };
	
	  /**
	   * Run a transformation as a transaction properly configured for this surface.
	   * @param beforeState (optional) use this to override the default before-state (e.g. to use a different the initial selection).
	   * @param transformation a (surface) transformation function(tx, args) which receives
	   *                       the selection the transaction was started with, and should return
	   *                       output arguments containing a selection, as well.
	   * @param ctx (optional) will be used as `this` object when calling the transformation.
	   *
	   * @example
	   *
	   *   ```
	   *   surface.transaction(function(tx, args) {
	   *     var selection = args.selection;
	   *     ...
	   *     selection = tx.createSelection(...);
	   *     return {
	   *       selection: selection
	   *     };
	   *   });
	   *
	   *   surface.transaction(function(tx, args) {
	   *     ...
	   *     this.foo();
	   *     ...
	   *     return args;
	   *   }, this);
	   *
	   *   surface.transaction(beforeState, function(tx, args) {
	   *     ...
	   *   });
	   *   ```
	   */
	  this.transaction = function(transformation, ctx) {
	    // `beforeState` is saved with the document operation and will be used
	    // to recover the selection when using 'undo'.
	    var beforeState = {
	      surfaceId: this.getName(),
	      selection: this.getSelection()
	    };
	    // Note: this is to provide the optional signature transaction(before)
	    if (!_.isFunction(arguments[0]) && arguments.length >= 2) {
	      var customBeforeState = arguments[0];
	      beforeState = _.extend(beforeState, customBeforeState);
	      transformation = arguments[1];
	      ctx = arguments[2];
	    }
	    var afterState;
	    // TODO: remove this clear here, and in future do it on document:willchange (not implemented yet)
	    // Then cursor flickering will be gone for undo/redos too.
	    // this.surfaceSelection.clear();
	    this.getDocument().transaction(beforeState, function(tx) {
	      // A transformation receives a set of input arguments and should return a set of output arguments.
	      var result = transformation.call(ctx, tx, { selection: beforeState.selection });
	      // The `afterState` is saved with the document operation and will be used
	      // to recover the selection whe using `redo`.
	      afterState = result || {};
	      // If no selection is returned, the old selection is for `afterState`.
	      if (!afterState.selection) {
	        afterState.selection = beforeState.selection;
	      }
	      afterState.surfaceId = beforeState.surfaceId;
	      return afterState;
	    });
	
	    this.setSelection(afterState.selection);
	  };
	
	  this.onTextInput = function(e) {
	    if (this.frozen) {
	      return;
	    }
	    if (!e.data) return;
	    // console.log("TextInput:", e);
	    e.preventDefault();
	    e.stopPropagation();
	    // necessary for handling dead keys properly
	    this.skipNextObservation=true;
	    this.transaction(function(tx, args) {
	      // trying to remove the DOM selection to reduce flickering
	      this.surfaceSelection.clear();
	      return this.editor.insertText(tx, { selection: args.selection, text: e.data });
	    }, this);
	    this.rerenderDomSelection();
	  };
	
	  // Handling Dead-keys under OSX
	  this.onCompositionStart = function() {
	    // just tell DOM observer that we have everything under control
	    this.skipNextObservation = true;
	  };
	
	  // a shim for textInput events based on keyPress and a horribly dangerous dance with the CE
	  this.onTextInputShim = function( e ) {
	    if (this.frozen) {
	      return;
	    }
	    // Filter out non-character keys. Doing this prevents:
	    // * Unexpected content deletion when selection is not collapsed and the user presses, for
	    //   example, the Home key (Firefox fires 'keypress' for it)
	    // * Incorrect pawning when selection is collapsed and the user presses a key that is not handled
	    //   elsewhere and doesn't produce any text, for example Escape
	    if (
	      // Catches most keys that don't produce output (charCode === 0, thus no character)
	      e.which === 0 || e.charCode === 0 ||
	      // Opera 12 doesn't always adhere to that convention
	      e.keyCode === Surface.Keys.TAB || e.keyCode === Surface.Keys.ESCAPE ||
	      // prevent combinations with meta keys, but not alt-graph which is represented as ctrl+alt
	      !!(e.metaKey) || (!!e.ctrlKey^!!e.altKey)
	    ) {
	      return;
	    }
	    var character = String.fromCharCode(e.which);
	    this.skipNextObservation=true;
	    if (!e.shiftKey) {
	      character = character.toLowerCase();
	    }
	    if (character.length>0) {
	      this.transaction(function(tx, args) {
	        // trying to remove the DOM selection to reduce flickering
	        this.surfaceSelection.clear();
	        return this.editor.insertText(tx, { selection: args.selection, text: character });
	      }, this);
	      this.rerenderDomSelection();
	      e.preventDefault();
	      e.stopPropagation();
	      return;
	    } else {
	      e.preventDefault();
	      e.stopPropagation();
	    }
	  };
	
	  this.handleLeftOrRightArrowKey = function ( e ) {
	    var self = this;
	    // Note: we need this timeout so that CE updates the DOM selection first
	    // before we map the DOM selection
	    window.setTimeout(function() {
	      var options = {
	        direction: (e.keyCode === Surface.Keys.LEFT) ? 'left' : 'right'
	      };
	      self._updateModelSelection(options);
	      // We could rerender the selection, to make sure the DOM is representing
	      // the model selection
	      // TODO: ATM, the SurfaceSelection is not good enough in doing this, e.g., there
	      // are situations where one can not use left/right navigation anymore, as
	      // SurfaceSelection will always decides to choose the initial positition,
	      // which means lockin.
	      // self.rerenderDomSelection();
	    });
	  };
	
	  this.handleUpOrDownArrowKey = function ( e ) {
	    var self = this;
	    // Note: we need this timeout so that CE updates the DOM selection first
	    // before we map the DOM selection
	    window.setTimeout(function() {
	      var options = {
	        direction: (e.keyCode === Surface.Keys.UP) ? 'left' : 'right'
	      };
	      self._updateModelSelection(options);
	      // TODO: enable this when we are better, see comment above
	      //self.rerenderDomSelection();
	    });
	  };
	
	  this.handleSpaceKey = function( e ) {
	    e.preventDefault();
	    e.stopPropagation();
	    this.transaction(function(tx, args) {
	      // trying to remove the DOM selection to reduce flickering
	      this.surfaceSelection.clear();
	      return this.editor.insertText(tx, { selection: args.selection, text: " " });
	    }, this);
	    this.rerenderDomSelection();
	  };
	
	  this.handleEnterKey = function( e ) {
	    e.preventDefault();
	    if (e.shiftKey) {
	      this.transaction(function(tx, args) {
	        return this.editor.softBreak(tx, args);
	      }, this);
	    } else {
	      this.transaction(function(tx, args) {
	        return this.editor.break(tx, args);
	      }, this);
	    }
	    this.rerenderDomSelection();
	  };
	
	  this.handleDeleteKey = function ( e ) {
	    e.preventDefault();
	    var direction = (e.keyCode === Surface.Keys.BACKSPACE) ? 'left' : 'right';
	    this.transaction(function(tx, args) {
	      return this.editor.delete(tx, { selection: args.selection, direction: direction });
	    }, this);
	    this.rerenderDomSelection();
	  };
	
	  // ###########################################
	  // Mouse Handling
	  //
	
	  this.onMouseDown = function(e) {
	    if (this.frozen) {
	      this.unfreeze();
	    }
	    if ( e.which !== 1 ) {
	      return;
	    }
	    // Bind mouseup to the whole document in case of dragging out of the surface
	    this.dragging = true;
	    this.$document.one( 'mouseup', this._onMouseUp );
	  };
	
	  this.onMouseUp = function(/*e*/) {
	    // ... and unbind the temporary handler
	    this.dragging = false;
	    this.setFocused(true);
	    // HACK: somehow the DOM selection is sometimes not there
	    var self = this;
	    setTimeout(function() {
	      if (self.surfaceSelection) {
	        var sel = self.surfaceSelection.getSelection();
	        self.setSelection(sel);
	      }
	    });
	  };
	
	  this.setFocused = function(val) {
	    this.isFocused = val;
	    if (this.isFocused) {
	      this.surfaceManager.didFocus(this);
	    }
	  };
	
	  this.onMouseMove = function() {
	    if (this.dragging) {
	      // TODO: do we want that?
	      // update selection during dragging
	      // this._setModelSelection(this.surfaceSelection.getSelection());
	    }
	  };
	
	  this.onDomMutations = function() {
	    if (this.skipNextObservation) {
	      this.skipNextObservation = false;
	      return;
	    }
	    // Known use-cases:
	    //  - Context-menu:
	    //      - Delete
	    //      - Note: copy, cut, paste work just fine
	    console.info("We want to enable a DOM MutationObserver which catches all changes made by native interfaces (such as spell corrections, etc). Lookout for this message and try to set Surface.skipNextObservation=true when you know that you will mutate the DOM.");
	  };
	
	  this.onDragStart = function(e) {
	    e.preventDefault();
	    e.stopPropagation();
	  };
	
	  // ###########################################
	  // Document and Selection Changes
	  //
	
	  this.getSelection = function() {
	    return this.selection;
	  };
	
	  /**
	   * Set the model selection and update the DOM selection accordingly
	   */
	  this.setSelection = function(sel) {
	    if (!sel) {
	      sel = Selection.nullSelection;
	    } else if (_.isObject(sel) && !(sel instanceof Selection)) {
	      sel = this.getDocument().createSelection(sel);
	    }
	    if (this._setModelSelection(sel)) {
	      this.rerenderDomSelection();
	    }
	  };
	
	  this.rerenderDomSelection = function() {
	    if (this.surfaceSelection) {
	      var surfaceSelection = this.surfaceSelection;
	      var sel = this.getSelection();
	      // IMO this delay was just necessary in case of async rerendering, e.g., with react.
	      // without it, the observed DOM selection flickering seems much better.
	      // setTimeout(function() {
	      surfaceSelection.setSelection(sel);
	      // });
	    }
	  };
	
	  this.getDomNodeForId = function(nodeId) {
	    return this.element.querySelector('*[data-id='+nodeId+']');
	  };
	
	  this._updateModelSelection = function(options) {
	    this._setModelSelection(this.surfaceSelection.getSelection(options));
	  };
	
	  /**
	   * Set the model selection only (without DOM selection update).
	   *
	   * Used internally if we derive the model selection from the DOM selcection.
	   */
	  this._setModelSelection = function(sel) {
	    sel = sel || Substance.Document.nullSelection;
	    this.selection = sel;
	    this.emit('selection:changed', sel, this);
	    return true;
	  };
	
	  this.getLogger = function() {
	    return this.logger;
	  };
	
	  this.placeCaretElement = function() {
	    var sel = this.getSelection();
	    if (sel.isNull()) {
	      throw new Error('Selection is null.');
	    }
	    var $caret = this.$caret;
	    $caret.empty().remove();
	    var pos = this.surfaceSelection._findDomPosition(sel.start.path, sel.start.offset);
	    if (pos.node.nodeType === window.Node.TEXT_NODE) {
	      var textNode = pos.node;
	      if (textNode.length === pos.offset) {
	        $caret.insertAfter(textNode);
	      } else {
	        // split the text node into two pieces
	        var wsel = window.getSelection();
	        var wrange = window.document.createRange();
	        var text = textNode.textContent;
	        var frag = window.document.createDocumentFragment();
	        var textFrag = window.document.createTextNode(text.substring(0, pos.offset));
	        frag.appendChild(textFrag);
	        frag.appendChild($caret[0]);
	        frag.appendChild(document.createTextNode(text.substring(pos.offset)));
	        $(textNode).replaceWith(frag);
	        wrange.setStart(textFrag, pos.offset);
	        wsel.removeAllRanges();
	        wsel.addRange(wrange);
	      }
	    } else {
	      pos.node.appendChild($caret[0]);
	    }
	    return $caret;
	  };
	
	  this.removeCaretElement = function() {
	    this.$caret.remove();
	  };
	
	  this.updateCaretElement = function() {
	    this.$caret.remove();
	    this.placeCaretElement();
	  };
	
	  // API for TextProperties
	  this.getAnnotationsForProperty = function(path) {
	    var doc = this.getDocument();
	    var annotations = doc.getIndex('annotations').get(path);
	    var containerName = this.getContainerName();
	    if (containerName) {
	      // Anchors
	      var anchors = doc.getIndex('container-annotation-anchors').get(path, containerName);
	      annotations = annotations.concat(anchors);
	      // Fragments
	      var fragments = doc.containerAnnotationIndex.getFragments(path, containerName);
	      annotations = annotations.concat(fragments);
	    }
	    return annotations;
	  };
	
	};
	
	OO.inherit(Surface, Substance.EventEmitter);
	
	Surface.Keys =  {
	  UNDEFINED: 0,
	  BACKSPACE: 8,
	  DELETE: 46,
	  LEFT: 37,
	  RIGHT: 39,
	  UP: 38,
	  DOWN: 40,
	  ENTER: 13,
	  END: 35,
	  HOME: 36,
	  TAB: 9,
	  PAGEUP: 33,
	  PAGEDOWN: 34,
	  ESCAPE: 27,
	  SHIFT: 16,
	  SPACE: 32
	};
	
	Surface.detectIE = function() {
	  var ua = window.navigator.userAgent;
	  var msie = ua.indexOf('MSIE ');
	  if (msie > 0) {
	      // IE 10 or older => return version number
	      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	  }
	  var trident = ua.indexOf('Trident/');
	  if (trident > 0) {
	      // IE 11 => return version number
	      var rv = ua.indexOf('rv:');
	      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	  }
	  var edge = ua.indexOf('Edge/');
	  if (edge > 0) {
	     // IE 12 => return version number
	     return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	  }
	  // other browser
	  return false;
	};
	
	
	module.exports = Surface;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var OO = __webpack_require__(2);
	var Document = __webpack_require__(18);
	var _ = __webpack_require__(1);
	var Range = Document.Range;
	var Coordinate = Document.Coordinate;
	
	/**
	 * A class that maps DOM selections to model selections.
	 *
	 * There are some difficulties with mapping model selections:
	 * 1. DOM selections can not model discontinuous selections, such as TableSelections or MultiSelections.
	 * 2. Not all positions reachable via ContentEditable can be mapped to model selections. For instance,
	 *    there are extra positions before and after non-editable child elements.
	 * 3. Some native cursor behaviors need to be overidden, such as for navigating tables.
	 *
	 * @class SurfaceSelection
	 * @constructor
	 * @param {Element} rootElement
	 * @module Surface
	 */
	function SurfaceSelection(rootElement, doc, container) {
	  this.element = rootElement;
	  this.doc = doc;
	  this.container = container;
	  this.state = new SurfaceSelection.State();
	}
	
	SurfaceSelection.Prototype = function() {
	
	  function compareNodes(node1, node2) {
	    var cmp = node1.compareDocumentPosition(node2);
	    if (cmp&window.document.DOCUMENT_POSITION_FOLLOWING) {
	      return -1;
	    } else if (cmp&window.document.DOCUMENT_POSITION_PRECEDING) {
	      return 1;
	    } else {
	      return 0;
	    }
	  }
	
	  // input methods:
	  // - mouse down (setting cursor with mouse)
	  // - keyboard cursor movement
	  // - expand:
	  //   - mouse dragging
	  //   - cursor movement with shift
	
	  // workflow for mapping from DOM to model:
	  // 1. extract coordinates
	  // 2. fixup coordinates
	  // 3. create a model selection
	  this._pullState = function(anchorNode, anchorOffset, focusNode, focusOffset, collapsed, options) {
	    options = options || {};
	    if (!focusNode || !anchorNode) {
	      this.state = null;
	      return;
	    }
	    // console.log('###', anchorNode, anchorOffset, focusNode, focusOffset);
	    var start, end;
	    if (collapsed) {
	      start = this.getModelCoordinate(anchorNode, anchorOffset, options);
	      end = start;
	    } else {
	      start = this.getModelCoordinate(anchorNode, anchorOffset, options);
	      end = this.getModelCoordinate(focusNode, focusOffset, options);
	    }
	    // the selection is reversed when the focus propertyEl is before
	    // the anchor el or the computed charPos is in reverse order
	    var reverse = false;
	    if (!collapsed && focusNode && anchorNode) {
	      var cmp = compareNodes(end.el, start.el);
	      reverse = ( cmp < 0 || (cmp === 0 && end.offset < start.offset) );
	    }
	    if (reverse) {
	      var tmp = end;
	      end = start;
	      start = tmp;
	    }
	    // console.log('### extracted selection:', start, end, reverse);
	    this.state = new SurfaceSelection.State(collapsed, reverse, start, end);
	  };
	
	  this.getModelCoordinate = function(node, offset, options) {
	    var current = node;
	    var propertyEl = null;
	    while(current) {
	      // if available extract a path fragment
	      if (current.dataset && current.dataset.path) {
	        propertyEl = current;
	        break;
	      }
	      // edge case: when a node is empty then then the given DOM node
	      // is the node element and with offset=0
	      if ($(current).is('.content-node') && offset === 0) {
	        var $propertyEl = $(current).find('[data-path]');
	        if ($propertyEl.length) {
	          return new SurfaceSelection.Coordinate($propertyEl[0], 0);
	        }
	      }
	      current = current.parentNode;
	    }
	    if (!propertyEl) {
	      return this.searchForCoordinate(node, offset, options);
	    }
	    var charPos = this._computeCharPosition(propertyEl, node, offset);
	    return new SurfaceSelection.Coordinate(propertyEl, charPos);
	  };
	
	  this._computeCharPosition = function(propertyEl, endNode, offset) {
	    var charPos = 0;
	
	    // This works with endNode being a TextNode
	    function _getPosition(node) {
	      if (endNode === node) {
	        charPos += offset;
	        return true;
	      }
	      if (node.nodeType === window.Node.TEXT_NODE) {
	        charPos += node.textContent.length;
	      } else if (node.nodeType === window.Node.ELEMENT_NODE) {
	        // external nodes have a length of 1
	        // they are attached to an invisible character
	        // but may have a custom rendering
	        if ($(node).data('external')) {
	          charPos += 1;
	          return false;
	        }
	        for (var childNode = node.firstChild; childNode; childNode = childNode.nextSibling) {
	          if (_getPosition(childNode)) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	    // count characters recursively
	    // by sum up the length of all TextNodes
	    // and counting external nodes by 1.
	    function _countCharacters(el) {
	      var type = el.nodeType;
	      if (type === window.Node.TEXT_NODE) {
	        return el.textContent.length;
	      } else if (type === window.Node.ELEMENT_NODE) {
	        if ($(el).data('external')) {
	          return 1;
	        } else {
	          var count = 0;
	          for (var childNode = el.firstChild; childNode; childNode = childNode.nextSibling) {
	            count += _countCharacters(childNode);
	          }
	          return count;
	        }
	      }
	      return 0;
	    }
	
	    var found = false;
	
	    // HACK: edge case which occurs when the last element
	    // is not content-editable (i.e., external)
	    // then the anchor node is the property element itself
	    if (endNode === propertyEl) {
	      var child = propertyEl.firstChild;
	      for (var i = 0; i < offset; i++) {
	        if (!child) {
	          break;
	        }
	        charPos += _countCharacters(child);
	        child = child.nextSibling;
	      }
	      found = true;
	    } else {
	      found = _getPosition(propertyEl);
	    }
	
	    if (!found) {
	      console.error('Could not find char position.');
	      return 0;
	    }
	    // console.log('charPos', charPos);
	    return charPos;
	  };
	
	  /**
	   * Look up model coordinate by doing a search
	   * on all available property elements.
	   */
	  this.searchForCoordinate = function(node, offset, options) {
	    var elements = this.element.querySelectorAll('*[data-path]');
	    var idx, idx1, idx2, cmp1, cmp2;
	    idx1 = 0;
	    idx2 = elements.length-1;
	    cmp1 = compareNodes(elements[idx1], node);
	    cmp2 = compareNodes(elements[idx2], node);
	    while(true) {
	      var l = idx2-idx1+1;
	      if (cmp2 < 0) {
	        idx = idx2;
	        break;
	      } else if (cmp1 > 0) {
	        idx = idx1;
	        break;
	      } else if (l<=2) {
	        idx = idx2;
	        break;
	      }
	      var pivotIdx = idx1 + Math.floor(l/2);
	      var pivotCmp = compareNodes(elements[pivotIdx], node);
	      if (pivotCmp < 0) {
	        idx1 = pivotIdx;
	        cmp1 = pivotCmp;
	      } else {
	        idx2 = pivotIdx;
	        cmp2 = pivotCmp;
	      }
	    }
	    var charPos;
	    if (options.direction === "left") {
	      idx = Math.max(0, idx-1);
	      charPos = elements[idx].textContent.length;
	    } else if (cmp2<0) {
	      charPos = elements[idx].textContent.length;
	    } else {
	      charPos = 0;
	    }
	    return new SurfaceSelection.Coordinate(elements[idx], charPos);
	  };
	
	  this._getSelection = function(anchorNode, anchorOffset, focusNode, focusOffset, collapsed) {
	    this._pullState(anchorNode, anchorOffset, focusNode, focusOffset, collapsed);
	    // console.log('#### selection state', this.state);
	    if (!this.state) {
	      return Document.nullSelection;
	    }
	    var doc = this.doc;
	    var start = this.state.start;
	    var end = this.state.end;
	    var node1, node2, parent1, parent2, row1, col1, row2, col2;
	    var range = new Range(
	      new Coordinate(start.path, start.offset),
	      new Coordinate(end.path, end.offset)
	    );
	    if (_.isEqual(start.path, end.path)) {
	      return doc.createSelection({
	        type: 'property',
	        path: start.path,
	        startOffset: start.offset,
	        endOffset: end.offset,
	        reverse: this.state.reverse
	      });
	    } else {
	      node1 = doc.get(start.path[0]);
	      node2 = doc.get(end.path[0]);
	      parent1 = node1.getRoot();
	      parent2 = node2.getRoot();
	      if (parent1.type === "table" && parent1.id === parent2.id) {
	        // HACK making sure that the table matrix has been computed
	        parent1.getMatrix();
	        row1 = node1.rowIdx;
	        col1 = node1.colIdx;
	        row2 = node2.rowIdx;
	        col2 = node2.colIdx;
	        return doc.createSelection({
	          type: 'table',
	          tableId: parent1.id,
	          startRow: row1,
	          startCol: col1,
	          endRow: row2,
	          endCol: col2
	        });
	      } else {
	        return doc.createSelection({
	          type: 'container',
	          containerId: this.container.id,
	          startPath: range.start.path,
	          startOffset: range.start.offset,
	          endPath: range.end.path,
	          endOffset: range.end.offset,
	          reverse: this.state.reverse
	        });
	      }
	    }
	  };
	
	  this.getSelection = function() {
	    var wSel = window.getSelection();
	    var sel = this._getSelection(wSel.anchorNode, wSel.anchorOffset, wSel.focusNode, wSel.focusOffset, wSel.collapsed);
	    // console.log('### selection', sel.toString());
	    return sel;
	  };
	
	  var _findDomPosition = function(element, offset) {
	    if (element.nodeType === document.TEXT_NODE) {
	      var l = element.textContent.length;
	      if (l < offset) {
	        return {
	          node: null,
	          offset: offset-l
	        };
	      } else {
	        return {
	          node: element,
	          offset: offset,
	          boundary: (l === offset)
	        };
	      }
	    } else if (element.nodeType === document.ELEMENT_NODE) {
	      if ($(element).data('external')) {
	        return {
	          node: null,
	          offset: offset-1
	        };
	      }
	      // edge case: if the element itself is empty and offset===0
	      if (!element.firstChild && offset === 0) {
	        return {
	          node: element,
	          offset: 0
	        };
	      }
	      for (var child = element.firstChild; child; child = child.nextSibling) {
	        var pos = _findDomPosition(child, offset);
	        if (pos.node) {
	          return pos;
	        } else {
	          // not found in this child; then pos.offset contains the translated offset
	          offset = pos.offset;
	        }
	      }
	    }
	    return {
	      node: null,
	      offset: offset
	    };
	  };
	
	  this._getDomPosition = function(path, offset) {
	    var selector = '*[data-path="'+path.join('.')+'"]';
	    var componentElement = this.element.querySelector(selector);
	    if (!componentElement) {
	      console.warn('Could not find DOM element for path', path);
	      return null;
	    }
	    // console.log('### Found component element', componentElement);
	    var pos = _findDomPosition(componentElement, offset);
	    if (pos.node) {
	      return pos;
	    } else {
	      return null;
	    }
	  };
	
	  this.setSelection = function(sel) {
	    // console.log('### renderSelection', sel.toString());
	    var wSel = window.getSelection();
	    if (sel.isNull() || sel.isTableSelection()) {
	      return this.clear();
	    }
	    var range = sel.getRange();
	    var startPosition = this._getDomPosition(range.start.path, range.start.offset);
	    if (!startPosition) {
	      return this.clear();
	    }
	    var endPosition;
	    if (range.isCollapsed()) {
	      endPosition = startPosition;
	    } else {
	      endPosition = this._getDomPosition(range.end.path, range.end.offset);
	    }
	    if (!endPosition) {
	      return this.clear();
	    }
	    // if there is a range then set replace the window selection accordingly
	    wSel.removeAllRanges();
	    range = window.document.createRange();
	    if (sel.isReverse()) {
	      range.setStart(endPosition.node, endPosition.offset);
	      wSel.addRange(range);
	      wSel.extend(startPosition.node, startPosition.offset);
	    } else {
	      range.setStart(startPosition.node, startPosition.offset);
	      range.setEnd(endPosition.node, endPosition.offset);
	      wSel.addRange(range);
	    }
	    this.state = new SurfaceSelection.State(sel.isCollapsed(), sel.isReverse(), range.start, range.end);
	  };
	
	  this.clear = function() {
	    var sel = window.getSelection();
	    sel.removeAllRanges();
	    this.state = null;
	  };
	
	};
	
	OO.initClass(SurfaceSelection);
	
	SurfaceSelection.State = function(collapsed, reverse, start, end) {
	  this.collapsed = collapsed;
	  this.reverse = reverse;
	  this.start = start;
	  this.end = end;
	  Object.freeze(this);
	};
	
	SurfaceSelection.Coordinate = function(el, charPos) {
	  this.el = el;
	  this.offset = charPos;
	  this.path = el.dataset.path.split('.');
	};
	
	module.exports = SurfaceSelection;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var OO = __webpack_require__(2);
	var Component = __webpack_require__(4);
	var $$ = Component.$$;
	
	function AnnotationComponent() {
	  Component.apply(this, arguments);
	}
	
	AnnotationComponent.Prototype = function() {
	
	  this.render = function() {
	    var el = $$('span')
	      .attr("data-id", this.props.node.id)
	      .addClass(this.getClassNames());
	    if (this.props.node.active) {
	      el.addClass('active');
	    }
	    el.append(this.props.children);
	    return el;
	  };
	
	  this.getClassNames = function() {
	    var typeNames = this.props.node.getTypeNames();
	    var classNames = typeNames.join(' ');
	    if (this.props.classNames) {
	      classNames += " " + this.props.classNames.join(' ');
	    }
	    return classNames.replace(/_/g, '-');
	  };
	
	  this.didMount = function() {
	    var node = this.props.node;
	    node.connect(this, {
	      'active': this.onActiveChanged
	    });
	  };
	
	  this.willUnmount = function() {
	    var node = this.props.node;
	    node.disconnect(this);
	  };
	
	  this.onActiveChanged = function() {
	    if (this.props.node.active) {
	      this.$el.addClass('active');
	    } else {
	      this.$el.removeClass('active');
	    }
	  };
	};
	
	OO.inherit(AnnotationComponent, Component);
	
	module.exports = AnnotationComponent;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var OO = __webpack_require__(2);
	var Component = __webpack_require__(4);
	var $$ = Component.$$;
	var Tool = __webpack_require__(9);
	var _ = __webpack_require__(1);
	
	// ToolComponent
	// -------------
	
	function ToolComponent() {
	  Component.apply(this, arguments);
	}
	
	ToolComponent.Prototype = function() {
	
	  this.didInitialize = function() {
	    this._initializeTool();
	  };
	
	  this.getInitialState = function() {
	    // Derive initial state from tool
	    return this.tool.state;
	  };
	
	  this.render = function() {
	    var title = this.props.title;
	
	    if (this.state.mode) {
	      title = [_.capitalize(this.state.mode), title].join(' ');
	    }
	
	    var el = $$("button")
	      .attr('title', title)
	      .addClass('button tool')
	      .on('mousedown', this.onMouseDown)
	      .on('click', this.onClick);
	
	    if (this.state.disabled) {
	      el.addClass('disabled');
	    }
	    if (this.state.active) {
	      el.addClass('active');
	    }
	    if (this.state.mode) {
	      el.addClass(this.state.mode);
	    }
	
	    el.append(this.props.children);
	
	    // When we are in edit mode showing the edit prompt
	    if (/*this.state.mode === 'edit' && this.state.prompt && */ this.editPrompt) {
	      var prompt = $$(this.editPrompt);
	      el.append(prompt);
	    }
	
	    return el;
	  };
	
	  this.didMount = function() {
	    var toolName = this.props.tool;
	    if (!toolName) {
	      throw new Error('Prop "tool" is mandatory.');
	    }
	    this.tool = this.context.toolRegistry.get(toolName);
	    if (!this.tool) {
	      console.warn('No tool registered with name %s', toolName);
	      this.tool = new ToolComponent.StubTool(toolName);
	    }
	    // Derive initial state from tool
	    this.state = this.tool.state;
	    this.tool.connect(this, {
	      'toolstate:changed': this.onToolstateChanged
	    });
	  };
	
	  this._initializeTool = function() {
	    var toolName = this.props.tool;
	    if (!toolName) {
	      throw new Error('Prop "tool" is mandatory.');
	    }
	    this.tool = this.context.toolRegistry.get(toolName);
	    if (!this.tool) {
	      console.warn('No tool registered with name %s', toolName);
	      this.tool = new ToolComponent.StubTool(toolName);
	    }
	    this.tool.connect(this, {
	      'toolstate:changed': this.onToolstateChanged
	    });
	  };
	
	  this.onToolstateChanged = function(toolState/*, tool, oldState*/) {
	    this.setState(toolState);
	  };
	
	  this.onClick = function(e) {
	    e.preventDefault();
	  };
	
	  this.onMouseDown = function(e) {
	    e.preventDefault();
	    if (this.state.disabled) {
	      return;
	    }
	    this.tool.performAction();
	  };
	};
	
	OO.inherit(ToolComponent, Component);
	
	ToolComponent.StubTool = Tool.extend({
	
	  init: function(name) {
	    this.name = name;
	  },
	
	  performAction: function() {
	    console.log('Stub-Tool %s', this.name);
	  }
	});
	
	module.exports = ToolComponent;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(108)['default'];
	
	var _classCallCheck = __webpack_require__(107)['default'];
	
	var _interopRequireDefault = __webpack_require__(61)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(262);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _substanceUiEditor = __webpack_require__(250);
	
	var _substanceUiEditor2 = _interopRequireDefault(_substanceUiEditor);
	
	var _substanceUiComponent = __webpack_require__(4);
	
	var _substanceUiComponent2 = _interopRequireDefault(_substanceUiComponent);
	
	var $$ = _substanceUiComponent2['default'].$$;
	
	var SubstanceEditor = (function (_React$Component) {
	  _inherits(SubstanceEditor, _React$Component);
	
	  function SubstanceEditor(props) {
	    _classCallCheck(this, SubstanceEditor);
	
	    _React$Component.call(this, props);
	
	    this.state = {
	      contentEditor: undefined
	    };
	  }
	
	  SubstanceEditor.prototype.componentDidMount = function componentDidMount() {
	    var container = this.refs.substance_editor;
	    this.setState({ contentEditor: _substanceUiComponent2['default'].mount($$(_substanceUiEditor2['default'], {
	        content: this.props.initialValue || ''
	      }), container) });
	  };
	
	  SubstanceEditor.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'substance-editor', ref: 'substance_editor' },
	      'Loading editor...'
	    );
	  };
	
	  return SubstanceEditor;
	})(_react2['default'].Component);
	
	exports['default'] = SubstanceEditor;
	module.exports = exports['default'];

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(109), __esModule: true };

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(110), __esModule: true };

/***/ },
/* 107 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	exports.__esModule = true;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$create = __webpack_require__(105)["default"];
	
	var _Object$setPrototypeOf = __webpack_require__(106)["default"];
	
	exports["default"] = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = _Object$create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _Object$setPrototypeOf ? _Object$setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	exports.__esModule = true;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(64);
	module.exports = function create(P, D){
	  return $.create(P, D);
	};

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(117);
	module.exports = __webpack_require__(62).Object.setPrototypeOf;

/***/ },
/* 111 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(63);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(111);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  } return function(/* ...args */){
	      return fn.apply(that, arguments);
	    };
	};

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(115)
	  , core      = __webpack_require__(62)
	  , PROTOTYPE = 'prototype';
	var ctx = function(fn, that){
	  return function(){
	    return fn.apply(that, arguments);
	  };
	};
	var $def = function(type, name, source){
	  var key, own, out, exp
	    , isGlobal = type & $def.G
	    , isProto  = type & $def.P
	    , target   = isGlobal ? global : type & $def.S
	        ? global[name] : (global[name] || {})[PROTOTYPE]
	    , exports  = isGlobal ? core : core[name] || (core[name] = {});
	  if(isGlobal)source = name;
	  for(key in source){
	    // contains in native
	    own = !(type & $def.F) && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    if(isGlobal && typeof target[key] != 'function')exp = source[key];
	    // bind timers to global for call from export context
	    else if(type & $def.B && own)exp = ctx(out, global);
	    // wrap global constructors for prevent change them in library
	    else if(type & $def.W && target[key] == out)!function(C){
	      exp = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      exp[PROTOTYPE] = C[PROTOTYPE];
	    }(out);
	    else exp = isProto && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export
	    exports[key] = exp;
	    if(isProto)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$def.F = 1;  // forced
	$def.G = 2;  // global
	$def.S = 4;  // static
	$def.P = 8;  // proto
	$def.B = 16; // bind
	$def.W = 32; // wrap
	module.exports = $def;

/***/ },
/* 115 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var UNDEFINED = 'undefined';
	var global = module.exports = typeof window != UNDEFINED && window.Math == Math
	  ? window : typeof self != UNDEFINED && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var getDesc  = __webpack_require__(64).getDesc
	  , isObject = __webpack_require__(63)
	  , anObject = __webpack_require__(112);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} // eslint-disable-line
	    ? function(buggy, set){
	        try {
	          set = __webpack_require__(113)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
	          set({}, []);
	        } catch(e){ buggy = true; }
	        return function setPrototypeOf(O, proto){
	          check(O, proto);
	          if(buggy)O.__proto__ = proto;
	          else set(O, proto);
	          return O;
	        };
	      }()
	    : undefined),
	  check: check
	};

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $def = __webpack_require__(114);
	$def($def.S, 'Object', {setPrototypeOf: __webpack_require__(116).set});

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// Substance Article
	// ----------------
	// 
	// The default Article Implementation
	// 
	// Uses well-defined HTML exchange representation
	
	var OO = __webpack_require__(2);
	var Document = __webpack_require__(18);
	var HtmlImporter = Document.HtmlImporter;
	var HtmlExporter = Document.HtmlExporter;
	
	var defaultNodes = [
	  Document.Paragraph,
	  Document.Codeblock,
	  Document.Blockquote,
	  Document.Heading,
	  Document.List, Document.ListItem,
	  Document.Emphasis,
	  Document.Strong,
	  Document.Link
	];
	
	// Default Schema
	// ----------------
	
	var defaultSchema = new Document.Schema("substance-article", "1.0.0");
	
	defaultSchema.getDefaultTextType = function() {
	  return "paragraph";
	};
	
	defaultSchema.addNodes(defaultNodes);
	
	// Importer
	// ----------------
	
	function Importer(schema) {
	  Importer.super.call(this, { schema: schema });
	}
	
	Importer.Prototype = function() {
	  this.convert = function($rootEl, doc) {
	    this.initialize(doc, $rootEl);
	    this.convertContainer($rootEl, 'body');
	    this.finish();
	  };
	};
	
	OO.inherit(Importer, HtmlImporter);
	
	// Exporter
	// ----------------
	
	function Exporter(schema) {
	  Exporter.super.call(this, { schema: schema });
	}
	
	Exporter.Prototype = function() {
	
	  this.convert = function(doc, options) {
	    this.initialize(doc, options);
	
	    var body = doc.get('body');
	    var bodyNodes = this.convertContainer(body);
	    var $el = $('<div>');
	    $el.append(bodyNodes);
	    return $el.html();
	  };
	};
	
	OO.inherit(Exporter, HtmlExporter);
	
	
	// Article Class
	// ----------------
	
	var Article = function(schema) {
	  Document.call(this, schema || defaultSchema);
	};
	
	Article.Prototype = function() {
	
	  this.initialize = function() {
	    Document.prototype.initialize.apply(this, arguments);
	
	    this.create({
	      type: "container",
	      id: "body",
	      nodes: []
	    });
	  };
	
	  this.toHtml = function() {
	    return new Exporter(this.schema).convert(this);
	  };
	
	  // replaces the content by loading from the given html
	  this.loadHtml = function(html) {
	    this.clear();
	
	    // Re-enable transaction for the importing step
	    this.FORCE_TRANSACTIONS = false;
	    var $root = $('<div>'+html+'</div>');
	    new Importer(this.schema).convert($root, this);
	    this.documentDidLoad();
	  };
	};
	
	OO.inherit(Article, Document);
	Article.schema = defaultSchema;
	
	Article.Importer = Importer;
	module.exports = Article;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var OO = __webpack_require__(2);
	
	/**
	 * Base class for Substance errors.
	 *
	 * @class SubstanceError
	 * @extends Error
	 * @constructor
	 * @module Basics
	 */
	function SubstanceError() {
	  Error.apply(this, arguments);
	}
	
	OO.inherit(SubstanceError, Error);
	
	module.exports = SubstanceError;


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var OO = __webpack_require__(2);
	var Registry = __webpack_require__(34);
	
	/**
	 * Factory
	 * -------
	 * Simple factory implementation.
	 *
	 * @class Factory
	 * @extends Registry
	 * @constructor
	 * @module Basics
	 */
	function Factory() {
	  Factory.super.call(this);
	}
	
	Factory.Prototype = function() {
	
	  /**
	   * Create an instance of the clazz with a given name.
	   *
	   * @param {String} name
	   * @return A new instance.
	   * @method create
	   */
	  this.create = function ( name ) {
	    var clazz = this.get(name);
	    if ( !clazz ) {
	      throw new Error( 'No class registered by that name: ' + name );
	    }
	    // call the clazz providing the remaining arguments
	    var args = Array.prototype.slice.call( arguments, 1 );
	    var obj = Object.create( clazz.prototype );
	    clazz.apply( obj, args );
	    return obj;
	  };
	
	};
	
	OO.inherit(Factory, Registry);
	
	module.exports = Factory;


/***/ },
/* 121 */
/***/ function(module, exports) {

	'use strict';
	var lastTime = Date.now();
	
	module.exports = {
	  tic: function() {
	    lastTime = Date.now();
	  },
	  toc: function () {
	    return Date.now() - lastTime;
	  },
	};


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var OO = __webpack_require__(2);
	var _ = __webpack_require__(1);
	
	var Data = __webpack_require__(65);
	var Operator = __webpack_require__(228);
	var ObjectOperation = Operator.ObjectOperation;
	var ArrayOperation = Operator.ArrayOperation;
	var TextOperation = Operator.TextOperation;
	
	/**
	 * Incremental data storage implemention.
	 *
	 * @class Data.Incremental
	 * @extends Data
	 * @constructor
	 * @param {Schema} schema
	 * @param {Object} [options]
	 * @module Data
	 */
	var IncrementalData = function(schema, options) {
	  IncrementalData.super.call(this, schema, options);
	};
	
	IncrementalData.Prototype = function() {
	
	  /**
	   * Create a new node.
	   *
	   * @method create
	   * @param {Object} nodeData
	   * @return The applied operation.
	   */
	  this.create = function(nodeData) {
	    var op = ObjectOperation.Create([nodeData.id], nodeData);
	    this.apply(op);
	    return op;
	  };
	
	  /**
	   * Delete a node.
	   *
	   * @method delete
	   * @param {String} nodeId
	   * @return The applied operation.
	   */
	  this.delete = function(nodeId) {
	    var op = null;
	    var node = this.get(nodeId);
	    if (node) {
	      var nodeData = node.toJSON();
	      op = ObjectOperation.Delete([nodeId], nodeData);
	      this.apply(op);
	    }
	    return op;
	  };
	
	  /**
	   * Update a property incrementally.
	   *
	   * The diff can be of the following forms (depending on the updated property type):
	   *   - String:
	   *     - `{ insert: { offset: Number, value: Object } }`
	   *     - `{ delete: { start: Number, end: Number } }`
	   *   - Array:
	   *     - `{ insert: { offset: Number, value: Object } }`
	   *     - `{ delete: { offset: Number } }`
	   *
	   * @method update
	   * @param {Array} path
	   * @param {Object} diff
	   * @return The applied operation.
	   */
	  this.update = function(path, diff) {
	    var diffOp = this._getDiffOp(path, diff);
	    var op = ObjectOperation.Update(path, diffOp);
	    this.apply(op);
	    return op;
	  };
	
	  /**
	   * Set a property to a new value
	   *
	   * @method set
	   * @param {Array} path
	   * @param {Object} newValue
	   * @return The applied operation.
	   */
	  this.set = function(path, newValue) {
	    var oldValue = this.get(path);
	    var op = ObjectOperation.Set(path, oldValue, newValue);
	    this.apply(op);
	    return op;
	  };
	
	  /**
	   * Apply a given operation.
	   *
	   * @method apply
	   * @param {ObjectOperation} op
	   */
	  this.apply = function(op) {
	    if (op.type === ObjectOperation.NOP) return;
	    else if (op.type === ObjectOperation.CREATE) {
	      // clone here as the operations value must not be changed
	      this.super.create.call(this, _.deepclone(op.val));
	    } else if (op.type === ObjectOperation.DELETE) {
	      this.super.delete.call(this, op.val.id);
	    } else if (op.type === ObjectOperation.UPDATE) {
	      var oldVal = this.get(op.path);
	      var diff = op.diff;
	      if (op.propertyType === 'array') {
	        if (! (diff instanceof ArrayOperation) ) {
	          diff = ArrayOperation.fromJSON(diff);
	        }
	        // array ops work inplace
	        diff.apply(oldVal);
	      } else if (op.propertyType === 'string') {
	        if (! (diff instanceof TextOperation) ) {
	          diff = TextOperation.fromJSON(diff);
	        }
	        var newVal = diff.apply(oldVal);
	        this.super.set.call(this, op.path, newVal);
	      } else {
	        throw new Error("Unsupported type for operational update.");
	      }
	    } else if (op.type === ObjectOperation.SET) {
	      this.super.set.call(this, op.path, op.val);
	    } else {
	      throw new Error("Illegal state.");
	    }
	    this.emit('operation:applied', op, this);
	  };
	
	  this._getDiffOp = function(path, diff) {
	    var diffOp = null;
	    if (diff.isOperation) {
	      diffOp = diff;
	    } else {
	      var value = this.get(path);
	      var start, end, pos, val;
	      if (value === null || value === undefined) {
	        throw new Error('Property has not been initialized: ' + JSON.stringify(path));
	      } else if (_.isString(value)) {
	        if (diff['delete']) {
	          // { delete: [2, 5] }
	          start = diff['delete'].start;
	          end = diff['delete'].end;
	          diffOp = TextOperation.Delete(start, value.substring(start, end));
	        } else if (diff['insert']) {
	          // { insert: [2, "foo"] }
	          pos = diff['insert'].offset;
	          val = diff['insert'].value;
	          diffOp = TextOperation.Insert(pos, val);
	        }
	      } else if (_.isArray(value)) {
	        if (diff['delete']) {
	          // { delete: 2 }
	          pos = diff['delete'].offset;
	          diffOp = ArrayOperation.Delete(pos, value[pos]);
	        } else if (diff['insert']) {
	          // { insert: [2, "foo"] }
	          pos = diff['insert'].offset;
	          val = diff['insert'].value;
	          diffOp = ArrayOperation.Insert(pos, val);
	        }
	      }
	    }
	    if (!diffOp) {
	      throw new Error('Unsupported diff: ' + JSON.stringify(diff));
	    }
	    return diffOp;
	  };
	
	};
	
	OO.inherit(IncrementalData, Data);
	
	module.exports = IncrementalData;


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Substance = __webpack_require__(3);
	var Node = __webpack_require__(36);
	var Factory = Substance.Factory;
	
	/**
	 * Factory for Nodes.
	 *
	 * @class Data.NodeFactory
	 * @extends Factory
	 * @constructor
	 * @module Data
	 */
	function NodeFactory() {
	  Factory.call(this);
	}
	
	NodeFactory.Prototype = function() {
	  /**
	   * Register a Node class.
	   *
	   * @method register
	   * @param {Class} nodeClass
	   */
	  this.register = function ( nodeClazz ) {
	    var name = nodeClazz.static && nodeClazz.static.name;
	    if ( typeof name !== 'string' || name === '' ) {
	      throw new Error( 'Node names must be strings and must not be empty' );
	    }
	    if ( !( nodeClazz.prototype instanceof Node) ) {
	      throw new Error( 'Nodes must be subclasses of Substance.Data.Node' );
	    }
	
	    if (this.contains(name)) {
	      throw new Error('Node class is already registered: ' + name);
	    }
	
	    this.add(name, nodeClazz);
	  };
	};
	
	Substance.inherit(NodeFactory, Factory);
	
	module.exports = NodeFactory;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Substance = __webpack_require__(3);
	var PathAdapter = Substance.PathAdapter;
	
	/**
	 * Index for Nodes.
	 *
	 * Node indexes are first-class citizens in Substance.Data.
	 * I.e., they are updated after each operation.
	 *
	 * @class Data.NodeIndex
	 * @constructor
	 * @module Data
	 */
	var NodeIndex = function() {
	  /**
	   * Internal storage.
	   * @property {PathAdapter} index
	   * @private
	   */
	  this.index = new PathAdapter();
	};
	
	NodeIndex.Prototype = function() {
	
	  /**
	   * Reset the index using a Data instance.
	   *
	   * @method reset
	   * @private
	   */
	  this.reset = function(data) {
	    this.index.clear();
	    this._initialize(data);
	  };
	
	  this._initialize = function(data) {
	    Substance.each(data.getNodes(), function(node) {
	      if (this.select(node)) {
	        this.create(node);
	      }
	    }, this);
	  };
	
	  /**
	   * The property used for indexing.
	   *
	   * @property {String} property
	   * @protected
	   */
	  this.property = "id";
	
	  /**
	   * Check if a node should be indexed.
	   *
	   * Used internally only. Override this in subclasses to achieve a custom behavior.
	   *
	   * @method select
	   * @protected
	   */
	  this.select = function(node) {
	    if(!this.type) {
	      return true;
	    } else {
	      return node.isInstanceOf(this.type);
	    }
	  };
	
	  /**
	   * Get all indexed nodes for a given path.
	   *
	   * @method get
	   * @param {Array} path
	   * @return A node or an object with ids and nodes as values.
	   */
	  // TODO: what is the correct return value. We have arrays at some places.
	  this.get = function(path) {
	    // HACK: unwrap objects on the index when method is called without a path
	    if (!path) return this.getAll();
	    return this.index.get(path) || {};
	  };
	
	  /**
	   * Collects all indexed nodes.
	   *
	   * @method getAll
	   * @return An object with ids as keys and nodes as values.
	   */
	  // TODO: is that true?
	  this.getAll = function() {
	    var result = {};
	    Substance.each(this.index, function(values) {
	      Substance.extend(result, values);
	    });
	    return result;
	  };
	
	  /**
	   * Called when a node has been created.
	   *
	   * Override this in subclasses for customization.
	   *
	   * @method create
	   * @param {Node} node
	   * @protected
	   */
	  this.create = function(node) {
	    var values = node[this.property];
	    if (!Substance.isArray(values)) {
	      values = [values];
	    }
	    Substance.each(values, function(value) {
	      this.index.set([value, node.id], node);
	    }, this);
	  };
	
	  /**
	   * Called when a node has been deleted.
	   *
	   * Override this in subclasses for customization.
	   *
	   * @method delete
	   * @param {Node} node
	   * @protected
	   */
	  this.delete = function(node) {
	    var values = node[this.property];
	    if (!Substance.isArray(values)) {
	      values = [values];
	    }
	    Substance.each(values, function(value) {
	      this.index.delete([value, node.id]);
	    }, this);
	  };
	
	  /**
	   * Called when a property has been updated.
	   *
	   * Override this in subclasses for customization.
	   *
	   * @method update
	   * @param {Node} node
	   * @protected
	   */
	  this.update = function(node, path, newValue, oldValue) {
	    if (!this.select(node) || path[1] !== this.property) return;
	    var values = oldValue;
	    if (!Substance.isArray(values)) {
	      values = [values];
	    }
	    Substance.each(values, function(value) {
	      this.index.delete([value, node.id]);
	    }, this);
	    values = newValue;
	    if (!Substance.isArray(values)) {
	      values = [values];
	    }
	    Substance.each(values, function(value) {
	      this.index.set([value, node.id], node);
	    }, this);
	  };
	
	  /**
	   * Clone this index.
	   *
	   * @method clone
	   * @return A cloned NodeIndex.
	   */
	  this.clone = function() {
	    var NodeIndexClass = this.constructor;
	    var clone = new NodeIndexClass();
	    return clone;
	  };
	};
	
	Substance.initClass( NodeIndex );
	
	/**
	 * Create a new NodeIndex using the given prototype as mixin.
	 *
	 * @method create
	 * @param {Object} prototype
	 * @static
	 * @return A customized NodeIndex.
	 */
	NodeIndex.create = function(prototype) {
	  var index = Substance.extend(new NodeIndex(), prototype);
	  index.clone = function() {
	    return NodeIndex.create(prototype);
	  };
	  return index;
	};
	
	module.exports = NodeIndex;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var OO = __webpack_require__(2);
	var Node = __webpack_require__(36);
	var NodeFactory = __webpack_require__(123);
	
	/**
	 * Data Schema.
	 *
	 * @class Data.Schema
	 * @constructor
	 * @param {String} name
	 * @param {String} version
	 * @module Data
	 */
	function Schema(name, version) {
	  /**
	   * @property {String} name
	   */
	  this.name = name;
	  /**
	   * @property {String} version
	   */
	  this.version = version;
	  /**
	   * @property {NodeFactory} nodeFactory
	   * @private
	   */
	  this.nodeFactory = new NodeFactory();
	  /**
	   * @property {Array} _tocTypes all Node classes which have `Node.static.tocType = true`
	   * @private
	   */
	  this.tocTypes = [];
	
	  // add built-in node classes
	  this.addNodes(this.getBuiltIns());
	}
	
	Schema.Prototype = function() {
	
	  /**
	   * Add nodes to the schema.
	   *
	   * @method addNodes
	   * @param {Array} nodes Array of Node classes
	   */
	  this.addNodes = function(nodes) {
	    if (!nodes) return;
	    for (var i = 0; i < nodes.length; i++) {
	      var NodeClass = nodes[i];
	      this.nodeFactory.register(NodeClass);
	      if (NodeClass.static.tocType) {
	        this.tocTypes.push(NodeClass.static.name);
	      }
	    }
	  };
	
	  /**
	   * Get the node class for a type name.
	   *
	   * @method getNodeClass
	   * @param {String} name
	   */
	  this.getNodeClass = function(name) {
	    return this.nodeFactory.get(name);
	  };
	
	  /**
	   * Provide the node factory.
	   *
	   * @method getNodeFactory
	   * @return A NodeFactory instance.
	   * @deprecated Use `this.createNode(type, data)` instead.
	   */
	  this.getNodeFactory = function() {
	    return this.nodeFactory;
	  };
	
	  function getJsonForNodeClass(nodeClass) {
	    var nodeSchema = {};
	    if (nodeClass.static.hasOwnProperty('schema')) {
	      nodeSchema.properties = _.clone(nodeClass.static.schema);
	    }
	    // add 'parent' attribute if the nodeClass has a parent
	    return nodeSchema;
	  }
	
	  /**
	   * Serialize to JSON.
	   *
	   * @method toJSON
	   * @return A plain object describing the schema.
	   */
	  // TODO: what is this used for? IMO this is not necessary anymore
	  this.toJSON = function() {
	    var data = {
	      id: this.name,
	      version: this.version,
	      types: {}
	    };
	    this.nodeFactory.each(function(nodeClass, name) {
	      data.types[name] = getJsonForNodeClass(nodeClass);
	    });
	    return data;
	  };
	
	  /**
	   * Create a node instance.
	   *
	   * @method createNode
	   * @param {String} type
	   * @param {Object} properties
	   * @return A new Node instance.
	   */
	  this.createNode = function(type, properties) {
	    var node = this.nodeFactory.create(type, properties);
	    return node;
	  };
	
	  /**
	   * Provide all built-in node classes.
	   *
	   * Used internally.
	   *
	   * @method getBuiltIns
	   * @protected
	   * @return An array of Node classes.
	   */
	  this.getBuiltIns = function() {
	    return [ Node ];
	  };
	
	  /**
	   * Check if a given type is of given parent type.
	   *
	   * @method isInstanceOf
	   * @param {String} type
	   * @param {String} parentType
	   * @return True if type instanceof parentType.
	   */
	  this.isInstanceOf = function(type, parentType) {
	    var NodeClass = this.getNodeClass(type);
	    if (NodeClass) {
	      return Node.static.isInstanceOf(NodeClass, parentType);
	    }
	    return false;
	  };
	
	  /**
	   * Iterate over all registered node classes.
	   *
	   * See {{#crossLink "Registry/each:method"}}Registry.each{{/crossLink}}
	   *
	   * @method each
	   * @param {Function} callback
	   * @param {Object} context
	   */
	  this.each = function() {
	    this.nodeFactory.each.apply(this.nodeFactory, arguments);
	  };
	
	  /**
	   * @method getTocTypes
	   * @return list of types that should appear in a TOC
	   */
	  this.getTocTypes = function() {
	    return this.tocTypes;
	  };
	
	  this.getDefaultTextType = function() {
	    throw new Error('Schmema.prototype.getDefaultTextType() must be overridden.');
	  };
	
	};
	
	OO.initClass(Schema);
	
	module.exports = Schema;


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Substance = __webpack_require__(3);
	var PathAdapter = Substance.PathAdapter;
	var Data = __webpack_require__(13);
	var ContainerAnnotation = __webpack_require__(22);
	
	var ContainerAnnotationAnchorIndex = function(doc) {
	  this.doc = doc;
	  this.byPath = new PathAdapter.Arrays();
	  this.byId = {};
	};
	
	ContainerAnnotationAnchorIndex.Prototype = function() {
	
	  this.select = function(node) {
	    return (node instanceof ContainerAnnotation);
	  };
	
	  this.reset = function(data) {
	    this.byPath.clear();
	    this.byId = {};
	    this._initialize(data);
	  };
	
	  this.get = function(path, containerName) {
	    var anchors = this.byPath.get(path) || [];
	    if (!Substance.isArray(anchors)) {
	      var _anchors = [];
	      this.byPath._traverse(anchors, [], function(path, anchors) {
	        _anchors = _anchors.concat(anchors);
	      });
	      anchors = _anchors;
	    }
	    if (containerName) {
	      return Substance.filter(anchors, function(anchor) {
	        return (anchor.container === containerName);
	      });
	    } else {
	      // return a copy of the array
	      return anchors.slice(0);
	    }
	    return anchors;
	  };
	
	  this.create = function(containerAnno) {
	    var startAnchor = containerAnno.getStartAnchor();
	    var endAnchor = containerAnno.getEndAnchor();
	    this.byPath.add(startAnchor.path, startAnchor);
	    this.byPath.add(endAnchor.path, endAnchor);
	    this.byId[containerAnno.id] = containerAnno;
	  };
	
	  this.delete = function(containerAnno) {
	    var startAnchor = containerAnno.getStartAnchor();
	    var endAnchor = containerAnno.getEndAnchor();
	    this.byPath.remove(startAnchor.path, startAnchor);
	    this.byPath.remove(endAnchor.path, endAnchor);
	    delete this.byId[containerAnno.id];
	  };
	
	  this.update = function(node, path, newValue, oldValue) {
	    if (this.select(node)) {
	      var anchor = null;
	      if (path[1] === 'startPath') {
	        anchor = node.getStartAnchor();
	      } else if (path[1] === 'endPath') {
	        anchor = node.getEndAnchor();
	      } else {
	        return;
	      }
	      this.byPath.remove(oldValue, anchor);
	      this.byPath.add(anchor.path, anchor);
	    }
	  };
	
	};
	
	Substance.inherit(ContainerAnnotationAnchorIndex, Data.Index);
	
	module.exports = ContainerAnnotationAnchorIndex;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Substance = __webpack_require__(3);
	var PathAdapter = Substance.PathAdapter;
	var Data = __webpack_require__(13);
	var Annotation = __webpack_require__(17);
	
	// Annotation Index
	// ----------------
	//
	// Lets us look up existing annotations by path and type
	//
	// To get all annotations for the content of a text node
	//
	//    var aIndex = doc.annotationIndex;
	//    aIndex.get(["text_1", "content"]);
	//
	// You can also scope for a specific range
	//
	//    aIndex.get(["text_1", "content"], 23, 45);
	
	var AnnotationIndex = function() {
	  this.byPath = new PathAdapter();
	  this.byType = new PathAdapter();
	};
	
	AnnotationIndex.Prototype = function() {
	
	  this.property = "path";
	
	  this.select = function(node) {
	    return (node instanceof Annotation);
	  };
	
	  this.reset = function(data) {
	    this.byPath.clear();
	    this.byType.clear();
	    this._initialize(data);
	  };
	
	  // TODO: use object interface? so we can combine filters (path and type)
	  this.get = function(path, start, end, type) {
	    var annotations = this.byPath.get(path) || {};
	    if (Substance.isString(path) || path.length === 1) {
	      // flatten annotations if this is called via node id
	      var _annos = annotations;
	      annotations = [];
	      Substance.each(_annos, function(level) {
	        annotations = annotations.concat(Substance.map(level, function(anno) {
	          return anno;
	        }));
	      });
	    } else {
	      annotations = Substance.map(annotations, function(anno) {
	        return anno;
	      });
	    }
	    /* jshint eqnull:true */
	    // null check for null or undefined
	    if (start != null) {
	      annotations = Substance.filter(annotations, AnnotationIndex.filterByRange(start, end));
	    }
	    if (type) {
	      annotations = Substance.filter(annotations, AnnotationIndex.filterByType(type));
	    }
	    return annotations;
	  };
	
	  this.create = function(anno) {
	    this.byType.set([anno.type, anno.id], anno);
	    this.byPath.set(anno.path.concat([anno.id]), anno);
	  };
	
	  this.delete = function(anno) {
	    this.byType.delete([anno.type, anno.id]);
	    this.byPath.delete(anno.path.concat([anno.id]));
	  };
	
	  this.update = function(node, path, newValue, oldValue) {
	    if (this.select(node) && path[1] === this.property) {
	      this.delete({ id: node.id, type: node.type, path: oldValue });
	      this.create(node);
	    }
	  };
	
	};
	
	Substance.inherit(AnnotationIndex, Data.Index);
	
	AnnotationIndex.filterByRange = function(start, end) {
	  return function(anno) {
	    var aStart = anno.startOffset;
	    var aEnd = anno.endOffset;
	    var overlap = (aEnd >= start);
	    // Note: it is allowed to omit the end part
	    /* jshint eqnull: true */
	    if (end != null) {
	      overlap = overlap && (aStart <= end);
	    }
	    /* jshint eqnull: false */
	    return overlap;
	  };
	};
	
	AnnotationIndex.filterByType = function(type) {
	  return function(anno) {
	    return anno.isInstanceOf(type);
	  };
	};
	
	module.exports = AnnotationIndex;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var OO = __webpack_require__(2);
	var PathAdapter = __webpack_require__(21);
	var Data = __webpack_require__(13);
	var ContainerAnnotation = __webpack_require__(22);
	
	// HACK: this is not the final version
	var ContainerAnnotationIndex = function(doc) {
	  this.doc = doc;
	  this.indexes = {};
	  this.containers = {};
	  this.containerAnnotations = {};
	};
	
	ContainerAnnotationIndex.Prototype = function() {
	
	  this.getFragments = function(path, containerName) {
	    var index = this.indexes[containerName];
	    if (index) {
	      return index.get(path) || [];
	    }
	    return [];
	  };
	
	  this.getAllContainerAnnotations = function() {
	    return this.containerAnnotations;
	  };
	
	  this.reset = function() {
	    this.indexes = {};
	    this._initialize(this.doc.data);
	  };
	
	  this._initialize = function(data) {
	    _.each(data.getNodes(), function(node) {
	      if (this.select(node)) {
	        this.create(node, "isInitializing");
	      }
	    }, this);
	    _.each(this.containers, function(container) {
	      this.recompute(container.id);
	    }, this);
	  };
	
	  this.select = function(node) {
	    return (node.type === "container" || node.isInstanceOf(ContainerAnnotation.static.name));
	  };
	
	  this.create = function(node, isInitializing) {
	    if (node.type === "container") {
	      this.containers[node.id] = node;
	      this.indexes[node.id] = new PathAdapter.Arrays();
	    } else if (node.isInstanceOf(ContainerAnnotation.static.name)) {
	      var containerId = node.container;
	      this.containerAnnotations[node.id] = node;
	      if (!isInitializing) {
	        this.recompute(containerId);
	      }
	    }
	  };
	
	  this.recompute = function(containerId) {
	    var container = this.containers[containerId];
	    var index = this.indexes[containerId] = new PathAdapter.Arrays();
	    _.each(this.containerAnnotations, function(anno) {
	      var fragments = anno.getFragments();
	      _.each(fragments, function(frag) {
	        index.add(frag.path, frag);
	      });
	    });
	  };
	
	  this.onDocumentChange = function(change) {
	    var needsUpdate = false;
	    var dirtyContainers = {};
	    var doc = this.doc;
	    var schema = doc.getSchema();
	    for (var i = 0; i < change.ops.length; i++) {
	      var op = change.ops[i];
	      if (op.isCreate() || op.isDelete()) {
	        var nodeData = op.getValue();
	        if (nodeData.type === "container") {
	          dirtyContainers[nodeData.id] = true;
	          if (op.isCreate()) {
	            this.containers[nodeData.id] = doc.get(nodeData.id);
	          } else {
	            delete this.containers[nodeData.id];
	          }
	          needsUpdate = true;
	        } else if (schema.isInstanceOf(nodeData.type, ContainerAnnotation.static.name)) {
	          dirtyContainers[nodeData.container] = true;
	          if (op.isCreate()) {
	            this.containerAnnotations[nodeData.id] = doc.get(nodeData.id);
	          } else {
	            delete this.containerAnnotations[nodeData.id];
	          }
	          needsUpdate = true;
	        }
	      } else {
	        var nodeId = op.path[0];
	        // skip updates on nodes which have been deleted by this change
	        if (change.deleted[nodeId]) {
	          continue;
	        }
	        var node = doc.get(nodeId);
	        if (node.type === "container") {
	          dirtyContainers[node.id] = true;
	          needsUpdate = true;
	        } else if (node.isInstanceOf(ContainerAnnotation.static.name)) {
	          dirtyContainers[node.container] = true;
	          needsUpdate = true;
	        }
	      }
	    }
	    if (needsUpdate) {
	      _.each(dirtyContainers, function(val, containerId) {
	        this.recompute(containerId);
	      }, this);
	    }
	  };
	
	};
	
	OO.inherit(ContainerAnnotationIndex, Data.Index);
	
	module.exports = ContainerAnnotationIndex;
	


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var Substance = __webpack_require__(3);
	var Data = __webpack_require__(13);
	var AbstractDocument = __webpack_require__(66);
	
	var AnnotationIndex = __webpack_require__(127);
	var AnchorIndex = __webpack_require__(126);
	var ContainerAnnotationIndex = __webpack_require__(128);
	
	var TransactionDocument = __webpack_require__(147);
	var DocumentChange = __webpack_require__(130);
	
	var PathEventProxy = __webpack_require__(146);
	var ClipboardImporter = __webpack_require__(38);
	var ClipboardExporter = __webpack_require__(67);
	
	var __id__ = 0;
	
	function Document(schema) {
	  AbstractDocument.call(this, schema);
	  this.__id__ = __id__++;
	
	  // all by type
	  this.nodeIndex = this.addIndex('type', Data.Index.create({
	    property: "type"
	  }));
	
	  // special index for (property-scoped) annotations
	  this.annotationIndex = this.addIndex('annotations', new AnnotationIndex());
	
	  // special index for (contaoiner-scoped) annotations
	  this.anchorIndex = this.addIndex('container-annotation-anchors', new AnchorIndex());
	
	  // HACK: ATM we can't register this as Data.Index, as it depends on Containers to be up2date,
	  // but containers are updated after indexes.
	  // This must not be used from within transactions.
	  this.containerAnnotationIndex = new ContainerAnnotationIndex(this);
	
	  this.done = [];
	  this.undone = [];
	
	  // change event proxies are triggered after a document change has been applied
	  // before the regular document:changed event is fired.
	  // They serve the purpose of making the event notification more efficient
	  // In earlier days all observers such as node views where listening on the same event 'operation:applied'.
	  // This did not scale with increasing number of nodes, as on every operation all listeners where notified.
	  // The proxies filter the document change by interest and then only notify a small set of observers.
	  // Example: NotifyByPath notifies only observers which are interested in changes to a certain path.
	  this.eventProxies = {
	    'path': new PathEventProxy(this),
	  };
	
	  this.initialize();
	
	  // the stage is a essentially a clone of this document
	  // used to apply a sequence of document operations
	  // without touching this document
	  this.stage = new TransactionDocument(this);
	  this.isTransacting = false;
	
	  this.FORCE_TRANSACTIONS = false;
	
	  // Note: using the general event queue (as opposed to calling updateEventProxies from within _notifyChangeListeners)
	  // so that handler priorities are considered correctly
	  this.connect(this, {
	    'document:changed': this.updateEventProxies
	  })
	}
	
	Document.Prototype = function() {
	
	  this.isTransaction = function() {
	    return false;
	  };
	
	  this.newInstance = function() {
	    var DocumentClass = this.constructor;
	    return new DocumentClass(this.schema);
	  };
	
	  this.fromSnapshot = function(data) {
	    var doc = this.newInstance();
	    doc.loadSeed(data);
	    return doc;
	  };
	
	  this.documentDidLoad = function() {
	    // HACK: need to reset the stage
	    this.stage.reset();
	    this.containerAnnotationIndex.reset();
	    this.done = [];
	    // do not allow non-transactional changes after that
	    this.FORCE_TRANSACTIONS = true;
	  };
	
	  this.clear = function() {
	    var self = this;
	    this.transaction(function(tx) {
	      _.each(self.data.nodes, function(id) {
	        tx.delete(id);
	      });
	    });
	    this.documentDidLoad();
	  };
	
	  this.getEventProxy = function(name) {
	    return this.eventProxies[name];
	  };
	
	  // Document manipulation
	  //
	
	  /**
	   * @param beforeState object which will be used as before start of transaction
	   * @param eventData object which will be used as payload for the emitted change event
	   * @param transformation a function(tx) that performs actions on the transaction document tx
	   *
	   * @example
	   * ```
	   *   doc.transaction({ selection: sel }, {'event-hack': true}, function(tx, args) {
	   *     tx.update(...);
	   *     ...
	   *     return {
	   *       selection: newSelection
	   *     };
	   *   })
	   * ```
	   */
	  this.transaction = function(beforeState, eventData, transformation) {
	    if (arguments.length === 1) {
	      transformation = arguments[0];
	      eventData = {};
	      beforeState = {};
	    }
	    if (arguments.length === 2) {
	      transformation = arguments[1];
	      eventData = {};
	    } else {
	      eventData = eventData || {};
	    }
	    if (!_.isFunction(transformation)) {
	      throw new Error('Document.transaction() requires a transformation function.');
	    }
	    // var time = Date.now();
	    // HACK: ATM we can't deep clone as we do not have a deserialization
	    // for selections.
	    var tx = this.startTransaction(_.clone(beforeState));
	    // console.log('Starting the transaction took', Date.now() - time);
	    try {
	      // time = Date.now();
	      var result = transformation(tx);
	      // console.log('Executing the transformation took', Date.now() - time);
	      var afterState = {};
	      // only keys that are in the beforeState can be in the afterState
	      // TODO: maybe this is to sharp?
	      // we could also just merge the transformation result with beforeState
	      // but then we might have non-state related information in the after state.
	      for (var key in beforeState) {
	        if (result[key]) {
	          afterState[key] = result[key];
	        } else {
	          afterState[key] = beforeState[key];
	        }
	      }
	      // save automatically if not yet saved or cancelled
	      if (this.isTransacting) {
	        tx.save(afterState, eventData);
	      }
	    } finally {
	      tx.finish();
	    }
	  };
	
	  this.startTransaction = function(beforeState) {
	    if (this.isTransacting) {
	      throw new Error('Nested transactions are not supported.');
	    }
	    this.isTransacting = true;
	    // TODO: maybe we need to prepare the stage
	    this.stage.before = beforeState || {};
	    this.emit('transaction:started', this.stage);
	    return this.stage;
	  };
	
	  this.create = function(nodeData) {
	    if (this.FORCE_TRANSACTIONS) {
	      throw new Error('Use a transaction!');
	    }
	    if (this.isTransacting) {
	      this.stage.create(nodeData);
	    } else {
	      if (this.stage) {
	        this.stage.create(nodeData);
	      }
	      this._create(nodeData);
	    }
	    return this.data.get(nodeData.id);
	  };
	
	  this.delete = function(nodeId) {
	    if (this.FORCE_TRANSACTIONS) {
	      throw new Error('Use a transaction!');
	    }
	    if (this.isTransacting) {
	      this.stage.delete(nodeId);
	    } else {
	      if (this.stage) {
	        this.stage.delete(nodeId);
	      }
	      this._delete(nodeId);
	    }
	  };
	
	  this.set = function(path, value) {
	    if (this.FORCE_TRANSACTIONS) {
	      throw new Error('Use a transaction!');
	    }
	    if (this.isTransacting) {
	      this.stage.set(path, value);
	    } else {
	      if (this.stage) {
	        this.stage.set(path, value);
	      }
	      this._set(path, value);
	    }
	  };
	
	  this.update = function(path, diff) {
	    if (this.FORCE_TRANSACTIONS) {
	      throw new Error('Use a transaction!');
	    }
	    if (this.isTransacting) {
	      this.stage.update(path, diff);
	    } else {
	      this._update(path, diff);
	      if (this.stage) {
	        this.stage.update(path, diff);
	      }
	    }
	  };
	
	  this.undo = function() {
	    var change = this.done.pop();
	    if (change) {
	      var inverted = change.invert();
	      this._apply(inverted);
	      this.undone.push(inverted);
	      this._notifyChangeListeners(inverted, { 'replay': true });
	    } else {
	      console.error('No change can be undone.');
	    }
	  };
	
	  this.redo = function() {
	    var change = this.undone.pop();
	    if (change) {
	      var inverted = change.invert();
	      this._apply(inverted);
	      this.done.push(inverted);
	      this._notifyChangeListeners(inverted, { 'replay': true });
	    } else {
	      console.error('No change can be redone.');
	    }
	  };
	
	  // sel: PropertySelection
	  // options:
	  //   container: container instance
	  //   type: string (annotation type filter)
	  //
	  // WARNING: Returns an empty array when selection is a container selection
	  this.getAnnotationsForSelection = function(sel, options) {
	    options = options || {};
	    var annotations;
	    var path, startOffset, endOffset;
	
	    if (sel.isPropertySelection()) {
	      path = sel.getPath();
	      startOffset = sel.getStartOffset();
	      endOffset = sel.getEndOffset();
	    } else {
	      return [];
	    }
	    annotations = this.annotationIndex.get(path, startOffset, endOffset);
	    if (options.type) {
	      annotations = _.filter(annotations, AnnotationIndex.filterByType(options.type));
	    }
	    return annotations;
	  };
	
	  // Attention: looking for container annotations is not as efficient
	  // as property selections, as we do not have an index that has
	  // notion of the spatial extend of an annotation
	  // (which would depend on a model-side implementation of Container).
	  // Opposed to that, common annotations are bound to properties which make it easy to lookup.
	  this.getContainerAnnotationsForSelection = function(sel, container, options) {
	    if (!container) {
	      // Fail more silently
	      return [];
	      // throw new Error('Container required.');
	    }
	    var annotations;
	    // Also look for container annotations if a Container instance is given
	    if (options.type) {
	      annotations = this.getIndex('type').get(options.type);
	    } else {
	      annotations = this.getIndex('container-annotation-anchors').byId;
	    }
	    annotations = _.filter(annotations, function(anno) {
	      var annoSel = anno.getSelection();
	      return sel.overlaps(annoSel);
	    });
	    return annotations;
	  };
	
	  this.getDocumentMeta = function() {
	    return this.get('document');
	  };
	
	  this.getClipboardImporter = function() {
	    return new ClipboardImporter({ schema: this.getSchema()});
	  };
	
	  this.getClipboardExporter = function() {
	    return new ClipboardExporter();
	  };
	
	  /**
	   * Enable or disable auto-attaching of nodes.
	   * When this is enabled (default), a created node
	   * gets attached to the document instantly.
	   * Otherwise you need to take care of that yourself.
	   *
	   * Used internally e.g., by AbstractDocument.prototype.loadSeed()
	   */
	  this._setAutoAttach = function(val) {
	    Document.super.prototype._setAutoAttach.call(this, val);
	    this.stage._setAutoAttach(val);
	  };
	
	
	  this._saveTransaction = function(beforeState, afterState, info) {
	    // var time = Date.now();
	    if (!this.isTransacting) {
	      throw new Error('Not in a transaction.');
	    }
	    this.isTransacting = false;
	    var ops = this.stage.getOperations();
	    if (ops.length > 0) {
	      var documentChange = new DocumentChange(ops, beforeState, afterState);
	      // apply the change
	      this._apply(documentChange, 'skipStage');
	      // push to undo queue and wipe the redo queue
	      this.done.push(documentChange);
	      this.undone = [];
	      // console.log('Document._saveTransaction took %s ms', (Date.now() - time));
	      // time = Date.now();
	      this._notifyChangeListeners(documentChange, info);
	      // console.log('Notifying change listener took %s ms', (Date.now() - time));
	    }
	  };
	
	  this._cancelTransaction = function() {
	    if (!this.isTransacting) {
	      throw new Error('Not in a transaction.');
	    }
	    this.isTransacting = false;
	  };
	
	  this._apply = function(documentChange, mode) {
	    if (this.isTransacting) {
	      throw new Error('Can not replay a document change during transaction.');
	    }
	    // Note: we apply everything doubled, to keep the staging clone up2date.
	    if (mode !== 'skipStage') {
	      this.stage.apply(documentChange);
	    }
	    _.each(documentChange.ops, function(op) {
	      this.data.apply(op);
	      this._updateContainers(op);
	      this.emit('operation:applied', op);
	    }, this);
	  };
	
	  this._notifyChangeListeners = function(documentChange, info) {
	    info = info || {};
	    // HACK: update the container annotation index first
	    // TODO: we should have a better concept to define the order of listeners
	    // However, ContainerAnnotationIndex should be treated as an index
	    // this order would suffice: [containers, indexes, ]
	    this.containerAnnotationIndex.onDocumentChange(documentChange);
	    this.emit('document:changed', documentChange, info, this);
	  };
	
	  this.updateEventProxies = function(documentChange, info) {
	    _.each(this.eventProxies, function(proxy) {
	      proxy.onDocumentChanged(documentChange, info, this);
	    }, this);
	  };
	};
	
	Substance.inherit(Document, AbstractDocument);
	
	Object.defineProperty(Document.prototype, 'id', {
	  get: function() {
	    return this.getDocumentMeta().guid;
	  },
	  set: function() {
	    throw new Error("Id is an immutable property.");
	  }
	});
	
	module.exports = Document;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Substance = __webpack_require__(3);
	var PathAdapter = Substance.PathAdapter;
	
	function DocumentChange(ops, before, after) {
	  this.id = Substance.uuid();
	  this.ops = ops.slice(0);
	  this.before = before;
	  this.after = after;
	  this.updated = null;
	  this.created = null;
	  this.deleted = null;
	  this._init();
	  Object.freeze(this);
	  Object.freeze(this.ops);
	  Object.freeze(this.before);
	  Object.freeze(this.after);
	  // FIXME: ATM this is not possible, as NotifyPropertyChange monkey patches this info
	  // Object.freeze(this.updated);
	  // Object.freeze(this.deleted);
	  // Object.freeze(this.created);
	}
	
	DocumentChange.Prototype = function() {
	
	  this._init = function() {
	    var ops = this.ops;
	    var created = {};
	    var deleted = {};
	    var updated = new PathAdapter.Arrays();
	    var i;
	    for (i = 0; i < ops.length; i++) {
	      var op = ops[i];
	      if (op.type === "create") {
	        created[op.val.id] = op.val;
	        delete deleted[op.val.id];
	      }
	      if (op.type === "delete") {
	        delete created[op.val.id];
	        delete updated[op.val.id];
	        deleted[op.val.id] = op.val;
	      }
	      if (op.type === "set" || op.type === "update") {
	        // The old as well the new one is affected
	        updated.add(op.path, op);
	      }
	    }
	    this.created = created;
	    this.deleted = deleted;
	    this.updated = updated;
	  };
	
	  this.isAffected = function(path) {
	    return !!this.updated.get(path);
	  };
	
	  this.isUpdated = this.isAffected;
	
	  this.invert = function() {
	    var ops = [];
	    for (var i = this.ops.length - 1; i >= 0; i--) {
	      ops.push(this.ops[i].invert());
	    }
	    var before = this.after;
	    var after = this.before;
	    return new DocumentChange(ops, before, after);
	  };
	
	  this.traverse = function(fn, ctx) {
	    this.updated.traverse(function() {
	      fn.apply(ctx, arguments);
	    });
	  };
	
	  this.getUpdates = function(path) {
	    return this.updated.get(path) || [];
	  };
	
	  this.getCreated = function() {
	    return this.created;
	  };
	
	  this.getDeleted = function() {
	    return this.deleted;
	  };
	
	};
	
	Substance.initClass(DocumentChange);
	
	module.exports = DocumentChange;


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Substance = __webpack_require__(3);
	var Data = __webpack_require__(13);
	
	var Node = __webpack_require__(6);
	var Annotation = __webpack_require__(17);
	var Container = __webpack_require__(68);
	var ContainerAnnotation = __webpack_require__(22);
	
	function DocumentSchema(name, version) {
	  DocumentSchema.super.call(this, name, version);
	}
	
	DocumentSchema.Prototype = function() {
	
	  this.getDefaultTextType = function() {
	    throw new Error('DocumentSchema.getDefaultTextType() is abstract and must be overridden.');
	  };
	
	  this.isAnnotationType = function(type) {
	    var nodeClass = this.getNodeClass(type);
	    return (nodeClass && nodeClass.prototype instanceof Annotation);
	  };
	
	  this.getBuiltIns = function() {
	    return [ Node, Annotation, Container, ContainerAnnotation ];
	  };
	
	};
	
	Substance.inherit( DocumentSchema, Data.Schema );
	
	module.exports = DocumentSchema;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var OO = __webpack_require__(2);
	
	function EditingBehavior() {
	  this._merge = {};
	  this._mergeComponents = {};
	  this._break = {};
	}
	
	EditingBehavior.Prototype = function() {
	
	  this.defineMerge = function(firstType, secondType, impl) {
	    if (!this._merge[firstType]) {
	      this._merge[firstType] = {};
	    }
	    this._merge[firstType][secondType] = impl;
	    return this;
	  };
	
	  this.canMerge = function(firstType, secondType) {
	    return (this._merge[firstType] && this._merge[firstType][secondType]);
	  };
	
	  this.getMerger = function(firstType, secondType) {
	    return this._merge[firstType][secondType];
	  };
	
	  this.defineComponentMerge = function(nodeType, impl) {
	    this._mergeComponents[nodeType] = impl;
	  };
	
	  this.canMergeComponents = function(nodeType) {
	    return this._mergeComponents[nodeType];
	  };
	
	  this.getComponentMerger = function(nodeType) {
	    return this._mergeComponents[nodeType];
	  };
	
	  this.defineBreak = function(nodeType, impl) {
	    this._break[nodeType] = impl;
	    return this;
	  };
	
	  this.canBreak = function(nodeType) {
	    return this._break[nodeType];
	  };
	
	  this.getBreaker = function(nodeType) {
	    return this._break[nodeType];
	  };
	
	};
	
	OO.initClass(EditingBehavior);
	
	module.exports = EditingBehavior;


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var TextNode = __webpack_require__(23);
	
	var Blockquote = TextNode.extend({
	  displayName: "Blockquote",
	  name: "blockquote"
	});
	
	// HtmlImporter
	
	Blockquote.static.blockType = true;
	
	Blockquote.static.matchElement = function($el) {
	  return $el.is('blockquote');
	};
	
	Blockquote.static.fromHtml = function($el, converter) {
	  var id = converter.defaultId($el, 'blockquote');
	  var blockquote = {
	    id: id,
	    content: ''
	  };
	  blockquote.content = converter.annotatedText($el, [id, 'content']);
	  return blockquote;
	};
	
	// HtmlExporter
	
	Blockquote.static.toHtml = function(paragraph, converter) {
	  var id = paragraph.id;
	  var $el = $('<blockquote>')
	    .attr('id', id);
	  $el.append(converter.annotatedText([id, 'content']));
	  return $el;
	};
	
	module.exports = Blockquote;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var TextNode = __webpack_require__(23);
	
	var Codeblock = TextNode.extend({
	  displayName: "Codeblock",
	  name: "codeblock"
	});
	
	// HtmlImporter
	
	Codeblock.static.blockType = true;
	
	Codeblock.static.matchElement = function($el) {
	  return $el.is('pre');
	};
	
	Codeblock.static.fromHtml = function($el, converter) {
	  var $codeEl = $el.find('code');
	  var id = converter.defaultId($el, 'codeblock');
	  var codeblock = {
	    id: id,
	    content: ''
	  };
	  codeblock.content = converter.annotatedText($codeEl, [id, 'content']);
	  return codeblock;
	};
	
	// HtmlExporter
	
	Codeblock.static.toHtml = function(codeblock, converter) {
	  var id = codeblock.id;
	  var $el = $('<pre>')
	    .attr('id', id);
	  var $codeEl = $('<code>');
	  $codeEl.append(converter.annotatedText([id, 'content']));
	  $el.append($codeEl);
	  return $el;
	};
	
	module.exports = Codeblock;


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var Annotation = __webpack_require__(17);
	
	var Emphasis = Annotation.extend({
	  name: "emphasis",
	  displayName: "Emphasis",
	  splitContainerSelections: true
	});
	
	Emphasis.static.tagName = "em";
	
	Emphasis.static.matchElement = function($el) {
	  return $el.is("em,i");
	};
	
	module.exports = Emphasis;


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	var TextNode = __webpack_require__(23);
	
	var Heading = TextNode.extend({
	  name: "heading",
	  displayName: "Heading",
	  properties: {
	    "level": "number"
	  }
	});
	
	// HtmlImporter
	
	Heading.static.blockType = true;
	
	Heading.static.tocType = true;
	
	Heading.static.matchElement = function($el) {
	  return /^h\d$/.exec($el[0].tagName.toLowerCase());
	};
	
	Heading.static.fromHtml = function($el, converter) {
	  var id = converter.defaultId($el, 'heading');
	  var heading = {
	    id: id,
	    level: parseInt(''+$el[0].tagName[1], 10),
	    content: ''
	  };
	  heading.content = converter.annotatedText($el, [id, 'content']);
	  return heading;
	};
	
	// HtmlExporter
	
	Heading.static.toHtml = function(heading, converter) {
	  var id = heading.id;
	  var $el = $('<h' + heading.level + '>')
	  $el.append(converter.annotatedText([id, 'content']));
	  return $el;
	};
	
	module.exports = Heading;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var DocumentNode = __webpack_require__(6);
	
	var Include = DocumentNode.extend({
	  name: "include",
	  displayName: "Include",
	  properties: {
	    "nodeType": "string",
	    "nodeId": "id"
	  },
	
	  getIncludedNode: function() {
	    return this.getDocument().get(this.nodeId);
	  },
	});
	
	Include.static.components = ['nodeId'];
	
	Include.static.blockType = true;
	
	Include.static.matchElement = function($el) {
	  return $el.is('include');
	};
	
	Include.static.fromHtml = function($el, converter) {
	  var id = converter.defaultId($el, 'include');
	  var inc = {
	    id: id,
	    nodeId: $el.attr('data-rid'),
	    nodeType: $el.attr('data-rtype'),
	  };
	  return inc;
	};
	
	Include.static.toHtml = function(inc, converter) {
	  var id = inc.id;
	  var $el = $('<include>')
	    .attr('id', id)
	    .attr('data-rtype', inc.nodeType)
	    .attr('data-rid', inc.nodeId);
	  return $el;
	};
	
	module.exports = Include;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var Annotation = __webpack_require__(17);
	
	var Link = Annotation.extend({
	  name: "link",
	  displayName: "Link",
	  properties: {
	    url: 'string',
	    title: 'string'
	  }
	});
	
	// HtmlImporter
	
	Link.static.tagName = 'a';
	
	Link.static.matchElement = function($el) {
	  return $el.is('a');
	};
	
	Link.static.fromHtml = function($el, converter) {
	  var link = {
	    url: $el.attr('href'),
	    title: $el.attr('title')
	  };
	  // Note: we need to call back the converter
	  // that it can process the element's inner html.
	  // We do not need it for the link itself, though
	  // TODO: maybe it is possible to detect if it has called back
	  converter.annotatedText($el);
	  return link;
	};
	
	Link.static.toHtml = function(link, converter, children) {
	  var $el = Annotation.static.toHtml(link, converter, children);
	  $el.attr('href', link.url);
	  $el.attr('title', link.title);
	  return $el;
	};
	
	module.exports = Link;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var TextNode = __webpack_require__(23);
	
	var Paragraph = TextNode.extend({
	  displayName: "Paragraph",
	  name: "paragraph"
	});
	
	// HtmlImporter
	
	Paragraph.static.blockType = true;
	
	Paragraph.static.matchElement = function($el) {
	  return $el.is('p');
	};
	
	Paragraph.static.fromHtml = function($el, converter) {
	  var id = converter.defaultId($el, 'p');
	  var paragraph = {
	    id: id,
	    content: ''
	  };
	  paragraph.content = converter.annotatedText($el, [id, 'content']);
	  return paragraph;
	};
	
	// HtmlExporter
	
	Paragraph.static.toHtml = function(paragraph, converter) {
	  var id = paragraph.id;
	  var $el = $('<p>')
	    .attr('id', id);
	  $el.append(converter.annotatedText([id, 'content']));
	  return $el;
	};
	
	module.exports = Paragraph;


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var Annotation = __webpack_require__(17);
	
	var Strong = Annotation.extend({
	  displayName: "Strong",
	  name: "strong",
	
	  // this means that it will annotate also when you have
	  // selected multiple paragraphs, creating a single annotation
	  // for every paragraph
	  splitContainerSelections: true
	
	});
	
	Strong.static.tagName = 'strong';
	
	Strong.static.matchElement = function($el) {
	  return $el.is('strong,b');
	};
	
	module.exports = Strong;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var OO = __webpack_require__(2);
	var _ = __webpack_require__(1);
	var Node = __webpack_require__(6);
	var TableMatrix = __webpack_require__(143);
	
	var Table = Node.extend({
	  displayName: "Table",
	  name: "table",
	
	  matrix: null,
	
	  properties: {
	    "sections": ["array", "id"],
	  },
	
	  getSections: function() {
	    var doc = this.getDocument();
	    return _.map(this.sections, function(id) {
	      return doc.get(id);
	    }, this);
	  },
	
	  getSectionAt: function(secIdx) {
	    var doc = this.getDocument();
	    var secId = this.sections[secIdx];
	    if (secId) {
	      return doc.get(secId);
	    } else {
	      return null;
	    }
	  },
	
	  attach: function() {
	    this.super.attach.apply(this, arguments);
	  },
	
	  getMatrix: function() {
	    if (!this.matrix) {
	      this.matrix = new TableMatrix(this);
	      this.matrix.update();
	    }
	    return this.matrix;
	  },
	
	  /**
	   * Provides a cell iterator that allows convenient traversal regardless of
	   * the structure with respect to sections.
	   *
	   * @return {ve.dm.TableNode.CellIterator}
	   */
	  getIterator: function() {
	    return new Table.CellIterator(this);
	  },
	
	  /**
	   */
	  getSize: function ( dimension ) {
	    var dim = this.matrix.getSize();
	    if ( dimension === 'row' ) {
	      return dim[0];
	    } else if ( dimension === 'col' ) {
	      return dim[1];
	    } else {
	      return dim;
	    }
	  }
	
	});
	
	Table.static.components = ['sections'];
	
	// HtmlImporter
	
	Table.static.blockType = true;
	
	Table.static.matchElement = function($el) {
	  return $el.is("table");
	};
	
	Table.static.fromHtml = function($el, converter) {
	  var id = converter.defaultId($el, 'table');
	  var table = {
	    id: id,
	    sections: []
	  };
	  // either we find thead, tbody, tfoot
	  // or we take the rows right away
	  _.each(["thead", "tbody", "tfoot"], function(name) {
	    var $tsec = $el.find(name);
	    if ($tsec.length) {
	      var sectionNode = converter.convertElement($tsec, { parent: id });
	      table.sections.push(sectionNode.id);
	    }
	  });
	
	  if (table.sections.length === 0) {
	    var sectionNode = {
	      id: converter.nextId('tbody'),
	      parent: id,
	      type: "table-section",
	      sectionType: "body",
	      rows: []
	    };
	    $el.find('tr').each(function() {
	      var $row = $(this);
	      var rowNode = converter.convertElement($row, { parent: id });
	      sectionNode.rows.push(rowNode.id);
	    });
	    converter.getDocument().create(sectionNode);
	    table.sections.push(sectionNode.id);
	  }
	
	  return table;
	};
	
	Table.static.toHtml = function(table, converter) {
	  var id = table.id;
	  var $el = $('<table>')
	    .attr('id', id);
	  _.each(table.getSections(), function(sec) {
	    $el.append(sec.toHtml(converter));
	  });
	  return $el;
	};
	
	Object.defineProperties(Table.prototype, {
	  rowNodes: {
	    'get': function() {
	      return this.getRows();
	    }
	  }
	});
	
	/**
	 * A helper class to iterate over the cells of a table node.
	 *
	 * It provides a unified interface to iterate cells in presence of table sections,
	 * e.g., providing consecutive row indexes.
	 *
	 * @class
	 * @constructor
	 * @param {ve.dm.TableNode} [tableNode]
	 */
	Table.CellIterator = function(tableNode) {
	  this.table = tableNode;
	
	  this.__it = {
	    sectionIndex: -1,
	    rowIndex: -1,
	    rowNode: null,
	    cellIndex: -1,
	    cellNode: null,
	    sectionNode: null,
	    finished: false
	  };
	
	  // hooks
	  this.onNewSection = function() {};
	  this.onNewRow = function() {};
	};
	
	Table.CellIterator.Prototype = function() {
	
	  this.next = function() {
	    if (this.__it.finished) throw new Error("TableCellIterator has no more cells left.");
	    this.nextCell(this.__it);
	    if (this.__it.finished) return null;
	    else return this.__it.cellNode;
	  };
	
	  this.nextSection = function(it) {
	    it.sectionIndex++;
	    it.sectionNode = this.table.getSectionAt(it.sectionIndex);
	    if (!it.sectionNode) {
	      it.finished = true;
	    } else {
	      it.rowIndex = 0;
	      it.rowNode = it.sectionNode.getRowAt(0);
	      this.onNewSection(it.sectionNode);
	    }
	  };
	
	  this.nextRow = function(it) {
	    it.rowIndex++;
	    if (it.sectionNode) {
	      it.rowNode = it.sectionNode.getRowAt(it.rowIndex);
	    }
	    while (!it.rowNode && !it.finished) {
	      this.nextSection(it);
	    }
	    if (it.rowNode) {
	      it.cellIndex = 0;
	      it.cellNode = it.rowNode.getCellAt(0);
	      this.onNewRow(it.rowNode);
	    }
	  };
	
	  this.nextCell = function(it) {
	    if (it.cellNode) {
	      it.cellIndex++;
	      it.cellNode = it.rowNode.getCellAt(it.cellIndex);
	    }
	    // step into the next row if there is no next cell or if the column is
	    // beyond the rectangle boundaries
	    while (!it.cellNode && !it.finished) {
	      this.nextRow(it);
	    }
	  };
	};
	OO.initClass(Table.CellIterator);
	
	module.exports = Table;


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	var Node = __webpack_require__(6);
	
	var TableCell = Node.extend({
	  displayName: "TableCell",
	  name: "table-cell",
	  properties: {
	    "parent": "id",
	    "cellType": "string", // "head" or "data"
	    "colspan": "number",
	    "rowspan": "number",
	    "content": "string"
	  },
	  getSpan: function(dim) {
	    if (dim === "col") {
	      return this.colspan || 1;
	    } else if (dim === "row") {
	      return this.rowspan || 1;
	    }
	  }
	});
	
	TableCell.static.components = ['content'];
	
	// HtmlImporter
	
	TableCell.static.matchElement = function($el) {
	  return $el.is('th, td');
	};
	
	TableCell.static.fromHtml = function($el, converter) {
	  var id = converter.defaultId($el, 'tcell');
	  var tableCell = {
	    id: id,
	    content: ""
	  };
	  if ($el.is('th')) {
	    tableCell.cellType = "head";
	  } else {
	    tableCell.cellType = "data";
	  }
	  var colspan = $el.attr('colspan');
	  if (colspan) {
	    tableCell.colspan = parseInt(colspan, 10);
	  }
	  var rowspan = $el.attr('rowspan');
	  if (rowspan) {
	    tableCell.rowspan = parseInt(rowspan, 10);
	  }
	  tableCell.content = converter.annotatedText($el, [id, 'content']);
	  return tableCell;
	};
	
	TableCell.static.toHtml = function(cell, converter) {
	  var id = cell.id;
	  var tagName = (cell.cellType==="head" ? "th" : "td");
	  var $el = $('<' + tagName + '>')
	    .attr('id', 'id')
	    .append(converter.annotatedText([id, 'content']));
	  return $el;
	};
	
	Object.defineProperties(TableCell.prototype, {
	  isData: {
	    'get': function() {
	      return this.cellType === "data";
	    }
	  }
	});
	
	module.exports = TableCell;


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	var OO = __webpack_require__(2);
	
	/**
	 * A helper class that allows random access to the table cells
	 * and introduces place-holders for fields occupied by spanning cells,
	 * making it a non-sparse representation of the sparse HTML model.
	 * This is essential for the implementation of table manipulations, such as row insertions or deletions.
	 *
	 * Example:
	 *
	 * <table>
	 *   <tr><td rowspan=2>1</td><td colspan=2>2</td><td rowspan=2 colspan=2>3</td></tr>
	 *   <tr><td>4</td><td>5</td></tr>
	 * </table>
	 *
	 * Visually this table would look like:
	 *
	 *  -------------------
	 * | 1 | 2     | 3     |
	 * |   |-------|       |
	 * |   | 4 | 5 |       |
	 *  -------------------
	 *
	 * The HTML model is sparse which makes it hard to read but also difficult to work with programmatically.
	 * The corresponding TableCellMatrix would look like:
	 *
	 * | C[1] | C[2] | P[2] | C[3] | P[3] |
	 * | P[1] | C[4] | C[5] | P[3] | P[3] |
	 *
	 * Where C[1] represents a Cell instance wrapping cell 1,
	 * and P[1] a PlaceHolder instance owned by that cell.
	 *
	 * @class
	 * @constructor
	 * @param {ve.dm.TableNode} [tableNode] Reference to a table instance
	 */
	function TableMatrix(tableNode) {
	  this.tableNode = tableNode;
	  // Do not access these directly as they get invalidated on structural changes
	  // Use the accessor methods instead.
	  this._matrix = null;
	  this._rowNodes = null;
	};
	
	TableMatrix.Prototype = function() {
	  /**
	   * Invalidates the matrix structure.
	   *
	   * This is called by ve.dm.TableNode on structural changes.
	   */
	  this.invalidate = function() {
	    this._matrix = null;
	    this._rowNodes = null;
	  };
	
	  /**
	   * Recreates the matrix structure.
	   */
	  this.update = function() {
	    var cellNode, cell,
	      rowSpan, colSpan, i, j, _row, _col,
	      matrix = [],
	      rowNodes = [],
	      iterator = this.tableNode.getIterator(),
	      row = -1, col = -1;
	
	    // hook to react on row transitions
	    iterator.onNewRow = function( rowNode ) {
	      row++; col = -1;
	      // initialize a matrix row
	      matrix[row] = matrix[row] || [];
	      // store the row node
	      rowNodes.push(rowNode);
	    };
	
	    // Iterates through all cells and stores the cells as well as
	    // so called placeholders into the matrix.
	    while ((cellNode = iterator.next()) !== null)  {
	      col++;
	      // skip placeholders
	      while (matrix[row][col]) {
	        col++;
	      }
	      cell = new TableMatrix.Cell(cellNode, row, col);
	      // store indexes
	      cellNode.rowIdx = row;
	      cellNode.colIdx = col;
	      // store the cell in the matrix
	      matrix[row][col] = cell;
	      // add place holders for spanned cells
	      rowSpan = cellNode.getSpan('row');
	      colSpan = cellNode.getSpan('col');
	      if (rowSpan === 1 && colSpan === 1) continue;
	      for (i = 0; i < rowSpan; i++) {
	        for (j = 0; j < colSpan; j++) {
	          if (i===0 && j===0) continue;
	          _row = row + i;
	          _col = col + j;
	          // initialize the cell matrix row if not yet present
	          matrix[_row] = matrix[_row] || [];
	          matrix[_row][_col] = new TableMatrix.Placeholder(cell, _row, _col);
	        }
	      }
	    }
	    this._matrix = matrix;
	    this._rowNodes = rowNodes;
	  };
	
	  /**
	   * Retrieves a single cell.
	   *
	   * @param {Number} [row]
	   * @param {Number} [col]
	   * @return {ve.dm.TableMatrix.Cell}
	   */
	  this.getCell = function(row, col) {
	    var matrix = this.getMatrix();
	    return matrix[row][col];
	  };
	
	  /**
	   * Retrieves all cells of a column with given index.
	   *
	   * @param {Number} [col]
	   * @return {ve.dm.TableMatrix.Cell[]} The cells of a column
	   */
	  this.getColumn = function(col) {
	    var cells, row,
	      matrix = this.getMatrix();
	    cells = [];
	    for (row = 0; row < matrix.length; row++) {
	      cells.push(matrix[row][col]);
	    }
	    return cells;
	  };
	
	  /**
	   * Retrieves all cells of a row with given index.
	   *
	   * @param {Number} [row]
	   * @return {ve.dm.TableMatrix.Cell[]} The cells of a row
	   */
	  this.getRow = function(row) {
	    var matrix = this.getMatrix();
	    return matrix[row];
	  };
	
	  /**
	   * Retrieves the row node of a row with given index.
	   *
	   * @param {Number} [row]
	   * @return {ve.dm.TableRowNode}
	   */
	  this.getRowNode = function(row) {
	    var rowNodes = this.getRowNodes();
	    return rowNodes[row];
	  };
	
	  /**
	   * Provides a reference to the internal cell matrix.
	   *
	   * Note: this is primarily for internal use. Do not change the delivered matrix
	   * and do not store as it may be invalidated.
	   *
	   * @return {ve.dm.TableMatrix.Cell[]}
	   */
	  this.getMatrix = function() {
	    if (!this._matrix) this.update();
	    return this._matrix;
	  };
	
	  /**
	   * Provides a reference to the internal array of row nodes.
	   *
	   * Note: this is primarily for internal use. Do not change the delivered array
	   * and do not store it as it may be invalidated.
	   *
	   * @return {ve.dm.TableRowNode[]}
	   */
	  this.getRowNodes = function() {
	    if (!this._rowNodes) this.update();
	    return this._rowNodes;
	  };
	
	  /**
	   * Computes a the rectangle for a given start and end cell node.
	   *
	   *
	   * @param {ve.dm.TableCellNode} [startCellNode] start anchor
	   * @param {ve.dm.TableCellNode} [endCellNode] end anchor
	   * @return {ve.dm.TableMatrix.Rectangle}
	   */
	  this.getRectangle = function ( startCellNode, endCellNode ) {
	    var startCell, endCell, minRow, maxRow, minCol, maxCol;
	    startCell = this.lookupCell(startCellNode);
	    if (!startCell) return null;
	    if (startCellNode === endCellNode) {
	      endCell = startCell;
	    } else {
	      endCell = this.lookupCell(endCellNode);
	    }
	    minRow = Math.min(startCell.row, endCell.row);
	    maxRow = Math.max(startCell.row, endCell.row);
	    minCol = Math.min(startCell.col, endCell.col);
	    maxCol = Math.max(startCell.col, endCell.col);
	    return new TableMatrix.Rectangle(minRow, minCol, maxRow, maxCol);
	  };
	
	  /**
	   * Retrieves all cells (no placeholders) within a given rectangle.
	   *
	   * @param {ve.dm.TableMatrix.Rectangle} [rect]
	   * @return {ve.dm.TableMatrix.Cell[]}
	   */
	  this.getCellsForRectangle = function ( rect ) {
	    var row, col, cells, visited, cell;
	    cells = [];
	    visited = {};
	    for (row = rect.start.row; row <= rect.end.row; row++) {
	      for (col = rect.start.col; col <= rect.end.col; col++) {
	        cell = this.getCell(row, col);
	        if (cell.type === 'placeholder') cell = cell.owner;
	        if (!visited[cell.key]) {
	          cells.push(cell);
	          visited[cell.key] = true;
	        }
	      }
	    }
	    return cells;
	  };
	
	  /**
	   * Retrieves a bounding rectangle for all cells described by a given rectangle.
	   * This takes spanning cells into account.
	   *
	   * @param {ve.dm.TableMatrix.Rectangle} [rect]
	   * @return {ve.dm.TableMatrix.Rectangle} A new rectangle
	   */
	  this.getBoundingRectangle = function (rect) {
	    var cells, cell, i;
	    rect = TableMatrix.Rectangle.copy(rect);
	    cells = this.getCellsForRectangle(rect);
	    if (!cells || cells.length === 0) return null;
	    for (i = 0; i < cells.length; i++) {
	      cell = cells[i];
	      rect.start.row = Math.min(rect.start.row, cell.row);
	      rect.start.col = Math.min(rect.start.col, cell.col);
	      rect.end.row = Math.max(rect.end.row, cell.row + cell.node.getSpan('row') - 1);
	      rect.end.col = Math.max(rect.end.col, cell.col + cell.node.getSpan('col') - 1);
	    }
	    return rect;
	  };
	
	  /**
	   * Provides a tuple with number of rows and columns.
	   *
	   * @return {Number[2]} (number of rows) X (number of columns)
	   */
	  this.getSize = function () {
	    var matrix = this.getMatrix();
	    if (matrix.length === 0) {
	      return { rows: 0,  cols: 0 };
	    } else {
	      return { rows: matrix.length,  cols: matrix[0].length };
	    }
	  };
	
	  /**
	   * Looks up the cell for a given cell node.
	   *
	   * @return {ve.dm.TableMatrix.Cell} The cell or null if not found
	   */
	  this.lookupCell = function( cellNode ) {
	    var row, col, cell, rowCells,
	      matrix = this.getMatrix(),
	      rowNodes = this.getRowNodes();
	    row = rowNodes.indexOf(cellNode.parent);
	    if (row < 0) return null;
	    cell = null;
	    rowCells = matrix[row];
	    for (col = 0; col < rowCells.length; col++) {
	      cell = rowCells[col];
	      if (cell.node === cellNode) {
	        break;
	      }
	    }
	    return cell;
	  };
	
	  /**
	   * Finds the closest cell not being a placeholder for a given cell.
	   *
	   * @return {ve.dm.TableMatrix.Cell}
	   */
	  this.findClosestCell = function(cell) {
	    var col, rowCells,
	      matrix = this.getMatrix();
	    rowCells = matrix[cell.row];
	    for (col = cell.col; col >= 0; col--) {
	      if (rowCells[col].type === 'cell') return rowCells[col];
	    }
	    for (col = cell.col + 1; col < rowCells.length; col++) {
	      if (rowCells[col].type === 'cell') return rowCells[col];
	    }
	    return null;
	  };
	};
	
	OO.initClass(TableMatrix);
	
	/**
	 * An object wrapping a table cell node, augmenting it with row and column indexes.
	 *
	 * @class
	 * @constructor
	 * @param {ve.dm.TableCellNode} [node]
	 * @param {Number} [row] row index
	 * @param {Number} [col] column index
	 */
	TableMatrix.Cell = function Cell(node, row, col) {
	  this.type = 'cell';
	  this.node = node;
	  this.row = row;
	  this.col = col;
	  this.key = row + '_' + col;
	};
	
	TableMatrix.Cell.sortDescending = function( a, b ) {
	  if (a.row !== b.row) return b.row - a.row;
	  return b.col - a.col;
	};
	
	/**
	 * An object representing a cell which is occupied by another cell with 'rowspan' or 'colspan' attribute.
	 * Placeholders are used to create a dense representation of the sparse HTML table model.
	 *
	 * @class
	 * @constructor
	 * @param {ve.dm.TableMatrix.Cell} [owner]
	 * @param {Number} [row] row index
	 * @param {Number} [col] column index
	 */
	TableMatrix.Placeholder = function PlaceHolder( owner, row, col ) {
	  TableMatrix.Cell.call(this, owner.node, row, col);
	  this.type = 'placeholder';
	  this.owner = owner;
	};
	
	OO.inherit(TableMatrix.Placeholder, TableMatrix.Cell);
	
	/**
	 * An object describing a rectangular selection in a table matrix.
	 * It has two properties, 'start' and 'end', which both are objects with
	 * properties 'row' and 'col'. 'start' describes the upper-left, and
	 * 'end' the lower-right corner of the rectangle.
	 *
	 * @class
	 * @constructor
	 * @param {Number} [minRow] row index of upper-left corner
	 * @param {Number} [minCol] column index of upper-left corner
	 * @param {Number} [maxRow] row index of lower-left corner
	 * @param {Number} [maxCol] column index of lower-left corner
	 */
	TableMatrix.Rectangle = function( minRow, minCol, maxRow, maxCol ) {
	  this.start = { row: minRow, col: minCol };
	  this.end = { row: maxRow, col: maxCol };
	};
	
	TableMatrix.Rectangle.copy = function( rect ) {
	  return new TableMatrix.Rectangle(rect.start.row, rect.start.col, rect.end.row, rect.end.col);
	};
	
	module.exports = TableMatrix;


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var Node = __webpack_require__(6);
	var _ = __webpack_require__(1);
	
	var TableRow = Node.extend({
	  displayName: "TableRow",
	  name: "table-row",
	  properties: {
	    "parent": "id",
	    "cells": ["array", "id"]
	  },
	  getCells: function() {
	    var doc = this.getDocument();
	    return _.map(this.cells, function(id) {
	      return doc.get(id);
	    }, this);
	  },
	  getCellAt: function(cellIdx) {
	    var doc = this.getDocument();
	    var cellId = this.cells[cellIdx];
	    if (cellId) {
	      return doc.get(cellId);
	    } else {
	      return null;
	    }
	  },
	});
	
	TableRow.static.components = ['cells'];
	
	
	// HtmlImporter
	
	TableRow.static.matchElement = function($el) {
	  return $el.is('tr');
	};
	
	TableRow.static.fromHtml = function($el, converter) {
	  var id = converter.defaultId($el, 'tr');
	  var tableRow = {
	    id: id,
	    cells: []
	  };
	  $el.find('th,td').each(function() {
	    var $cell = $(this);
	    var cellNode = converter.convertElement($cell, { parent: id });
	    tableRow.cells.push(cellNode.id);
	  });
	  return tableRow;
	};
	
	TableRow.static.toHtml = function(row, converter) {
	  var id = row.id;
	  var $el = $('<tr>').attr('id', id);
	  _.each(row.getCells(), function(cell) {
	    $el.append(cell.toHtml(converter));
	  });
	  return $el;
	};
	
	Object.defineProperties(TableRow.prototype, {
	  cellNodes: {
	    'get': function() {
	      return this.getCells();
	    }
	  }
	});
	
	module.exports = TableRow;


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var Node = __webpack_require__(6);
	var _ = __webpack_require__(1);
	
	var TableSection = Node.extend({
	  displayName: "TableSection",
	  name: "table-section",
	  properties: {
	    "parent": "id",
	    "rows": ["array", "id"],
	    "sectionType": "string",
	  },
	  getRows: function() {
	    var doc = this.getDocument();
	    return _.map(this.rows, function(id) {
	      return doc.get(id);
	    }, this);
	  },
	  getRowAt: function(rowIdx) {
	    var doc = this.getDocument();
	    var rowId = this.rows[rowIdx];
	    if (rowId) {
	      return doc.get(rowId);
	    } else {
	      return null;
	    }
	  },
	});
	
	TableSection.static.components = ['rows'];
	
	
	// HtmlImporter
	
	TableSection.static.matchElement = function($el) {
	  return $el.is('thead, tbody, tfoot');
	};
	
	TableSection.static.fromHtml = function($el, converter) {
	  var tagName = $el[0].tagName.toLowerCase();
	  var sectionType = tagName.substring(1);
	  var id = converter.defaultId($el, tagName);
	  var tableSection = {
	    id: id,
	    sectionType: sectionType,
	    rows: []
	  };
	  $el.find('tr').each(function() {
	    var $row = $(this);
	    var rowNode = converter.convertElement($row, { parent: id });
	    tableSection.rows.push(rowNode.id);
	  });
	  return tableSection;
	};
	
	TableSection.static.toHtml = function(sec, converter) {
	  var id = sec.id;
	  var $el = $('<t' + sec.sectionType + '>')
	    .attr('id', id);
	  _.each(sec.getRows(), function(row) {
	    $el.append(row.toHtml(converter));
	  });
	  return $el;
	};
	
	Object.defineProperties(TableSection.prototype, {
	  cellNodes: {
	    'get': function() {
	      return this.getCells();
	    }
	  }
	});
	
	module.exports = TableSection;


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var OO = __webpack_require__(2);
	var PathAdapter = __webpack_require__(21);
	
	var NotifyByPathProxy = function(doc) {
	  this.listeners = new PathAdapter();
	  this._list = [];
	  this.doc = doc;
	};
	
	NotifyByPathProxy.Prototype = function() {
	
	  this.onDocumentChanged = function(change, info, doc) {
	    var listeners = this.listeners;
	    var updated = change.updated;
	
	    function _updated(path, op) {
	      if (!change.deleted[path[0]]) {
	        updated.add(path, op);
	      }
	    }
	
	    function _updatedContainerAnno(containerId, startPath, endPath, op) {
	      var container = doc.get(containerId);
	      var startComp = container.getComponent(startPath);
	      var endComp = container.getComponent(endPath);
	      if (startComp && endComp) {
	        var startIdx = startComp.getIndex();
	        var endIdx = endComp.getIndex();
	        var comp = startComp;
	        for (var i = startIdx; comp && i <= endIdx; i++, comp = comp.getNext()) {
	          _updated(comp.getPath(), op);
	        }
	      } else {
	        _updated(startPath, op);
	        _updated(endPath, op);
	      }
	    }
	
	    _.each(change.ops, function(op) {
	      if ( (op.type === "create" || op.type === "delete") && (op.val.path || op.val.startPath)) {
	        if (op.val.path) {
	          _updated(op.val.path, op);
	        } else if (op.val.startPath) {
	          _updatedContainerAnno(op.val.container, op.val.startPath, op.val.endPath, op);
	        }
	      }
	      else if (op.type === "set" && (op.path[1] === "path" || op.path[1] === "startPath" || op.path[1] === "endPath")) {
	        _updated(op.val, op);
	        _updated(op.original, op);
	      }
	      else if (op.type === "set" && (op.path[1] === "startOffset" || op.path[1] === "endOffset")) {
	        var anno = this.doc.get(op.path[0]);
	        if (anno) {
	          if (anno.path) {
	            _updated(anno.path, op);
	          } else {
	            _updatedContainerAnno(anno.container, anno.startPath, anno.endPath, op);
	          }
	        }
	      }
	    }, this);
	    change.traverse(function(path) {
	      var key = path.concat(['listeners']);
	      var scopedListeners = listeners.get(key);
	      _.each(scopedListeners, function(entry) {
	        entry.method.call(entry.listener, change, info, doc);
	      });
	    }, this);
	  };
	
	  this.add = function(path, listener, method) {
	    var key = path.concat(['listeners']);
	    var listeners = this.listeners.get(key);
	    if (!listeners) {
	      listeners = [];
	      this.listeners.set(key, listeners);
	    }
	    if (!method) {
	      throw new Error('Invalid argument: expected function but got ' + method);
	    }
	    listeners.push({ method: method, listener: listener });
	  };
	
	  this.connect = function(listener, path, method) {
	    this.add(path, listener, method);
	  };
	
	  // TODO: it would be cool if we would just need to provide the listener instance, no path
	  this.remove = function(path, listener) {
	    var key = path.concat(['listeners']);
	    var listeners = this.listeners.get(key);
	    if (listeners) {
	      for (var i = 0; i < listeners.length; i++) {
	        if (listeners[i].listener === listener) {
	          listeners.splice(i, 1);
	          return;
	        }
	      }
	    }
	  };
	
	  this.disconnect = function(listener, path) {
	    this.remove(path, listener);
	  };
	
	};
	
	OO.initClass(NotifyByPathProxy);
	
	module.exports = NotifyByPathProxy;


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var OO = __webpack_require__(2);
	var AbstractDocument = __webpack_require__(66);
	
	var __id__ = 0;
	
	function TransactionDocument(document) {
	  AbstractDocument.call(this, document.schema);
	  this.__id__ = "TX_"+__id__++;
	
	  this.document = document;
	  // ops recorded since transaction start
	  this.ops = [];
	  // app information state information used to recover the state before the transaction
	  // when calling undo
	  this.before = {};
	  // HACK: copying all indexes
	  _.each(document.data.indexes, function(index, name) {
	    this.data.addIndex(name, index.clone());
	  }, this);
	
	  this.loadSeed(document.toJSON());
	}
	
	TransactionDocument.Prototype = function() {
	
	  this.isTransaction = function() {
	    return true;
	  };
	
	  this.reset = function() {
	    this.ops = [];
	    this.before = {};
	    this._resetContainers();
	  };
	
	  this.create = function(nodeData) {
	    var op = this.data.create(nodeData);
	    if (!op) return;
	    if (this.document.isTransacting) {
	      this.ops.push(op);
	    }
	    // TODO: incremental graph returns op not the node,
	    // so probably here we should too?
	    return this.data.get(nodeData.id);
	  };
	
	  this.delete = function(nodeId) {
	    var op = this.data.delete(nodeId);
	    if (!op) return;
	    if (this.document.isTransacting) {
	      this.ops.push(op);
	    }
	    return op;
	  };
	
	  this.set = function(path, value) {
	    var op = this.data.set(path, value);
	    if (!op) return;
	    this._updateContainers(op);
	    if (this.document.isTransacting) {
	      this.ops.push(op);
	    }
	    return op;
	  };
	
	  this.update = function(path, diffOp) {
	    var op = this.data.update(path, diffOp);
	    if (!op) return;
	    this._updateContainers(op);
	    if (this.document.isTransacting) {
	      this.ops.push(op);
	    }
	    return op;
	  };
	
	  this.save = function(afterState, info) {
	    var before = this.before;
	    var after = _.extend({}, before, afterState);
	    this.document._saveTransaction(before, after, info);
	    // reset after finishing
	    this.reset();
	  };
	
	  this.cancel = function() {
	    // revert all recorded changes
	    for (var i = this.ops.length - 1; i >= 0; i--) {
	      this.data.apply(this.ops[i].invert());
	    }
	    this.document._cancelTransaction();
	    this.reset();
	  };
	
	  this.finish = function() {
	    if (this.document.isTransacting) {
	      this.cancel();
	    }
	  };
	
	  this.cleanup = this.finish;
	
	  this.getOperations = function() {
	    return this.ops;
	  };
	
	  this.apply = function(documentChange) {
	    _.each(documentChange.ops, function(op) {
	      this.data.apply(op);
	      this._updateContainers(op);
	    }, this);
	  };
	
	  this.getIndex = function(name) {
	    return this.data.getIndex(name);
	  };
	
	  // Called back by Substance.Data after a node instance has been created
	  this._didCreateNode = function(node) {
	    node.document = this;
	  };
	
	  this._didDeleteNode = function(node) {
	    node.document = null;
	  };
	
	  this.createSelection = function() {
	    return this.document.createSelection.apply(this, arguments);
	  };
	
	  this.getSchema = function() {
	    return this.schema;
	  };
	
	};
	
	OO.inherit(TransactionDocument, AbstractDocument);
	
	module.exports = TransactionDocument;


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var OO = __webpack_require__(2);
	
	var Annotations = __webpack_require__(10);
	
	function ListEditing() {}
	
	ListEditing.Prototype = function() {
	
	  this.register = function(behavior) {
	    behavior
	      .defineBreak('list-item', this.breakList)
	      .defineMerge('list','list', this.mergeListWithList)
	      .defineMerge('list','textish', this.mergeListWithTextish)
	      .defineMerge('textish','list', this.mergeTextishWithList)
	      .defineComponentMerge('list', this.mergeListItems);
	  };
	
	  this.breakList = function(tx, args) {
	    console.log("TODO: implement break list");
	    return args;
	  };
	
	  /**
	   * Implements a transformation that will be applied in situations like that
	   * ```
	   *   <ul>
	   *    ...
	   *   </ul>
	   *   |<!-- cursor here, pressed backspace -->
	   *   <ul>
	   *    ...
	   *   </ul>
	   * ```
	   *
	   * @param tx the transaction
	   * @param args an object with `first` being the first list node, and `second` being
	   *        the second list node.
	   */
	  this.mergeListWithList = function(tx, args) {
	    console.log('TODO: implement merge list-list');
	    return args;
	  };
	
	  /**
	   * Implements a transformation that will be applied for
	   * merging somthing like that
	   * ```
	   *   <ul>
	   *    ...
	   *   </ul>
	   *   |<!-- cursor here, pressed backspace -->
	   *   <p>...</p>
	   * ```
	   *
	   * @param tx the transaction
	   * @param args an object with `first` being the first list node, and `second` being
	   *        a textish node.
	   */
	  this.mergeListWithTextish = function(tx, args) {
	    console.log('TODO: implement merge list-text');
	    return args;
	  };
	
	  /**
	   * Implements a transformation that will be applied for
	   * merging somthing like that
	   * ```
	   *   <p>...</p>
	   *   <ul>
	   *     <li>|<!-- cursor here, pressed backspace -->...</li>
	   *     ...
	   *   </ul>
	   * ```
	   *
	   * @param tx the transaction
	   * @param args an object with `first` being the first list node, and `second` being
	   *        a textish node.
	   */
	  this.mergeTextishWithList = function(tx, args) {
	    console.log('TODO: implement merge text-list');
	    return args;
	  };
	
	
	  // TODO: this implementation is *very* similar to merge.mergeTextNodes
	  // try to consolidate this
	  this.mergeListItems = function(tx, args) {
	    var list = args.node;
	    var first = args.first;
	    var second = args.second;
	    var firstPath = first.getPath();
	    var secondPath = second.getPath();
	    var firstText = tx.get(first.getPath());
	    var selection;
	    // when the first component is empty we rather remove than merging into it
	    if (firstText.length === 0) {
	      // remove the first item from the item list, and delete it from the document
	      list.removeItem(first[0]);
	      tx.delete(firstPath[0]);
	      // set the selection to the end of the first component
	      selection = tx.createSelection({
	        type: 'property',
	        path: secondPath,
	        startOffset: 0
	      });
	    } else {
	      var secondText = tx.get(second.getPath());
	      // TODO: we should introduce a trafo that moves a text fragment and its annotations
	      // to a new location
	      // append the second text and transfer annotations
	      tx.update(firstPath, { insert: { offset: firstText.length, value: secondText } });
	      Annotations.transferAnnotations(tx, secondPath, 0, firstPath, firstText.length);
	      // remove the second item from the list and delete it from the document
	      list.removeItem(secondPath[0]);
	      tx.delete(secondPath[0]);
	      // set the selection to the end of the first component
	      selection = tx.createSelection({
	        type: 'property',
	        path: first.path,
	        startOffset: firstText.length
	      });
	    }
	    args.selection = selection;
	    return args;
	  };
	
	};
	
	OO.initClass(ListEditing);
	
	module.exports = ListEditing;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  breakNode: __webpack_require__(42),
	  copySelection: __webpack_require__(43),
	  deleteCharacter: __webpack_require__(75),
	  deleteNode: __webpack_require__(44),
	  deleteSelection: __webpack_require__(24),
	  insertNode: __webpack_require__(150),
	  insertText: __webpack_require__(76),
	  merge: __webpack_require__(45),
	  paste: __webpack_require__(151),
	  switchTextType: __webpack_require__(152),
	};


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var deleteSelection = __webpack_require__(24);
	var breakNode = __webpack_require__(42);
	
	function insertNode(tx, args) {
	  var selection = args.selection;
	  var node = args.node;
	  if (!args.containerId) {
	    throw new Error("containerId is mandatory");
	  }
	  if (!args.selection) {
	    throw new Error("selection is mandatory");
	  }
	  if (!args.node) {
	    throw new Error("node is mandatory");
	  }
	  var containerId = args.containerId;
	  var container = tx.get(containerId);
	  var tmp;
	  if (!selection.isCollapsed()) {
	    tmp = deleteSelection(tx, args);
	    selection = tmp.selection;
	  }
	  tmp = breakNode(tx, args);
	  selection = tmp.selection;
	  if (!tx.get(node.id)) {
	    node = tx.create(node);
	  }
	  var comp = container.getComponent(selection.start.path);
	  var pos = container.getPosition(comp.rootId);
	  container.show(node.id, pos);
	  // if possible set the selection to the first position in the inserted node
	  var comps = container.getComponentsForNode(node.id);
	  if (comps.length > 0) {
	    args.selection = tx.createSelection({
	      type: 'property',
	      path: comps[0].getPath(),
	      startOffset: 0
	    });
	  }
	  return args;
	}
	
	module.exports = insertNode;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var Annotations = __webpack_require__(10);
	var deleteSelection = __webpack_require__(24);
	var insertText = __webpack_require__(76);
	var breakNode = __webpack_require__(42);
	var CLIPBOARD_CONTAINER_ID = __webpack_require__(43).CLIPBOARD_CONTAINER_ID;
	
	/* jshint latedef: false */
	
	var paste = function(tx, args) {
	  if (args.selection.isNull()) {
	    console.error("Can not paste, without selection.");
	    return args;
	  }
	  // if paste dataplain text paste is simple
	  if (args.text && !args.doc) {
	    return insertText(tx, args);
	  }
	  var pasteDoc = args.doc;
	  if (!args.selection.isCollapsed()) {
	    var tmp = deleteSelection(tx, args);
	    args.selection = tmp.selection;
	  }
	  var nodes = pasteDoc.get(CLIPBOARD_CONTAINER_ID).nodes;
	  if (nodes.length > 0) {
	    var first = pasteDoc.get(nodes[0]);
	    // copy of a property selection creates a doc containing
	    // one default text node with id 'text'
	    if (nodes.length === 1 && first.isInstanceOf("text")) {
	      return _pasteAnnotatedText(tx, args);
	    } else {
	      return _pasteDocument(tx, args);
	    }
	  }
	  return args;
	};
	
	var _pasteAnnotatedText = function(tx, args) {
	  var copy = args.doc;
	  var selection = args.selection;
	
	  var nodes = copy.get(CLIPBOARD_CONTAINER_ID).nodes;
	  var textPath = [nodes[0], 'content'];
	  var text = copy.get(textPath);
	  var annotations = copy.getIndex('annotations').get(textPath);
	  // insert plain text
	  var path = selection.start.path;
	  var offset = selection.start.offset;
	  tx.update(path, { insert: { offset: offset, value: text } } );
	  Annotations.insertedText(tx, selection.start, text.length);
	  selection = tx.createSelection({
	    type: 'property',
	    path: selection.start.path,
	    startOffset: selection.start.offset+text.length
	  });
	  // copy annotations
	  _.each(annotations, function(anno) {
	    var data = anno.toJSON();
	    data.path = path.slice(0);
	    data.startOffset += offset;
	    data.endOffset += offset;
	    if (tx.get(data.id)) {
	      data.id = _.uuid(data.type);
	    }
	    tx.create(data);
	  });
	  args.selection = selection;
	  return args;
	};
	
	var _pasteDocument = function(tx, args) {
	  var pasteDoc = args.doc;
	  var containerId = args.containerId;
	  var selection = args.selection;
	  var container = tx.get(containerId);
	
	  // Break, unless we are at the last character of a node,
	  // then we can simply insert after the node
	  var startComp = container.getComponent(selection.start.path);
	  var startNodeComp = startComp.parentNode;
	  var insertPos;
	  if ( startComp === _.last(startNodeComp.components) &&
	    tx.get(startComp.path).length === selection.start.offset )
	  {
	    insertPos = container.getPosition(selection.start.path[0]) + 1;
	  } else {
	    var result = breakNode(tx, args);
	    selection = result.selection;
	    insertPos = container.getPosition(selection.start.path[0]);
	  }
	  if (insertPos < 0) {
	    console.error('Could not find insertion position in ContainerNode.');
	  }
	  // transfer nodes from content document
	  // TODO: transfer annotations
	  var nodeIds = pasteDoc.get(CLIPBOARD_CONTAINER_ID).nodes;
	  var annoIndex = pasteDoc.getIndex('annotations');
	  var insertedNodes = [];
	  for (var i = 0; i < nodeIds.length; i++) {
	    var nodeId = nodeIds[i];
	    var node = pasteDoc.get(nodeId).toJSON();
	    // create a new id if the node exists already
	    if (tx.get(nodeId)) {
	      node.id = _.uuid(node.type);
	    }
	    tx.create(node);
	    container.show(node.id, insertPos++);
	    insertedNodes.push(node);
	
	    // transfer annotations
	    // what about nodes that are referenced by annotations?
	    var annos = annoIndex.get(nodeId);
	    for (var j = 0; j < annos.length; j++) {
	      var data = annos[j].toJSON();
	      if (node.id !== nodeId) {
	        data.path[0] = node.id;
	      }
	      if (tx.get(data.id)) {
	        data.id = _.uuid(data.type);
	      }
	      tx.create(data);
	    }
	  }
	
	  if (insertedNodes.length === 0) return args;
	
	  // set a new selection
	  var lastId = _.last(insertedNodes).id;
	  var lastComp = _.last(container.getComponentsForNode(lastId));
	  var lastLength = tx.get(lastComp.path).length;
	  // This version turned out to be useful in some situations
	  // as it hightlights the pasted content
	  // we leave it here for debugging
	  if (false) {
	    var firstId = insertedNodes[0].id;
	    var firstComp = container.getComponentsForNode(firstId)[0];
	    selection = tx.createSelection({
	      type: 'container',
	      containerId: container.id,
	      startPath: firstComp.path,
	      startOffset: 0,
	      endPath: lastComp.path,
	      endOffset: lastLength
	    });
	  } else {
	    selection = tx.createSelection({
	      type: 'property',
	      path: lastComp.path,
	      startOffset: lastLength
	    });
	  }
	  args.selection = selection;
	  return args;
	};
	
	module.exports = paste;


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var Annotations = __webpack_require__(10);
	var deleteNode = __webpack_require__(44);
	
	// TODO: needs to be overhauled should work without a given container
	// Working without a container does not really make really sense.
	// Non-container editing situations are typically form-editors, where no notion
	// of nodes exist actually, but only properties. Changing a node type is not necessary
	// The only interesting thing is, to iterate over all containers
	// so that a switched node gets replaced in all occurrences automatically.
	// However, we don't have a use-case for it right now.
	
	function switchTextType(tx, args) {
	  var selection = args.selection;
	  if (!selection.isPropertySelection()) {
	    console.error("Selection must be a PropertySelection.");
	    return args;
	  }
	  var nodeId = selection.getPath()[0];
	  var data = args.data;
	  var node = tx.get(nodeId);
	  var path = selection.path;
	  if (!(node.isInstanceOf('text'))) {
	    console.warn('Trying to use switchTextType on a non text node. Skipping.');
	    return args;
	  }
	  // create a new node and transfer annotations
	  var newNode = _.extend({
	    id: _.uuid(data.type),
	    type: data.type,
	    content: node.content
	  }, data);
	  var newPath = [newNode.id, 'content'];
	  tx.create(newNode);
	  Annotations.transferAnnotations(tx, path, 0, newPath, 0);
	
	  // TODO: should work without a given container
	  // _.each(tx.getContainers(), function(container) {
	  //   pos = container.getPosition(nodeId);
	  //   ....
	  // });
	
	  // hide the old one, show the new node
	  var container = tx.get(args.containerId);
	  var pos = container.getPosition(nodeId);
	  if (pos >= 0) {
	    container.hide(nodeId);
	    container.show(newNode.id, pos);
	  }
	
	  // remove the old one from the document
	  deleteNode(tx, { nodeId: node.id });
	
	  args.selection = tx.createSelection({
	    type: 'property',
	    path: newPath,
	    startOffset: selection.startOffset,
	    endOffset: selection.endOffset
	  });
	
	  return args;
	}
	
	module.exports = switchTextType;


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 154 */
/***/ function(module, exports) {

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array ? array.length : 0,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = compact;


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(14);
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for, instead of the element itself.
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(chr) {
	 *   return chr.user == 'barney';
	 * });
	 * // => 0
	 *
	 * // using the `_.matches` callback shorthand
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.findIndex(users, 'active', false);
	 * // => 0
	 *
	 * // using the `_.property` callback shorthand
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, thisArg) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  predicate = baseCallback(predicate, thisArg, 3);
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = findIndex;


/***/ },
/* 156 */
/***/ function(module, exports) {

	/**
	 * Gets the first element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @alias head
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the first element of `array`.
	 * @example
	 *
	 * _.first([1, 2, 3]);
	 * // => 1
	 *
	 * _.first([]);
	 * // => undefined
	 */
	function first(array) {
	  return array ? array[0] : undefined;
	}
	
	module.exports = first;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(29),
	    cacheIndexOf = __webpack_require__(49),
	    createCache = __webpack_require__(50),
	    isArguments = __webpack_require__(25),
	    isArray = __webpack_require__(5);
	
	/**
	 * Creates an array of unique values in all provided arrays using `SameValueZero`
	 * for equality comparisons.
	 *
	 * **Note:** `SameValueZero` comparisons are like strict equality comparisons,
	 * e.g. `===`, except that `NaN` matches `NaN`. See the
	 * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of shared values.
	 * @example
	 * _.intersection([1, 2], [4, 2], [2, 1]);
	 * // => [2]
	 */
	function intersection() {
	  var args = [],
	      argsIndex = -1,
	      argsLength = arguments.length,
	      caches = [],
	      indexOf = baseIndexOf,
	      isCommon = true;
	
	  while (++argsIndex < argsLength) {
	    var value = arguments[argsIndex];
	    if (isArray(value) || isArguments(value)) {
	      args.push(value);
	      caches.push((isCommon && value.length >= 120) ? createCache(argsIndex && value) : null);
	    }
	  }
	  argsLength = args.length;
	  var array = args[0],
	      index = -1,
	      length = array ? array.length : 0,
	      result = [],
	      seen = caches[0];
	
	  outer:
	  while (++index < length) {
	    value = array[index];
	    if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value)) < 0) {
	      argsIndex = argsLength;
	      while (--argsIndex) {
	        var cache = caches[argsIndex];
	        if ((cache ? cacheIndexOf(cache, value) : indexOf(args[argsIndex], value)) < 0) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(value);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = intersection;


/***/ },
/* 158 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(84),
	    baseUniq = __webpack_require__(89);
	
	/**
	 * Creates an array of unique values, in order, of the provided arrays using
	 * `SameValueZero` for equality comparisons.
	 *
	 * **Note:** `SameValueZero` comparisons are like strict equality comparisons,
	 * e.g. `===`, except that `NaN` matches `NaN`. See the
	 * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([1, 2], [4, 2], [2, 1]);
	 * // => [1, 2, 4]
	 */
	function union() {
	  return baseUniq(baseFlatten(arguments, false, true));
	}
	
	module.exports = union;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(14),
	    baseUniq = __webpack_require__(89),
	    isIterateeCall = __webpack_require__(31),
	    sortedUniq = __webpack_require__(213);
	
	/**
	 * Creates a duplicate-value-free version of an array using `SameValueZero`
	 * for equality comparisons. Providing `true` for `isSorted` performs a faster
	 * search algorithm for sorted arrays. If an iteratee function is provided it
	 * is invoked for each value in the array to generate the criterion by which
	 * uniqueness is computed. The `iteratee` is bound to `thisArg` and invoked
	 * with three arguments; (value, index, array).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * **Note:** `SameValueZero` comparisons are like strict equality comparisons,
	 * e.g. `===`, except that `NaN` matches `NaN`. See the
	 * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @alias unique
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {boolean} [isSorted] Specify the array is sorted.
	 * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array} Returns the new duplicate-value-free array.
	 * @example
	 *
	 * _.uniq([1, 2, 1]);
	 * // => [1, 2]
	 *
	 * // using `isSorted`
	 * _.uniq([1, 1, 2], true);
	 * // => [1, 2]
	 *
	 * // using an iteratee function
	 * _.uniq([1, 2.5, 1.5, 2], function(n) {
	 *   return this.floor(n);
	 * }, Math);
	 * // => [1, 2.5]
	 *
	 * // using the `_.property` callback shorthand
	 * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniq(array, isSorted, iteratee, thisArg) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return [];
	  }
	  if (isSorted != null && typeof isSorted != 'boolean') {
	    thisArg = iteratee;
	    iteratee = isIterateeCall(array, isSorted, thisArg) ? null : isSorted;
	    isSorted = false;
	  }
	  iteratee = iteratee == null ? iteratee : baseCallback(iteratee, thisArg, 3);
	  return (isSorted)
	    ? sortedUniq(array, iteratee)
	    : baseUniq(array, iteratee);
	}
	
	module.exports = uniq;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(83),
	    baseSlice = __webpack_require__(48);
	
	/**
	 * Creates an array excluding all provided values using `SameValueZero` for
	 * equality comparisons.
	 *
	 * **Note:** `SameValueZero` comparisons are like strict equality comparisons,
	 * e.g. `===`, except that `NaN` matches `NaN`. See the
	 * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to filter.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.without([1, 2, 1, 3], 1, 2);
	 * // => [3]
	 */
	function without(array) {
	  return baseDifference(array, baseSlice(arguments, 1));
	}
	
	module.exports = without;


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(173),
	    baseCallback = __webpack_require__(14),
	    baseFilter = __webpack_require__(178),
	    isArray = __webpack_require__(5);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	 * invoked with three arguments; (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias select
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Array} Returns the new filtered array.
	 * @example
	 *
	 * _.filter([4, 5, 6], function(n) {
	 *   return n % 2 == 0;
	 * });
	 * // => [4, 6]
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // using the `_.matches` callback shorthand
	 * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	 * // => ['barney']
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.pluck(_.filter(users, 'active', false), 'user');
	 * // => ['fred']
	 *
	 * // using the `_.property` callback shorthand
	 * _.pluck(_.filter(users, 'active'), 'user');
	 * // => ['barney']
	 */
	function filter(collection, predicate, thisArg) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  predicate = baseCallback(predicate, thisArg, 3);
	  return func(collection, predicate);
	}
	
	module.exports = filter;


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(14),
	    baseEach = __webpack_require__(20),
	    baseFind = __webpack_require__(179),
	    findIndex = __webpack_require__(155),
	    isArray = __webpack_require__(5);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	 * invoked with three arguments; (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias detect
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.result(_.find(users, function(chr) {
	 *   return chr.age < 40;
	 * }), 'user');
	 * // => 'barney'
	 *
	 * // using the `_.matches` callback shorthand
	 * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	 * // => 'pebbles'
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.result(_.find(users, 'active', false), 'user');
	 * // => 'fred'
	 *
	 * // using the `_.property` callback shorthand
	 * _.result(_.find(users, 'active'), 'user');
	 * // => 'barney'
	 */
	function find(collection, predicate, thisArg) {
	  if (isArray(collection)) {
	    var index = findIndex(collection, predicate, thisArg);
	    return index > -1 ? collection[index] : undefined;
	  }
	  predicate = baseCallback(predicate, thisArg, 3);
	  return baseFind(collection, predicate, baseEach);
	}
	
	module.exports = find;


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(79),
	    baseEach = __webpack_require__(20),
	    bindCallback = __webpack_require__(15),
	    isArray = __webpack_require__(5);
	
	/**
	 * Iterates over elements of `collection` invoking `iteratee` for each element.
	 * The `iteratee` is bound to `thisArg` and invoked with three arguments;
	 * (value, index|key, collection). Iterator functions may exit iteration early
	 * by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a `length` property
	 * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	 * may be used for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @alias each
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array|Object|string} Returns `collection`.
	 * @example
	 *
	 * _([1, 2]).forEach(function(n) {
	 *   console.log(n);
	 * }).value();
	 * // => logs each value from left to right and returns the array
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	 *   console.log(n, key);
	 * });
	 * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	 */
	function forEach(collection, iteratee, thisArg) {
	  return (typeof iteratee == 'function' && typeof thisArg == 'undefined' && isArray(collection))
	    ? arrayEach(collection, iteratee)
	    : baseEach(collection, bindCallback(iteratee, thisArg, 3));
	}
	
	module.exports = forEach;


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(29),
	    isArray = __webpack_require__(5),
	    isLength = __webpack_require__(7),
	    isString = __webpack_require__(55),
	    values = __webpack_require__(224);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection` using `SameValueZero` for equality
	 * comparisons. If `fromIndex` is negative, it is used as the offset from
	 * the end of `collection`.
	 *
	 * **Note:** `SameValueZero` comparisons are like strict equality comparisons,
	 * e.g. `===`, except that `NaN` matches `NaN`. See the
	 * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @alias contains, include
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {*} target The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	 * // => true
	 *
	 * _.includes('pebbles', 'eb');
	 * // => true
	 */
	function includes(collection, target, fromIndex) {
	  var length = collection ? collection.length : 0;
	  if (!isLength(length)) {
	    collection = values(collection);
	    length = collection.length;
	  }
	  if (!length) {
	    return false;
	  }
	  if (typeof fromIndex == 'number') {
	    fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	  } else {
	    fromIndex = 0;
	  }
	  return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	    ? (fromIndex < length && collection.indexOf(target, fromIndex) > -1)
	    : (baseIndexOf(collection, target, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	var createAggregator = __webpack_require__(192);
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` through `iteratee`. The corresponding value
	 * of each key is the last element responsible for generating the key. The
	 * iteratee function is bound to `thisArg` and invoked with three arguments;
	 * (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * var keyData = [
	 *   { 'dir': 'left', 'code': 97 },
	 *   { 'dir': 'right', 'code': 100 }
	 * ];
	 *
	 * _.indexBy(keyData, 'dir');
	 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	 *
	 * _.indexBy(keyData, function(object) {
	 *   return String.fromCharCode(object.code);
	 * });
	 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	 *
	 * _.indexBy(keyData, function(object) {
	 *   return this.fromCharCode(object.code);
	 * }, String);
	 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	 */
	var indexBy = createAggregator(function(result, value, key) {
	  result[key] = value;
	});
	
	module.exports = indexBy;


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(87),
	    map = __webpack_require__(77);
	
	/**
	 * Gets the value of `key` from all elements in `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {string} key The key of the property to pluck.
	 * @returns {Array} Returns the property values.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 }
	 * ];
	 *
	 * _.pluck(users, 'user');
	 * // => ['barney', 'fred']
	 *
	 * var userIndex = _.indexBy(users, 'user');
	 * _.pluck(userIndex, 'age');
	 * // => [36, 40] (iteration order is not guaranteed)
	 */
	function pluck(collection, key) {
	  return map(collection, baseProperty(key));
	}
	
	module.exports = pluck;


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(14),
	    baseEach = __webpack_require__(20),
	    baseSortBy = __webpack_require__(187),
	    compareAscending = __webpack_require__(191),
	    isIterateeCall = __webpack_require__(31),
	    isLength = __webpack_require__(7);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection through `iteratee`. This method performs
	 * a stable sort, that is, it preserves the original sort order of equal elements.
	 * The `iteratee` is bound to `thisArg` and invoked with three arguments;
	 * (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Array|Function|Object|string} [iteratee=_.identity] The function
	 *  invoked per iteration. If a property name or an object is provided it is
	 *  used to create a `_.property` or `_.matches` style callback respectively.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * _.sortBy([1, 2, 3], function(n) {
	 *   return Math.sin(n);
	 * });
	 * // => [3, 1, 2]
	 *
	 * _.sortBy([1, 2, 3], function(n) {
	 *   return this.sin(n);
	 * }, Math);
	 * // => [3, 1, 2]
	 *
	 * var users = [
	 *   { 'user': 'fred' },
	 *   { 'user': 'pebbles' },
	 *   { 'user': 'barney' }
	 * ];
	 *
	 * // using the `_.property` callback shorthand
	 * _.pluck(_.sortBy(users, 'user'), 'user');
	 * // => ['barney', 'fred', 'pebbles']
	 */
	function sortBy(collection, iteratee, thisArg) {
	  var index = -1,
	      length = collection ? collection.length : 0,
	      result = isLength(length) ? Array(length) : [];
	
	  if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	    iteratee = null;
	  }
	  iteratee = baseCallback(iteratee, thisArg, 3);
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = { 'criteria': iteratee(value, key, collection), 'index': index, 'value': value };
	  });
	  return baseSortBy(result, compareAscending);
	}
	
	module.exports = sortBy;


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(48),
	    createWrapper = __webpack_require__(197),
	    replaceHolders = __webpack_require__(53);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of `thisArg`
	 * and prepends any additional `_.bind` arguments to those provided to the
	 * bound function.
	 *
	 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** Unlike native `Function#bind` this method does not set the `length`
	 * property of bound functions.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {...*} [args] The arguments to be partially applied.
	 * @returns {Function} Returns the new bound function.
	 * @example
	 *
	 * var greet = function(greeting, punctuation) {
	 *   return greeting + ' ' + this.user + punctuation;
	 * };
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * var bound = _.bind(greet, object, 'hi');
	 * bound('!');
	 * // => 'hi fred!'
	 *
	 * // using placeholders
	 * var bound = _.bind(greet, object, _, '!');
	 * bound('hi');
	 * // => 'hi fred!'
	 */
	function bind(func, thisArg) {
	  var bitmask = BIND_FLAG;
	  if (arguments.length > 2) {
	    var partials = baseSlice(arguments, 2),
	        holders = replaceHolders(partials, bind.placeholder);
	
	    bitmask |= PARTIAL_FLAG;
	  }
	  return createWrapper(func, bitmask, thisArg, partials, holders);
	}
	
	// Assign default placeholders.
	bind.placeholder = {};
	
	module.exports = bind;


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(8),
	    now = __webpack_require__(78);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that delays invoking `func` until after `wait` milliseconds
	 * have elapsed since the last time it was invoked. The created function comes
	 * with a `cancel` method to cancel delayed invocations. Provide an options
	 * object to indicate that `func` should be invoked on the leading and/or
	 * trailing edge of the `wait` timeout. Subsequent calls to the debounced
	 * function return the result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	 * on the trailing edge of the timeout only if the the debounced function is
	 * invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.leading=false] Specify invoking on the leading
	 *  edge of the timeout.
	 * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	 *  delayed before it is invoked.
	 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	 *  edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // avoid costly calculations while the window size is in flux
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	 * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // ensure `batchLog` is invoked once after 1 second of debounced calls
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', _.debounce(batchLog, 250, {
	 *   'maxWait': 1000
	 * }));
	 *
	 * // cancel a debounced call
	 * var todoChanges = _.debounce(batchLog, 1000);
	 * Object.observe(models.todo, todoChanges);
	 *
	 * Object.observe(models, function(changes) {
	 *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	 *     todoChanges.cancel();
	 *   }
	 * }, ['delete']);
	 *
	 * // ...at some point `models.todo` is changed
	 * models.todo.completed = true;
	 *
	 * // ...before 1 second has passed `models.todo` is deleted
	 * // which cancels the debounced `todoChanges` call
	 * delete models.todo;
	 */
	function debounce(func, wait, options) {
	  var args,
	      maxTimeoutId,
	      result,
	      stamp,
	      thisArg,
	      timeoutId,
	      trailingCall,
	      lastCalled = 0,
	      maxWait = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = wait < 0 ? 0 : (+wait || 0);
	  if (options === true) {
	    var leading = true;
	    trailing = false;
	  } else if (isObject(options)) {
	    leading = options.leading;
	    maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	    trailing = 'trailing' in options ? options.trailing : trailing;
	  }
	
	  function cancel() {
	    if (timeoutId) {
	      clearTimeout(timeoutId);
	    }
	    if (maxTimeoutId) {
	      clearTimeout(maxTimeoutId);
	    }
	    maxTimeoutId = timeoutId = trailingCall = undefined;
	  }
	
	  function delayed() {
	    var remaining = wait - (now() - stamp);
	    if (remaining <= 0 || remaining > wait) {
	      if (maxTimeoutId) {
	        clearTimeout(maxTimeoutId);
	      }
	      var isCalled = trailingCall;
	      maxTimeoutId = timeoutId = trailingCall = undefined;
	      if (isCalled) {
	        lastCalled = now();
	        result = func.apply(thisArg, args);
	        if (!timeoutId && !maxTimeoutId) {
	          args = thisArg = null;
	        }
	      }
	    } else {
	      timeoutId = setTimeout(delayed, remaining);
	    }
	  }
	
	  function maxDelayed() {
	    if (timeoutId) {
	      clearTimeout(timeoutId);
	    }
	    maxTimeoutId = timeoutId = trailingCall = undefined;
	    if (trailing || (maxWait !== wait)) {
	      lastCalled = now();
	      result = func.apply(thisArg, args);
	      if (!timeoutId && !maxTimeoutId) {
	        args = thisArg = null;
	      }
	    }
	  }
	
	  function debounced() {
	    args = arguments;
	    stamp = now();
	    thisArg = this;
	    trailingCall = trailing && (timeoutId || !leading);
	
	    if (maxWait === false) {
	      var leadingCall = leading && !timeoutId;
	    } else {
	      if (!maxTimeoutId && !leading) {
	        lastCalled = stamp;
	      }
	      var remaining = maxWait - (stamp - lastCalled),
	          isCalled = remaining <= 0 || remaining > maxWait;
	
	      if (isCalled) {
	        if (maxTimeoutId) {
	          maxTimeoutId = clearTimeout(maxTimeoutId);
	        }
	        lastCalled = stamp;
	        result = func.apply(thisArg, args);
	      }
	      else if (!maxTimeoutId) {
	        maxTimeoutId = setTimeout(maxDelayed, remaining);
	      }
	    }
	    if (isCalled && timeoutId) {
	      timeoutId = clearTimeout(timeoutId);
	    }
	    else if (!timeoutId && wait !== maxWait) {
	      timeoutId = setTimeout(delayed, wait);
	    }
	    if (leadingCall) {
	      isCalled = true;
	      result = func.apply(thisArg, args);
	    }
	    if (isCalled && !timeoutId && !maxTimeoutId) {
	      args = thisArg = null;
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var baseDelay = __webpack_require__(177);
	
	/**
	 * Invokes `func` after `wait` milliseconds. Any additional arguments are
	 * provided to `func` when it is invoked.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to delay.
	 * @param {number} wait The number of milliseconds to delay invocation.
	 * @param {...*} [args] The arguments to invoke the function with.
	 * @returns {number} Returns the timer id.
	 * @example
	 *
	 * _.delay(function(text) {
	 *   console.log(text);
	 * }, 1000, 'later');
	 * // => logs 'later' after one second
	 */
	function delay(func, wait) {
	  return baseDelay(func, wait, arguments, 2);
	}
	
	module.exports = delay;


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var cachePush = __webpack_require__(190),
	    isNative = __webpack_require__(11);
	
	/** Native method references. */
	var Set = isNative(Set = global.Set) && Set;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = isNative(nativeCreate = Object.create) && nativeCreate;
	
	/**
	 *
	 * Creates a cache object to store unique values.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var length = values ? values.length : 0;
	
	  this.data = { 'hash': nativeCreate(null), 'set': new Set };
	  while (length--) {
	    this.push(values[length]);
	  }
	}
	
	// Add functions to the `Set` cache.
	SetCache.prototype.push = cachePush;
	
	module.exports = SetCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 173 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for callback
	 * shorthands or `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array.length,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var baseCopy = __webpack_require__(82),
	    keys = __webpack_require__(16);
	
	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `this` binding `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} [customizer] The function to customize assigning values.
	 * @returns {Object} Returns the destination object.
	 */
	function baseAssign(object, source, customizer) {
	  var props = keys(source);
	  if (!customizer) {
	    return baseCopy(source, object, props);
	  }
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key],
	        result = customizer(value, source[key], key, object, source);
	
	    if ((result === result ? result !== value : value === value) ||
	        (typeof value == 'undefined' && !(key in object))) {
	      object[key] = result;
	    }
	  }
	  return object;
	}
	
	module.exports = baseAssign;


/***/ },
/* 175 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `compareAscending` which compares values and
	 * sorts them in ascending order without guaranteeing a stable sort.
	 *
	 * @private
	 * @param {*} value The value to compare to `other`.
	 * @param {*} other The value to compare to `value`.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function baseCompareAscending(value, other) {
	  if (value !== other) {
	    var valIsReflexive = value === value,
	        othIsReflexive = other === other;
	
	    if (value > other || !valIsReflexive || (typeof value == 'undefined' && othIsReflexive)) {
	      return 1;
	    }
	    if (value < other || !othIsReflexive || (typeof other == 'undefined' && valIsReflexive)) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = baseCompareAscending;


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var isObject = __webpack_require__(8);
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function Object() {}
	  return function(prototype) {
	    if (isObject(prototype)) {
	      Object.prototype = prototype;
	      var result = new Object;
	      Object.prototype = null;
	    }
	    return result || global.Object();
	  };
	}());
	
	module.exports = baseCreate;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(48);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * The base implementation of `_.delay` and `_.defer` which accepts an index
	 * of where to slice the arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to delay.
	 * @param {number} wait The number of milliseconds to delay invocation.
	 * @param {Object} args The `arguments` object to slice and provide to `func`.
	 * @returns {number} Returns the timer id.
	 */
	function baseDelay(func, wait, args, fromIndex) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return setTimeout(function() { func.apply(undefined, baseSlice(args, fromIndex)); }, wait);
	}
	
	module.exports = baseDelay;


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(20);
	
	/**
	 * The base implementation of `_.filter` without support for callback
	 * shorthands or `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 179 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	 * without support for callback shorthands and `this` binding, which iterates
	 * over `collection` using the provided `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @param {boolean} [retKey] Specify returning the key of the found element
	 *  instead of the element itself.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFind(collection, predicate, eachFunc, retKey) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = retKey ? key : value;
	      return false;
	    }
	  });
	  return result;
	}
	
	module.exports = baseFind;


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(85),
	    keysIn = __webpack_require__(56);
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	module.exports = baseForIn;


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var equalArrays = __webpack_require__(198),
	    equalByTag = __webpack_require__(199),
	    equalObjects = __webpack_require__(200),
	    isArray = __webpack_require__(5),
	    isTypedArray = __webpack_require__(220);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the `toStringTag` of values.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * for more details.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @param {boolean} [isWhere] Specify performing partial comparisons.
	 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, isWhere, stackA, stackB) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = objToString.call(object);
	    if (objTag == argsTag) {
	      objTag = objectTag;
	    } else if (objTag != objectTag) {
	      objIsArr = isTypedArray(object);
	    }
	  }
	  if (!othIsArr) {
	    othTag = objToString.call(other);
	    if (othTag == argsTag) {
	      othTag = objectTag;
	    } else if (othTag != objectTag) {
	      othIsArr = isTypedArray(other);
	    }
	  }
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !(objIsArr || objIsObj)) {
	    return equalByTag(object, other, objTag);
	  }
	  var valWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	      othWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	  if (valWrapped || othWrapped) {
	    return equalFunc(valWrapped ? object.value() : object, othWrapped ? other.value() : other, customizer, isWhere, stackA, stackB);
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  // For more information on detecting circular references see https://es5.github.io/#JO.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == object) {
	      return stackB[length] == other;
	    }
	  }
	  // Add `object` and `other` to the stack of traversed objects.
	  stackA.push(object);
	  stackB.push(other);
	
	  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isWhere, stackA, stackB);
	
	  stackA.pop();
	  stackB.pop();
	
	  return result;
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 182 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isFunction` without support for environments
	 * with incorrect `typeof` results.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 */
	function baseIsFunction(value) {
	  // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	  // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	  return typeof value == 'function' || false;
	}
	
	module.exports = baseIsFunction;


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(46);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.isMatch` without support for callback
	 * shorthands or `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} props The source property names to match.
	 * @param {Array} values The source values to match.
	 * @param {Array} strictCompareFlags Strict comparison flags for source values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, props, values, strictCompareFlags, customizer) {
	  var length = props.length;
	  if (object == null) {
	    return !length;
	  }
	  var index = -1,
	      noCustomizer = !customizer;
	
	  while (++index < length) {
	    if ((noCustomizer && strictCompareFlags[index])
	          ? values[index] !== object[props[index]]
	          : !hasOwnProperty.call(object, props[index])
	        ) {
	      return false;
	    }
	  }
	  index = -1;
	  while (++index < length) {
	    var key = props[index];
	    if (noCustomizer && strictCompareFlags[index]) {
	      var result = hasOwnProperty.call(object, key);
	    } else {
	      var objValue = object[key],
	          srcValue = values[index];
	
	      result = customizer ? customizer(objValue, srcValue, key) : undefined;
	      if (typeof result == 'undefined') {
	        result = baseIsEqual(srcValue, objValue, customizer, true);
	      }
	    }
	    if (!result) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(20);
	
	/**
	 * The base implementation of `_.map` without support for callback shorthands
	 * or `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var result = [];
	  baseEach(collection, function(value, key, collection) {
	    result.push(iteratee(value, key, collection));
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(183),
	    isStrictComparable = __webpack_require__(52),
	    keys = __webpack_require__(16);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.matches` which does not clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var props = keys(source),
	      length = props.length;
	
	  if (length == 1) {
	    var key = props[0],
	        value = source[key];
	
	    if (isStrictComparable(value)) {
	      return function(object) {
	        return object != null && object[key] === value && hasOwnProperty.call(object, key);
	      };
	    }
	  }
	  var values = Array(length),
	      strictCompareFlags = Array(length);
	
	  while (length--) {
	    value = source[props[length]];
	    values[length] = value;
	    strictCompareFlags[length] = isStrictComparable(value);
	  }
	  return function(object) {
	    return baseIsMatch(object, props, values, strictCompareFlags);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(46),
	    isStrictComparable = __webpack_require__(52);
	
	/**
	 * The base implementation of `_.matchesProperty` which does not coerce `key`
	 * to a string.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} value The value to compare.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(key, value) {
	  if (isStrictComparable(value)) {
	    return function(object) {
	      return object != null && object[key] === value;
	    };
	  }
	  return function(object) {
	    return object != null && baseIsEqual(value, object[key], null, true);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 187 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` and `_.sortByAll` which uses `comparer`
	 * to define the sort order of `array` and replaces criteria objects with their
	 * corresponding values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 188 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * returned by `keysFunc`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  var index = -1,
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = object[props[index]];
	  }
	  return result;
	}
	
	module.exports = baseValues;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var constant = __webpack_require__(94),
	    isNative = __webpack_require__(11);
	
	/** Native method references. */
	var ArrayBuffer = isNative(ArrayBuffer = global.ArrayBuffer) && ArrayBuffer,
	    bufferSlice = isNative(bufferSlice = ArrayBuffer && new ArrayBuffer(0).slice) && bufferSlice,
	    floor = Math.floor,
	    Uint8Array = isNative(Uint8Array = global.Uint8Array) && Uint8Array;
	
	/** Used to clone array buffers. */
	var Float64Array = (function() {
	  // Safari 5 errors when using an array buffer to initialize a typed array
	  // where the array buffer's `byteLength` is not a multiple of the typed
	  // array's `BYTES_PER_ELEMENT`.
	  try {
	    var func = isNative(func = global.Float64Array) && func,
	        result = new func(new ArrayBuffer(10), 0, 1) && func;
	  } catch(e) {}
	  return result;
	}());
	
	/** Used as the size, in bytes, of each `Float64Array` element. */
	var FLOAT64_BYTES_PER_ELEMENT = Float64Array ? Float64Array.BYTES_PER_ELEMENT : 0;
	
	/**
	 * Creates a clone of the given array buffer.
	 *
	 * @private
	 * @param {ArrayBuffer} buffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function bufferClone(buffer) {
	  return bufferSlice.call(buffer, 0);
	}
	if (!bufferSlice) {
	  // PhantomJS has `ArrayBuffer` and `Uint8Array` but not `Float64Array`.
	  bufferClone = !(ArrayBuffer && Uint8Array) ? constant(null) : function(buffer) {
	    var byteLength = buffer.byteLength,
	        floatLength = Float64Array ? floor(byteLength / FLOAT64_BYTES_PER_ELEMENT) : 0,
	        offset = floatLength * FLOAT64_BYTES_PER_ELEMENT,
	        result = new ArrayBuffer(byteLength);
	
	    if (floatLength) {
	      var view = new Float64Array(result, 0, floatLength);
	      view.set(new Float64Array(buffer, 0, floatLength));
	    }
	    if (byteLength != offset) {
	      view = new Uint8Array(result, offset);
	      view.set(new Uint8Array(buffer, offset));
	    }
	    return result;
	  };
	}
	
	module.exports = bufferClone;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(8);
	
	/**
	 * Adds `value` to the cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var data = this.data;
	  if (typeof value == 'string' || isObject(value)) {
	    data.set.add(value);
	  } else {
	    data.hash[value] = true;
	  }
	}
	
	module.exports = cachePush;


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var baseCompareAscending = __webpack_require__(175);
	
	/**
	 * Used by `_.sortBy` to compare transformed elements of a collection and stable
	 * sort them in ascending order.
	 *
	 * @private
	 * @param {Object} object The object to compare to `other`.
	 * @param {Object} other The object to compare to `object`.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareAscending(object, other) {
	  return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	}
	
	module.exports = compareAscending;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(14),
	    baseEach = __webpack_require__(20),
	    isArray = __webpack_require__(5);
	
	/**
	 * Creates a function that aggregates a collection, creating an accumulator
	 * object composed from the results of running each element in the collection
	 * through an iteratee.
	 *
	 * @private
	 * @param {Function} setter The function to set keys and values of the accumulator object.
	 * @param {Function} [initializer] The function to initialize the accumulator object.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee, thisArg) {
	    var result = initializer ? initializer() : {};
	    iteratee = baseCallback(iteratee, thisArg, 3);
	
	    if (isArray(collection)) {
	      var index = -1,
	          length = collection.length;
	
	      while (++index < length) {
	        var value = collection[index];
	        setter(result, value, iteratee(value, index, collection), collection);
	      }
	    } else {
	      baseEach(collection, function(value, key, collection) {
	        setter(result, value, iteratee(value, key, collection), collection);
	      });
	    }
	    return result;
	  };
	}
	
	module.exports = createAggregator;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var bindCallback = __webpack_require__(15),
	    isIterateeCall = __webpack_require__(31);
	
	/**
	 * Creates a function that assigns properties of source object(s) to a given
	 * destination object.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return function() {
	    var length = arguments.length,
	        object = arguments[0];
	
	    if (length < 2 || object == null) {
	      return object;
	    }
	    if (length > 3 && isIterateeCall(arguments[1], arguments[2], arguments[3])) {
	      length = 2;
	    }
	    // Juggle arguments.
	    if (length > 3 && typeof arguments[length - 2] == 'function') {
	      var customizer = bindCallback(arguments[--length - 1], arguments[length--], 5);
	    } else if (length > 2 && typeof arguments[length - 1] == 'function') {
	      customizer = arguments[--length];
	    }
	    var index = 0;
	    while (++index < length) {
	      var source = arguments[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createAssigner;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var createCtorWrapper = __webpack_require__(51);
	
	/**
	 * Creates a function that wraps `func` and invokes it with the `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new bound function.
	 */
	function createBindWrapper(func, thisArg) {
	  var Ctor = createCtorWrapper(func);
	
	  function wrapper() {
	    return (this instanceof wrapper ? Ctor : func).apply(thisArg, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBindWrapper;


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(28),
	    composeArgs = __webpack_require__(90),
	    composeArgsRight = __webpack_require__(91),
	    createCtorWrapper = __webpack_require__(51),
	    reorder = __webpack_require__(210),
	    replaceHolders = __webpack_require__(53);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64,
	    ARY_FLAG = 256;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that wraps `func` and invokes it with optional `this`
	 * binding of, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to reference.
	 * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & ARY_FLAG,
	      isBind = bitmask & BIND_FLAG,
	      isBindKey = bitmask & BIND_KEY_FLAG,
	      isCurry = bitmask & CURRY_FLAG,
	      isCurryBound = bitmask & CURRY_BOUND_FLAG,
	      isCurryRight = bitmask & CURRY_RIGHT_FLAG;
	
	  var Ctor = !isBindKey && createCtorWrapper(func),
	      key = func;
	
	  function wrapper() {
	    // Avoid `arguments` object use disqualifying optimizations by
	    // converting it to an array before providing it to other functions.
	    var length = arguments.length,
	        index = length,
	        args = Array(length);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight);
	    }
	    if (isCurry || isCurryRight) {
	      var placeholder = wrapper.placeholder,
	          argsHolders = replaceHolders(args, placeholder);
	
	      length -= argsHolders.length;
	      if (length < arity) {
	        var newArgPos = argPos ? arrayCopy(argPos) : null,
	            newArity = nativeMax(arity - length, 0),
	            newsHolders = isCurry ? argsHolders : null,
	            newHoldersRight = isCurry ? null : argsHolders,
	            newPartials = isCurry ? args : null,
	            newPartialsRight = isCurry ? null : args;
	
	        bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	        bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	        if (!isCurryBound) {
	          bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	        }
	        var result = createHybridWrapper(func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity);
	        result.placeholder = placeholder;
	        return result;
	      }
	    }
	    var thisBinding = isBind ? thisArg : this;
	    if (isBindKey) {
	      func = thisBinding[key];
	    }
	    if (argPos) {
	      args = reorder(args, argPos);
	    }
	    if (isAry && ary < args.length) {
	      args.length = ary;
	    }
	    return (this instanceof wrapper ? (Ctor || createCtorWrapper(func)) : func).apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybridWrapper;


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var createCtorWrapper = __webpack_require__(51);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` and invokes it with the optional `this`
	 * binding of `thisArg` and the `partials` prepended to those provided to
	 * the wrapper.
	 *
	 * @private
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to the new function.
	 * @returns {Function} Returns the new bound function.
	 */
	function createPartialWrapper(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtorWrapper(func);
	
	  function wrapper() {
	    // Avoid `arguments` object use disqualifying optimizations by
	    // converting it to an array before providing it `func`.
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(argsLength + leftLength);
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return (this instanceof wrapper ? Ctor : func).apply(isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartialWrapper;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(47),
	    createBindWrapper = __webpack_require__(194),
	    createHybridWrapper = __webpack_require__(195),
	    createPartialWrapper = __webpack_require__(196),
	    getData = __webpack_require__(201),
	    mergeData = __webpack_require__(207),
	    setData = __webpack_require__(211);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to reference.
	 * @param {number} bitmask The bitmask of flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - `_.bind`
	 *     2 - `_.bindKey`
	 *     4 - `_.curry` or `_.curryRight` of a bound function
	 *     8 - `_.curry`
	 *    16 - `_.curryRight`
	 *    32 - `_.partial`
	 *    64 - `_.partialRight`
	 *   128 - `_.rearg`
	 *   256 - `_.ary`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	    partials = holders = null;
	  }
	  length -= (holders ? holders.length : 0);
	  if (bitmask & PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = null;
	  }
	  var data = !isBindKey && getData(func),
	      newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	  if (data && data !== true) {
	    mergeData(newData, data);
	    bitmask = newData[1];
	    arity = newData[9];
	  }
	  newData[9] = arity == null
	    ? (isBindKey ? 0 : func.length)
	    : (nativeMax(arity - length, 0) || 0);
	
	  if (bitmask == BIND_FLAG) {
	    var result = createBindWrapper(newData[0], newData[2]);
	  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	    result = createPartialWrapper.apply(undefined, newData);
	  } else {
	    result = createHybridWrapper.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setter(result, newData);
	}
	
	module.exports = createWrapper;


/***/ },
/* 198 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing arrays.
	 * @param {boolean} [isWhere] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, isWhere, stackA, stackB) {
	  var index = -1,
	      arrLength = array.length,
	      othLength = other.length,
	      result = true;
	
	  if (arrLength != othLength && !(isWhere && othLength > arrLength)) {
	    return false;
	  }
	  // Deep compare the contents, ignoring non-numeric properties.
	  while (result && ++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    result = undefined;
	    if (customizer) {
	      result = isWhere
	        ? customizer(othValue, arrValue, index)
	        : customizer(arrValue, othValue, index);
	    }
	    if (typeof result == 'undefined') {
	      // Recursively compare arrays (susceptible to call stack limits).
	      if (isWhere) {
	        var othIndex = othLength;
	        while (othIndex--) {
	          othValue = other[othIndex];
	          result = (arrValue && arrValue === othValue) || equalFunc(arrValue, othValue, customizer, isWhere, stackA, stackB);
	          if (result) {
	            break;
	          }
	        }
	      } else {
	        result = (arrValue && arrValue === othValue) || equalFunc(arrValue, othValue, customizer, isWhere, stackA, stackB);
	      }
	    }
	  }
	  return !!result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 199 */
/***/ function(module, exports) {

	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} value The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag) {
	  switch (tag) {
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object)
	        ? other != +other
	        // But, treat `-0` vs. `+0` as not equal.
	        : (object == 0 ? ((1 / object) == (1 / other)) : object == +other);
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(16);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isWhere] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, isWhere, stackA, stackB) {
	  var objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isWhere) {
	    return false;
	  }
	  var hasCtor,
	      index = -1;
	
	  while (++index < objLength) {
	    var key = objProps[index],
	        result = hasOwnProperty.call(other, key);
	
	    if (result) {
	      var objValue = object[key],
	          othValue = other[key];
	
	      result = undefined;
	      if (customizer) {
	        result = isWhere
	          ? customizer(othValue, objValue, key)
	          : customizer(objValue, othValue, key);
	      }
	      if (typeof result == 'undefined') {
	        // Recursively compare objects (susceptible to call stack limits).
	        result = (objValue && objValue === othValue) || equalFunc(objValue, othValue, customizer, isWhere, stackA, stackB);
	      }
	    }
	    if (!result) {
	      return false;
	    }
	    hasCtor || (hasCtor = key == 'constructor');
	  }
	  if (!hasCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor && ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalObjects;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(92),
	    noop = __webpack_require__(227);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ },
/* 202 */
/***/ function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 * If `fromRight` is provided elements of `array` are iterated from right to left.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} [fromIndex] The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromRight ? (fromIndex || length) : ((fromIndex || 0) - 1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ },
/* 203 */
/***/ function(module, exports) {

	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add array properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var bufferClone = __webpack_require__(189);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return bufferClone(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      var buffer = object.buffer;
	      return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      var result = new Ctor(object.source, reFlags.exec(object));
	      result.lastIndex = object.lastIndex;
	  }
	  return result;
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 205 */
/***/ function(module, exports) {

	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  var Ctor = object.constructor;
	  if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	    Ctor = Object;
	  }
	  return new Ctor;
	}
	
	module.exports = initCloneObject;


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(47),
	    isNative = __webpack_require__(11),
	    support = __webpack_require__(57);
	
	/** Used to detect named functions. */
	var reFuncName = /^\s*function[ \n\r\t]+\w/;
	
	/** Used to detect functions containing a `this` reference. */
	var reThis = /\bthis\b/;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/**
	 * Checks if `func` is eligible for `this` binding.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is eligible, else `false`.
	 */
	function isBindable(func) {
	  var result = !(support.funcNames ? func.name : support.funcDecomp);
	
	  if (!result) {
	    var source = fnToString.call(func);
	    if (!support.funcNames) {
	      result = !reFuncName.test(source);
	    }
	    if (!result) {
	      // Check if `func` references the `this` keyword and store the result.
	      result = reThis.test(source) || isNative(func);
	      baseSetData(func, result);
	    }
	  }
	  return result;
	}
	
	module.exports = isBindable;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(28),
	    composeArgs = __webpack_require__(90),
	    composeArgsRight = __webpack_require__(91),
	    replaceHolders = __webpack_require__(53);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_RIGHT_FLAG = 16,
	    REARG_FLAG = 128,
	    ARY_FLAG = 256;
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers required to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	 * augment function arguments, making the order in which they are executed important,
	 * preventing the merging of metadata. However, we make an exception for a safe
	 * common case where curried functions have `_.ary` and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask;
	
	  var arityFlags = ARY_FLAG | REARG_FLAG,
	      bindFlags = BIND_FLAG | BIND_KEY_FLAG,
	      comboFlags = arityFlags | bindFlags | CURRY_BOUND_FLAG | CURRY_RIGHT_FLAG;
	
	  var isAry = bitmask & ARY_FLAG && !(srcBitmask & ARY_FLAG),
	      isRearg = bitmask & REARG_FLAG && !(srcBitmask & REARG_FLAG),
	      argPos = (isRearg ? data : source)[7],
	      ary = (isAry ? data : source)[8];
	
	  var isCommon = !(bitmask >= REARG_FLAG && srcBitmask > bindFlags) &&
	    !(bitmask > bindFlags && srcBitmask >= REARG_FLAG);
	
	  var isCombo = (newBitmask >= arityFlags && newBitmask <= comboFlags) &&
	    (bitmask < REARG_FLAG || ((isRearg || isAry) && argPos.length <= ary));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = arrayCopy(value);
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(54);
	
	/**
	 * A specialized version of `_.pick` that picks `object` properties specified
	 * by the `props` array.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property names to pick.
	 * @returns {Object} Returns the new object.
	 */
	function pickByArray(object, props) {
	  object = toObject(object);
	
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index];
	    if (key in object) {
	      result[key] = object[key];
	    }
	  }
	  return result;
	}
	
	module.exports = pickByArray;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var baseForIn = __webpack_require__(180);
	
	/**
	 * A specialized version of `_.pick` that picks `object` properties `predicate`
	 * returns truthy for.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Object} Returns the new object.
	 */
	function pickByCallback(object, predicate) {
	  var result = {};
	  baseForIn(object, function(value, key, object) {
	    if (predicate(value, key, object)) {
	      result[key] = value;
	    }
	  });
	  return result;
	}
	
	module.exports = pickByCallback;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(28),
	    isIndex = __webpack_require__(30);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = arrayCopy(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(47),
	    now = __webpack_require__(78);
	
	/** Used to detect when a function becomes hot. */
	var HOT_COUNT = 150,
	    HOT_SPAN = 16;
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity function
	 * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = (function() {
	  var count = 0,
	      lastCalled = 0;
	
	  return function(key, value) {
	    var stamp = now(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return key;
	      }
	    } else {
	      count = 0;
	    }
	    return baseSetData(key, value);
	  };
	}());
	
	module.exports = setData;


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(25),
	    isArray = __webpack_require__(5),
	    isIndex = __webpack_require__(30),
	    isLength = __webpack_require__(7),
	    keysIn = __webpack_require__(56),
	    support = __webpack_require__(57);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = length && isLength(length) &&
	    (isArray(object) || (support.nonEnumArgs && isArguments(object)));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = shimKeys;


/***/ },
/* 213 */
/***/ function(module, exports) {

	/**
	 * An implementation of `_.uniq` optimized for sorted arrays without support
	 * for callback shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The function invoked per iteration.
	 * @returns {Array} Returns the new duplicate-value-free array.
	 */
	function sortedUniq(array, iteratee) {
	  var seen,
	      index = -1,
	      length = array.length,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value, index, array) : value;
	
	    if (!index || seen !== computed) {
	      seen = computed;
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = sortedUniq;


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(81),
	    bindCallback = __webpack_require__(15),
	    isIterateeCall = __webpack_require__(31);
	
	/**
	 * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	 * otherwise they are assigned by reference. If `customizer` is provided it is
	 * invoked to produce the cloned values. If `customizer` returns `undefined`
	 * cloning is handled by the method instead. The `customizer` is bound to
	 * `thisArg` and invoked with two argument; (value [, index|key, object]).
	 *
	 * **Note:** This method is loosely based on the structured clone algorithm.
	 * The enumerable properties of `arguments` objects and objects created by
	 * constructors other than `Object` are cloned to plain `Object` objects. An
	 * empty object is returned for uncloneable values such as functions, DOM nodes,
	 * Maps, Sets, and WeakMaps. See the [HTML5 specification](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {Function} [customizer] The function to customize cloning values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {*} Returns the cloned value.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * var shallow = _.clone(users);
	 * shallow[0] === users[0];
	 * // => true
	 *
	 * var deep = _.clone(users, true);
	 * deep[0] === users[0];
	 * // => false
	 *
	 * // using a customizer callback
	 * var el = _.clone(document.body, function(value) {
	 *   if (_.isElement(value)) {
	 *     return value.cloneNode(false);
	 *   }
	 * });
	 *
	 * el === document.body
	 * // => false
	 * el.nodeName
	 * // => BODY
	 * el.childNodes.length;
	 * // => 0
	 */
	function clone(value, isDeep, customizer, thisArg) {
	  if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	    isDeep = false;
	  }
	  else if (typeof isDeep == 'function') {
	    thisArg = customizer;
	    customizer = isDeep;
	    isDeep = false;
	  }
	  customizer = typeof customizer == 'function' && bindCallback(customizer, thisArg, 1);
	  return baseClone(value, isDeep, customizer);
	}
	
	module.exports = clone;


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(81),
	    bindCallback = __webpack_require__(15);
	
	/**
	 * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	 * to produce the cloned values. If `customizer` returns `undefined` cloning
	 * is handled by the method instead. The `customizer` is bound to `thisArg`
	 * and invoked with two argument; (value [, index|key, object]).
	 *
	 * **Note:** This method is loosely based on the structured clone algorithm.
	 * The enumerable properties of `arguments` objects and objects created by
	 * constructors other than `Object` are cloned to plain `Object` objects. An
	 * empty object is returned for uncloneable values such as functions, DOM nodes,
	 * Maps, Sets, and WeakMaps. See the [HTML5 specification](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to deep clone.
	 * @param {Function} [customizer] The function to customize cloning values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {*} Returns the deep cloned value.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * var deep = _.cloneDeep(users);
	 * deep[0] === users[0];
	 * // => false
	 *
	 * // using a customizer callback
	 * var el = _.cloneDeep(document.body, function(value) {
	 *   if (_.isElement(value)) {
	 *     return value.cloneNode(true);
	 *   }
	 * });
	 *
	 * el === document.body
	 * // => false
	 * el.nodeName
	 * // => BODY
	 * el.childNodes.length;
	 * // => 20
	 */
	function cloneDeep(value, customizer, thisArg) {
	  customizer = typeof customizer == 'function' && bindCallback(customizer, thisArg, 1);
	  return baseClone(value, true, customizer);
	}
	
	module.exports = cloneDeep;


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(12);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the `toStringTag` of values.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * for more details.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a boolean primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isBoolean(false);
	 * // => true
	 *
	 * _.isBoolean(null);
	 * // => false
	 */
	function isBoolean(value) {
	  return (value === true || value === false || isObjectLike(value) && objToString.call(value) == boolTag) || false;
	}
	
	module.exports = isBoolean;


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(25),
	    isArray = __webpack_require__(5),
	    isFunction = __webpack_require__(93),
	    isLength = __webpack_require__(7),
	    isObjectLike = __webpack_require__(12),
	    isString = __webpack_require__(55),
	    keys = __webpack_require__(16);
	
	/**
	 * Checks if a value is empty. A value is considered empty unless it is an
	 * `arguments` object, array, string, or jQuery-like collection with a length
	 * greater than `0` or an object with own enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {Array|Object|string} value The value to inspect.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  var length = value.length;
	  if (isLength(length) && (isArray(value) || isString(value) || isArguments(value) ||
	      (isObjectLike(value) && isFunction(value.splice)))) {
	    return !length;
	  }
	  return !keys(value).length;
	}
	
	module.exports = isEmpty;


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(46),
	    bindCallback = __webpack_require__(15),
	    isStrictComparable = __webpack_require__(52);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent. If `customizer` is provided it is invoked to compare values.
	 * If `customizer` returns `undefined` comparisons are handled by the method
	 * instead. The `customizer` is bound to `thisArg` and invoked with three
	 * arguments; (value, other [, index|key]).
	 *
	 * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	 * numbers, `Object` objects, regexes, and strings. Objects are compared by
	 * their own, not inherited, enumerable properties. Functions and DOM nodes
	 * are **not** supported. Provide a customizer function to extend support
	 * for comparing other values.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * object == other;
	 * // => false
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * // using a customizer callback
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqual(array, other, function(value, other) {
	 *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	 *     return true;
	 *   }
	 * });
	 * // => true
	 */
	function isEqual(value, other, customizer, thisArg) {
	  customizer = typeof customizer == 'function' && bindCallback(customizer, thisArg, 3);
	  if (!customizer && isStrictComparable(value) && isStrictComparable(other)) {
	    return value === other;
	  }
	  var result = customizer ? customizer(value, other) : undefined;
	  return typeof result == 'undefined' ? baseIsEqual(value, other, customizer) : !!result;
	}
	
	module.exports = isEqual;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(12);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the `toStringTag` of values.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * for more details.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	 * as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isNumber(8.4);
	 * // => true
	 *
	 * _.isNumber(NaN);
	 * // => true
	 *
	 * _.isNumber('8.4');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag) || false;
	}
	
	module.exports = isNumber;


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(7),
	    isObjectLike = __webpack_require__(12);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the `toStringTag` of values.
	 * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * for more details.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return (isObjectLike(value) && isLength(value.length) && typedArrayTags[objToString.call(value)]) || false;
	}
	
	module.exports = isTypedArray;


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssign = __webpack_require__(174),
	    createAssigner = __webpack_require__(193);
	
	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object. Subsequent sources overwrite property assignments of previous sources.
	 * If `customizer` is provided it is invoked to produce the assigned values.
	 * The `customizer` is bound to `thisArg` and invoked with five arguments;
	 * (objectValue, sourceValue, key, object, source).
	 *
	 * @static
	 * @memberOf _
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigning values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	 * // => { 'user': 'fred', 'age': 40 }
	 *
	 * // using a customizer callback
	 * var defaults = _.partialRight(_.assign, function(value, other) {
	 *   return typeof value == 'undefined' ? other : value;
	 * });
	 *
	 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var assign = createAssigner(baseAssign);
	
	module.exports = assign;


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(221);


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(80),
	    baseDifference = __webpack_require__(83),
	    baseFlatten = __webpack_require__(84),
	    bindCallback = __webpack_require__(15),
	    keysIn = __webpack_require__(56),
	    pickByArray = __webpack_require__(208),
	    pickByCallback = __webpack_require__(209);
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable properties of `object` that are not omitted.
	 * Property names may be specified as individual arguments or as arrays of
	 * property names. If `predicate` is provided it is invoked for each property
	 * of `object` omitting the properties `predicate` returns truthy for. The
	 * predicate is bound to `thisArg` and invoked with three arguments;
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|...(string|string[])} [predicate] The function invoked per
	 *  iteration or property names to omit, specified as individual property
	 *  names or arrays of property names.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'user': 'fred', 'age': 40 };
	 *
	 * _.omit(object, 'age');
	 * // => { 'user': 'fred' }
	 *
	 * _.omit(object, _.isNumber);
	 * // => { 'user': 'fred' }
	 */
	function omit(object, predicate, thisArg) {
	  if (object == null) {
	    return {};
	  }
	  if (typeof predicate != 'function') {
	    var props = arrayMap(baseFlatten(arguments, false, false, 1), String);
	    return pickByArray(object, baseDifference(keysIn(object), props));
	  }
	  predicate = bindCallback(predicate, thisArg, 3);
	  return pickByCallback(object, function(value, key, object) {
	    return !predicate(value, key, object);
	  });
	}
	
	module.exports = omit;


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(188),
	    keys = __webpack_require__(16);
	
	/**
	 * Creates an array of the own enumerable property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(88);
	
	/**
	 * Capitalizes the first character of `string`.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to capitalize.
	 * @returns {string} Returns the capitalized string.
	 * @example
	 *
	 * _.capitalize('fred');
	 * // => 'Fred'
	 */
	function capitalize(string) {
	  string = baseToString(string);
	  return string && (string.charAt(0).toUpperCase() + string.slice(1));
	}
	
	module.exports = capitalize;


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(88);
	
	/**
	 * Used to match `RegExp` special characters.
	 * See this [article on `RegExp` characters](http://www.regular-expressions.info/characters.html#special)
	 * for more details.
	 */
	var reRegExpChars = /[.*+?^${}()|[\]\/\\]/g,
	    reHasRegExpChars = RegExp(reRegExpChars.source);
	
	/**
	 * Escapes the `RegExp` special characters "\", "^", "$", ".", "|", "?", "*",
	 * "+", "(", ")", "[", "]", "{" and "}" in `string`.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escapeRegExp('[lodash](https://lodash.com/)');
	 * // => '\[lodash\]\(https://lodash\.com/\)'
	 */
	function escapeRegExp(string) {
	  string = baseToString(string);
	  return (string && reHasRegExpChars.test(string))
	    ? string.replace(reRegExpChars, '\\$&')
	    : string;
	}
	
	module.exports = escapeRegExp;


/***/ },
/* 227 */
/***/ function(module, exports) {

	/**
	 * A no-operation function which returns `undefined` regardless of the
	 * arguments it receives.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.noop(object) === undefined;
	 * // => true
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  Operation: __webpack_require__(32),
	  TextOperation: __webpack_require__(96),
	  ArrayOperation: __webpack_require__(95),
	  ObjectOperation: __webpack_require__(229)
	};


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var OO = __webpack_require__(2);
	var Substance = __webpack_require__(3);
	var PathAdapter = Substance.PathAdapter;
	
	var Operation = __webpack_require__(32);
	var TextOperation = __webpack_require__(96);
	var ArrayOperation = __webpack_require__(95);
	
	var Conflict = __webpack_require__(59);
	
	var NOP = "NOP";
	var CREATE = "create";
	var DELETE = 'delete';
	var UPDATE = 'update';
	var SET = 'set';
	
	var ObjectOperation = function(data) {
	  Operation.call(this);
	  if (!data) {
	    throw new Error('Data of ObjectOperation is missing.');
	  }
	  if (!data.type) {
	    throw new Error('Invalid data: type is mandatory.');
	  }
	  this.type = data.type;
	  if (data.type === NOP) {
	    return;
	  }
	  this.path = data.path;
	  if (!data.path) {
	    throw new Error('Invalid data: path is mandatory.');
	  }
	  if (this.type === CREATE || this.type === DELETE) {
	    if (!data.val) {
	      throw new Error('Invalid data: value is missing.');
	    }
	    this.val = data.val;
	  }
	  else if (this.type === UPDATE) {
	    if (data.diff) {
	      this.diff = data.diff;
	      if (data.diff instanceof TextOperation) {
	        this.propertyType = 'string';
	      } else if (data.diff instanceof ArrayOperation) {
	        this.propertyType = 'array';
	      } else {
	        throw new Error('Invalid data: diff must be a TextOperation or an ArrayOperation.');
	      }
	    } else {
	      throw new Error("Invalid data: diff is mandatory for update operation.");
	    }
	  }
	  else if (this.type === SET) {
	    this.val = data.val;
	    this.original = data.original;
	  } else {
	    throw new Error('Invalid type: '+ data.type);
	  }
	};
	
	ObjectOperation.fromJSON = function(data) {
	  data = _.deepclone(data);
	  if (data.type === "update") {
	    switch (data.propertyType) {
	    case "string":
	      data.diff = TextOperation.fromJSON(data.diff);
	      break;
	    case "array":
	      data.diff = ArrayOperation.fromJSON(data.diff);
	      break;
	    default:
	      throw new Error("Unsupported update diff:" + JSON.stringify(data.diff));
	    }
	  }
	  var op = new ObjectOperation(data);
	  return op;
	};
	
	ObjectOperation.Prototype = function() {
	
	  this.apply = function(obj) {
	    if (this.type === NOP) return obj;
	    var adapter;
	    if (obj instanceof PathAdapter) {
	      adapter = obj;
	    } else {
	      adapter = new PathAdapter(obj);
	    }
	    if (this.type === CREATE) {
	      adapter.set(this.path, _.deepclone(this.val));
	      return obj;
	    }
	    if (this.type === DELETE) {
	      adapter.delete(this.path, "strict");
	    }
	    else if (this.type === UPDATE) {
	      var diff = this.diff;
	      var oldVal = adapter.get(this.path);
	      var newVal;
	      if (diff instanceof ArrayOperation) {
	        newVal = diff.apply(oldVal);
	      } else {
	        newVal = diff.apply(oldVal);
	      }
	      adapter.set(this.path, newVal);
	    }
	    else /* if (this.type === SET) */ {
	      // clone here as the operations value must not be changed
	      adapter.set(this.path, _.deepclone(this.val));
	    }
	    return obj;
	  };
	
	  this.clone = function() {
	    var data = {
	      type: this.type,
	      path: this.path,
	    };
	    if (this.val) {
	      data.val = _.deepclone(this.val);
	    }
	    if (this.diff) {
	      data.diff = this.diff.clone();
	    }
	    return new ObjectOperation(data);
	  };
	
	  this.isNOP = function() {
	    if (this.type === NOP) return true;
	    else if (this.type === UPDATE) return this.diff.isNOP();
	  };
	
	  this.isCreate = function() {
	    return this.type === CREATE;
	  };
	
	  this.isDelete = function() {
	    return this.type === DELETE;
	  };
	
	  this.isUpdate = function() {
	    return this.type === UPDATE;
	  };
	
	  this.isSet = function() {
	    return this.type === SET;
	  };
	
	  this.invert = function() {
	    if (this.type === NOP) {
	      return new ObjectOperation({ type: NOP });
	    }
	    var result = new ObjectOperation(this);
	    if (this.type === CREATE) {
	      result.type = DELETE;
	    }
	    else if (this.type === DELETE) {
	      result.type = CREATE;
	    }
	    else if (this.type === UPDATE) {
	      var invertedDiff;
	      if (this.diff instanceof TextOperation) {
	        invertedDiff = TextOperation.fromJSON(this.diff.toJSON()).invert();
	      } else {
	        invertedDiff = ArrayOperation.fromJSON(this.diff.toJSON()).invert();
	      }
	      result.diff = invertedDiff;
	    }
	    else /* if (this.type === SET) */ {
	      result.val = this.original;
	      result.original = this.val;
	    }
	    return result;
	  };
	
	  this.hasConflict = function(other) {
	    return ObjectOperation.hasConflict(this, other);
	  };
	
	  this.toJSON = function() {
	    if (this.type === NOP) {
	      return { type: NOP };
	    }
	    var data = {
	      type: this.type,
	      path: this.path,
	    };
	    if (this.type === CREATE || this.type === DELETE) {
	      data.val = this.val;
	    }
	    else if (this.type === UPDATE) {
	      if (this.diff instanceof ArrayOperation) {
	        data.propertyType = "array";
	      } else /* if (this.diff instanceof TextOperation) */ {
	        data.propertyType = "string";
	      }
	      data.diff = this.diff.toJSON();
	    }
	    else /* if (this.type === SET) */ {
	      data.val = this.val;
	      data.original = this.original;
	    }
	    return data;
	  };
	
	  this.getType = function() {
	    return this.type;
	  };
	
	  this.getPath = function() {
	    return this.path;
	  };
	
	  this.getValue = function() {
	    return this.val;
	  };
	
	  this.toString = function() {
	    switch (this.type) {
	      case CREATE:
	        return ["(+,", JSON.stringify(this.path), JSON.stringify(this.val), ")"].join('');
	      case DELETE:
	        return ["(-,", JSON.stringify(this.path), JSON.stringify(this.val), ")"].join('');
	      case UPDATE:
	        return ["(>>,", JSON.stringify(this.path), this.propertyType, this.diff.toString(), ")"].join('');
	      case SET:
	        return ["(=,", JSON.stringify(this.path), this.val, this.original, ")"].join('');
	    }
	  };
	};
	
	OO.inherit(ObjectOperation, Operation);
	
	/* Low level implementation */
	
	var hasConflict = function(a, b) {
	  if (a.type === NOP || b.type === NOP) return false;
	  return _.isEqual(a.path, b.path);
	};
	
	var transform_delete_delete = function(a, b) {
	  // both operations have the same effect.
	  // the transformed operations are turned into NOPs
	  a.type = NOP;
	  b.type = NOP;
	};
	
	var transform_create_create = function() {
	  throw new Error("Can not transform two concurring creates of the same property");
	};
	
	var transform_delete_create = function() {
	  throw new Error('Illegal state: can not create and delete a value at the same time.');
	};
	
	var transform_delete_update = function(a, b, flipped) {
	  if (a.type !== DELETE) {
	    return transform_delete_update(b, a, true);
	  }
	  var op;
	  if (b.propertyType === 'string') {
	    op = TextOperation.fromJSON(b.diff);
	  } else /* if (b.propertyType === 'array') */ {
	    op = ArrayOperation.fromJSON(b.diff);
	  }
	  // (DELETE, UPDATE) is transformed into (DELETE, CREATE)
	  if (!flipped) {
	    a.type = NOP;
	    b.type = CREATE;
	    b.val = op.apply(a.val);
	  }
	  // (UPDATE, DELETE): the delete is updated to delete the updated value
	  else {
	    a.val = op.apply(a.val);
	    b.type = NOP;
	  }
	};
	
	var transform_create_update = function() {
	  // it is not possible to reasonably transform this.
	  throw new Error("Can not transform a concurring create and update of the same property");
	};
	
	var transform_update_update = function(a, b) {
	  // Note: this is a conflict the user should know about
	  var op_a, op_b, t;
	  if (b.propertyType === 'string') {
	    op_a = TextOperation.fromJSON(a.diff);
	    op_b = TextOperation.fromJSON(b.diff);
	    t = TextOperation.transform(op_a, op_b, {inplace: true});
	  } else /* if (b.propertyType === 'array') */ {
	    op_a = ArrayOperation.fromJSON(a.diff);
	    op_b = ArrayOperation.fromJSON(b.diff);
	    t = ArrayOperation.transform(op_a, op_b, {inplace: true});
	  }
	  a.diff = t[0];
	  b.diff = t[1];
	};
	
	var transform_create_set = function() {
	  throw new Error('Illegal state: can not create and set a value at the same time.');
	};
	
	var transform_delete_set = function(a, b, flipped) {
	  if (a.type !== DELETE) return transform_delete_set(b, a, true);
	  if (!flipped) {
	    a.type = NOP;
	    b.type = CREATE;
	    b.original = undefined;
	  } else {
	    a.val = b.val;
	    b.type = NOP;
	  }
	};
	
	var transform_update_set = function() {
	  throw new Error("Unresolvable conflict: update + set.");
	};
	
	var transform_set_set = function(a, b) {
	  a.type = NOP;
	  b.original = a.val;
	};
	
	var _NOP = 0;
	var _CREATE = 1;
	var _DELETE = 2;
	var _UPDATE = 4;
	var _SET = 8;
	
	var CODE = {};
	CODE[NOP] =_NOP;
	CODE[CREATE] = _CREATE;
	CODE[DELETE] = _DELETE;
	CODE[UPDATE] = _UPDATE;
	CODE[SET] = _SET;
	
	var __transform__ = [];
	__transform__[_DELETE | _DELETE] = transform_delete_delete;
	__transform__[_DELETE | _CREATE] = transform_delete_create;
	__transform__[_DELETE | _UPDATE] = transform_delete_update;
	__transform__[_CREATE | _CREATE] = transform_create_create;
	__transform__[_CREATE | _UPDATE] = transform_create_update;
	__transform__[_UPDATE | _UPDATE] = transform_update_update;
	__transform__[_CREATE | _SET   ] = transform_create_set;
	__transform__[_DELETE | _SET   ] = transform_delete_set;
	__transform__[_UPDATE | _SET   ] = transform_update_set;
	__transform__[_SET    | _SET   ] = transform_set_set;
	
	var transform = function(a, b, options) {
	  options = options || {};
	  if (options['no-conflict'] && hasConflict(a, b)) {
	    throw new Conflict(a, b);
	  }
	  if (!options.inplace) {
	    a = a.clone();
	    b = b.clone();
	  }
	  if (a.isNOP() || b.isNOP()) {
	    return [a, b];
	  }
	  var sameProp = _.isEqual(a.path, b.path);
	  // without conflict: a' = a, b' = b
	  if (sameProp) {
	    __transform__[CODE[a.type] | CODE[b.type]](a,b);
	  }
	  return [a, b];
	};
	
	ObjectOperation.transform = transform;
	ObjectOperation.hasConflict = hasConflict;
	
	/* Factories */
	
	ObjectOperation.Create = function(idOrPath, val) {
	  var path;
	  if (_.isString(idOrPath)) {
	    path = [idOrPath];
	  } else {
	    path = idOrPath;
	  }
	  return new ObjectOperation({type: CREATE, path: path, val: val});
	};
	
	ObjectOperation.Delete = function(idOrPath, val) {
	  var path;
	  if (_.isString(idOrPath)) {
	    path = [idOrPath];
	  } else {
	    path = idOrPath;
	  }
	  return new ObjectOperation({type: DELETE, path: path, val: val});
	};
	
	ObjectOperation.Update = function(path, op) {
	  var propertyType;
	  if (op instanceof TextOperation) {
	    propertyType = "string";
	  }
	  else if (op instanceof ArrayOperation) {
	    propertyType = "array";
	  }
	  else {
	    throw new Error('Unsupported type for operational changes');
	  }
	  return new ObjectOperation({
	    type: UPDATE,
	    path: path,
	    diff: op
	  });
	};
	
	ObjectOperation.Set = function(path, oldVal, newVal) {
	  return new ObjectOperation({
	    type: SET,
	    path: path,
	    val: _.deepclone(newVal),
	    original: _.deepclone(oldVal)
	  });
	};
	
	ObjectOperation.NOP = NOP;
	ObjectOperation.CREATE = CREATE;
	ObjectOperation.DELETE = DELETE;
	ObjectOperation.UPDATE = UPDATE;
	ObjectOperation.SET = SET;
	
	module.exports = ObjectOperation;


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var OO = __webpack_require__(2);
	
	// context must have a getSurface() method.
	var Clipboard = function(surfaceManager, htmlImporter, htmlExporter) {
	
	  this.surfaceManager = surfaceManager;
	  this.htmlImporter = htmlImporter;
	  this.htmlExporter = htmlExporter;
	
	  this._contentDoc = null;
	  this._contentText = "";
	
	  this._onKeyDown = _.bind(this.onKeyDown, this);
	  this._onCopy = _.bind(this.onCopy, this);
	  this._onCut = _.bind(this.onCut, this);
	
	  this.isIe = (window.navigator.userAgent.toLowerCase().indexOf("msie") != -1 || window.navigator.userAgent.toLowerCase().indexOf("trident") != -1);
	  this.isFF = window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
	
	  if (this.isIe) {
	    this._beforePasteShim = _.bind(this.beforePasteShim, this);
	    this._pasteShim = _.bind(this.pasteShim, this);
	  } else {
	    this._onPaste = _.bind(this.onPaste, this);
	  }
	
	};
	
	Clipboard.Prototype = function() {
	
	  this.getSurface = function() {
	    return this.surfaceManager.getFocusedSurface();
	  };
	
	  this.attach = function(rootElement) {
	    this.el = window.document.createElement('div');
	    this.$el = $(this.el);
	    this.$el.prop("contentEditable", "true").addClass('clipboard');
	    rootElement.appendChild(this.el);
	
	    rootElement.addEventListener('keydown', this._onKeyDown, false);
	    rootElement.addEventListener('copy', this._onCopy, false);
	    rootElement.addEventListener('cut', this._onCut, false);
	
	    if (this.isIe) {
	      rootElement.addEventListener('beforepaste', this._beforePasteShim, false);
	      rootElement.addEventListener('paste', this._pasteShim, false);
	    } else {
	      rootElement.addEventListener('paste', this._onPaste, false);
	    }
	  };
	
	  this.detach = function(rootElement) {
	    this.$el.remove();
	
	    rootElement.removeEventListener('keydown', this._onKeyDown, false);
	    rootElement.removeEventListener('copy', this._onCopy, false);
	    rootElement.removeEventListener('cut', this._onCut, false);
	    if (this.isIe) {
	      rootElement.removeEventListener('beforepaste', this._beforePasteShim, false);
	      rootElement.removeEventListener('paste', this._pasteShim, false);
	    } else {
	      rootElement.removeEventListener('paste', this._onPaste, false);
	    }
	  };
	
	  this.onCopy = function(event) {
	    // console.log("Clipboard.onCopy", arguments);
	    this._copySelection();
	    if (event.clipboardData && this._contentDoc) {
	      var html = this.htmlExporter.convert(this._contentDoc);
	      // console.log('Stored HTML in clipboard', html);
	      this._contentDoc.__id__ = _.uuid();
	      var data = this._contentDoc.toJSON();
	      data.__id__ = this._contentDoc.__id__;
	      event.clipboardData.setData('application/substance', JSON.stringify(data));
	      event.clipboardData.setData('text/plain', $(html).text());
	      event.clipboardData.setData('text/html', html);
	      event.preventDefault();
	    }
	  };
	
	  // nothing special for cut.
	  this.onCut = function(e) {
	    e.preventDefault();
	    // console.log("Clipboard.onCut", arguments);
	    this.onCopy(e);
	    var surface = this.getSurface();
	    if (!surface) return;
	    var editor = surface.getEditor();
	    surface.transaction(function(tx, args) {
	      return editor.delete(tx, args);
	    });
	  };
	
	  this.pasteSubstanceData = function(data) {
	    var surface = this.getSurface();
	    if (!surface) return;
	    var editor = surface.getEditor();
	    var doc = surface.getDocument();
	    // try {
	      var content = doc.newInstance();
	      content._setForClipboard(true);
	      content.loadSeed(JSON.parse(data));
	      var plainText = "";
	      var pasteContent = content.get('clipboard_content');
	      // TODO: try to get rid of that here.
	      // we need a document.toPlainText() for that
	      if (pasteContent.nodes.length > 0) {
	        var first = pasteContent.getFirstComponent();
	        var last = pasteContent.getLastComponent();
	        var lastLength = content.get(last.path).length;
	        var sel = doc.createSelection({
	          type: 'container',
	          containerId: 'clipboard_content',
	          startPath: first.path,
	          startOffset: 0,
	          endPath: last.path,
	          endOffset: lastLength
	        });
	        plainText = content.getTextForSelection(sel);
	      }
	      surface.transaction(function(tx, args) {
	        args.text = plainText;
	        args.doc = content;
	        return editor.paste(tx, args);
	      });
	    // } catch (error) {
	    //   console.error(error);
	    //   logger.error(error);
	    // }
	  };
	
	  this.pasteHtml = function(htmlDoc) {
	    var surface = this.getSurface();
	    if (!surface) return;
	    var editor = surface.getEditor();
	    var logger = surface.getLogger();
	    var doc = surface.getDocument();
	    try {
	      var content = doc.newInstance();
	      content._setForClipboard(true);
	      // TODO: the clipboard importer should make sure
	      // that the container exists
	      if (!content.get('clipboard_content')) {
	        content.create({
	          id: 'clipboard_content',
	          type: 'container',
	          nodes: []
	        });
	      }
	      this.htmlImporter.convert($(htmlDoc), content);
	      surface.transaction(function(tx, args) {
	        args.text = htmlDoc.body.textContent;
	        args.doc = content;
	        return editor.paste(tx, args);
	      });
	    } catch (error) {
	      console.error(error);
	      logger.error(error);
	    }
	  };
	
	  // Works on Safari/Chrome/FF
	  this.onPaste = function(e) {
	    var clipboardData = e.clipboardData;
	    var surface = this.getSurface();
	    if (!surface) return;
	    var editor = surface.getEditor();
	    var logger = surface.getLogger();
	    var types = {};
	    for (var i = 0; i < clipboardData.types.length; i++) {
	      types[clipboardData.types[i]] = true;
	    }
	
	    // HACK: FF does not provide HTML coming in from other applications
	    // so fall back to the paste shim
	    if (this.isFF && !types['application/substance'] && !types['text/html']) {
	      this.beforePasteShim();
	      surface.rerenderSelection();
	      this.pasteShim();
	      return;
	    }
	
	    e.preventDefault();
	    e.stopPropagation();
	    // console.log('Available types', types);
	
	    // use internal data if available
	    if (types['application/substance']) {
	      return this.pasteSubstanceData(clipboardData.getData('application/substance'));
	    }
	
	    // if we have content given as HTML we let the importer assess the quality first
	    // and fallback to plain text import if it's bad
	    if (types['text/html']) {
	      var html = clipboardData.getData('text/html');
	      var htmlDoc = new window.DOMParser().parseFromString(html, "text/html");
	      if (this.htmlImporter.checkQuality($(htmlDoc))) {
	        return this.pasteHtml(htmlDoc);
	      }
	    }
	    // Fallback to plain-text in other cases
	    var plainText = clipboardData.getData('text/plain');
	    if (surface.getEditor().isContainerEditor()) {
	      var doc = surface.getDocument();
	      var defaultTextType = doc.getSchema().getDefaultTextType();
	      surface.transaction(function(tx, args) {
	        // TODO: this implementation should not do this
	        // instead the 'paste' transformation should be able to do it.
	        var paraText = plainText.split(/\s*\n\s*\n/);
	        var pasteDoc = doc.newInstance();
	        pasteDoc._setForClipboard(true);
	        var container = pasteDoc.create({
	          type: 'container',
	          id: 'clipboard_content',
	          nodes: []
	        });
	        for (var i = 0; i < paraText.length; i++) {
	          var paragraph = pasteDoc.create({
	            id: _.uuid(defaultTextType),
	            type: defaultTextType,
	            content: paraText[i]
	          });
	          container.show(paragraph.id);
	        }
	        args.doc = pasteDoc;
	        return editor.paste(tx, args);
	      });
	    } else {
	      surface.transaction(function(tx, args) {
	        args.text = plainText.split('').join('');
	        return editor.insertText(tx, args);
	      });
	    }
	  };
	
	  this.beforePasteShim = function() {
	    var surface = this.getSurface();
	    if (!surface) return;
	    // console.log("Paste before...");
	    this.$el.focus();
	    var range = document.createRange();
	    range.selectNodeContents(this.el);
	    var selection = window.getSelection();
	    selection.removeAllRanges();
	    selection.addRange(range);
	  };
	
	  this.pasteShim = function() {
	    this.$el.empty();
	    var self = this;
	    var surface = this.getSurface();
	    if (!surface) return;
	    var sel = surface.getSelection();
	    setTimeout(function() {
	      surface.selection = sel;
	      var html = self.$el.html();
	      html = ['<html><head></head><body>', html, '</body></html>'].join('');
	      self.$el.empty();
	      var htmlDoc = new window.DOMParser().parseFromString(html, "text/html");
	      // if (self.htmlImporter.checkQuality($(htmlDoc))) {
	        return self.pasteHtml(htmlDoc);
	      // }
	    }, 0);
	  };
	
	  this.onKeyDown = function(e) {
	    if (e.keyCode === 88 && (e.metaKey||e.ctrlKey)) {
	      // console.log('Handle cut');
	      // this.handleCut();
	      // e.preventDefault();
	      // e.stopPropagation();
	    }
	    else if (e.keyCode === 86 && (e.metaKey||e.ctrlKey)) {
	      // console.log('Handle paste');
	      this.handlePaste();
	      // e.preventDefault();
	      // e.stopPropagation();
	    }
	    else if (e.keyCode === 67 && (e.metaKey||e.ctrlKey)) {
	      // console.log('Handle copy');
	      // this.handleCopy(e);
	      // e.preventDefault();
	      // e.stopPropagation();
	    }
	  };
	
	  this.handleCut = function() {
	    // console.log("Cutting into Clipboard...");
	    var wSel = window.getSelection();
	    // TODO: deal with multiple ranges
	    // first extract the selected content into the hidden element
	    var wRange = wSel.getRangeAt(0);
	    var frag = wRange.cloneContents();
	    this.el.innerHTML = "";
	    this.el.appendChild(frag);
	    this._copySelection();
	    var surface = this.getSurface();
	    if (!surface) return;
	    try {
	      // console.log("...selection before deletion", surface.getSelection().toString());
	      surface.getEditor().delete();
	    } catch (error) {
	      console.error(error);
	      this.logger.error(error);
	      return;
	    }
	    // select the copied content
	    var wRangeNew = window.document.createRange();
	    wRangeNew.selectNodeContents(this.el);
	    wSel.removeAllRanges();
	    wSel.addRange(wRangeNew);
	
	    // hacky way to reset the selection which gets lost otherwise
	    window.setTimeout(function() {
	      // console.log("...restoring the selection");
	      surface.rerenderDomSelection();
	    }, 10);
	  };
	
	  this.handlePaste = function() {
	  };
	
	  this.handleCopy = function() {
	    // Nothing here
	  };
	
	  this._copySelection = function() {
	    var wSel = window.getSelection();
	    this._contentText = "";
	    this._contentDoc = null;
	    var surface = this.getSurface();
	    var sel = surface.getSelection();
	    var editor = surface.getEditor();
	    var doc = surface.getDocument();
	    if (wSel.rangeCount > 0 && !sel.isCollapsed()) {
	      var wRange = wSel.getRangeAt(0);
	      this._contentText = wRange.toString();
	      this._contentDoc = editor.copy(doc, sel);
	      // console.log("Clipboard._copySelection(): created a copy", this._contentDoc);
	    } else {
	      this._contentDoc = null;
	      this._contentText = "";
	    }
	  };
	
	};
	
	OO.initClass(Clipboard);
	
	module.exports = Clipboard;


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var OO = __webpack_require__(2);
	var Document = __webpack_require__(18);
	var FormEditor = __webpack_require__(98);
	var EditingBehavior = __webpack_require__(132);
	var Annotations = Document.AnnotationUpdates;
	var Transformations = Document.Transformations;
	
	function ContainerEditor(containerId) {
	  if (!_.isString(containerId)) throw new Error("Illegal argument: Expecting container id.");
	  FormEditor.call(this);
	  this.containerId = containerId;
	  this.editingBehavior = new EditingBehavior();
	}
	
	ContainerEditor.Prototype = function() {
	
	  this.extendBehavior = function(extension) {
	    extension.register(this.editingBehavior);
	  };
	
	  this.isContainerEditor = function() {
	    return true;
	  };
	
	  this.getContainerId = function() {
	    return this.containerId;
	  };
	
	  /**
	   * Performs a `deleteSelection` tr
	   */
	  this.delete = function(tx, args) {
	    this._prepareArgs(args);
	    return Transformations.deleteSelection(tx, args);
	  };
	
	  this.break = function(tx, args) {
	    this._prepareArgs(args);
	    if (args.selection.isPropertySelection() || args.selection.isContainerSelection()) {
	      return Transformations.breakNode(tx, args);
	    }
	  };
	
	  this.insertNode = function(tx, args) {
	    this._prepareArgs(args);
	    if (args.selection.isPropertySelection() || args.selection.isContainerSelection()) {
	      return Transformations.insertNode(tx, args);
	    }
	  };
	
	  this.switchType = function(tx, args) {
	    this._prepareArgs(args);
	    if (args.selection.isPropertySelection()) {
	      return Transformations.switchTextType(tx, args);
	    }
	  };
	
	  this.selectAll = function(doc) {
	    var container = doc.get(this.containerId);
	    var first = container.getFirstComponent();
	    var last = container.getLastComponent();
	    var lastText = doc.get(last.path);
	    return doc.createSelection({
	      type: 'container',
	      containerId: this.containerId,
	      startPath: first.path,
	      startOffset: 0,
	      endPath: last.path,
	      endOffset: lastText.length
	    });
	  };
	
	  this.paste = function(tx, args) {
	    this._prepareArgs(args);
	    if (args.selection.isPropertySelection() || args.selection.isContainerSelection()) {
	      return Transformations.paste(tx, args);
	    }
	  };
	
	  this._prepareArgs = function(args) {
	    args.containerId = this.containerId;
	    args.editingBehavior = this.editingBehavior;
	  };
	
	};
	
	OO.inherit(ContainerEditor, FormEditor);
	
	module.exports = ContainerEditor;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Substance = __webpack_require__(3);
	
	// Mixin with helpers to implement a scrollable panel
	function Panel() {
	
	}
	
	Panel.Prototype = function() {
	
	  // Get the current coordinates of the first element in the
	  // set of matched elements, relative to the offset parent
	  // Please be aware that it looks up until it finds a parent that has
	  // position: relative|absolute set. So for now never set relative somewhere in your panel
	  this.getPanelOffsetForElement = function(el) {
	    var offsetTop = $(el).position().top;
	    return offsetTop;
	  };
	
	  this.scrollToNode = function(nodeId) {
	    // var n = this.findNodeView(nodeId);
	    // TODO make this generic
	    var panelContentEl = this.getScrollableContainer();
	
	    // Node we want to scroll to
	    var targetNode = $(panelContentEl).find("*[data-id="+nodeId+"]")[0];
	
	    if (targetNode) {
	      $(panelContentEl).scrollTop(this.getPanelOffsetForElement(targetNode));
	    } else {
	      console.warn(nodeId, 'not found in scrollable container');
	    }
	  };
	
	};
	
	Substance.initClass(Panel);
	module.exports = Panel;
	
	


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var OO = __webpack_require__(2);
	var _ = __webpack_require__(1);
	var Surface = __webpack_require__(100);
	var EventEmitter = __webpack_require__(27);
	
	var SurfaceManager = function(doc) {
	  EventEmitter.call(this);
	  this.doc = doc;
	  this.surfaces = {};
	  this.focusedSurface = null;
	  this.stack = [];
	  doc.connect(this, { 'document:changed': this.onDocumentChange }, {
	    //lower priority so that everyting is up2date
	    //when we render the selection
	    priority: -1
	  });
	};
	
	SurfaceManager.Prototype = function() {
	
	  this.dispose = function() {
	    this.doc.disconnect(this);
	    this.surfaces = {};
	  };
	
	  this.createSurface = function(editor, options) {
	    return new Surface(this, editor, options);
	  };
	
	  this.registerSurface = function(surface) {
	    surface.connect(this, {
	      'selection:changed': this.onSelectionChanged
	    });
	    this.surfaces[surface.getName()] = surface;
	  };
	
	  this.unregisterSurface = function(surface) {
	    surface.disconnect(this);
	    delete this.surfaces[surface.getName()];
	    if (surface && this.focusedSurface === surface) {
	      this.focusedSurface = null;
	    }
	  };
	
	  this.hasSurfaces = function() {
	    return Object.keys(this.surfaces).length > 0;
	  };
	
	  this.didFocus = function(surface) {
	    if (this.focusedSurface && surface !== this.focusedSurface) {
	      this.focusedSurface.setFocused(false);
	    }
	    this.focusedSurface = surface;
	  };
	
	  this.getFocusedSurface = function() {
	    return this.focusedSurface;
	  };
	
	  this.onDocumentChange = function(change, info) {
	    if (info.replay) {
	      var selection = change.after.selection;
	      var surfaceId = change.after.surfaceId;
	      if (surfaceId) {
	        var surface = this.surfaces[surfaceId];
	        if (surface) {
	          if (this.focusedSurface !== surface) {
	            this.didFocus(surface);
	          }
	          surface.setSelection(selection);
	        } else {
	          console.warn('No surface with name', surfaceId);
	        }
	      }
	    }
	  };
	
	  this.onSelectionChanged = function(sel, surface) {
	    this.emit('selection:changed', sel, surface);
	  };
	
	  this.pushState = function() {
	    var state = {
	      surface: this.focusedSurface,
	      selection: null
	    }
	    if (this.focusedSurface) {
	      state.selection = this.focusedSurface.getSelection();
	    }
	    this.focusedSurface = null;
	    this.stack.push(state);
	  };
	
	  this.popState = function() {
	    var state = this.stack.pop();
	    if (state && state.surface) {
	      state.surface.setFocused(true);
	      state.surface.setSelection(state.selection);
	    }
	  };
	
	};
	
	OO.inherit(SurfaceManager, EventEmitter);
	
	module.exports = SurfaceManager;


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	var Substance = __webpack_require__(3);
	var Tool = __webpack_require__(9);
	
	function SwitchTypeTool() {
	  Tool.call(this);
	}
	
	SwitchTypeTool.Prototype = function() {
	
	  // Provides the type of the associated annotation node.
	  // The default implementation uses the Tool's static name.
	  // Override this method to customize.
	  this.getNodeType = function() {
	    if (this.constructor.static.name) {
	      return this.constructor.static.name;
	    } else {
	      throw new Error('Contract: SwitchTypeTool.static.name should be associated to a document annotation type.');
	    }
	  };
	
	  this.getData = function() {
	    return {};
	  };
	
	  this.matchNode = function(node) {
	    return (node.type === this.getNodeType());
	  };
	
	  this.update = function(surface, sel) {
	    this.surface = surface;
	    if (!surface.isEnabled() || sel.isNull() || sel.isContainerSelection() ||
	        !surface.getEditor().isContainerEditor()) {
	      return this.setDisabled();
	    }
	    var container = surface.getEditor().getContainer();
	    var node = container.getNodeForComponentPath(sel.start.path);
	    if (this.matchNode(node)) {
	      return this.setToolState({
	        enabled: true,
	        selected: true
	      });
	    } else if (node.isInstanceOf('text')) {
	      return this.setToolState({
	        enabled: true,
	        selected: true,
	        sel: sel,
	        node: node,
	        mode: "switch"
	      });
	    }
	  };
	
	  this.performAction = function() {
	    var state = this.getToolState();
	    if (state.mode === "switch") {
	      this.surface.getEditor().switchType(state.sel, this.getNodeType(), this.getData());
	    }
	  };
	};
	
	Substance.inherit(SwitchTypeTool, Tool);
	
	module.exports = SwitchTypeTool;


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	var Substance = __webpack_require__(3);
	var Document = __webpack_require__(18);
	var NodeView = __webpack_require__(60);
	var AnnotationView = __webpack_require__(97);
	var Annotator = Document.Annotator;
	
	// Basic implementation of a text property.
	//
	
	function TextProperty() {}
	
	TextProperty.Prototype = function() {
	
	  this.getSurface = function() {
	    throw new Error('This is abstract');
	  };
	
	  this.getDocument = function() {
	    var surface = this.getSurface();
	    if (!surface) {
	      return null;
	    } else {
	      return surface.getDocument();
	    }
	  };
	
	  this.getPath = function() {
	    throw new Error('This is abstract');
	  };
	
	  /*
	    Add these when creating the element
	      class: 'text-property'
	      style: "whiteSpace: pre-wrap;"
	      'data-path': path.join('.')
	   */
	  this.getElement = function() {
	    throw new Error('This is abstract');
	  };
	
	  // Override this if you want to add app-specific annotations, such as highlights
	  this.getAnnotations = function() {
	    var doc = this.getDocument();
	    var path = this.getPath();
	    return doc.getIndex('annotations').get(path);
	  };
	
	  this.attach = function() {
	    var doc = this.getDocument();
	    var path = this.getPath();
	    doc.getEventProxy('path').add(path, this, this.propertyDidChange);
	  };
	
	  this.detach = function() {
	    var doc = this.getDocument();
	    var path = this.getPath();
	    doc.getEventProxy('path').remove(path, this);
	  };
	
	  this.renderContent = function() {
	    var doc = this.getDocument();
	    var domNode = this.getElement();
	    if (!domNode) { return; }
	    var contentView = new TextProperty.ContentView({
	      doc: doc,
	      children: this.renderChildren()
	    });
	    var fragment = contentView.render();
	    // Add a <br> so that the node gets rendered when empty and Contenteditable will stop when moving the cursor.
	    // TODO: probably this is not good when using the property inline.
	    fragment.appendChild(document.createElement('br'));
	    domNode.innerHTML = "";
	    domNode.appendChild(fragment);
	  };
	
	  this.renderChildren = function() {
	    var doc = this.getDocument();
	    var path = this.getPath();
	    var text = doc.get(path) || "";
	
	    var annotations = this.getAnnotations();
	
	    var annotator = new Annotator();
	    annotator.onText = function(context, text) {
	      context.children.push(text);
	    };
	    annotator.onEnter = function(entry) {
	      var node = entry.node;
	      // TODO: we need a component factory, so that we can create the appropriate component
	      var ViewClass = AnnotationView;
	      var classNames = [];
	      return {
	        ViewClass: ViewClass,
	        props: {
	          doc: doc,
	          node: node,
	          classNames: classNames,
	        },
	        children: []
	      };
	    };
	    annotator.onExit = function(entry, context, parentContext) {
	      var props = context.props;
	      props.children = context.children;
	      var view = new context.ViewClass(props);
	      parentContext.children.push(view);
	    };
	    var root = { children: [] };
	    annotator.start(root, text, annotations);
	    return root.children;
	  };
	
	  this.propertyDidChange = function(change, info) {
	    // Note: Surface provides the source element as element
	    // whenever editing is done by Contenteditable (as opposed to programmatically)
	    // In that case we trust in CE and do not rerender.
	    if (info.source === this.getElement()) {
	      console.log('Skipping update...');
	      // NOTE: this hack triggers a rerender of the text-property
	      // after a burst of changes. Atm, we let CE do incremental rendering,
	      // which is important for a good UX. However CE sometimes does undesired
	      // things which can lead to a slight diversion of model and view.
	      // Using this hack we can stick to the trivial rerender based implementation
	      // of TextProperty as opposed to an incremental version.
	      if (info.surface && info.typing) {
	        if (!this._debouncedRerender) {
	          var INTERVAL = 200; //ms
	          var self = this;
	          this._debouncedRerender = Substance.debounce(function() {
	            var doc = this.getDocument();
	            // as this get called delayed it can happen
	            // that this element has been deleted in the mean time
	            if (doc) {
	              self.renderContent();
	              info.surface.rerenderDomSelection();
	            }
	          }, INTERVAL);
	        }
	        this._debouncedRerender();
	        return;
	      }
	    }
	    // For now, we stick to rerendering as opposed to incremental rendering.
	    // As long the user is not editing this property this strategy is sufficient.
	    // For the editing the above strategy is applied.
	    this.renderContent();
	
	    if (info.source === this.getElement() && info.surface) {
	      setTimeout(function() {
	        info.surface.rerenderDomSelection();
	      });
	    }
	  };
	};
	
	Substance.initClass(TextProperty);
	
	TextProperty.ContentView = NodeView.extend({
	  createElement: function() {
	    return document.createDocumentFragment();
	  }
	});
	
	module.exports = TextProperty;


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var Substance = __webpack_require__(3);
	var _ = Substance._;
	
	var ToolRegistry = function() {
	  Substance.Registry.call(this);
	};
	
	ToolRegistry.Prototype = function() {
	
	  this.dispose = function() {
	    this.each(function(tool) {
	      if (tool.dispose) {
	        tool.dispose();
	      }
	    });
	    this.clear();
	  };
	
	};
	
	Substance.inherit(ToolRegistry, Substance.Registry);
	
	module.exports = ToolRegistry;


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Tool = __webpack_require__(9);
	
	var DeleteColumnsTool = Tool.extend({
	
	  name: "delete_columns",
	
	  update: function(surface, sel) {
	    this.surface = surface; // IMPORTANT!
	    // Set disabled when not a property selection
	    if (!surface.isEnabled() || sel.isNull() || !sel.isTableSelection()) {
	      return this.setDisabled();
	    }
	    this.setToolState({
	      surface: surface,
	      sel: sel,
	      disabled: false
	    });
	  },
	
	  performAction: function(options) {
	    this.surface.transaction(function(tx, args) {
	      console.log('TODO: delete columns', options);
	      return args;
	    });
	  },
	
	});
	
	module.exports = DeleteColumnsTool;


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Tool = __webpack_require__(9);
	
	var DeleteRowsTool = Tool.extend({
	
	  name: "delete_rows",
	
	  update: function(surface, sel) {
	    this.surface = surface; // IMPORTANT!
	    // Set disabled when not a property selection
	    if (!surface.isEnabled() || sel.isNull() || !sel.isTableSelection()) {
	      return this.setDisabled();
	    }
	    this.setToolState({
	      surface: surface,
	      sel: sel,
	      disabled: false
	    });
	  },
	
	  performAction: function(options) {
	    this.surface.transaction(function(tx, args) {
	      console.log('TODO: delete rows', options);
	      return args;
	    });
	  },
	
	});
	
	module.exports = DeleteRowsTool;


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var AnnotationTool = __webpack_require__(33);
	
	var EmphasisTool = AnnotationTool.extend({
	  name: "emphasis"
	});
	
	module.exports = EmphasisTool;


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  Undo: __webpack_require__(247),
	  Redo: __webpack_require__(244),
	  Emphasis: __webpack_require__(239),
	  Strong: __webpack_require__(245),
	  Link: __webpack_require__(243),
	  SwitchTextType: __webpack_require__(246),
	  InsertRows: __webpack_require__(242),
	  DeleteRows: __webpack_require__(238),
	  InsertColumns: __webpack_require__(241),
	  DeleteColumns: __webpack_require__(237),
	};

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Tool = __webpack_require__(9);
	
	var InsertColumnsTool = Tool.extend({
	
	  name: "insert_columns",
	
	  update: function(surface, sel) {
	    this.surface = surface; // IMPORTANT!
	    // Set disabled when not a property selection
	    if (!surface.isEnabled() || sel.isNull() || !sel.isTableSelection()) {
	      return this.setDisabled();
	    }
	    this.setToolState({
	      surface: surface,
	      sel: sel,
	      disabled: false
	    });
	  },
	
	  performAction: function(options) {
	    this.surface.transaction(function(tx, args) {
	      console.log('TODO: insert columns', options);
	      return args;
	    });
	  },
	
	});
	
	module.exports = InsertColumnsTool;


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Tool = __webpack_require__(9);
	
	var InsertRowsTool = Tool.extend({
	
	  name: "insert_rows",
	
	  update: function(surface, sel) {
	    this.surface = surface; // IMPORTANT!
	    // Set disabled when not a property selection
	    if (!surface.isEnabled() || sel.isNull() || !sel.isTableSelection()) {
	      return this.setDisabled();
	    }
	    this.setToolState({
	      surface: surface,
	      sel: sel,
	      disabled: false
	    });
	  },
	
	  performAction: function(options) {
	    this.surface.transaction(function(tx, args) {
	      console.log('TODO: insert rows', options);
	      return args;
	    });
	  },
	
	});
	
	module.exports = InsertRowsTool;


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(153);
	var AnnotationTool = __webpack_require__(33);
	var LinkTool = AnnotationTool.extend({
	
	  name: "link",
	
	  getAnnotationData: function() {
	    return {
	      url: "",
	      title: ""
	    };
	  },
	
	  // Immediately switch to edit mode after link creation
	  // and make it show the edit prompt.
	  afterCreate: function(anno) {
	    var state = this.getToolState();
	    var newState = _.extend({}, state);
	    newState.mode = 'edit';
	    newState.showPrompt = true;
	    this.setToolState(newState);
	  },
	  
	  update: function(surface, sel) {
	    this.surface = surface;
	    if ( !surface.isEnabled() || sel.isNull() || sel.isContainerSelection() ) {
	      return this.setDisabled();
	    }
	    var doc = this.getDocument();
	    var annos = doc.getAnnotationsForSelection(sel, { type: 'link' });
	    var oldState = this.getToolState();
	    var newState = {
	      surface: surface,
	      disabled: false,
	      active: false,
	      mode: null,
	      sel: sel,
	      annos: annos
	    };
	    if (this.canCreate(annos, sel)) {
	      newState.mode = "create";
	    } else if (this.canTruncate(annos, sel)) {
	      newState.mode = "truncate";
	      newState.active = true;
	    } else if (this.canExpand(annos, sel)) {
	      newState.mode = "expand";
	    } else if (annos.length === 1) {
	      newState.mode = "edit";
	      newState.linkId = annos[0].id;
	      newState.active = true;
	    } else {
	      return this.setDisabled();
	    }
	    this.setToolState(newState);
	  },
	
	  updateLink: function(linkAttrs) {
	    var doc = this.getDocument();
	    var link = this.getLink();
	    // this.surface.transaction causes the prompt to close. If you don't want that
	    // e.g. when re-enabling link title editing, switch to use doc.transaction.
	    // QUESTION: Is it possible to use this.surface.transaction without causing the
	    // prompt to close. -> Probably by changing the update implementation above
	    // to preserve the showPrompt variable
	    this.surface.transaction(function(tx) {
	      tx.set([link.id, "url"], linkAttrs.url);
	      tx.set([link.id, "title"], linkAttrs.title);
	    });
	  },
	
	  deleteLink: function() {
	    var doc = this.getDocument();
	    var link = this.getLink();
	    this.surface.transaction(function(tx) {
	      tx.delete(link.id);
	    });
	  },
	
	  getLink: function() {
	    return this.getDocument().get(this.state.linkId);
	  },
	
	  performAction: function() {
	    var state = this.getToolState();
	    var newState = _.extend({}, state);
	    if (state.mode === "edit") {
	      newState.showPrompt = !state.showPrompt;
	      this.setToolState(newState);
	    } else {
	      AnnotationTool.prototype.performAction.call(this);
	    }
	  },
	
	});
	
	module.exports = LinkTool;


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	var Tool = __webpack_require__(9);
	
	var RedoTool = Tool.extend({
	
	  name: "redo",
	
	  update: function(surface) {
	    this.surface = surface;
	    var doc = surface.getDocument();
	    if (!surface.isEnabled() || doc.undone.length===0) {
	      this.setDisabled();
	    } else {
	      this.setEnabled();
	    }
	  },
	
	  performAction: function() {
	    var doc = this.getDocument();
	    if (this.isEnabled() && doc.undone.length>0) {
	      doc.redo();
	    }
	  }
	
	});
	
	module.exports = RedoTool;


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var AnnotationTool = __webpack_require__(33);
	
	var StrongTool = AnnotationTool.extend({
	  name: "strong"
	});
	
	module.exports = StrongTool;


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Tool = __webpack_require__(9);
	
	var TEXT_NODE_TYPES = ["paragraph", "heading", "blockquote", "codeblock"];
	
	var TEXT_TYPES = {
	  "paragraph": {label: 'Paragraph', data: {type: "paragraph"}},
	  "heading1": {label: 'Heading 1', data: {type: "heading", level: 1}},
	  "heading2": {label: 'Heading 2', data: {type: "heading", level: 2}},
	  "heading3": {label: 'Heading 3', data: {type: "heading", level: 3}},
	  "blockquote": {label: 'Blockquote', data: {type: "blockquote"}},
	  "codeblock": {label: 'Codeblock', data: {type: "codeblock"}}
	};
	
	var TextTool = Tool.extend({
	  name: "text",
	
	  update: function(surface, sel) {
	    this.surface = surface; // IMPORTANT!
	    // Set disabled when not a property selection
	    if (!surface.isEnabled() || sel.isNull()) {
	      return this.setDisabled();
	    }
	    if (sel.isTableSelection()) {
	      return this.setToolState({
	        disabled: true,
	        currentContext: 'table'
	      });
	    } else if (sel.isContainerSelection()) {
	      return this.setToolState({
	        disabled: true,
	        currentContext: 'container'
	      });
	    }
	
	    var doc = this.getDocument();
	    var path = sel.getPath();
	    var node = doc.get(path[0]);
	    var textType = this.getTextType(node);
	    var parentNode = node.getRoot();
	    var currentContext = this.getContext(parentNode, path);
	
	    var newState = {
	      surface: surface,
	      sel: sel,
	      disabled: !textType,
	      currentTextType: textType,
	      currentContext: currentContext,
	    };
	
	    this.setToolState(newState);
	  },
	
	  getAvailableTextTypes: function() {
	    return TEXT_TYPES;
	  },
	
	  isTextType: function(type) {
	    return TEXT_NODE_TYPES.indexOf(type) >= 0;
	  },
	
	  // Get text type for a given node
	  getTextType: function(node) {
	    if (this.isTextType(node.type)) {
	      var textType = node.type;
	      if (textType === "heading") {
	        textType += node.level;
	      }
	      return textType;
	    }
	  },
	
	  switchTextType: function(textTypeName) {
	    var state = this.getToolState();
	    if (this.isDisabled()) return;
	
	    var textType = TEXT_TYPES[textTypeName];
	    var surface = state.surface;
	    var editor = surface.getEditor();
	
	    surface.transaction(function(tx, args) {
	      args.data = textType.data;
	      return editor.switchType(tx, args);
	    });
	  },
	
	  getContext: function(parentNode, path) {
	    if (parentNode.id === path[0]) {
	      return path[1];
	    } else {
	      return parentNode.type;
	    }
	  },
	
	});
	
	module.exports = TextTool;


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	var Tool = __webpack_require__(9);
	
	var UndoTool = Tool.extend({
	
	  name: "undo",
	
	  update: function(surface) {
	    this.surface = surface;
	    var doc = surface.getDocument();
	    if (!surface.isEnabled() || doc.done.length===0) {
	      this.setDisabled();
	    } else {
	      this.setEnabled();
	    }
	  },
	
	  performAction: function() {
	    var doc = this.getDocument();
	    if (this.isEnabled() && doc.done.length>0) {
	      doc.undo();
	    }
	  }
	
	});
	
	module.exports = UndoTool;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var Component = __webpack_require__(4);
	var $$ = Component.$$;
	
	var ToolComponent = __webpack_require__(103);
	var TextToolComponent = __webpack_require__(261);
	var LinkToolComponent = __webpack_require__(260);
	var Icon = __webpack_require__(251);
	
	var DefaultToolbar = Component.extend({
	
	  displayName: "DefaultToolbar",
	
	  render: function() {
	    var el = $$('div').addClass('toolbar');
	    el.append(
	      $$(TextToolComponent, { tool: 'text', 'title': 'Switch text'}),
	      $$(ToolComponent, {tool: 'undo', 'title': 'Undo'})
	        .append($$(Icon, {icon: "fa-undo"})),
	      $$(ToolComponent, {tool: 'redo', 'title': 'Redo'})
	        .append($$(Icon, {icon: "fa-repeat"})),
	      $$(ToolComponent).addProps({tool: 'emphasis', 'title': 'Emphasis'})
	        .append($$(Icon).addProps({icon: "fa-italic"})),
	      $$(ToolComponent).addProps({tool: 'strong', 'title': 'Strong'})
	        .append($$(Icon).addProps({icon: "fa-bold"})),
	      $$(LinkToolComponent).addProps({
	        tool: 'link',
	        'title': 'Link',
	        children: [$$(Icon).addProps({icon: "fa-link"})]
	      }).addClass('tool')
	    );
	    return el;
	  }
	});
	
	module.exports = DefaultToolbar;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var Component = __webpack_require__(4);
	var Surface = __webpack_require__(99);
	var Registry = __webpack_require__(34);
	var ContainerComponent = __webpack_require__(254);
	var SubstanceArticle = __webpack_require__(118);
	var DefaultToolbar = __webpack_require__(248);
	var ListEditing = __webpack_require__(148);
	
	var $$ = Component.$$;
	var Clipboard = Surface.Clipboard;
	var SurfaceManager = Surface.SurfaceManager;
	var ContainerEditor = Surface.ContainerEditor;
	
	var defaultComponents = {
	  "paragraph": __webpack_require__(258),
	  "heading": __webpack_require__(255),
	  "blockquote": __webpack_require__(252),
	  "codeblock": __webpack_require__(253),
	  "list": __webpack_require__(257),
	  "link": __webpack_require__(256)
	};
	
	var defaultTools = Surface.Tools;
	
	// TODO: discuss how to organize editor extensions
	var editingBehavior = [ new ListEditing() ];
	
	// Editor
	// ----------------
	//
	// A simple rich text editor implementation based on Substance
	
	var Editor = Component.extend({
	
	  displayName: "Editor",
	
	  didInitialize: function() {
	    if (!this.config) this.config = {};
	
	    var ArticleClass = this.config.article || SubstanceArticle;
	    var components = this.config.components || defaultComponents;
	    var tools = this.config.tools || defaultTools;
	
	    this.doc = new ArticleClass();
	    this.doc.loadHtml(this.props.content);
	
	    // Editing Surface
	    this.surfaceManager = new SurfaceManager(this.doc);
	    this.clipboard = new Clipboard(this.surfaceManager, this.doc.getClipboardImporter(), this.doc.getClipboardExporter());
	    this.editor = new ContainerEditor('body');
	
	    // Editing behavior
	    _.each(editingBehavior, function(behavior) {
	      this.editor.extendBehavior(behavior);
	    }, this);
	
	    // Component registry
	    this.componentRegistry = new Registry();
	    _.each(components, function(ComponentClass, name) {
	      this.componentRegistry.add(name, ComponentClass);
	    }, this);
	
	    // Tool registry
	    this.toolRegistry = new Registry();
	    _.each(tools, function(ToolClass) {
	      this.toolRegistry.add(ToolClass.static.name, new ToolClass());
	    }, this);
	
	    // Dependency Injection
	    this.childContext = {
	      componentRegistry: this.componentRegistry,
	      toolRegistry: this.toolRegistry,
	      surfaceManager: this.surfaceManager
	    };
	  },
	
	  render: function() {
	    var el = $$('div').addClass('editor-component');
	
	    // Toolbar
	    var ToolbarClass = this.config.toolbar || DefaultToolbar;
	    var toolbar = $$(ToolbarClass);
	    toolbar.key('toolbar');
	    el.append(toolbar);
	
	    // Content Container
	    el.append($$(ContainerComponent)
	      .key('bodyContainer')
	      .attr({ contentEditable: true })
	      .addProps({
	        doc: this.doc,
	        node: this.doc.get('body'),
	        editor: this.editor
	      })
	    );
	    return el;
	  },
	
	  didReceiveProps: function() {
	    if (this.doc.toHtml() !== this.props.content) {
	      this.doc.loadHtml(this.props.content);
	    }
	  },
	
	  didMount: function() {
	    this.surfaceManager.on('selection:changed', this.onSelectionChanged, this);
	    this.clipboard.attach(this.$el[0]);
	  },
	
	  willUnmount: function() {
	    this.dispose();
	  },
	
	  dispose: function() {
	    var clipboard = this.clipboard;
	    var surfaceManager = this.surfaceManager;
	    if (clipboard) clipboard.detach(this.$el[0]);
	    if (surfaceManager) surfaceManager.dispose();
	  },
	
	  getContent: function() {
	    return this.doc.toHtml();
	  },
	
	  getDocument: function() {
	    return this.doc;
	  },
	
	  onSelectionChanged: function(sel, surface) {
	    this.toolRegistry.each(function(tool) {
	      tool.update(surface, sel);
	    }, this);
	  }
	});
	
	module.exports = Editor;


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	var Editor = __webpack_require__(249);
	module.exports = Editor;


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var OO = __webpack_require__(2);
	var Component = __webpack_require__(4);
	var $$ = Component.$$;
	
	function FontAwesomeIcon() {
	  Component.Container.apply(this, arguments);
	}
	
	FontAwesomeIcon.Prototype = function() {
	  this.render = function() {
	    return $$('i').addClass('fa ' + this.props.icon);
	  };
	};
	
	OO.inherit(FontAwesomeIcon, Component.Container);
	
	module.exports = FontAwesomeIcon;


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var OO = __webpack_require__(2);
	var Component = __webpack_require__(4);
	var $$ = Component.$$;
	var TextProperty = __webpack_require__(26);
	
	function Blockquote() {
	  Component.apply(this, arguments);
	}
	
	Blockquote.Prototype = function() {
	
	  this.getClassNames = function() {
	    return "content-node blockquote";
	  };
	
	  this.render = function() {
	    return $$('div')
	      .addClass(this.getClassNames())
	      .attr("data-id", this.props.node.id)
	      .append($$(TextProperty)
	        .addProps({
	          doc: this.props.doc,
	          path: [ this.props.node.id, "content"]
	        })
	      );
	  };
	};
	
	OO.inherit(Blockquote, Component);
	
	module.exports = Blockquote;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var OO = __webpack_require__(2);
	var Component = __webpack_require__(4);
	var $$ = Component.$$;
	var TextProperty = __webpack_require__(26);
	
	function Codeblock() {
	  Component.apply(this, arguments);
	}
	
	Codeblock.Prototype = function() {
	
	  this.getClassNames = function() {
	    return "content-node codeblock";
	  };
	
	  this.render = function() {
	    return $$('div')
	      .addClass(this.getClassNames())
	      .attr("data-id", this.props.node.id)
	      .append($$(TextProperty)
	        .addProps({
	          doc: this.props.doc,
	          path: [ this.props.node.id, "content"]
	        })
	      );
	  };
	};
	
	OO.inherit(Codeblock, Component);
	
	module.exports = Codeblock;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var OO = __webpack_require__(2);
	var Component = __webpack_require__(4);
	var $$ = Component.$$;
	var UnsupporedNode = __webpack_require__(259);
	var Surface = __webpack_require__(99);
	
	function ContainerNodeComponent() {
	  Component.apply(this, arguments);
	
	  // calling this here for initialization
	  this._initialize();
	}
	
	ContainerNodeComponent.Prototype = function() {
	
	  this.getChildContext = function() {
	    return {
	      surface: this.surface
	    };
	  };
	
	  this.render = function() {
	    var el = $$("div")
	      .addClass("container-node " + this.props.node.id)
	      .attr({
	        spellCheck: false,
	        "data-id": this.props.node.id
	      });
	    el.append(this.renderComponents());
	    return el;
	  };
	
	  this.renderComponents = function() {
	    var doc = this.props.doc;
	    var containerNode = this.props.node;
	    var componentRegistry = this.context.componentRegistry;
	    return containerNode.nodes.map(function(nodeId) {
	      var node = doc.get(nodeId);
	      var ComponentClass = componentRegistry.get(node.type);
	      if (!ComponentClass) {
	        console.error('Could not resolve a component for type: ' + node.type);
	        ComponentClass = UnsupporedNode;
	      }
	      return $$(ComponentClass).key(node.id).addProps({
	        doc: doc,
	        node: node
	      });
	    });
	  };
	
	  this.willReceiveProps = function(newProps) {
	    if (this.props.doc && this.props.doc !== newProps.doc) {
	      this.surface.detach();
	    }
	  };
	
	  this.didReceiveProps = function() {
	    this._initialize();
	  };
	
	  this.didMount = function() {
	    this.props.doc.connect(this, {
	      'document:changed': this.onDocumentChange
	    });
	    this.surface.attach(this.$el[0]);
	  };
	
	  this.willUnmount = function() {
	    this.props.doc.disconnect(this);
	    this.surface.detach();
	  };
	
	  this.onDocumentChange = function(change) {
	    // TODO: update the DOM element incrementally
	    if (change.isAffected([this.props.node.id, 'nodes'])) {
	      this.rerender();
	    }
	  };
	
	  this._initialize = function() {
	    var doc = this.props.doc;
	    var editor = this.props.editor;
	    var options = {
	      name: this.props.node.id,
	      logger: this.context.notifications
	    };
	    this.surface = new Surface(this.context.surfaceManager, doc, editor, options);
	  };
	};
	
	OO.inherit(ContainerNodeComponent, Component);
	
	module.exports = ContainerNodeComponent;


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var OO = __webpack_require__(2);
	var Component = __webpack_require__(4);
	var $$ = Component.$$;
	var TextProperty = __webpack_require__(26);
	
	function HeadingComponent() {
	  Component.apply(this, arguments);
	}
	
	HeadingComponent.Prototype = function() {
	
	  this.render = function() {
	    return $$('div')
	      .addClass("content-node heading level-"+this.props.node.level)
	      .attr("data-id", this.props.node.id)
	      .append($$(TextProperty)
	        .addProps({
	          doc: this.props.doc,
	          path: [ this.props.node.id, "content"]
	        })
	      );
	  };
	};
	
	OO.inherit(HeadingComponent, Component);
	
	module.exports = HeadingComponent;


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var AnnotationComponent = __webpack_require__(102);
	
	var LinkComponent = AnnotationComponent.extend({
	
	  displayName: "LinkComponent",
	
	  render: function() {
	    var el = AnnotationComponent.prototype.render.call(this);
	    var titleComps = [this.props.node.url];
	    if (this.props.node.title) {
	      titleComps.push(this.props.node.title);
	    }
	
	    return el.attr("title", titleComps.join(' | '));
	  },
	
	  didMount: function() {
	    AnnotationComponent.prototype.didMount.call(this);
	    var node = this.props.node;
	    this.doc = node.getDocument();
	    this.doc.getEventProxy('path').add([node.id, 'title'], this, this.rerender);
	    this.doc.getEventProxy('path').add([node.id, 'url'], this, this.rerender);
	  },
	
	  willUnmount: function() {
	    AnnotationComponent.prototype.willUnmount.call(this);
	    this.doc.getEventProxy('path').remove([this.props.node.id, 'title'], this);
	    this.doc.getEventProxy('path').remove([this.props.node.id, 'url'], this);
	  }
	
	});
	
	module.exports = LinkComponent;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// var _ = require('../../basics/helpers');
	var Component = __webpack_require__(4);
	var $$ = Component.$$;
	var TextProperty = __webpack_require__(26);
	var List = __webpack_require__(72);
	
	var ListComponent = Component.extend({
	
	  displayName: "ListComponent",
	
	  render: function() {
	    var doc = this.props.doc;
	    return List.static.render(this.props.node, {
	      createElement: function(tagName) {
	        return $$(tagName);
	      },
	      createAnnotatedTextNode: function(path) {
	        return $$(TextProperty, { doc: doc, path: path });
	      }
	    });
	  },
	
	  didMount: function() {
	    if (this.doc) {
	      this._dispose();
	    }
	    this.doc = this.props.doc;
	    this.doc.getEventProxy('path').add([this.props.node.id, 'items'], this, this.onItemsChanged);
	  },
	
	  willUnmount: function() {
	    this._dispose();
	  },
	
	  _dispose: function() {
	    this.doc.getEventProxy('path').remove([this.props.node.id, 'items'], this);
	    this.doc = null;
	  },
	
	  onItemsChanged: function() {
	    console.log('YAY');
	    this.rerender();
	  },
	
	});
	
	module.exports = ListComponent;


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var OO = __webpack_require__(2);
	var Component = __webpack_require__(4);
	var $$ = Component.$$;
	var TextProperty = __webpack_require__(26);
	
	function Paragraph() {
	  Component.apply(this, arguments);
	}
	
	Paragraph.Prototype = function() {
	
	  this.getClassNames = function() {
	    return "content-node paragraph";
	  };
	
	  this.render = function() {
	    return $$('div')
	      .addClass(this.getClassNames())
	      .attr("data-id", this.props.node.id)
	      .append($$(TextProperty)
	        .addProps({
	          doc: this.props.doc,
	          path: [ this.props.node.id, "content"]
	        })
	      );
	  };
	};
	
	OO.inherit(Paragraph, Component);
	
	module.exports = Paragraph;


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var OO = __webpack_require__(2);
	var Component = __webpack_require__(4);
	var $$ = Component.$$;
	
	function UnsupportedNodeComponent() {
	  Component.apply(this, arguments);
	}
	
	UnsupportedNodeComponent.Prototype = function() {
	
	  this.render = function() {
	    return $$('pre')
	      .addClass("content-node unsupported")
	      .attr({
	        "data-id": this.props.node.id,
	        contentEditable: false
	      })
	      .append(
	        JSON.stringify(this.props.node.properties, null, 2)
	      );
	  };
	};
	
	OO.inherit(UnsupportedNodeComponent, Component);
	
	module.exports = UnsupportedNodeComponent;


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Component = __webpack_require__(4);
	var _ = __webpack_require__(1);
	var $$ = Component.$$;
	var ToolComponent = __webpack_require__(103);
	
	// We disabled editing of a link title for the time being, as it makes for a more mimal interface.
	
	var EditLinkPrompt = Component.extend({
	
	  onSave: function(e) {
	    e.preventDefault();
	    this.props.tool.updateLink({
	      url: this.refs.url.$el.val(),
	      // title: this.refs.title.$el.val()
	    });
	  },
	
	  onDelete: function(e) {
	    e.preventDefault();
	    this.props.tool.deleteLink();
	  },
	
	  render: function() {
	    var link = this.props.link;
	    var el = $$('div').addClass('prompt shadow border fill-white');
	
	    el.append([
	      $$('div').addClass('prompt-title').append('Hyperlink'),
	      $$('input').attr({type: 'text', placeholder: 'http://your-website.com', value: link.url})
	                 .key('url')
	                 .on('change', this.onSave),
	      // $$('input').attr({type: 'text', placeholder: 'Optional title', value: link.title})
	      //            .key('title')
	      //            .on('change', this.onSave),
	      $$('a').attr({href: '#'})
	             .addClass('delete-link')
	             .append('Delete')
	             .on('click', this.onDelete)
	
	    ]);
	    return el;
	  }
	});
	
	var LinkToolComponent = ToolComponent.extend({
	
	  render: function() {
	    var title = this.props.title;
	
	    if (this.state.mode) {
	      title = [_.capitalize(this.state.mode), title].join(' ');
	    }
	
	    var el = $$('div')
	      .addClass('link');
	
	    if (this.state.disabled) {
	      el.addClass('disabled');
	    }
	
	    // el.addClass('active');
	    if (this.state.mode === 'edit') {
	      el.addClass('active');
	    }
	    if (this.state.mode) {
	      el.addClass(this.state.mode);
	    }
	
	    var button = $$("button")
	      .addClass('button')
	      .attr('title', title)
	      .on('mousedown', this.onMouseDown)
	      .on('click', this.onClick);
	
	    button.append(this.props.children);
	
	    el.append(button);
	
	    // When we are in edit mode showing the edit prompt
	    if (this.state.mode === 'edit' && this.state.showPrompt) {
	      var link = this.tool.getLink();
	      var prompt = $$(EditLinkPrompt, {link: link, tool: this.tool});
	      el.append(prompt);
	    }
	
	    return el;
	  }
	
	});
	
	module.exports = LinkToolComponent;
	


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var OO = __webpack_require__(2);
	var Component = __webpack_require__(4);
	var $$ = Component.$$;
	
	// Text Tool Component
	// ----------------
	
	function TextToolComponent() {
	  Component.apply(this, arguments);
	}
	
	TextToolComponent.Prototype = function() {
	
	  this.didInitialize = function() {
	    this._initializeTool();
	  };
	
	  this.getInitialState = function() {
	    // TODO: is this a cool way to do custom initialization?
	    // this hook gets called once during construction
	    // see also this.willReceiveProps and this.didReceiveProps
	    // Derive initial state from tool
	    return this.tool.state;
	  };
	
	  this.render = function() {
	    var textTypes = this.tool.getAvailableTextTypes();
	    var el = $$("div")
	      .addClass('text-tool-component select');
	
	    // Note: this is a view internal state for opening the select dropdown
	    if (this.state.open) {
	      el.addClass('open');
	    }
	    if (this.state.disabled) {
	      el.addClass('disabled');
	    }
	    // label/dropdown button
	    var isTextContext = textTypes[this.state.currentTextType];
	    var label;
	    if (isTextContext) {
	      label = textTypes[this.state.currentTextType].label;
	    } else if (this.state.currentContext) {
	      label = this.state.currentContext; // i18n.t(this.state.currentContext);
	    } else {
	      label = 'No selection';
	    }
	    el.append($$('button')
	      .addClass("toggle small").attr('href', "#")
	      .attr('title', this.props.title)
	      .append(label)
	      .on('mousedown', this.toggleAvailableTextTypes)
	      .on('click', this.handleClick)
	    );
	    // dropdown options
	    var options = $$('div').addClass("options shadow border fill-white");
	    _.each(textTypes, function(textType, textTypeId) {
	      var button = $$('button').key(textTypeId)
	          .addClass('option '+textTypeId)
	          .attr("data-type", textTypeId)
	          .append(textType.label)
	          .on('click', this.handleClick)
	          .on('mousedown', this.handleSwitchTextType);
	      options.append(button);
	    }, this);
	    el.append(options);
	    return el;
	  };
	
	  this.willReceiveProps = function(newProps) {
	    if (this.tool && newProps.tool !== this.tool.getName()) {
	      this.tool.disconnect(this);
	    }
	  };
	
	  this.didReceiveProps = function() {
	    this._initializeTool();
	  };
	
	  this.willUnmount = function() {
	    this.tool.disconnect(this);
	  };
	
	  this._initializeTool = function() {
	    var toolName = this.props.tool;
	    if (!toolName) {
	      throw new Error('Prop "tool" is mandatory.');
	    }
	    this.tool = this.context.toolRegistry.get(toolName);
	    if (!this.tool) {
	      console.error('No tool registered with name %s', toolName);
	    }
	    this.tool.connect(this, {
	      'toolstate:changed': this.onToolstateChanged
	    });
	  };
	
	  this.onToolstateChanged = function(toolState) {
	    this.setState(toolState);
	  };
	
	  this.handleClick = function(e) {
	    e.preventDefault();
	    e.stopPropagation();
	  };
	
	  this.handleSwitchTextType = function(e) {
	    e.preventDefault();
	    // Modifies the tool's state so that state.open is undefined, which is nice
	    // because it means the dropdown will be closed automatically
	    this.tool.switchTextType(e.currentTarget.dataset.type);
	  };
	
	  this.toggleAvailableTextTypes = function(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    if (this.tool.isDisabled()) return;
	    // HACK: This only updates the view state state.open is not set on the tool itself
	    // That way the dropdown automatically closes when the selection changes
	    this.toggleDropdown();
	  };
	
	  this.toggleDropdown = function() {
	    this.extendState({
	      open: !this.state.open
	    });
	  };
	};
	
	OO.inherit(TextToolComponent, Component);
	
	module.exports = TextToolComponent;


/***/ },
/* 262 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_262__;

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** react-substance.min.js
 **/